export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigInt: { input: string; output: string; }
  Cursor: { input: unknown; output: unknown; }
  Datetime: { input: string; output: string; }
  Email: { input: string; output: string; }
  EventName: { input: string; output: string; }
  JSON: { input: unknown; output: unknown; }
  UUID: { input: string; output: string; }
};

/** Links an account to an auth provider */
export type Account = Node & {
  __typename?: 'Account';
  /** Reads and enables pagination through a set of `AuthAccount`. */
  authAccounts: AuthAccountsConnection;
  /** Reads and enables pagination through a set of `BusinessUser`. */
  businessUsers: BusinessUsersConnection;
  created: Scalars['Datetime']['output'];
  email: Scalars['Email']['output'];
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};


/** Links an account to an auth provider */
export type AccountAuthAccountsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AuthAccountCondition>;
  filter?: InputMaybe<AuthAccountFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AuthAccountsOrderBy>>;
};


/** Links an account to an auth provider */
export type AccountBusinessUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BusinessUserCondition>;
  filter?: InputMaybe<BusinessUserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessUsersOrderBy>>;
};

/** A condition to be used against `Account` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type AccountCondition = {
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['Email']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `Account` object types. All fields are combined with a logical ‘and.’ */
export type AccountFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AccountFilter>>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<EmailFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AccountFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AccountFilter>>;
};

/** A connection to a list of `Account` values. */
export type AccountsConnection = {
  __typename?: 'AccountsConnection';
  /** A list of edges which contains the `Account` and cursor to aid in pagination. */
  edges: Array<AccountsEdge>;
  /** A list of `Account` objects. */
  nodes: Array<Account>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Account` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Account` edge in the connection. */
export type AccountsEdge = {
  __typename?: 'AccountsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Account` at the end of the edge. */
  node: Account;
};

/** Methods to use when ordering `Account`. */
export enum AccountsOrderBy {
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type ActionFlowApproval = Node & {
  __typename?: 'ActionFlowApproval';
  /** Reads a single `ActionFlowConfigVersion` that is related to this `ActionFlowApproval`. */
  actionFlowConfigVersionByEnvironmentIdAndFlowConfigIdAndFlowConfigVersion?: Maybe<ActionFlowConfigVersion>;
  approvedBy?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `BusinessUser` that is related to this `ActionFlowApproval`. */
  businessUserByOrganisationIdAndApprovedBy?: Maybe<BusinessUser>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  environmentId: Scalars['String']['output'];
  flowConfigId: Scalars['String']['output'];
  flowConfigVersion: Scalars['Int']['output'];
  groupId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organisation` that is related to this `ActionFlowApproval`. */
  organisation?: Maybe<Organisation>;
  /** Reads a single `Group` that is related to this `ActionFlowApproval`. */
  organisationGroup?: Maybe<Group>;
  organisationId: Scalars['String']['output'];
};

/**
 * A condition to be used against `ActionFlowApproval` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ActionFlowApprovalCondition = {
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `organisationId` field. */
  organisationId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `ActionFlowApproval` object types. All fields are combined with a logical ‘and.’ */
export type ActionFlowApprovalFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ActionFlowApprovalFilter>>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ActionFlowApprovalFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ActionFlowApprovalFilter>>;
  /** Filter by the object’s `organisationId` field. */
  organisationId?: InputMaybe<StringFilter>;
};

export type ActionFlowApprovalRequest = Node & {
  __typename?: 'ActionFlowApprovalRequest';
  /** Reads a single `ActionFlowConfigVersion` that is related to this `ActionFlowApprovalRequest`. */
  actionFlowConfigVersionByEnvironmentIdAndFlowConfigIdAndFlowConfigVersion?: Maybe<ActionFlowConfigVersion>;
  /** Reads a single `BusinessUser` that is related to this `ActionFlowApprovalRequest`. */
  businessUserByOrganisationIdAndRequestedBy?: Maybe<BusinessUser>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  environmentId: Scalars['String']['output'];
  flowConfigId: Scalars['String']['output'];
  flowConfigVersion: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organisation` that is related to this `ActionFlowApprovalRequest`. */
  organisation?: Maybe<Organisation>;
  organisationId: Scalars['String']['output'];
  requestedBy?: Maybe<Scalars['Int']['output']>;
};

/**
 * A condition to be used against `ActionFlowApprovalRequest` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ActionFlowApprovalRequestCondition = {
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `organisationId` field. */
  organisationId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `ActionFlowApprovalRequest` object types. All fields are combined with a logical ‘and.’ */
export type ActionFlowApprovalRequestFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ActionFlowApprovalRequestFilter>>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ActionFlowApprovalRequestFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ActionFlowApprovalRequestFilter>>;
  /** Filter by the object’s `organisationId` field. */
  organisationId?: InputMaybe<StringFilter>;
};

/** A connection to a list of `ActionFlowApprovalRequest` values. */
export type ActionFlowApprovalRequestsConnection = {
  __typename?: 'ActionFlowApprovalRequestsConnection';
  /** A list of edges which contains the `ActionFlowApprovalRequest` and cursor to aid in pagination. */
  edges: Array<ActionFlowApprovalRequestsEdge>;
  /** A list of `ActionFlowApprovalRequest` objects. */
  nodes: Array<ActionFlowApprovalRequest>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ActionFlowApprovalRequest` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ActionFlowApprovalRequest` edge in the connection. */
export type ActionFlowApprovalRequestsEdge = {
  __typename?: 'ActionFlowApprovalRequestsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ActionFlowApprovalRequest` at the end of the edge. */
  node: ActionFlowApprovalRequest;
};

/** Methods to use when ordering `ActionFlowApprovalRequest`. */
export enum ActionFlowApprovalRequestsOrderBy {
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OrganisationIdAsc = 'ORGANISATION_ID_ASC',
  OrganisationIdDesc = 'ORGANISATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A connection to a list of `ActionFlowApproval` values. */
export type ActionFlowApprovalsConnection = {
  __typename?: 'ActionFlowApprovalsConnection';
  /** A list of edges which contains the `ActionFlowApproval` and cursor to aid in pagination. */
  edges: Array<ActionFlowApprovalsEdge>;
  /** A list of `ActionFlowApproval` objects. */
  nodes: Array<ActionFlowApproval>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ActionFlowApproval` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ActionFlowApproval` edge in the connection. */
export type ActionFlowApprovalsEdge = {
  __typename?: 'ActionFlowApprovalsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ActionFlowApproval` at the end of the edge. */
  node: ActionFlowApproval;
};

/** Methods to use when ordering `ActionFlowApproval`. */
export enum ActionFlowApprovalsOrderBy {
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OrganisationIdAsc = 'ORGANISATION_ID_ASC',
  OrganisationIdDesc = 'ORGANISATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type ActionFlowConfig = Node & {
  __typename?: 'ActionFlowConfig';
  /** Reads and enables pagination through a set of `ActionFlowConfigVersion`. */
  actionFlowConfigVersionsByEnvironmentIdAndFlowConfigId: ActionFlowConfigVersionsConnection;
  /** Reads and enables pagination through a set of `CardTemplate`. */
  cardTemplatesByEnvironmentIdAndFlowConfigId: CardTemplatesConnection;
  config?: Maybe<Scalars['JSON']['output']>;
  configLastUpdated?: Maybe<Scalars['Datetime']['output']>;
  configStatus?: Maybe<ActionFlowVersionStatus>;
  /** Computed column, return config at a given version */
  configVersion?: Maybe<ActionFlowConfigVersion>;
  /** Reads and enables pagination through a set of `ConnectorRuntime`. */
  connectorRuntimesByEnvironmentIdAndFlowConfigId: ConnectorRuntimesConnection;
  created: Scalars['Datetime']['output'];
  /** Computed column, most recent action_flow_version */
  currentVersion?: Maybe<ActionFlowConfigVersion>;
  description?: Maybe<Scalars['String']['output']>;
  /** Computed column, draft status - DRAFT, PENDING, APPROVED, NA */
  draftStatus?: Maybe<ActionFlowConfigDraftStatus>;
  environmentId: Scalars['String']['output'];
  /** Computed column, true if we have a dirty draft version  */
  hasDirtyDraft?: Maybe<Scalars['Boolean']['output']>;
  /** deprecated computed column. Use publishedConfigVersion instead;  true if we have published versions */
  hasPublishedVersions?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  listeners: Array<Maybe<Scalars['String']['output']>>;
  migratedFromCardAt?: Maybe<Scalars['Datetime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organisation` that is related to this `ActionFlowConfig`. */
  organisation?: Maybe<Organisation>;
  organisationId: Scalars['String']['output'];
  publishedConfigVersion?: Maybe<Scalars['Int']['output']>;
  /** Computed column, most recent published action flow */
  publishedVersion?: Maybe<ActionFlowConfigVersion>;
  segmentTriggerStreamIds?: Maybe<Array<Scalars['String']['output']>>;
  shareLinkIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  status: ActionFlowConfigStatus;
  updated?: Maybe<Scalars['Datetime']['output']>;
  workbenchFolderIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  workbenchFolderName?: Maybe<Scalars['String']['output']>;
};


export type ActionFlowConfigActionFlowConfigVersionsByEnvironmentIdAndFlowConfigIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ActionFlowConfigVersionCondition>;
  filter?: InputMaybe<ActionFlowConfigVersionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActionFlowConfigVersionsOrderBy>>;
};


export type ActionFlowConfigCardTemplatesByEnvironmentIdAndFlowConfigIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CardTemplateCondition>;
  filter?: InputMaybe<CardTemplateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CardTemplatesOrderBy>>;
};


export type ActionFlowConfigConfigVersionArgs = {
  version: Scalars['Int']['input'];
};


export type ActionFlowConfigConnectorRuntimesByEnvironmentIdAndFlowConfigIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ConnectorRuntimeCondition>;
  filter?: InputMaybe<ConnectorRuntimeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ConnectorRuntimesOrderBy>>;
};

/**
 * A condition to be used against `ActionFlowConfig` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ActionFlowConfigCondition = {
  /** Checks for equality with the object’s `configLastUpdated` field. */
  configLastUpdated?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `configStatus` field. */
  configStatus?: InputMaybe<ActionFlowVersionStatus>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `isDefault` field. */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organisationId` field. */
  organisationId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `publishedConfigVersion` field. */
  publishedConfigVersion?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `workbenchFolderIds` field. */
  workbenchFolderIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum ActionFlowConfigDraftStatus {
  Approved = 'APPROVED',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Na = 'NA',
  Pending = 'PENDING'
}

/** A filter to be used against ActionFlowConfigDraftStatus fields. All fields are combined with a logical ‘and.’ */
export type ActionFlowConfigDraftStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ActionFlowConfigDraftStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ActionFlowConfigDraftStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ActionFlowConfigDraftStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ActionFlowConfigDraftStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ActionFlowConfigDraftStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ActionFlowConfigDraftStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ActionFlowConfigDraftStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ActionFlowConfigDraftStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ActionFlowConfigDraftStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ActionFlowConfigDraftStatus>>;
};

/** A filter to be used against `ActionFlowConfig` object types. All fields are combined with a logical ‘and.’ */
export type ActionFlowConfigFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ActionFlowConfigFilter>>;
  /** Filter by the object’s `configLastUpdated` field. */
  configLastUpdated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `configStatus` field. */
  configStatus?: InputMaybe<ActionFlowVersionStatusFilter>;
  /** Filter by the object’s `draftStatus` field. */
  draftStatus?: InputMaybe<ActionFlowConfigDraftStatusFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `hasDirtyDraft` field. */
  hasDirtyDraft?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `hasPublishedVersions` field. */
  hasPublishedVersions?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `isDefault` field. */
  isDefault?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ActionFlowConfigFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ActionFlowConfigFilter>>;
  /** Filter by the object’s `organisationId` field. */
  organisationId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `publishedConfigVersion` field. */
  publishedConfigVersion?: InputMaybe<IntFilter>;
  /** Filter by the object’s `workbenchFolderIds` field. */
  workbenchFolderIds?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `workbenchFolderName` field. */
  workbenchFolderName?: InputMaybe<StringFilter>;
};

export enum ActionFlowConfigStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/** A `ActionFlowConfigStatusCountsRecord` edge in the connection. */
export type ActionFlowConfigStatusCountEdge = {
  __typename?: 'ActionFlowConfigStatusCountEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ActionFlowConfigStatusCountsRecord` at the end of the edge. */
  node: ActionFlowConfigStatusCountsRecord;
};

/** A connection to a list of `ActionFlowConfigStatusCountsRecord` values. */
export type ActionFlowConfigStatusCountsConnection = {
  __typename?: 'ActionFlowConfigStatusCountsConnection';
  /** A list of edges which contains the `ActionFlowConfigStatusCountsRecord` and cursor to aid in pagination. */
  edges: Array<ActionFlowConfigStatusCountEdge>;
  /** A list of `ActionFlowConfigStatusCountsRecord` objects. */
  nodes: Array<ActionFlowConfigStatusCountsRecord>;
  /** The count of *all* `ActionFlowConfigStatusCountsRecord` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** The return type of our `actionFlowConfigStatusCounts` query. */
export type ActionFlowConfigStatusCountsRecord = {
  __typename?: 'ActionFlowConfigStatusCountsRecord';
  count?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<ActionFlowConfigDraftStatus>;
};

/** A filter to be used against `ActionFlowConfigStatusCountsRecord` object types. All fields are combined with a logical ‘and.’ */
export type ActionFlowConfigStatusCountsRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ActionFlowConfigStatusCountsRecordFilter>>;
  /** Filter by the object’s `count` field. */
  count?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ActionFlowConfigStatusCountsRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ActionFlowConfigStatusCountsRecordFilter>>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<ActionFlowConfigDraftStatusFilter>;
};

export type ActionFlowConfigVersion = Node & {
  __typename?: 'ActionFlowConfigVersion';
  /** Reads and enables pagination through a set of `ActionFlowApprovalRequest`. */
  actionFlowApprovalRequestsByEnvironmentIdAndFlowConfigIdAndFlowConfigVersion: ActionFlowApprovalRequestsConnection;
  /** Reads and enables pagination through a set of `ActionFlowApproval`. */
  actionFlowApprovalsByEnvironmentIdAndFlowConfigIdAndFlowConfigVersion: ActionFlowApprovalsConnection;
  /** computed column, count of approvals to date */
  approvalCount?: Maybe<Scalars['Int']['output']>;
  /** computed column, true if approvals are required, action flow hasn't been approved and an approval has been logged */
  approvalPending?: Maybe<Scalars['Boolean']['output']>;
  /** computed column, array of groups that are yet to approve this action flow */
  approvalPendingGroups?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** computed column, true if an approval request has been made for this action flow, and approvals are required */
  approvalRequested?: Maybe<Scalars['Boolean']['output']>;
  /** computed column, date of first approval request */
  approvalRequestedAt?: Maybe<Scalars['Datetime']['output']>;
  /** computed column, number of approvals required */
  approvalRequiredCount?: Maybe<Scalars['Int']['output']>;
  /** computed column, connection to groups a business member must belong to in order to approve action flows */
  approvalRequiredGroups: GroupsConnection;
  /** computed column, true if action flow approvals are enabled via configuration */
  approvalsEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Reads a single `BusinessUser` that is related to this `ActionFlowConfigVersion`. */
  businessUserByOrganisationIdAndPublishedBy?: Maybe<BusinessUser>;
  /** Reads a single `BusinessUser` that is related to this `ActionFlowConfigVersion`. */
  businessUserByOrganisationIdAndUpdatedBy?: Maybe<BusinessUser>;
  /** computed column, true if user is able to approve action flow, based on group memberships */
  canApprove?: Maybe<Scalars['Boolean']['output']>;
  config: Scalars['JSON']['output'];
  created: Scalars['Datetime']['output'];
  dirty?: Maybe<Scalars['Boolean']['output']>;
  /** Computed column, drafts of published action flows without edits show as published */
  displayStatus?: Maybe<ActionFlowVersionStatus>;
  /** Computed column, only return the draft version number there if it's dirty otherwise display published version */
  displayVersion?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `ActionFlowConfig` that is related to this `ActionFlowConfigVersion`. */
  environmentFlowConfig?: Maybe<ActionFlowConfig>;
  environmentId: Scalars['String']['output'];
  flowConfigId: Scalars['String']['output'];
  /** computed column, true if action flow is approved */
  isApproved?: Maybe<Scalars['Boolean']['output']>;
  listeners: Array<Maybe<Scalars['String']['output']>>;
  /** computed column, intersection of approval groups with users group membership, or all groups if an approver admin */
  myApprovalGroups: GroupsConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organisation` that is related to this `ActionFlowConfigVersion`. */
  organisation?: Maybe<Organisation>;
  organisationId: Scalars['String']['output'];
  publishedBy?: Maybe<Scalars['Int']['output']>;
  publishedPeriod?: Maybe<DatetimeRange>;
  screenshots?: Maybe<Scalars['JSON']['output']>;
  status: ActionFlowVersionStatus;
  /** Reads and enables pagination through a set of `TriggerEvent`. */
  triggerEventsByEnvironmentIdAndFlowConfigIdAndFlowConfigVersion: TriggerEventsConnection;
  updated?: Maybe<Scalars['Datetime']['output']>;
  updatedBy?: Maybe<Scalars['Int']['output']>;
  version: Scalars['Int']['output'];
};


export type ActionFlowConfigVersionActionFlowApprovalRequestsByEnvironmentIdAndFlowConfigIdAndFlowConfigVersionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ActionFlowApprovalRequestCondition>;
  filter?: InputMaybe<ActionFlowApprovalRequestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActionFlowApprovalRequestsOrderBy>>;
};


export type ActionFlowConfigVersionActionFlowApprovalsByEnvironmentIdAndFlowConfigIdAndFlowConfigVersionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ActionFlowApprovalCondition>;
  filter?: InputMaybe<ActionFlowApprovalFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActionFlowApprovalsOrderBy>>;
};


export type ActionFlowConfigVersionApprovalRequiredGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<GroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ActionFlowConfigVersionMyApprovalGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<GroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ActionFlowConfigVersionTriggerEventsByEnvironmentIdAndFlowConfigIdAndFlowConfigVersionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TriggerEventCondition>;
  filter?: InputMaybe<TriggerEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TriggerEventsOrderBy>>;
};

export type ActionFlowConfigVersionAnalytic = Node & {
  __typename?: 'ActionFlowConfigVersionAnalytic';
  created: Scalars['Datetime']['output'];
  /** Reads a single `Environment` that is related to this `ActionFlowConfigVersionAnalytic`. */
  environment?: Maybe<Environment>;
  environmentId: Scalars['String']['output'];
  eventCount?: Maybe<Scalars['BigInt']['output']>;
  eventName: Scalars['String']['output'];
  flowConfigId: Scalars['String']['output'];
  flowConfigVersion: Scalars['Int']['output'];
  goalSum?: Maybe<Scalars['BigInt']['output']>;
  id: Scalars['BigInt']['output'];
  isTest?: Maybe<Scalars['Boolean']['output']>;
  lastOccurredAt: Scalars['Datetime']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  stepId?: Maybe<Scalars['String']['output']>;
  updated: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `ActionFlowConfigVersionAnalytic` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type ActionFlowConfigVersionAnalyticCondition = {
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `eventName` field. */
  eventName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `flowConfigId` field. */
  flowConfigId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `flowConfigVersion` field. */
  flowConfigVersion?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `isTest` field. */
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A filter to be used against `ActionFlowConfigVersionAnalytic` object types. All fields are combined with a logical ‘and.’ */
export type ActionFlowConfigVersionAnalyticFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ActionFlowConfigVersionAnalyticFilter>>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `eventName` field. */
  eventName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `flowConfigId` field. */
  flowConfigId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `flowConfigVersion` field. */
  flowConfigVersion?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `isTest` field. */
  isTest?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ActionFlowConfigVersionAnalyticFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ActionFlowConfigVersionAnalyticFilter>>;
};

/** A connection to a list of `ActionFlowConfigVersionAnalytic` values. */
export type ActionFlowConfigVersionAnalyticsConnection = {
  __typename?: 'ActionFlowConfigVersionAnalyticsConnection';
  /** A list of edges which contains the `ActionFlowConfigVersionAnalytic` and cursor to aid in pagination. */
  edges: Array<ActionFlowConfigVersionAnalyticsEdge>;
  /** A list of `ActionFlowConfigVersionAnalytic` objects. */
  nodes: Array<ActionFlowConfigVersionAnalytic>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ActionFlowConfigVersionAnalytic` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ActionFlowConfigVersionAnalytic` edge in the connection. */
export type ActionFlowConfigVersionAnalyticsEdge = {
  __typename?: 'ActionFlowConfigVersionAnalyticsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ActionFlowConfigVersionAnalytic` at the end of the edge. */
  node: ActionFlowConfigVersionAnalytic;
};

/** Methods to use when ordering `ActionFlowConfigVersionAnalytic`. */
export enum ActionFlowConfigVersionAnalyticsOrderBy {
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  EventNameAsc = 'EVENT_NAME_ASC',
  EventNameDesc = 'EVENT_NAME_DESC',
  FlowConfigIdAsc = 'FLOW_CONFIG_ID_ASC',
  FlowConfigIdDesc = 'FLOW_CONFIG_ID_DESC',
  FlowConfigVersionAsc = 'FLOW_CONFIG_VERSION_ASC',
  FlowConfigVersionDesc = 'FLOW_CONFIG_VERSION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsTestAsc = 'IS_TEST_ASC',
  IsTestDesc = 'IS_TEST_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/**
 * A condition to be used against `ActionFlowConfigVersion` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ActionFlowConfigVersionCondition = {
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organisationId` field. */
  organisationId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<ActionFlowVersionStatus>;
  /** Checks for equality with the object’s `version` field. */
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `ActionFlowConfigVersion` object types. All fields are combined with a logical ‘and.’ */
export type ActionFlowConfigVersionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ActionFlowConfigVersionFilter>>;
  /** Filter by the object’s `approvalCount` field. */
  approvalCount?: InputMaybe<IntFilter>;
  /** Filter by the object’s `approvalPending` field. */
  approvalPending?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `approvalPendingGroups` field. */
  approvalPendingGroups?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `approvalRequested` field. */
  approvalRequested?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `approvalRequestedAt` field. */
  approvalRequestedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `approvalRequiredCount` field. */
  approvalRequiredCount?: InputMaybe<IntFilter>;
  /** Filter by the object’s `approvalsEnabled` field. */
  approvalsEnabled?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `canApprove` field. */
  canApprove?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `displayStatus` field. */
  displayStatus?: InputMaybe<ActionFlowVersionStatusFilter>;
  /** Filter by the object’s `displayVersion` field. */
  displayVersion?: InputMaybe<IntFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `isApproved` field. */
  isApproved?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ActionFlowConfigVersionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ActionFlowConfigVersionFilter>>;
  /** Filter by the object’s `organisationId` field. */
  organisationId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<ActionFlowVersionStatusFilter>;
  /** Filter by the object’s `version` field. */
  version?: InputMaybe<IntFilter>;
};

/** A connection to a list of `ActionFlowConfigVersion` values. */
export type ActionFlowConfigVersionsConnection = {
  __typename?: 'ActionFlowConfigVersionsConnection';
  /** A list of edges which contains the `ActionFlowConfigVersion` and cursor to aid in pagination. */
  edges: Array<ActionFlowConfigVersionsEdge>;
  /** A list of `ActionFlowConfigVersion` objects. */
  nodes: Array<ActionFlowConfigVersion>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ActionFlowConfigVersion` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ActionFlowConfigVersion` edge in the connection. */
export type ActionFlowConfigVersionsEdge = {
  __typename?: 'ActionFlowConfigVersionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ActionFlowConfigVersion` at the end of the edge. */
  node: ActionFlowConfigVersion;
};

/** Methods to use when ordering `ActionFlowConfigVersion`. */
export enum ActionFlowConfigVersionsOrderBy {
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  Natural = 'NATURAL',
  OrganisationIdAsc = 'ORGANISATION_ID_ASC',
  OrganisationIdDesc = 'ORGANISATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  VersionAsc = 'VERSION_ASC',
  VersionDesc = 'VERSION_DESC'
}

/** A connection to a list of `ActionFlowConfig` values. */
export type ActionFlowConfigsConnection = {
  __typename?: 'ActionFlowConfigsConnection';
  /** A list of edges which contains the `ActionFlowConfig` and cursor to aid in pagination. */
  edges: Array<ActionFlowConfigsEdge>;
  /** A list of `ActionFlowConfig` objects. */
  nodes: Array<ActionFlowConfig>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ActionFlowConfig` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ActionFlowConfig` edge in the connection. */
export type ActionFlowConfigsEdge = {
  __typename?: 'ActionFlowConfigsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ActionFlowConfig` at the end of the edge. */
  node: ActionFlowConfig;
};

/** Methods to use when ordering `ActionFlowConfig`. */
export enum ActionFlowConfigsOrderBy {
  ConfigLastUpdatedAsc = 'CONFIG_LAST_UPDATED_ASC',
  ConfigLastUpdatedDesc = 'CONFIG_LAST_UPDATED_DESC',
  ConfigStatusAsc = 'CONFIG_STATUS_ASC',
  ConfigStatusDesc = 'CONFIG_STATUS_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  IsDefaultAsc = 'IS_DEFAULT_ASC',
  IsDefaultDesc = 'IS_DEFAULT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  OrganisationIdAsc = 'ORGANISATION_ID_ASC',
  OrganisationIdDesc = 'ORGANISATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  PublishedConfigVersionAsc = 'PUBLISHED_CONFIG_VERSION_ASC',
  PublishedConfigVersionDesc = 'PUBLISHED_CONFIG_VERSION_DESC',
  WorkbenchFolderIdsAsc = 'WORKBENCH_FOLDER_IDS_ASC',
  WorkbenchFolderIdsDesc = 'WORKBENCH_FOLDER_IDS_DESC',
  WorkbenchFolderNameAsc = 'WORKBENCH_FOLDER_NAME_ASC',
  WorkbenchFolderNameDesc = 'WORKBENCH_FOLDER_NAME_DESC'
}

export type ActionFlowConfigurationPayload = {
  __typename?: 'ActionFlowConfigurationPayload';
  actionFlowConfig?: Maybe<ActionFlowConfig>;
  query?: Maybe<Query>;
};

export type ActionFlowIntegrationSummary = {
  __typename?: 'ActionFlowIntegrationSummary';
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  usedInPublishedVersion: Scalars['Boolean']['output'];
};

export type ActionFlowSegmentSummary = {
  __typename?: 'ActionFlowSegmentSummary';
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  usedInPublishedVersion: Scalars['Boolean']['output'];
};

export type ActionFlowShareLinkPayload = {
  __typename?: 'ActionFlowShareLinkPayload';
  secret: Scalars['String']['output'];
};

export enum ActionFlowVersionStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

/** A filter to be used against ActionFlowVersionStatus fields. All fields are combined with a logical ‘and.’ */
export type ActionFlowVersionStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ActionFlowVersionStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ActionFlowVersionStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ActionFlowVersionStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ActionFlowVersionStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ActionFlowVersionStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ActionFlowVersionStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ActionFlowVersionStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ActionFlowVersionStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ActionFlowVersionStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ActionFlowVersionStatus>>;
};

/** All input for the `activateInvitedBusinessUserAccount` mutation. */
export type ActivateInvitedBusinessUserAccountInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organisationId: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  secretValue: Scalars['String']['input'];
};

/** The output of our `activateInvitedBusinessUserAccount` mutation. */
export type ActivateInvitedBusinessUserAccountPayload = {
  __typename?: 'ActivateInvitedBusinessUserAccountPayload';
  /** Reads a single `Account` that is related to this `BusinessUser`. */
  account?: Maybe<Account>;
  businessUser?: Maybe<BusinessUser>;
  /** An edge for our `BusinessUser`. May be used by Relay 1. */
  businessUserEdge?: Maybe<BusinessUsersEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organisation` that is related to this `BusinessUser`. */
  organisation?: Maybe<Organisation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `activateInvitedBusinessUserAccount` mutation. */
export type ActivateInvitedBusinessUserAccountPayloadBusinessUserEdgeArgs = {
  orderBy?: InputMaybe<Array<BusinessUsersOrderBy>>;
};

/** All input for the `addCardTemplateWithVersion` mutation. */
export type AddCardTemplateWithVersionInput = {
  cardId?: InputMaybe<Scalars['String']['input']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  definition?: InputMaybe<Scalars['JSON']['input']>;
  environmentId: Scalars['String']['input'];
  expires?: InputMaybe<Scalars['Datetime']['input']>;
  expiresInterval?: InputMaybe<IntervalInput>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  testData?: InputMaybe<Scalars['JSON']['input']>;
};

/** The output of our `addCardTemplateWithVersion` mutation. */
export type AddCardTemplateWithVersionPayload = {
  __typename?: 'AddCardTemplateWithVersionPayload';
  /** Reads a single `BusinessUser` that is related to this `CardTemplateVersion`. */
  businessUserByOrganisationIdAndPublishedBy?: Maybe<BusinessUser>;
  /** Reads a single `BusinessUser` that is related to this `CardTemplateVersion`. */
  businessUserByOrganisationIdAndUpdatedBy?: Maybe<BusinessUser>;
  cardTemplateVersion?: Maybe<CardTemplateVersion>;
  /** An edge for our `CardTemplateVersion`. May be used by Relay 1. */
  cardTemplateVersionEdge?: Maybe<CardTemplateVersionsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CardTemplate` that is related to this `CardTemplateVersion`. */
  environmentCardTemplate?: Maybe<CardTemplate>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `addCardTemplateWithVersion` mutation. */
export type AddCardTemplateWithVersionPayloadCardTemplateVersionEdgeArgs = {
  orderBy?: InputMaybe<Array<CardTemplateVersionsOrderBy>>;
};

/** All input for the `addEventDefinitionWithVersion` mutation. */
export type AddEventDefinitionWithVersionInput = {
  archivePrevious?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clientTriggerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  environmentId: Scalars['String']['input'];
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['EventName']['input'];
  versionDetailSchema: Scalars['JSON']['input'];
};

/** The output of our `addEventDefinitionWithVersion` mutation. */
export type AddEventDefinitionWithVersionPayload = {
  __typename?: 'AddEventDefinitionWithVersionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `EventDefinition` that is related to this `EventDefinitionVersion`. */
  environmentEventDefinition?: Maybe<EventDefinition>;
  eventDefinitionVersion?: Maybe<EventDefinitionVersion>;
  /** An edge for our `EventDefinitionVersion`. May be used by Relay 1. */
  eventDefinitionVersionEdge?: Maybe<EventDefinitionVersionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `addEventDefinitionWithVersion` mutation. */
export type AddEventDefinitionWithVersionPayloadEventDefinitionVersionEdgeArgs = {
  orderBy?: InputMaybe<Array<EventDefinitionVersionsOrderBy>>;
};

/** All input for the `addTriggerEvent` mutation. */
export type AddTriggerEventInput = {
  _cardTemplateId: Scalars['String']['input'];
  _cardTemplateVersion: Scalars['Int']['input'];
  _environmentId: Scalars['String']['input'];
  _eventDefinitionId: Scalars['String']['input'];
  _eventDefinitionVersion: Scalars['Int']['input'];
  _streamId: Scalars['String']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `addTriggerEvent` mutation. */
export type AddTriggerEventPayload = {
  __typename?: 'AddTriggerEventPayload';
  /** Reads a single `ActionFlowConfigVersion` that is related to this `TriggerEvent`. */
  actionFlowConfigVersionByEnvironmentIdAndFlowConfigIdAndFlowConfigVersion?: Maybe<ActionFlowConfigVersion>;
  /** Reads a single `CardTemplateVersion` that is related to this `TriggerEvent`. */
  cardTemplateVersionByEnvironmentIdAndCardTemplateIdAndCardTemplateVersion?: Maybe<CardTemplateVersion>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Environment` that is related to this `TriggerEvent`. */
  environment?: Maybe<Environment>;
  /** Reads a single `Stream` that is related to this `TriggerEvent`. */
  environmentStream?: Maybe<Stream>;
  /** Reads a single `EventDefinitionVersion` that is related to this `TriggerEvent`. */
  eventDefinitionVersionByEnvironmentIdAndEventDefinitionIdAndEventDefinitionVersion?: Maybe<EventDefinitionVersion>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  triggerEvent?: Maybe<TriggerEvent>;
  /** An edge for our `TriggerEvent`. May be used by Relay 1. */
  triggerEventEdge?: Maybe<TriggerEventsEdge>;
};


/** The output of our `addTriggerEvent` mutation. */
export type AddTriggerEventPayloadTriggerEventEdgeArgs = {
  orderBy?: InputMaybe<Array<TriggerEventsOrderBy>>;
};

/** All input for the `aggregateActionFlowAnalytics` mutation. */
export type AggregateActionFlowAnalyticsInput = {
  batchLimitParam: Scalars['Int']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentIdParam: Scalars['String']['input'];
};

/** The output of our `aggregateActionFlowAnalytics` mutation. */
export type AggregateActionFlowAnalyticsPayload = {
  __typename?: 'AggregateActionFlowAnalyticsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  results?: Maybe<Array<Maybe<AggregateActionFlowAnalyticsRecord>>>;
};

/** The return type of our `aggregateActionFlowAnalytics` mutation. */
export type AggregateActionFlowAnalyticsRecord = {
  __typename?: 'AggregateActionFlowAnalyticsRecord';
  aggregateUpdates?: Maybe<Scalars['BigInt']['output']>;
  batchSize?: Maybe<Scalars['BigInt']['output']>;
  initialCursorCreated?: Maybe<Scalars['Datetime']['output']>;
  initialCursorId?: Maybe<Scalars['UUID']['output']>;
  updatedCursorCreated?: Maybe<Scalars['Datetime']['output']>;
  updatedCursorId?: Maybe<Scalars['UUID']['output']>;
};

export type AnalyticsBatch = Node & {
  __typename?: 'AnalyticsBatch';
  /** Reads a single `Environment` that is related to this `AnalyticsBatch`. */
  environment?: Maybe<Environment>;
  environmentId: Scalars['String']['output'];
  filenames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  filenamesCsv?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  filenamesInternal?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  filenamesNdjson?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  metadata: Scalars['JSON']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  processFrom: Scalars['Datetime']['output'];
  processTo: Scalars['Datetime']['output'];
  startedAt: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `AnalyticsBatch` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AnalyticsBatchCondition = {
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `AnalyticsBatch` object types. All fields are combined with a logical ‘and.’ */
export type AnalyticsBatchFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AnalyticsBatchFilter>>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AnalyticsBatchFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AnalyticsBatchFilter>>;
};

/** A connection to a list of `AnalyticsBatch` values. */
export type AnalyticsBatchesConnection = {
  __typename?: 'AnalyticsBatchesConnection';
  /** A list of edges which contains the `AnalyticsBatch` and cursor to aid in pagination. */
  edges: Array<AnalyticsBatchesEdge>;
  /** A list of `AnalyticsBatch` objects. */
  nodes: Array<AnalyticsBatch>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AnalyticsBatch` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `AnalyticsBatch` edge in the connection. */
export type AnalyticsBatchesEdge = {
  __typename?: 'AnalyticsBatchesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AnalyticsBatch` at the end of the edge. */
  node: AnalyticsBatch;
};

/** Methods to use when ordering `AnalyticsBatch`. */
export enum AnalyticsBatchesOrderBy {
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** Application clients for custom SSO within an organisation */
export type AppClient = Node & {
  __typename?: 'AppClient';
  appClientId: Scalars['String']['output'];
  created: Scalars['Datetime']['output'];
  domains: Array<Maybe<Scalars['String']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organisation` that is related to this `AppClient`. */
  organisation?: Maybe<Organisation>;
  organisationId: Scalars['String']['output'];
  ssoClaimMapping: Scalars['JSON']['output'];
  updated: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `AppClient` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type AppClientCondition = {
  /** Checks for equality with the object’s `organisationId` field. */
  organisationId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `AppClient` object types. All fields are combined with a logical ‘and.’ */
export type AppClientFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AppClientFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<AppClientFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AppClientFilter>>;
  /** Filter by the object’s `organisationId` field. */
  organisationId?: InputMaybe<StringFilter>;
};

/** Represents an update to a `AppClient`. Fields that are set will be updated. */
export type AppClientPatch = {
  appClientId?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['Datetime']['input']>;
  domains?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationId?: InputMaybe<Scalars['String']['input']>;
  ssoClaimMapping?: InputMaybe<Scalars['JSON']['input']>;
  updated?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A connection to a list of `AppClient` values. */
export type AppClientsConnection = {
  __typename?: 'AppClientsConnection';
  /** A list of edges which contains the `AppClient` and cursor to aid in pagination. */
  edges: Array<AppClientsEdge>;
  /** A list of `AppClient` objects. */
  nodes: Array<AppClient>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AppClient` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `AppClient` edge in the connection. */
export type AppClientsEdge = {
  __typename?: 'AppClientsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AppClient` at the end of the edge. */
  node: AppClient;
};

/** Methods to use when ordering `AppClient`. */
export enum AppClientsOrderBy {
  Natural = 'NATURAL',
  OrganisationIdAsc = 'ORGANISATION_ID_ASC',
  OrganisationIdDesc = 'ORGANISATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type ApprovalConfiguration = {
  __typename?: 'ApprovalConfiguration';
  enabled: Scalars['Boolean']['output'];
  requiredCount?: Maybe<Scalars['Int']['output']>;
  requiredGroups: Array<Scalars['String']['output']>;
};

export type ApprovalConfigurationInput = {
  enabled: Scalars['Boolean']['input'];
  requiredCount?: InputMaybe<Scalars['Int']['input']>;
  requiredGroups: Array<Scalars['String']['input']>;
};

export type ApprovalConfigurationResponse = {
  __typename?: 'ApprovalConfigurationResponse';
  configuration?: Maybe<ApprovalConfiguration>;
};

/** All input for the `approveActionFlowGroups` mutation. */
export type ApproveActionFlowGroupsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  flowConfigId: Scalars['String']['input'];
  flowConfigVersion: Scalars['Int']['input'];
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** The output of our `approveActionFlowGroups` mutation. */
export type ApproveActionFlowGroupsPayload = {
  __typename?: 'ApproveActionFlowGroupsPayload';
  actionFlowApprovals?: Maybe<Array<ActionFlowApproval>>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `approveActionFlow` mutation. */
export type ApproveActionFlowInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  flowConfigId: Scalars['String']['input'];
  flowConfigVersion: Scalars['Int']['input'];
  groupId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `approveActionFlow` mutation. */
export type ApproveActionFlowPayload = {
  __typename?: 'ApproveActionFlowPayload';
  actionFlowApproval?: Maybe<ActionFlowApproval>;
  /** An edge for our `ActionFlowApproval`. May be used by Relay 1. */
  actionFlowApprovalEdge?: Maybe<ActionFlowApprovalsEdge>;
  /** Reads a single `ActionFlowConfigVersion` that is related to this `ActionFlowApproval`. */
  actionFlowConfigVersionByEnvironmentIdAndFlowConfigIdAndFlowConfigVersion?: Maybe<ActionFlowConfigVersion>;
  /** Reads a single `BusinessUser` that is related to this `ActionFlowApproval`. */
  businessUserByOrganisationIdAndApprovedBy?: Maybe<BusinessUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organisation` that is related to this `ActionFlowApproval`. */
  organisation?: Maybe<Organisation>;
  /** Reads a single `Group` that is related to this `ActionFlowApproval`. */
  organisationGroup?: Maybe<Group>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `approveActionFlow` mutation. */
export type ApproveActionFlowPayloadActionFlowApprovalEdgeArgs = {
  orderBy?: InputMaybe<Array<ActionFlowApprovalsOrderBy>>;
};

/** All input for the `approveCardTemplateGroups` mutation. */
export type ApproveCardTemplateGroupsInput = {
  cardTemplateId: Scalars['String']['input'];
  cardTemplateVersion: Scalars['Int']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** The output of our `approveCardTemplateGroups` mutation. */
export type ApproveCardTemplateGroupsPayload = {
  __typename?: 'ApproveCardTemplateGroupsPayload';
  cardApprovals?: Maybe<Array<CardApproval>>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `approveCardTemplate` mutation. */
export type ApproveCardTemplateInput = {
  cardTemplateId: Scalars['String']['input'];
  cardTemplateVersion: Scalars['Int']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  groupId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `approveCardTemplate` mutation. */
export type ApproveCardTemplatePayload = {
  __typename?: 'ApproveCardTemplatePayload';
  /** Reads a single `BusinessUser` that is related to this `CardApproval`. */
  businessUserByOrganisationIdAndApprovedBy?: Maybe<BusinessUser>;
  cardApproval?: Maybe<CardApproval>;
  /** An edge for our `CardApproval`. May be used by Relay 1. */
  cardApprovalEdge?: Maybe<CardApprovalsEdge>;
  /** Reads a single `CardTemplateVersion` that is related to this `CardApproval`. */
  cardTemplateVersionByEnvironmentIdAndCardTemplateIdAndCardTemplateVersion?: Maybe<CardTemplateVersion>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organisation` that is related to this `CardApproval`. */
  organisation?: Maybe<Organisation>;
  /** Reads a single `Group` that is related to this `CardApproval`. */
  organisationGroup?: Maybe<Group>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `approveCardTemplate` mutation. */
export type ApproveCardTemplatePayloadCardApprovalEdgeArgs = {
  orderBy?: InputMaybe<Array<CardApprovalsOrderBy>>;
};

/** All input for the `archiveActionFlowConfigVersions` mutation. */
export type ArchiveActionFlowConfigVersionsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  flowConfigId: Scalars['String']['input'];
  includeDrafts?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The output of our `archiveActionFlowConfigVersions` mutation. */
export type ArchiveActionFlowConfigVersionsPayload = {
  __typename?: 'ArchiveActionFlowConfigVersionsPayload';
  actionFlowConfigVersion?: Maybe<ActionFlowConfigVersion>;
  /** An edge for our `ActionFlowConfigVersion`. May be used by Relay 1. */
  actionFlowConfigVersionEdge?: Maybe<ActionFlowConfigVersionsEdge>;
  /** Reads a single `BusinessUser` that is related to this `ActionFlowConfigVersion`. */
  businessUserByOrganisationIdAndPublishedBy?: Maybe<BusinessUser>;
  /** Reads a single `BusinessUser` that is related to this `ActionFlowConfigVersion`. */
  businessUserByOrganisationIdAndUpdatedBy?: Maybe<BusinessUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `ActionFlowConfig` that is related to this `ActionFlowConfigVersion`. */
  environmentFlowConfig?: Maybe<ActionFlowConfig>;
  /** Reads a single `Organisation` that is related to this `ActionFlowConfigVersion`. */
  organisation?: Maybe<Organisation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `archiveActionFlowConfigVersions` mutation. */
export type ArchiveActionFlowConfigVersionsPayloadActionFlowConfigVersionEdgeArgs = {
  orderBy?: InputMaybe<Array<ActionFlowConfigVersionsOrderBy>>;
};

/** All input for the `archiveCardTemplateVersions` mutation. */
export type ArchiveCardTemplateVersionsInput = {
  _cardTemplateId: Scalars['String']['input'];
  _environmentId: Scalars['String']['input'];
  _includeDrafts?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `archiveCardTemplateVersions` mutation. */
export type ArchiveCardTemplateVersionsPayload = {
  __typename?: 'ArchiveCardTemplateVersionsPayload';
  /** Reads a single `BusinessUser` that is related to this `CardTemplateVersion`. */
  businessUserByOrganisationIdAndPublishedBy?: Maybe<BusinessUser>;
  /** Reads a single `BusinessUser` that is related to this `CardTemplateVersion`. */
  businessUserByOrganisationIdAndUpdatedBy?: Maybe<BusinessUser>;
  cardTemplateVersion?: Maybe<CardTemplateVersion>;
  /** An edge for our `CardTemplateVersion`. May be used by Relay 1. */
  cardTemplateVersionEdge?: Maybe<CardTemplateVersionsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CardTemplate` that is related to this `CardTemplateVersion`. */
  environmentCardTemplate?: Maybe<CardTemplate>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `archiveCardTemplateVersions` mutation. */
export type ArchiveCardTemplateVersionsPayloadCardTemplateVersionEdgeArgs = {
  orderBy?: InputMaybe<Array<CardTemplateVersionsOrderBy>>;
};

/** All input for the `archiveEventDefinitions` mutation. */
export type ArchiveEventDefinitionsInput = {
  _environmentId: Scalars['String']['input'];
  _eventDefinitionId: Scalars['String']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `archiveEventDefinitions` mutation. */
export type ArchiveEventDefinitionsPayload = {
  __typename?: 'ArchiveEventDefinitionsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type AuditLog = Node & {
  __typename?: 'AuditLog';
  created: Scalars['Datetime']['output'];
  data: Scalars['JSON']['output'];
  email?: Maybe<Scalars['String']['output']>;
  environmentId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  organisationId: Scalars['String']['output'];
  uniqueEmail?: Maybe<Scalars['String']['output']>;
  uniqueName?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `AuditLog` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type AuditLogCondition = {
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organisationId` field. */
  organisationId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `AuditLog` object types. All fields are combined with a logical ‘and.’ */
export type AuditLogFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AuditLogFilter>>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AuditLogFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AuditLogFilter>>;
  /** Filter by the object’s `organisationId` field. */
  organisationId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `uniqueEmail` field. */
  uniqueEmail?: InputMaybe<StringFilter>;
  /** Filter by the object’s `uniqueName` field. */
  uniqueName?: InputMaybe<StringFilter>;
};

export type AuditLogFilters = {
  authType?: InputMaybe<Scalars['String']['input']>;
  environmentId?: InputMaybe<Scalars['String']['input']>;
  resource?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type AuditLogListResponse = {
  __typename?: 'AuditLogListResponse';
  nodes: Array<Maybe<AuditLogNode>>;
  pagination?: Maybe<AuditLogPaginationResponse>;
};

export type AuditLogNode = {
  __typename?: 'AuditLogNode';
  created: Scalars['String']['output'];
  data: Scalars['JSON']['output'];
  email?: Maybe<Scalars['String']['output']>;
  environmentId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  organisationId: Scalars['String']['output'];
};

export type AuditLogPaginationInput = {
  lastId: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
};

export type AuditLogPaginationResponse = {
  __typename?: 'AuditLogPaginationResponse';
  hasNextPage: Scalars['Boolean']['output'];
  lastId: Scalars['String']['output'];
};

/** A connection to a list of `AuditLog` values. */
export type AuditLogsConnection = {
  __typename?: 'AuditLogsConnection';
  /** A list of edges which contains the `AuditLog` and cursor to aid in pagination. */
  edges: Array<AuditLogsEdge>;
  /** A list of `AuditLog` objects. */
  nodes: Array<AuditLog>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AuditLog` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `AuditLog` edge in the connection. */
export type AuditLogsEdge = {
  __typename?: 'AuditLogsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AuditLog` at the end of the edge. */
  node: AuditLog;
};

/** Methods to use when ordering `AuditLog`. */
export enum AuditLogsOrderBy {
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OrganisationIdAsc = 'ORGANISATION_ID_ASC',
  OrganisationIdDesc = 'ORGANISATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type AuthAccount = Node & {
  __typename?: 'AuthAccount';
  /** Reads a single `Account` that is related to this `AuthAccount`. */
  account?: Maybe<Account>;
  accountId: Scalars['Int']['output'];
  appClientId: Scalars['String']['output'];
  created: Scalars['Datetime']['output'];
  email: Scalars['Email']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  sub: Scalars['UUID']['output'];
};

/**
 * A condition to be used against `AuthAccount` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type AuthAccountCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `appClientId` field. */
  appClientId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `sub` field. */
  sub?: InputMaybe<Scalars['UUID']['input']>;
};

/** A filter to be used against `AuthAccount` object types. All fields are combined with a logical ‘and.’ */
export type AuthAccountFilter = {
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AuthAccountFilter>>;
  /** Filter by the object’s `appClientId` field. */
  appClientId?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AuthAccountFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AuthAccountFilter>>;
  /** Filter by the object’s `sub` field. */
  sub?: InputMaybe<UuidFilter>;
};

/** Represents an update to a `AuthAccount`. Fields that are set will be updated. */
export type AuthAccountPatch = {
  appClientId?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `AuthAccount` values. */
export type AuthAccountsConnection = {
  __typename?: 'AuthAccountsConnection';
  /** A list of edges which contains the `AuthAccount` and cursor to aid in pagination. */
  edges: Array<AuthAccountsEdge>;
  /** A list of `AuthAccount` objects. */
  nodes: Array<AuthAccount>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AuthAccount` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `AuthAccount` edge in the connection. */
export type AuthAccountsEdge = {
  __typename?: 'AuthAccountsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AuthAccount` at the end of the edge. */
  node: AuthAccount;
};

/** Methods to use when ordering `AuthAccount`. */
export enum AuthAccountsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  AppClientIdAsc = 'APP_CLIENT_ID_ASC',
  AppClientIdDesc = 'APP_CLIENT_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SubAsc = 'SUB_ASC',
  SubDesc = 'SUB_DESC'
}

/** A filter to be used against BigInt fields. All fields are combined with a logical ‘and.’ */
export type BigIntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['BigInt']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['BigInt']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['BigInt']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['BigInt']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

/** A filter to be used against Boolean fields. All fields are combined with a logical ‘and.’ */
export type BooleanFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/** An action cards business user */
export type BusinessUser = Node & {
  __typename?: 'BusinessUser';
  /** Reads a single `Account` that is related to this `BusinessUser`. */
  account?: Maybe<Account>;
  accountId: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `ActionFlowApprovalRequest`. */
  actionFlowApprovalRequestsByOrganisationIdAndRequestedBy: ActionFlowApprovalRequestsConnection;
  /** Reads and enables pagination through a set of `ActionFlowApproval`. */
  actionFlowApprovalsByOrganisationIdAndApprovedBy: ActionFlowApprovalsConnection;
  /** Reads and enables pagination through a set of `ActionFlowConfigVersion`. */
  actionFlowConfigVersionsByOrganisationIdAndPublishedBy: ActionFlowConfigVersionsConnection;
  /** Reads and enables pagination through a set of `ActionFlowConfigVersion`. */
  actionFlowConfigVersionsByOrganisationIdAndUpdatedBy: ActionFlowConfigVersionsConnection;
  /** Reads and enables pagination through a set of `BusinessUserGroup`. */
  businessUserGroupsByOrganisationIdAndBusinessUserId: BusinessUserGroupsConnection;
  /** Reads and enables pagination through a set of `CardApprovalRequest`. */
  cardApprovalRequestsByOrganisationIdAndRequestedBy: CardApprovalRequestsConnection;
  /** Reads and enables pagination through a set of `CardApproval`. */
  cardApprovalsByOrganisationIdAndApprovedBy: CardApprovalsConnection;
  /** Reads and enables pagination through a set of `CardTemplateVersion`. */
  cardTemplateVersionsByOrganisationIdAndPublishedBy: CardTemplateVersionsConnection;
  /** Reads and enables pagination through a set of `CardTemplateVersion`. */
  cardTemplateVersionsByOrganisationIdAndUpdatedBy: CardTemplateVersionsConnection;
  created: Scalars['Datetime']['output'];
  /** Get account email for an organisation member */
  email?: Maybe<Scalars['String']['output']>;
  /** computed column, end user id */
  endUserId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  inviteExpired?: Maybe<Scalars['Boolean']['output']>;
  inviteMessage?: Maybe<Scalars['String']['output']>;
  inviteSecret: Scalars['String']['output'];
  invitedAt?: Maybe<Scalars['Datetime']['output']>;
  invitedBy?: Maybe<Scalars['Int']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** Id of linked test user for the business user - computed column */
  linkedTestUserId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organisation` that is related to this `BusinessUser`. */
  organisation?: Maybe<Organisation>;
  organisationId: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  preferences: Scalars['JSON']['output'];
  status: BusinessUserStatus;
  /** linked test user for the business user - computed column */
  syncedEndUser?: Maybe<SyncedEndUser>;
  updated: Scalars['Datetime']['output'];
};


/** An action cards business user */
export type BusinessUserActionFlowApprovalRequestsByOrganisationIdAndRequestedByArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ActionFlowApprovalRequestCondition>;
  filter?: InputMaybe<ActionFlowApprovalRequestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActionFlowApprovalRequestsOrderBy>>;
};


/** An action cards business user */
export type BusinessUserActionFlowApprovalsByOrganisationIdAndApprovedByArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ActionFlowApprovalCondition>;
  filter?: InputMaybe<ActionFlowApprovalFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActionFlowApprovalsOrderBy>>;
};


/** An action cards business user */
export type BusinessUserActionFlowConfigVersionsByOrganisationIdAndPublishedByArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ActionFlowConfigVersionCondition>;
  filter?: InputMaybe<ActionFlowConfigVersionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActionFlowConfigVersionsOrderBy>>;
};


/** An action cards business user */
export type BusinessUserActionFlowConfigVersionsByOrganisationIdAndUpdatedByArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ActionFlowConfigVersionCondition>;
  filter?: InputMaybe<ActionFlowConfigVersionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActionFlowConfigVersionsOrderBy>>;
};


/** An action cards business user */
export type BusinessUserBusinessUserGroupsByOrganisationIdAndBusinessUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BusinessUserGroupCondition>;
  filter?: InputMaybe<BusinessUserGroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessUserGroupsOrderBy>>;
};


/** An action cards business user */
export type BusinessUserCardApprovalRequestsByOrganisationIdAndRequestedByArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CardApprovalRequestCondition>;
  filter?: InputMaybe<CardApprovalRequestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CardApprovalRequestsOrderBy>>;
};


/** An action cards business user */
export type BusinessUserCardApprovalsByOrganisationIdAndApprovedByArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CardApprovalCondition>;
  filter?: InputMaybe<CardApprovalFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CardApprovalsOrderBy>>;
};


/** An action cards business user */
export type BusinessUserCardTemplateVersionsByOrganisationIdAndPublishedByArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CardTemplateVersionCondition>;
  filter?: InputMaybe<CardTemplateVersionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CardTemplateVersionsOrderBy>>;
};


/** An action cards business user */
export type BusinessUserCardTemplateVersionsByOrganisationIdAndUpdatedByArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CardTemplateVersionCondition>;
  filter?: InputMaybe<CardTemplateVersionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CardTemplateVersionsOrderBy>>;
};


/** An action cards business user */
export type BusinessUserSyncedEndUserArgs = {
  environmentId: Scalars['String']['input'];
};

export type BusinessUserAccount = {
  __typename?: 'BusinessUserAccount';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `BusinessUser` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BusinessUserCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `firstName` field. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `inviteSecret` field. */
  inviteSecret?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organisationId` field. */
  organisationId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<BusinessUserStatus>;
};

/** A filter to be used against `BusinessUser` object types. All fields are combined with a logical ‘and.’ */
export type BusinessUserFilter = {
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BusinessUserFilter>>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>;
  /** Filter by the object’s `endUserId` field. */
  endUserId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `firstName` field. */
  firstName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `inviteExpired` field. */
  inviteExpired?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `inviteSecret` field. */
  inviteSecret?: InputMaybe<StringFilter>;
  /** Filter by the object’s `linkedTestUserId` field. */
  linkedTestUserId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BusinessUserFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BusinessUserFilter>>;
  /** Filter by the object’s `organisationId` field. */
  organisationId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<BusinessUserStatusFilter>;
};

export type BusinessUserGroup = Node & {
  __typename?: 'BusinessUserGroup';
  businessUserId: Scalars['String']['output'];
  groupId: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organisation` that is related to this `BusinessUserGroup`. */
  organisation?: Maybe<Organisation>;
  /** Reads a single `BusinessUser` that is related to this `BusinessUserGroup`. */
  organisationBusinessUser?: Maybe<BusinessUser>;
  /** Reads a single `Group` that is related to this `BusinessUserGroup`. */
  organisationGroup?: Maybe<Group>;
  organisationId: Scalars['String']['output'];
};

/**
 * A condition to be used against `BusinessUserGroup` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BusinessUserGroupCondition = {
  /** Checks for equality with the object’s `organisationId` field. */
  organisationId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `BusinessUserGroup` object types. All fields are combined with a logical ‘and.’ */
export type BusinessUserGroupFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BusinessUserGroupFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<BusinessUserGroupFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BusinessUserGroupFilter>>;
  /** Filter by the object’s `organisationId` field. */
  organisationId?: InputMaybe<StringFilter>;
};

/** A connection to a list of `BusinessUserGroup` values. */
export type BusinessUserGroupsConnection = {
  __typename?: 'BusinessUserGroupsConnection';
  /** A list of edges which contains the `BusinessUserGroup` and cursor to aid in pagination. */
  edges: Array<BusinessUserGroupsEdge>;
  /** A list of `BusinessUserGroup` objects. */
  nodes: Array<BusinessUserGroup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BusinessUserGroup` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `BusinessUserGroup` edge in the connection. */
export type BusinessUserGroupsEdge = {
  __typename?: 'BusinessUserGroupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BusinessUserGroup` at the end of the edge. */
  node: BusinessUserGroup;
};

/** Methods to use when ordering `BusinessUserGroup`. */
export enum BusinessUserGroupsOrderBy {
  Natural = 'NATURAL',
  OrganisationIdAsc = 'ORGANISATION_ID_ASC',
  OrganisationIdDesc = 'ORGANISATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** An input for mutations affecting `BusinessUser` */
export type BusinessUserInput = {
  accountId: Scalars['Int']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  inviteMessage?: InputMaybe<Scalars['String']['input']>;
  invitedBy?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organisationId: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<BusinessUserStatus>;
};

/** Represents an update to a `BusinessUser`. Fields that are set will be updated. */
export type BusinessUserPatch = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  inviteMessage?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  preferences?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<BusinessUserStatus>;
};

export enum BusinessUserStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Invited = 'INVITED',
  InviteCancelled = 'INVITE_CANCELLED'
}

/** A filter to be used against BusinessUserStatus fields. All fields are combined with a logical ‘and.’ */
export type BusinessUserStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<BusinessUserStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<BusinessUserStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<BusinessUserStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<BusinessUserStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<BusinessUserStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<BusinessUserStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<BusinessUserStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<BusinessUserStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<BusinessUserStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<BusinessUserStatus>>;
};

/** A connection to a list of `BusinessUser` values. */
export type BusinessUsersConnection = {
  __typename?: 'BusinessUsersConnection';
  /** A list of edges which contains the `BusinessUser` and cursor to aid in pagination. */
  edges: Array<BusinessUsersEdge>;
  /** A list of `BusinessUser` objects. */
  nodes: Array<BusinessUser>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BusinessUser` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `BusinessUser` edge in the connection. */
export type BusinessUsersEdge = {
  __typename?: 'BusinessUsersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BusinessUser` at the end of the edge. */
  node: BusinessUser;
};

/** Methods to use when ordering `BusinessUser`. */
export enum BusinessUsersOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  FirstNameAsc = 'FIRST_NAME_ASC',
  FirstNameDesc = 'FIRST_NAME_DESC',
  InviteSecretAsc = 'INVITE_SECRET_ASC',
  InviteSecretDesc = 'INVITE_SECRET_DESC',
  Natural = 'NATURAL',
  OrganisationIdAsc = 'ORGANISATION_ID_ASC',
  OrganisationIdDesc = 'ORGANISATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC'
}

export type CardApproval = Node & {
  __typename?: 'CardApproval';
  approvedBy?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `BusinessUser` that is related to this `CardApproval`. */
  businessUserByOrganisationIdAndApprovedBy?: Maybe<BusinessUser>;
  cardTemplateId: Scalars['String']['output'];
  cardTemplateVersion: Scalars['Int']['output'];
  /** Reads a single `CardTemplateVersion` that is related to this `CardApproval`. */
  cardTemplateVersionByEnvironmentIdAndCardTemplateIdAndCardTemplateVersion?: Maybe<CardTemplateVersion>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  environmentId: Scalars['String']['output'];
  groupId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organisation` that is related to this `CardApproval`. */
  organisation?: Maybe<Organisation>;
  /** Reads a single `Group` that is related to this `CardApproval`. */
  organisationGroup?: Maybe<Group>;
  organisationId: Scalars['String']['output'];
};

/**
 * A condition to be used against `CardApproval` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CardApprovalCondition = {
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `organisationId` field. */
  organisationId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `CardApproval` object types. All fields are combined with a logical ‘and.’ */
export type CardApprovalFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CardApprovalFilter>>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CardApprovalFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CardApprovalFilter>>;
  /** Filter by the object’s `organisationId` field. */
  organisationId?: InputMaybe<StringFilter>;
};

export type CardApprovalRequest = Node & {
  __typename?: 'CardApprovalRequest';
  /** Reads a single `BusinessUser` that is related to this `CardApprovalRequest`. */
  businessUserByOrganisationIdAndRequestedBy?: Maybe<BusinessUser>;
  cardTemplateId: Scalars['String']['output'];
  cardTemplateVersion: Scalars['Int']['output'];
  /** Reads a single `CardTemplateVersion` that is related to this `CardApprovalRequest`. */
  cardTemplateVersionByEnvironmentIdAndCardTemplateIdAndCardTemplateVersion?: Maybe<CardTemplateVersion>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  environmentId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organisation` that is related to this `CardApprovalRequest`. */
  organisation?: Maybe<Organisation>;
  organisationId: Scalars['String']['output'];
  requestedBy?: Maybe<Scalars['Int']['output']>;
};

/**
 * A condition to be used against `CardApprovalRequest` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type CardApprovalRequestCondition = {
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `organisationId` field. */
  organisationId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `CardApprovalRequest` object types. All fields are combined with a logical ‘and.’ */
export type CardApprovalRequestFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CardApprovalRequestFilter>>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CardApprovalRequestFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CardApprovalRequestFilter>>;
  /** Filter by the object’s `organisationId` field. */
  organisationId?: InputMaybe<StringFilter>;
};

/** A connection to a list of `CardApprovalRequest` values. */
export type CardApprovalRequestsConnection = {
  __typename?: 'CardApprovalRequestsConnection';
  /** A list of edges which contains the `CardApprovalRequest` and cursor to aid in pagination. */
  edges: Array<CardApprovalRequestsEdge>;
  /** A list of `CardApprovalRequest` objects. */
  nodes: Array<CardApprovalRequest>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CardApprovalRequest` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CardApprovalRequest` edge in the connection. */
export type CardApprovalRequestsEdge = {
  __typename?: 'CardApprovalRequestsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CardApprovalRequest` at the end of the edge. */
  node: CardApprovalRequest;
};

/** Methods to use when ordering `CardApprovalRequest`. */
export enum CardApprovalRequestsOrderBy {
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OrganisationIdAsc = 'ORGANISATION_ID_ASC',
  OrganisationIdDesc = 'ORGANISATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A connection to a list of `CardApproval` values. */
export type CardApprovalsConnection = {
  __typename?: 'CardApprovalsConnection';
  /** A list of edges which contains the `CardApproval` and cursor to aid in pagination. */
  edges: Array<CardApprovalsEdge>;
  /** A list of `CardApproval` objects. */
  nodes: Array<CardApproval>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CardApproval` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CardApproval` edge in the connection. */
export type CardApprovalsEdge = {
  __typename?: 'CardApprovalsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CardApproval` at the end of the edge. */
  node: CardApproval;
};

/** Methods to use when ordering `CardApproval`. */
export enum CardApprovalsOrderBy {
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OrganisationIdAsc = 'ORGANISATION_ID_ASC',
  OrganisationIdDesc = 'ORGANISATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type CardCancelProgressInput = {
  environmentId: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
  tasks: Array<InputMaybe<CardCancelProgressTaskInput>>;
};

export type CardCancelProgressResult = {
  __typename?: 'CardCancelProgressResult';
  environmentId: Scalars['String']['output'];
  organisationId: Scalars['String']['output'];
  tasks: Array<Maybe<CardCancelProgressTaskOutput>>;
};

export type CardCancelProgressTaskInput = {
  expectedCardCount?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
  status: CardCancelStatus;
};

export type CardCancelProgressTaskOutput = {
  __typename?: 'CardCancelProgressTaskOutput';
  cancelledCardCount?: Maybe<Scalars['Int']['output']>;
  expectedCardCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  status: CardCancelStatus;
};

export enum CardCancelStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Retry = 'RETRY'
}

export type CardCancelTask = Node & {
  __typename?: 'CardCancelTask';
  cancelledCardCount: Scalars['Int']['output'];
  clientId?: Maybe<Scalars['String']['output']>;
  clientIdName?: Maybe<Scalars['String']['output']>;
  created: Scalars['Datetime']['output'];
  criteria: Scalars['JSON']['output'];
  environmentId: Scalars['String']['output'];
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  expectedCardCount?: Maybe<Scalars['Int']['output']>;
  finishedProcessingAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  organisationId: Scalars['String']['output'];
  remainingCardRecords?: Maybe<Scalars['JSON']['output']>;
  startedProcessingAt?: Maybe<Scalars['Datetime']['output']>;
  status: CardCancelStatus;
  triggeredBy?: Maybe<Scalars['Int']['output']>;
  triggeredByDisplay?: Maybe<Scalars['String']['output']>;
  triggeredByName?: Maybe<Scalars['String']['output']>;
  updated: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `CardCancelTask` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CardCancelTaskCondition = {
  /** Checks for equality with the object’s `created` field. */
  created?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `CardCancelTask` object types. All fields are combined with a logical ‘and.’ */
export type CardCancelTaskFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CardCancelTaskFilter>>;
  /** Filter by the object’s `clientIdName` field. */
  clientIdName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CardCancelTaskFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CardCancelTaskFilter>>;
  /** Filter by the object’s `triggeredByDisplay` field. */
  triggeredByDisplay?: InputMaybe<StringFilter>;
  /** Filter by the object’s `triggeredByName` field. */
  triggeredByName?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `CardCancelTask` */
export type CardCancelTaskInput = {
  criteria: Scalars['JSON']['input'];
  environmentId: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
  remainingCardRecords?: InputMaybe<Scalars['JSON']['input']>;
};

/** A connection to a list of `CardCancelTask` values. */
export type CardCancelTasksConnection = {
  __typename?: 'CardCancelTasksConnection';
  /** A list of edges which contains the `CardCancelTask` and cursor to aid in pagination. */
  edges: Array<CardCancelTasksEdge>;
  /** A list of `CardCancelTask` objects. */
  nodes: Array<CardCancelTask>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CardCancelTask` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CardCancelTask` edge in the connection. */
export type CardCancelTasksEdge = {
  __typename?: 'CardCancelTasksEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CardCancelTask` at the end of the edge. */
  node: CardCancelTask;
};

/** Methods to use when ordering `CardCancelTask`. */
export enum CardCancelTasksOrderBy {
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** Subset of card instance accessible to the workbench */
export type CardInstance = {
  __typename?: 'CardInstance';
  cardTemplateId?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['Datetime']['output']>;
  endUserId?: Maybe<Scalars['String']['output']>;
  environmentId?: Maybe<Scalars['String']['output']>;
  eventName?: Maybe<Scalars['String']['output']>;
  eventSource?: Maybe<EventSource>;
  lifecycleId?: Maybe<Scalars['String']['output']>;
  published?: Maybe<Scalars['Datetime']['output']>;
  state?: Maybe<Scalars['JSON']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  streamId?: Maybe<Scalars['String']['output']>;
  streamIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updated?: Maybe<Scalars['Datetime']['output']>;
};

/** A connection to a list of `CardInstance` values. */
export type CardInstancesConnection = {
  __typename?: 'CardInstancesConnection';
  /** A list of edges which contains the `CardInstance` and cursor to aid in pagination. */
  edges: Array<CardInstancesEdge>;
  /** A list of `CardInstance` objects. */
  nodes: Array<CardInstance>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CardInstance` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CardInstance` edge in the connection. */
export type CardInstancesEdge = {
  __typename?: 'CardInstancesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CardInstance` at the end of the edge. */
  node: CardInstance;
};

export type CardListCondition = {
  environmentId: Scalars['String']['input'];
};

export type CardListResponse = {
  __typename?: 'CardListResponse';
  totalCount: Scalars['Int']['output'];
};

/** Card layout and behaviour details */
export type CardTemplate = Node & {
  __typename?: 'CardTemplate';
  analytics?: Maybe<Scalars['JSON']['output']>;
  /** Computed column, most recent archived card_template_version */
  archivedVersion?: Maybe<CardTemplateVersion>;
  /** Display a generated name if name isn't set */
  cardName?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `CardTemplateVersion`. */
  cardTemplateVersionsByEnvironmentIdAndCardTemplateId: CardTemplateVersionsConnection;
  created: Scalars['Datetime']['output'];
  currentStatus?: Maybe<CardTemplateStatus>;
  /** Computed column, most recent card_template_version */
  currentVersion?: Maybe<CardTemplateVersion>;
  /** Computed column, card name from definition */
  currentVersionName?: Maybe<Scalars['String']['output']>;
  /** Computed column, draft status - DRAFT, PENDING, APPROVED, NA */
  draftStatus?: Maybe<CardTemplateDraftStatus>;
  /** Retrieves current active draft, if any */
  draftVersion?: Maybe<CardTemplateVersion>;
  /** Determines version number for the current draft, whether created or not */
  draftVersionNumber?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `Environment` that is related to this `CardTemplate`. */
  environment?: Maybe<Environment>;
  /** Reads a single `ActionFlowConfig` that is related to this `CardTemplate`. */
  environmentFlowConfig?: Maybe<ActionFlowConfig>;
  environmentId: Scalars['String']['output'];
  flowConfigId: Scalars['String']['output'];
  /** Computed column, true if we have archived versions */
  hasArchivedVersions?: Maybe<Scalars['Boolean']['output']>;
  /** Computed column, true if we have a dirty draft version  */
  hasDirtyDraft?: Maybe<Scalars['Boolean']['output']>;
  /** Computed column, true if we have published versions */
  hasPublishedVersions?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  /** @deprecated Computed column use versionLastUpdatedDesc instead */
  lastUpdated?: Maybe<Scalars['Datetime']['output']>;
  /** Computed column, returned the latest submitted approval request */
  latestApprovalRequest?: Maybe<CardApprovalRequest>;
  /** Computed column, wrapper to sort by approval request created */
  latestApprovalRequestCreated?: Maybe<Scalars['Datetime']['output']>;
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organisation` that is related to this `CardTemplate`. */
  organisation?: Maybe<Organisation>;
  /** Reads a single `Environment` that is related to this `CardTemplate`. */
  organisationEnvironment?: Maybe<Environment>;
  organisationId: Scalars['String']['output'];
  /** Computed column, most recent published card_template_version */
  publishedVersion?: Maybe<CardTemplateVersion>;
  /** Computed column, wrapper to sort by published version updated */
  publishedVersionUpdated?: Maybe<Scalars['Datetime']['output']>;
  /** @deprecated Computed column use currentStatus instead */
  status?: Maybe<CardTemplateStatus>;
  updated: Scalars['Datetime']['output'];
  versionLastUpdated?: Maybe<Scalars['Datetime']['output']>;
};


/** Card layout and behaviour details */
export type CardTemplateCardTemplateVersionsByEnvironmentIdAndCardTemplateIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CardTemplateVersionCondition>;
  filter?: InputMaybe<CardTemplateVersionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CardTemplateVersionsOrderBy>>;
};

/**
 * A condition to be used against `CardTemplate` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CardTemplateCondition = {
  /** Checks for equality with the object’s `currentStatus` field. */
  currentStatus?: InputMaybe<CardTemplateStatus>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organisationId` field. */
  organisationId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updated` field. */
  updated?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `versionLastUpdated` field. */
  versionLastUpdated?: InputMaybe<Scalars['Datetime']['input']>;
};

export enum CardTemplateDraftStatus {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  Na = 'NA',
  Pending = 'PENDING'
}

/** A filter to be used against CardTemplateDraftStatus fields. All fields are combined with a logical ‘and.’ */
export type CardTemplateDraftStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<CardTemplateDraftStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<CardTemplateDraftStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<CardTemplateDraftStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<CardTemplateDraftStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<CardTemplateDraftStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<CardTemplateDraftStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<CardTemplateDraftStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<CardTemplateDraftStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<CardTemplateDraftStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<CardTemplateDraftStatus>>;
};

/** A filter to be used against `CardTemplate` object types. All fields are combined with a logical ‘and.’ */
export type CardTemplateFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CardTemplateFilter>>;
  /** Filter by the object’s `cardName` field. */
  cardName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `currentStatus` field. */
  currentStatus?: InputMaybe<CardTemplateStatusFilter>;
  /** Filter by the object’s `currentVersionName` field. */
  currentVersionName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `draftStatus` field. */
  draftStatus?: InputMaybe<CardTemplateDraftStatusFilter>;
  /** Filter by the object’s `draftVersionNumber` field. */
  draftVersionNumber?: InputMaybe<IntFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `hasArchivedVersions` field. */
  hasArchivedVersions?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `hasDirtyDraft` field. */
  hasDirtyDraft?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `hasPublishedVersions` field. */
  hasPublishedVersions?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `lastUpdated` field. */
  lastUpdated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `latestApprovalRequestCreated` field. */
  latestApprovalRequestCreated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CardTemplateFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CardTemplateFilter>>;
  /** Filter by the object’s `organisationId` field. */
  organisationId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `publishedVersionUpdated` field. */
  publishedVersionUpdated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<CardTemplateStatusFilter>;
  /** Filter by the object’s `updated` field. */
  updated?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `versionLastUpdated` field. */
  versionLastUpdated?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `CardTemplate` */
export type CardTemplateInput = {
  environmentId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  organisationId: Scalars['String']['input'];
};

/** Represents an update to a `CardTemplate`. Fields that are set will be updated. */
export type CardTemplatePatch = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum CardTemplateStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

/** A `CardTemplateStatusCountsRecord` edge in the connection. */
export type CardTemplateStatusCountEdge = {
  __typename?: 'CardTemplateStatusCountEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CardTemplateStatusCountsRecord` at the end of the edge. */
  node: CardTemplateStatusCountsRecord;
};

/** A connection to a list of `CardTemplateStatusCountsRecord` values. */
export type CardTemplateStatusCountsConnection = {
  __typename?: 'CardTemplateStatusCountsConnection';
  /** A list of edges which contains the `CardTemplateStatusCountsRecord` and cursor to aid in pagination. */
  edges: Array<CardTemplateStatusCountEdge>;
  /** A list of `CardTemplateStatusCountsRecord` objects. */
  nodes: Array<CardTemplateStatusCountsRecord>;
  /** The count of *all* `CardTemplateStatusCountsRecord` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** The return type of our `cardTemplateStatusCounts` query. */
export type CardTemplateStatusCountsRecord = {
  __typename?: 'CardTemplateStatusCountsRecord';
  count?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<CardTemplateDraftStatus>;
};

/** A filter to be used against `CardTemplateStatusCountsRecord` object types. All fields are combined with a logical ‘and.’ */
export type CardTemplateStatusCountsRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CardTemplateStatusCountsRecordFilter>>;
  /** Filter by the object’s `count` field. */
  count?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CardTemplateStatusCountsRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CardTemplateStatusCountsRecordFilter>>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<CardTemplateDraftStatusFilter>;
};

/** A filter to be used against CardTemplateStatus fields. All fields are combined with a logical ‘and.’ */
export type CardTemplateStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<CardTemplateStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<CardTemplateStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<CardTemplateStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<CardTemplateStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<CardTemplateStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<CardTemplateStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<CardTemplateStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<CardTemplateStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<CardTemplateStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<CardTemplateStatus>>;
};

/** A version of a card template - immutable if published */
export type CardTemplateVersion = Node & {
  __typename?: 'CardTemplateVersion';
  /** computed column, count of approvals to date */
  approvalCount?: Maybe<Scalars['Int']['output']>;
  approvalGroups?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** computed column, true if approvals are required, card hasn't been approved and an approval has been logged */
  approvalPending?: Maybe<Scalars['Boolean']['output']>;
  /** computed column, array of groups that are yet to approve this card template */
  approvalPendingGroups?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** computed column, true if an approval request has been made for this card template, and approvals are required */
  approvalRequested?: Maybe<Scalars['Boolean']['output']>;
  /** computed column, date of first approval request */
  approvalRequestedAt?: Maybe<Scalars['Datetime']['output']>;
  /** computed column, number of approvals required */
  approvalRequiredCount?: Maybe<Scalars['Int']['output']>;
  /** computed column, connection to groups a business member must belong to in order to approve card templates */
  approvalRequiredGroups: GroupsConnection;
  /** computed column, true if card template approvals are enabled via configuration */
  approvalsEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Reads a single `BusinessUser` that is related to this `CardTemplateVersion`. */
  businessUserByOrganisationIdAndPublishedBy?: Maybe<BusinessUser>;
  /** Reads a single `BusinessUser` that is related to this `CardTemplateVersion`. */
  businessUserByOrganisationIdAndUpdatedBy?: Maybe<BusinessUser>;
  /** computed column, true if user is able to approve card, based on group memberships */
  canApprove?: Maybe<Scalars['Boolean']['output']>;
  /** Reads and enables pagination through a set of `CardApprovalRequest`. */
  cardApprovalRequestsByEnvironmentIdAndCardTemplateIdAndCardTemplateVersion: CardApprovalRequestsConnection;
  /** Reads and enables pagination through a set of `CardApproval`. */
  cardApprovalsByEnvironmentIdAndCardTemplateIdAndCardTemplateVersion: CardApprovalsConnection;
  /** Display parents name, name is generated if not explicity set */
  cardName?: Maybe<Scalars['String']['output']>;
  cardTemplateId: Scalars['String']['output'];
  created: Scalars['Datetime']['output'];
  definition: Scalars['JSON']['output'];
  dirty?: Maybe<Scalars['Boolean']['output']>;
  /** Computed column, drafts of published cards without edits show as published */
  displayStatus?: Maybe<CardTemplateStatus>;
  /** Computed column, only return the draft version number there if it's dirty otherwise display published version */
  displayVersion?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use definition.metadata.delivery.embargo instead. */
  embargo?: Maybe<Scalars['Datetime']['output']>;
  /** Reads a single `CardTemplate` that is related to this `CardTemplateVersion`. */
  environmentCardTemplate?: Maybe<CardTemplate>;
  environmentId: Scalars['String']['output'];
  /** @deprecated Use definition.metadata.delivery.expires instead. */
  expires?: Maybe<Scalars['Datetime']['output']>;
  /** @deprecated Use definition.metadata.delivery.expires_interval instead. */
  expiresInterval?: Maybe<Interval>;
  /** computed column, true if card is approved */
  isApproved?: Maybe<Scalars['Boolean']['output']>;
  metadata: Scalars['JSON']['output'];
  /** computed column, intersection of approval groups with users group membership, or all groups if an approver admin */
  myApprovalGroups: GroupsConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  organisationId: Scalars['String']['output'];
  publishedBy?: Maybe<Scalars['Int']['output']>;
  publishedPeriod?: Maybe<DatetimeRange>;
  status: CardTemplateStatus;
  sysPeriod: DatetimeRange;
  testData: Scalars['JSON']['output'];
  /** Reads and enables pagination through a set of `TriggerEvent`. */
  triggerEventsByEnvironmentIdAndCardTemplateIdAndCardTemplateVersion: TriggerEventsConnection;
  updated: Scalars['Datetime']['output'];
  updatedBy?: Maybe<Scalars['Int']['output']>;
  version: Scalars['Int']['output'];
};


/** A version of a card template - immutable if published */
export type CardTemplateVersionApprovalRequiredGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<GroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** A version of a card template - immutable if published */
export type CardTemplateVersionCardApprovalRequestsByEnvironmentIdAndCardTemplateIdAndCardTemplateVersionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CardApprovalRequestCondition>;
  filter?: InputMaybe<CardApprovalRequestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CardApprovalRequestsOrderBy>>;
};


/** A version of a card template - immutable if published */
export type CardTemplateVersionCardApprovalsByEnvironmentIdAndCardTemplateIdAndCardTemplateVersionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CardApprovalCondition>;
  filter?: InputMaybe<CardApprovalFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CardApprovalsOrderBy>>;
};


/** A version of a card template - immutable if published */
export type CardTemplateVersionMyApprovalGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<GroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** A version of a card template - immutable if published */
export type CardTemplateVersionTriggerEventsByEnvironmentIdAndCardTemplateIdAndCardTemplateVersionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TriggerEventCondition>;
  filter?: InputMaybe<TriggerEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TriggerEventsOrderBy>>;
};

/**
 * A condition to be used against `CardTemplateVersion` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type CardTemplateVersionCondition = {
  /** Checks for equality with the object’s `cardTemplateId` field. */
  cardTemplateId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organisationId` field. */
  organisationId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<CardTemplateStatus>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `version` field. */
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `CardTemplateVersion` object types. All fields are combined with a logical ‘and.’ */
export type CardTemplateVersionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CardTemplateVersionFilter>>;
  /** Filter by the object’s `approvalCount` field. */
  approvalCount?: InputMaybe<IntFilter>;
  /** Filter by the object’s `approvalGroups` field. */
  approvalGroups?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `approvalPending` field. */
  approvalPending?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `approvalPendingGroups` field. */
  approvalPendingGroups?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `approvalRequested` field. */
  approvalRequested?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `approvalRequestedAt` field. */
  approvalRequestedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `approvalRequiredCount` field. */
  approvalRequiredCount?: InputMaybe<IntFilter>;
  /** Filter by the object’s `approvalsEnabled` field. */
  approvalsEnabled?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `canApprove` field. */
  canApprove?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `cardName` field. */
  cardName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `cardTemplateId` field. */
  cardTemplateId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `displayStatus` field. */
  displayStatus?: InputMaybe<CardTemplateStatusFilter>;
  /** Filter by the object’s `displayVersion` field. */
  displayVersion?: InputMaybe<IntFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `isApproved` field. */
  isApproved?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CardTemplateVersionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CardTemplateVersionFilter>>;
  /** Filter by the object’s `organisationId` field. */
  organisationId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<CardTemplateStatusFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `version` field. */
  version?: InputMaybe<IntFilter>;
};

/** A connection to a list of `CardTemplateVersionHistory` values. */
export type CardTemplateVersionHistoriesConnection = {
  __typename?: 'CardTemplateVersionHistoriesConnection';
  /** A list of edges which contains the `CardTemplateVersionHistory` and cursor to aid in pagination. */
  edges: Array<CardTemplateVersionHistoriesEdge>;
  /** A list of `CardTemplateVersionHistory` objects. */
  nodes: Array<CardTemplateVersionHistory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CardTemplateVersionHistory` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CardTemplateVersionHistory` edge in the connection. */
export type CardTemplateVersionHistoriesEdge = {
  __typename?: 'CardTemplateVersionHistoriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CardTemplateVersionHistory` at the end of the edge. */
  node: CardTemplateVersionHistory;
};

/** Methods to use when ordering `CardTemplateVersionHistory`. */
export enum CardTemplateVersionHistoriesOrderBy {
  CardTemplateIdAsc = 'CARD_TEMPLATE_ID_ASC',
  CardTemplateIdDesc = 'CARD_TEMPLATE_ID_DESC',
  Natural = 'NATURAL',
  OrganisationIdAsc = 'ORGANISATION_ID_ASC',
  OrganisationIdDesc = 'ORGANISATION_ID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  SysPeriodAsc = 'SYS_PERIOD_ASC',
  SysPeriodDesc = 'SYS_PERIOD_DESC',
  VersionAsc = 'VERSION_ASC',
  VersionDesc = 'VERSION_DESC'
}

export type CardTemplateVersionHistory = {
  __typename?: 'CardTemplateVersionHistory';
  cardTemplateId: Scalars['String']['output'];
  created: Scalars['Datetime']['output'];
  definition: Scalars['JSON']['output'];
  dirty?: Maybe<Scalars['Boolean']['output']>;
  embargo?: Maybe<Scalars['Datetime']['output']>;
  environmentId: Scalars['String']['output'];
  expires?: Maybe<Scalars['Datetime']['output']>;
  expiresInterval?: Maybe<Interval>;
  metadata: Scalars['JSON']['output'];
  organisationId: Scalars['String']['output'];
  publishedBy?: Maybe<Scalars['Int']['output']>;
  publishedPeriod?: Maybe<DatetimeRange>;
  status: CardTemplateStatus;
  sysPeriod: DatetimeRange;
  testData: Scalars['JSON']['output'];
  updated: Scalars['Datetime']['output'];
  updatedBy?: Maybe<Scalars['Int']['output']>;
  version: Scalars['Int']['output'];
};

/**
 * A condition to be used against `CardTemplateVersionHistory` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type CardTemplateVersionHistoryCondition = {
  /** Checks for equality with the object’s `cardTemplateId` field. */
  cardTemplateId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organisationId` field. */
  organisationId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<CardTemplateStatus>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
  /** Checks for equality with the object’s `version` field. */
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** A filter to be used against `CardTemplateVersionHistory` object types. All fields are combined with a logical ‘and.’ */
export type CardTemplateVersionHistoryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CardTemplateVersionHistoryFilter>>;
  /** Filter by the object’s `cardTemplateId` field. */
  cardTemplateId?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CardTemplateVersionHistoryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CardTemplateVersionHistoryFilter>>;
  /** Filter by the object’s `organisationId` field. */
  organisationId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<CardTemplateStatusFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
  /** Filter by the object’s `version` field. */
  version?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `CardTemplateVersion` */
export type CardTemplateVersionInput = {
  cardTemplateId: Scalars['String']['input'];
  definition?: InputMaybe<Scalars['JSON']['input']>;
  dirty?: InputMaybe<Scalars['Boolean']['input']>;
  embargo?: InputMaybe<Scalars['Datetime']['input']>;
  environmentId: Scalars['String']['input'];
  expires?: InputMaybe<Scalars['Datetime']['input']>;
  expiresInterval?: InputMaybe<IntervalInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  organisationId: Scalars['String']['input'];
  status?: InputMaybe<CardTemplateStatus>;
  testData?: InputMaybe<Scalars['JSON']['input']>;
  version: Scalars['Int']['input'];
};

/** Represents an update to a `CardTemplateVersion`. Fields that are set will be updated. */
export type CardTemplateVersionPatch = {
  definition?: InputMaybe<Scalars['JSON']['input']>;
  dirty?: InputMaybe<Scalars['Boolean']['input']>;
  embargo?: InputMaybe<Scalars['Datetime']['input']>;
  expires?: InputMaybe<Scalars['Datetime']['input']>;
  expiresInterval?: InputMaybe<IntervalInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<CardTemplateStatus>;
  testData?: InputMaybe<Scalars['JSON']['input']>;
};

/** A connection to a list of `CardTemplateVersionWithHistory` values. */
export type CardTemplateVersionWithHistoriesConnection = {
  __typename?: 'CardTemplateVersionWithHistoriesConnection';
  /** A list of edges which contains the `CardTemplateVersionWithHistory` and cursor to aid in pagination. */
  edges: Array<CardTemplateVersionWithHistoriesEdge>;
  /** A list of `CardTemplateVersionWithHistory` objects. */
  nodes: Array<CardTemplateVersionWithHistory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CardTemplateVersionWithHistory` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CardTemplateVersionWithHistory` edge in the connection. */
export type CardTemplateVersionWithHistoriesEdge = {
  __typename?: 'CardTemplateVersionWithHistoriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CardTemplateVersionWithHistory` at the end of the edge. */
  node: CardTemplateVersionWithHistory;
};

/** Methods to use when ordering `CardTemplateVersionWithHistory`. */
export enum CardTemplateVersionWithHistoriesOrderBy {
  Natural = 'NATURAL'
}

export type CardTemplateVersionWithHistory = {
  __typename?: 'CardTemplateVersionWithHistory';
  cardTemplateId?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['Datetime']['output']>;
  definition?: Maybe<Scalars['JSON']['output']>;
  dirty?: Maybe<Scalars['Boolean']['output']>;
  embargo?: Maybe<Scalars['Datetime']['output']>;
  environmentId?: Maybe<Scalars['String']['output']>;
  expires?: Maybe<Scalars['Datetime']['output']>;
  expiresInterval?: Maybe<Interval>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  organisationId?: Maybe<Scalars['String']['output']>;
  publishedBy?: Maybe<Scalars['Int']['output']>;
  publishedPeriod?: Maybe<DatetimeRange>;
  status?: Maybe<CardTemplateStatus>;
  sysPeriod?: Maybe<DatetimeRange>;
  testData?: Maybe<Scalars['JSON']['output']>;
  updated?: Maybe<Scalars['Datetime']['output']>;
  updatedBy?: Maybe<Scalars['Int']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

/** A connection to a list of `CardTemplateVersion` values. */
export type CardTemplateVersionsConnection = {
  __typename?: 'CardTemplateVersionsConnection';
  /** A list of edges which contains the `CardTemplateVersion` and cursor to aid in pagination. */
  edges: Array<CardTemplateVersionsEdge>;
  /** A list of `CardTemplateVersion` objects. */
  nodes: Array<CardTemplateVersion>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CardTemplateVersion` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CardTemplateVersion` edge in the connection. */
export type CardTemplateVersionsEdge = {
  __typename?: 'CardTemplateVersionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CardTemplateVersion` at the end of the edge. */
  node: CardTemplateVersion;
};

/** Methods to use when ordering `CardTemplateVersion`. */
export enum CardTemplateVersionsOrderBy {
  CardTemplateIdAsc = 'CARD_TEMPLATE_ID_ASC',
  CardTemplateIdDesc = 'CARD_TEMPLATE_ID_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  Natural = 'NATURAL',
  OrganisationIdAsc = 'ORGANISATION_ID_ASC',
  OrganisationIdDesc = 'ORGANISATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  SysPeriodAsc = 'SYS_PERIOD_ASC',
  SysPeriodDesc = 'SYS_PERIOD_DESC',
  VersionAsc = 'VERSION_ASC',
  VersionDesc = 'VERSION_DESC'
}

/** A connection to a list of `CardTemplate` values. */
export type CardTemplatesConnection = {
  __typename?: 'CardTemplatesConnection';
  /** A list of edges which contains the `CardTemplate` and cursor to aid in pagination. */
  edges: Array<CardTemplatesEdge>;
  /** A list of `CardTemplate` objects. */
  nodes: Array<CardTemplate>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CardTemplate` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CardTemplate` edge in the connection. */
export type CardTemplatesEdge = {
  __typename?: 'CardTemplatesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CardTemplate` at the end of the edge. */
  node: CardTemplate;
};

/** Methods to use when ordering `CardTemplate`. */
export enum CardTemplatesOrderBy {
  CurrentStatusAsc = 'CURRENT_STATUS_ASC',
  CurrentStatusDesc = 'CURRENT_STATUS_DESC',
  CurrentVersionNameAsc = 'CURRENT_VERSION_NAME_ASC',
  CurrentVersionNameDesc = 'CURRENT_VERSION_NAME_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  LastUpdatedAsc = 'LAST_UPDATED_ASC',
  LastUpdatedDesc = 'LAST_UPDATED_DESC',
  LatestApprovalRequestCreatedAsc = 'LATEST_APPROVAL_REQUEST_CREATED_ASC',
  LatestApprovalRequestCreatedDesc = 'LATEST_APPROVAL_REQUEST_CREATED_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  OrganisationIdAsc = 'ORGANISATION_ID_ASC',
  OrganisationIdDesc = 'ORGANISATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  PublishedVersionUpdatedAsc = 'PUBLISHED_VERSION_UPDATED_ASC',
  PublishedVersionUpdatedDesc = 'PUBLISHED_VERSION_UPDATED_DESC',
  UpdatedAsc = 'UPDATED_ASC',
  UpdatedDesc = 'UPDATED_DESC',
  VersionLastUpdatedAsc = 'VERSION_LAST_UPDATED_ASC',
  VersionLastUpdatedDesc = 'VERSION_LAST_UPDATED_DESC'
}

/** A public key / API key pair used to authorise the client with a stream_container */
export type ClientKey = Node & {
  __typename?: 'ClientKey';
  activeKeyType: ClientKeyType;
  apiKey: Scalars['String']['output'];
  created: Scalars['Datetime']['output'];
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** Reads a single `Environment` that is related to this `ClientKey`. */
  environment?: Maybe<Environment>;
  environmentId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  issuerWhitelist?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  jwks?: Maybe<Scalars['JSON']['output']>;
  maxExpiryDays?: Maybe<Scalars['Int']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  organisationId: Scalars['String']['output'];
  profileMapping?: Maybe<Scalars['JSON']['output']>;
  publicKey?: Maybe<Scalars['String']['output']>;
  updated: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `ClientKey` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ClientKeyCondition = {
  /** Checks for equality with the object’s `apiKey` field. */
  apiKey?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updated` field. */
  updated?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `ClientKey` object types. All fields are combined with a logical ‘and.’ */
export type ClientKeyFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ClientKeyFilter>>;
  /** Filter by the object’s `apiKey` field. */
  apiKey?: InputMaybe<StringFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ClientKeyFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ClientKeyFilter>>;
  /** Filter by the object’s `updated` field. */
  updated?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `ClientKey` */
export type ClientKeyInput = {
  activeKeyType?: InputMaybe<ClientKeyType>;
  apiKey: Scalars['String']['input'];
  environmentId: Scalars['String']['input'];
  issuerWhitelist?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  jwks?: InputMaybe<Scalars['JSON']['input']>;
  maxExpiryDays?: InputMaybe<Scalars['Int']['input']>;
  profileMapping?: InputMaybe<Scalars['JSON']['input']>;
  publicKey?: InputMaybe<Scalars['String']['input']>;
};

/** Represents an update to a `ClientKey`. Fields that are set will be updated. */
export type ClientKeyPatch = {
  activeKeyType?: InputMaybe<ClientKeyType>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  issuerWhitelist?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  jwks?: InputMaybe<Scalars['JSON']['input']>;
  maxExpiryDays?: InputMaybe<Scalars['Int']['input']>;
  profileMapping?: InputMaybe<Scalars['JSON']['input']>;
  publicKey?: InputMaybe<Scalars['String']['input']>;
};

export enum ClientKeyType {
  Jwks = 'JWKS',
  PublicKey = 'PUBLIC_KEY'
}

/** A connection to a list of `ClientKey` values. */
export type ClientKeysConnection = {
  __typename?: 'ClientKeysConnection';
  /** A list of edges which contains the `ClientKey` and cursor to aid in pagination. */
  edges: Array<ClientKeysEdge>;
  /** A list of `ClientKey` objects. */
  nodes: Array<ClientKey>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ClientKey` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ClientKey` edge in the connection. */
export type ClientKeysEdge = {
  __typename?: 'ClientKeysEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ClientKey` at the end of the edge. */
  node: ClientKey;
};

/** Methods to use when ordering `ClientKey`. */
export enum ClientKeysOrderBy {
  ApiKeyAsc = 'API_KEY_ASC',
  ApiKeyDesc = 'API_KEY_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAsc = 'UPDATED_ASC',
  UpdatedDesc = 'UPDATED_DESC'
}

export type Condition = {
  condition: Scalars['String']['input'];
  field: Scalars['String']['input'];
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export enum ConditionOperator {
  Equals = 'EQUALS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanEqual = 'GREATER_THAN_EQUAL',
  GreaterThanEqualInterval = 'GREATER_THAN_EQUAL_INTERVAL',
  GreaterThanFutureInterval = 'GREATER_THAN_FUTURE_INTERVAL',
  GreaterThanInterval = 'GREATER_THAN_INTERVAL',
  IsEmpty = 'IS_EMPTY',
  LessThan = 'LESS_THAN',
  LessThanEqual = 'LESS_THAN_EQUAL',
  LessThanEqualInterval = 'LESS_THAN_EQUAL_INTERVAL',
  LessThanFutureInterval = 'LESS_THAN_FUTURE_INTERVAL',
  LessThanInterval = 'LESS_THAN_INTERVAL',
  NotEmpty = 'NOT_EMPTY',
  NotEquals = 'NOT_EQUALS',
  NotOneOf = 'NOT_ONE_OF',
  NotRegexMatch = 'NOT_REGEX_MATCH',
  OneOf = 'ONE_OF',
  RegexMatch = 'REGEX_MATCH',
  WithinFutureInterval = 'WITHIN_FUTURE_INTERVAL'
}

export enum ConnectorMode {
  Disabled = 'DISABLED',
  Live = 'LIVE',
  Paused = 'PAUSED',
  Test = 'TEST'
}

export type ConnectorRuntime = Node & {
  __typename?: 'ConnectorRuntime';
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  /** Reads a single `Environment` that is related to this `ConnectorRuntime`. */
  environment?: Maybe<Environment>;
  /** Reads a single `ActionFlowConfig` that is related to this `ConnectorRuntime`. */
  environmentFlowConfig?: Maybe<ActionFlowConfig>;
  environmentId: Scalars['String']['output'];
  flowConfigId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastCapturedSample?: Maybe<Scalars['JSON']['output']>;
  mode: ConnectorMode;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  refreshSample: Scalars['Boolean']['output'];
  secret: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
};

/**
 * A condition to be used against `ConnectorRuntime` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ConnectorRuntimeCondition = {
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `ConnectorRuntime` object types. All fields are combined with a logical ‘and.’ */
export type ConnectorRuntimeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ConnectorRuntimeFilter>>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ConnectorRuntimeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ConnectorRuntimeFilter>>;
};

/** An input for mutations affecting `ConnectorRuntime` */
export type ConnectorRuntimeInput = {
  environmentId: Scalars['String']['input'];
  flowConfigId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  mode?: InputMaybe<ConnectorMode>;
  refreshSample?: InputMaybe<Scalars['Boolean']['input']>;
  secret?: InputMaybe<Scalars['String']['input']>;
};

/** Represents an update to a `ConnectorRuntime`. Fields that are set will be updated. */
export type ConnectorRuntimePatch = {
  mode?: InputMaybe<ConnectorMode>;
  refreshSample?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A connection to a list of `ConnectorRuntime` values. */
export type ConnectorRuntimesConnection = {
  __typename?: 'ConnectorRuntimesConnection';
  /** A list of edges which contains the `ConnectorRuntime` and cursor to aid in pagination. */
  edges: Array<ConnectorRuntimesEdge>;
  /** A list of `ConnectorRuntime` objects. */
  nodes: Array<ConnectorRuntime>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ConnectorRuntime` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ConnectorRuntime` edge in the connection. */
export type ConnectorRuntimesEdge = {
  __typename?: 'ConnectorRuntimesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ConnectorRuntime` at the end of the edge. */
  node: ConnectorRuntime;
};

/** Methods to use when ordering `ConnectorRuntime`. */
export enum ConnectorRuntimesOrderBy {
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** All input for the `copyCardTemplateEvents` mutation. */
export type CopyCardTemplateEventsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fromVersion: CardTemplateVersionInput;
  toVersion: CardTemplateVersionInput;
};

/** The output of our `copyCardTemplateEvents` mutation. */
export type CopyCardTemplateEventsPayload = {
  __typename?: 'CopyCardTemplateEventsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  triggerEvents?: Maybe<Array<TriggerEvent>>;
};

export type CreateActionFlowShareLinkInput = {
  environmentId: Scalars['String']['input'];
  flowConfigId: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
};

/** All input for the create `BusinessUser` mutation. */
export type CreateBusinessUserInput = {
  /** The `BusinessUser` to be created by this mutation. */
  businessUser: BusinessUserInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `BusinessUser` mutation. */
export type CreateBusinessUserPayload = {
  __typename?: 'CreateBusinessUserPayload';
  /** Reads a single `Account` that is related to this `BusinessUser`. */
  account?: Maybe<Account>;
  /** The `BusinessUser` that was created by this mutation. */
  businessUser?: Maybe<BusinessUser>;
  /** An edge for our `BusinessUser`. May be used by Relay 1. */
  businessUserEdge?: Maybe<BusinessUsersEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organisation` that is related to this `BusinessUser`. */
  organisation?: Maybe<Organisation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `BusinessUser` mutation. */
export type CreateBusinessUserPayloadBusinessUserEdgeArgs = {
  orderBy?: InputMaybe<Array<BusinessUsersOrderBy>>;
};

/** All input for the create `CardCancelTask` mutation. */
export type CreateCardCancelTaskInput = {
  /** The `CardCancelTask` to be created by this mutation. */
  cardCancelTask: CardCancelTaskInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `CardCancelTask` mutation. */
export type CreateCardCancelTaskPayload = {
  __typename?: 'CreateCardCancelTaskPayload';
  /** The `CardCancelTask` that was created by this mutation. */
  cardCancelTask?: Maybe<CardCancelTask>;
  /** An edge for our `CardCancelTask`. May be used by Relay 1. */
  cardCancelTaskEdge?: Maybe<CardCancelTasksEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CardCancelTask` mutation. */
export type CreateCardCancelTaskPayloadCardCancelTaskEdgeArgs = {
  orderBy?: InputMaybe<Array<CardCancelTasksOrderBy>>;
};

/** All input for the create `CardTemplate` mutation. */
export type CreateCardTemplateInput = {
  /** The `CardTemplate` to be created by this mutation. */
  cardTemplate: CardTemplateInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `CardTemplate` mutation. */
export type CreateCardTemplatePayload = {
  __typename?: 'CreateCardTemplatePayload';
  /** The `CardTemplate` that was created by this mutation. */
  cardTemplate?: Maybe<CardTemplate>;
  /** An edge for our `CardTemplate`. May be used by Relay 1. */
  cardTemplateEdge?: Maybe<CardTemplatesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Environment` that is related to this `CardTemplate`. */
  environment?: Maybe<Environment>;
  /** Reads a single `ActionFlowConfig` that is related to this `CardTemplate`. */
  environmentFlowConfig?: Maybe<ActionFlowConfig>;
  /** Reads a single `Organisation` that is related to this `CardTemplate`. */
  organisation?: Maybe<Organisation>;
  /** Reads a single `Environment` that is related to this `CardTemplate`. */
  organisationEnvironment?: Maybe<Environment>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CardTemplate` mutation. */
export type CreateCardTemplatePayloadCardTemplateEdgeArgs = {
  orderBy?: InputMaybe<Array<CardTemplatesOrderBy>>;
};

/** All input for the create `CardTemplateVersion` mutation. */
export type CreateCardTemplateVersionInput = {
  /** The `CardTemplateVersion` to be created by this mutation. */
  cardTemplateVersion: CardTemplateVersionInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `CardTemplateVersion` mutation. */
export type CreateCardTemplateVersionPayload = {
  __typename?: 'CreateCardTemplateVersionPayload';
  /** Reads a single `BusinessUser` that is related to this `CardTemplateVersion`. */
  businessUserByOrganisationIdAndPublishedBy?: Maybe<BusinessUser>;
  /** Reads a single `BusinessUser` that is related to this `CardTemplateVersion`. */
  businessUserByOrganisationIdAndUpdatedBy?: Maybe<BusinessUser>;
  /** The `CardTemplateVersion` that was created by this mutation. */
  cardTemplateVersion?: Maybe<CardTemplateVersion>;
  /** An edge for our `CardTemplateVersion`. May be used by Relay 1. */
  cardTemplateVersionEdge?: Maybe<CardTemplateVersionsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CardTemplate` that is related to this `CardTemplateVersion`. */
  environmentCardTemplate?: Maybe<CardTemplate>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CardTemplateVersion` mutation. */
export type CreateCardTemplateVersionPayloadCardTemplateVersionEdgeArgs = {
  orderBy?: InputMaybe<Array<CardTemplateVersionsOrderBy>>;
};

/** All input for the create `ClientKey` mutation. */
export type CreateClientKeyInput = {
  /** The `ClientKey` to be created by this mutation. */
  clientKey: ClientKeyInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `ClientKey` mutation. */
export type CreateClientKeyPayload = {
  __typename?: 'CreateClientKeyPayload';
  /** The `ClientKey` that was created by this mutation. */
  clientKey?: Maybe<ClientKey>;
  /** An edge for our `ClientKey`. May be used by Relay 1. */
  clientKeyEdge?: Maybe<ClientKeysEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Environment` that is related to this `ClientKey`. */
  environment?: Maybe<Environment>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ClientKey` mutation. */
export type CreateClientKeyPayloadClientKeyEdgeArgs = {
  orderBy?: InputMaybe<Array<ClientKeysOrderBy>>;
};

/** All input for the create `ConnectorRuntime` mutation. */
export type CreateConnectorRuntimeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ConnectorRuntime` to be created by this mutation. */
  connectorRuntime: ConnectorRuntimeInput;
};

/** The output of our create `ConnectorRuntime` mutation. */
export type CreateConnectorRuntimePayload = {
  __typename?: 'CreateConnectorRuntimePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `ConnectorRuntime` that was created by this mutation. */
  connectorRuntime?: Maybe<ConnectorRuntime>;
  /** An edge for our `ConnectorRuntime`. May be used by Relay 1. */
  connectorRuntimeEdge?: Maybe<ConnectorRuntimesEdge>;
  /** Reads a single `Environment` that is related to this `ConnectorRuntime`. */
  environment?: Maybe<Environment>;
  /** Reads a single `ActionFlowConfig` that is related to this `ConnectorRuntime`. */
  environmentFlowConfig?: Maybe<ActionFlowConfig>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ConnectorRuntime` mutation. */
export type CreateConnectorRuntimePayloadConnectorRuntimeEdgeArgs = {
  orderBy?: InputMaybe<Array<ConnectorRuntimesOrderBy>>;
};

/** All input for the create `CsvUploadTask` mutation. */
export type CreateCsvUploadTaskInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `CsvUploadTask` to be created by this mutation. */
  csvUploadTask: CsvUploadTaskInput;
};

/** The output of our create `CsvUploadTask` mutation. */
export type CreateCsvUploadTaskPayload = {
  __typename?: 'CreateCsvUploadTaskPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `CsvUploadTask` that was created by this mutation. */
  csvUploadTask?: Maybe<CsvUploadTask>;
  /** An edge for our `CsvUploadTask`. May be used by Relay 1. */
  csvUploadTaskEdge?: Maybe<CsvUploadTasksEdge>;
  /** Reads a single `Organisation` that is related to this `CsvUploadTask`. */
  organisation?: Maybe<Organisation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CsvUploadTask` mutation. */
export type CreateCsvUploadTaskPayloadCsvUploadTaskEdgeArgs = {
  orderBy?: InputMaybe<Array<CsvUploadTasksOrderBy>>;
};

/** All input for the create `CustomRole` mutation. */
export type CreateCustomRoleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `CustomRole` to be created by this mutation. */
  customRole: CustomRoleInput;
};

/** The output of our create `CustomRole` mutation. */
export type CreateCustomRolePayload = {
  __typename?: 'CreateCustomRolePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `CustomRole` that was created by this mutation. */
  customRole?: Maybe<CustomRole>;
  /** An edge for our `CustomRole`. May be used by Relay 1. */
  customRoleEdge?: Maybe<CustomRolesEdge>;
  /** Reads a single `Organisation` that is related to this `CustomRole`. */
  organisation?: Maybe<Organisation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `CustomRole` mutation. */
export type CreateCustomRolePayloadCustomRoleEdgeArgs = {
  orderBy?: InputMaybe<Array<CustomRolesOrderBy>>;
};

/** All input for the create `EndUserSegment` mutation. */
export type CreateEndUserSegmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `EndUserSegment` to be created by this mutation. */
  endUserSegment: EndUserSegmentInput;
};

/** The output of our create `EndUserSegment` mutation. */
export type CreateEndUserSegmentPayload = {
  __typename?: 'CreateEndUserSegmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `EndUserSegment` that was created by this mutation. */
  endUserSegment?: Maybe<EndUserSegment>;
  /** An edge for our `EndUserSegment`. May be used by Relay 1. */
  endUserSegmentEdge?: Maybe<EndUserSegmentsEdge>;
  /** Reads a single `Environment` that is related to this `EndUserSegment`. */
  environment?: Maybe<Environment>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `EndUserSegment` mutation. */
export type CreateEndUserSegmentPayloadEndUserSegmentEdgeArgs = {
  orderBy?: InputMaybe<Array<EndUserSegmentsOrderBy>>;
};

/** All input for the `createEnvironment` mutation. */
export type CreateEnvironmentInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
};

/** The output of our `createEnvironment` mutation. */
export type CreateEnvironmentPayload = {
  __typename?: 'CreateEnvironmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  environment?: Maybe<Environment>;
  /** An edge for our `Environment`. May be used by Relay 1. */
  environmentEdge?: Maybe<EnvironmentsEdge>;
  /** Reads a single `Organisation` that is related to this `Environment`. */
  organisation?: Maybe<Organisation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `createEnvironment` mutation. */
export type CreateEnvironmentPayloadEnvironmentEdgeArgs = {
  orderBy?: InputMaybe<Array<EnvironmentsOrderBy>>;
};

/** All input for the create `EventDefinition` mutation. */
export type CreateEventDefinitionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `EventDefinition` to be created by this mutation. */
  eventDefinition: EventDefinitionInput;
};

/** The output of our create `EventDefinition` mutation. */
export type CreateEventDefinitionPayload = {
  __typename?: 'CreateEventDefinitionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Environment` that is related to this `EventDefinition`. */
  environment?: Maybe<Environment>;
  /** The `EventDefinition` that was created by this mutation. */
  eventDefinition?: Maybe<EventDefinition>;
  /** An edge for our `EventDefinition`. May be used by Relay 1. */
  eventDefinitionEdge?: Maybe<EventDefinitionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `EventDefinition` mutation. */
export type CreateEventDefinitionPayloadEventDefinitionEdgeArgs = {
  orderBy?: InputMaybe<Array<EventDefinitionsOrderBy>>;
};

/** All input for the create `EventDefinitionVersion` mutation. */
export type CreateEventDefinitionVersionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `EventDefinitionVersion` to be created by this mutation. */
  eventDefinitionVersion: EventDefinitionVersionInput;
};

/** The output of our create `EventDefinitionVersion` mutation. */
export type CreateEventDefinitionVersionPayload = {
  __typename?: 'CreateEventDefinitionVersionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `EventDefinition` that is related to this `EventDefinitionVersion`. */
  environmentEventDefinition?: Maybe<EventDefinition>;
  /** The `EventDefinitionVersion` that was created by this mutation. */
  eventDefinitionVersion?: Maybe<EventDefinitionVersion>;
  /** An edge for our `EventDefinitionVersion`. May be used by Relay 1. */
  eventDefinitionVersionEdge?: Maybe<EventDefinitionVersionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `EventDefinitionVersion` mutation. */
export type CreateEventDefinitionVersionPayloadEventDefinitionVersionEdgeArgs = {
  orderBy?: InputMaybe<Array<EventDefinitionVersionsOrderBy>>;
};

/** All input for the create `Grant` mutation. */
export type CreateGrantInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Grant` to be created by this mutation. */
  grant: GrantInput;
};

/** The output of our create `Grant` mutation. */
export type CreateGrantPayload = {
  __typename?: 'CreateGrantPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Environment` that is related to this `Grant`. */
  environment?: Maybe<Environment>;
  /** The `Grant` that was created by this mutation. */
  grant?: Maybe<Grant>;
  /** An edge for our `Grant`. May be used by Relay 1. */
  grantEdge?: Maybe<GrantsEdge>;
  /** Reads a single `Organisation` that is related to this `Grant`. */
  organisation?: Maybe<Organisation>;
  /** Reads a single `Group` that is related to this `Grant`. */
  organisationGroup?: Maybe<Group>;
  /** Reads a single `CustomRole` that is related to this `Grant`. */
  organisationRole?: Maybe<CustomRole>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Grant` mutation. */
export type CreateGrantPayloadGrantEdgeArgs = {
  orderBy?: InputMaybe<Array<GrantsOrderBy>>;
};

/** All input for the create `Group` mutation. */
export type CreateGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Group` to be created by this mutation. */
  group: GroupInput;
};

/** The output of our create `Group` mutation. */
export type CreateGroupPayload = {
  __typename?: 'CreateGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Group` that was created by this mutation. */
  group?: Maybe<Group>;
  /** An edge for our `Group`. May be used by Relay 1. */
  groupEdge?: Maybe<GroupsEdge>;
  /** Reads a single `Organisation` that is related to this `Group`. */
  organisation?: Maybe<Organisation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Group` mutation. */
export type CreateGroupPayloadGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};

/** All input for the create `InsightsReport` mutation. */
export type CreateInsightsReportInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `InsightsReport` to be created by this mutation. */
  insightsReport: InsightsReportInput;
};

/** The output of our create `InsightsReport` mutation. */
export type CreateInsightsReportPayload = {
  __typename?: 'CreateInsightsReportPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Environment` that is related to this `InsightsReport`. */
  environment?: Maybe<Environment>;
  /** The `InsightsReport` that was created by this mutation. */
  insightsReport?: Maybe<InsightsReport>;
  /** An edge for our `InsightsReport`. May be used by Relay 1. */
  insightsReportEdge?: Maybe<InsightsReportsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `InsightsReport` mutation. */
export type CreateInsightsReportPayloadInsightsReportEdgeArgs = {
  orderBy?: InputMaybe<Array<InsightsReportsOrderBy>>;
};

/** All input for the create `IntegrationConfiguration` mutation. */
export type CreateIntegrationConfigurationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `IntegrationConfiguration` to be created by this mutation. */
  integrationConfiguration: IntegrationConfigurationInput;
};

/** The output of our create `IntegrationConfiguration` mutation. */
export type CreateIntegrationConfigurationPayload = {
  __typename?: 'CreateIntegrationConfigurationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `IntegrationConfiguration` that was created by this mutation. */
  integrationConfiguration?: Maybe<IntegrationConfiguration>;
  /** An edge for our `IntegrationConfiguration`. May be used by Relay 1. */
  integrationConfigurationEdge?: Maybe<IntegrationConfigurationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `IntegrationConfiguration` mutation. */
export type CreateIntegrationConfigurationPayloadIntegrationConfigurationEdgeArgs = {
  orderBy?: InputMaybe<Array<IntegrationConfigurationsOrderBy>>;
};

export type CreateMarketoIntegrationConfigurationInput = {
  enabled: Scalars['Boolean']['input'];
  environmentId: Scalars['String']['input'];
  integrationType: IntegrationType;
  name: Scalars['String']['input'];
};

export type CreateMarketoIntegrationConfigurationPayload = {
  __typename?: 'CreateMarketoIntegrationConfigurationPayload';
  integrationConfiguration?: Maybe<MarketoIntegrationConfiguration>;
};

/** All input for the create `ResourceUser` mutation. */
export type CreateResourceUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ResourceUser` to be created by this mutation. */
  resourceUser: ResourceUserInput;
};

/** The output of our create `ResourceUser` mutation. */
export type CreateResourceUserPayload = {
  __typename?: 'CreateResourceUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `ResourceUser` that was created by this mutation. */
  resourceUser?: Maybe<ResourceUser>;
  /** An edge for our `ResourceUser`. May be used by Relay 1. */
  resourceUserEdge?: Maybe<ResourceUsersEdge>;
};


/** The output of our create `ResourceUser` mutation. */
export type CreateResourceUserPayloadResourceUserEdgeArgs = {
  orderBy?: InputMaybe<Array<ResourceUsersOrderBy>>;
};

/** All input for the create `RolePermission` mutation. */
export type CreateRolePermissionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `RolePermission` to be created by this mutation. */
  rolePermission: RolePermissionInput;
};

/** The output of our create `RolePermission` mutation. */
export type CreateRolePermissionPayload = {
  __typename?: 'CreateRolePermissionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organisation` that is related to this `RolePermission`. */
  organisation?: Maybe<Organisation>;
  /** Reads a single `CustomRole` that is related to this `RolePermission`. */
  organisationRole?: Maybe<CustomRole>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RolePermission` that was created by this mutation. */
  rolePermission?: Maybe<RolePermission>;
  /** An edge for our `RolePermission`. May be used by Relay 1. */
  rolePermissionEdge?: Maybe<RolePermissionsEdge>;
};


/** The output of our create `RolePermission` mutation. */
export type CreateRolePermissionPayloadRolePermissionEdgeArgs = {
  orderBy?: InputMaybe<Array<RolePermissionsOrderBy>>;
};

/** All input for the create `StreamContainer` mutation. */
export type CreateStreamContainerInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `StreamContainer` to be created by this mutation. */
  streamContainer: StreamContainerInput;
};

/** The output of our create `StreamContainer` mutation. */
export type CreateStreamContainerPayload = {
  __typename?: 'CreateStreamContainerPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Theme` that is related to this `StreamContainer`. */
  environmentDarkTheme?: Maybe<Theme>;
  /** Reads a single `Stream` that is related to this `StreamContainer`. */
  environmentStream?: Maybe<Stream>;
  /** Reads a single `Theme` that is related to this `StreamContainer`. */
  environmentTheme?: Maybe<Theme>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `StreamContainer` that was created by this mutation. */
  streamContainer?: Maybe<StreamContainer>;
  /** An edge for our `StreamContainer`. May be used by Relay 1. */
  streamContainerEdge?: Maybe<StreamContainersEdge>;
};


/** The output of our create `StreamContainer` mutation. */
export type CreateStreamContainerPayloadStreamContainerEdgeArgs = {
  orderBy?: InputMaybe<Array<StreamContainersOrderBy>>;
};

/** All input for the create `Stream` mutation. */
export type CreateStreamInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Stream` to be created by this mutation. */
  stream: StreamInput;
};

/** The output of our create `Stream` mutation. */
export type CreateStreamPayload = {
  __typename?: 'CreateStreamPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Environment` that is related to this `Stream`. */
  environment?: Maybe<Environment>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Stream` that was created by this mutation. */
  stream?: Maybe<Stream>;
  /** An edge for our `Stream`. May be used by Relay 1. */
  streamEdge?: Maybe<StreamsEdge>;
};


/** The output of our create `Stream` mutation. */
export type CreateStreamPayloadStreamEdgeArgs = {
  orderBy?: InputMaybe<Array<StreamsOrderBy>>;
};

/** All input for the create `Tag` mutation. */
export type CreateTagInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Tag` to be created by this mutation. */
  tag: TagInput;
};

/** The output of our create `Tag` mutation. */
export type CreateTagPayload = {
  __typename?: 'CreateTagPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Environment` that is related to this `Tag`. */
  environment?: Maybe<Environment>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Tag` that was created by this mutation. */
  tag?: Maybe<Tag>;
  /** An edge for our `Tag`. May be used by Relay 1. */
  tagEdge?: Maybe<TagsEdge>;
};


/** The output of our create `Tag` mutation. */
export type CreateTagPayloadTagEdgeArgs = {
  orderBy?: InputMaybe<Array<TagsOrderBy>>;
};

export type CreateTestEndUserEndUser = {
  __typename?: 'CreateTestEndUserEndUser';
  environmentId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  nickname: Scalars['String']['output'];
};

export type CreateTestEndUserResponse = {
  __typename?: 'CreateTestEndUserResponse';
  endUser: CreateTestEndUserEndUser;
};

/** All input for the create `Theme` mutation. */
export type CreateThemeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `Theme` to be created by this mutation. */
  theme: ThemeInput;
};

/** The output of our create `Theme` mutation. */
export type CreateThemePayload = {
  __typename?: 'CreateThemePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Environment` that is related to this `Theme`. */
  environment?: Maybe<Environment>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Theme` that was created by this mutation. */
  theme?: Maybe<Theme>;
  /** An edge for our `Theme`. May be used by Relay 1. */
  themeEdge?: Maybe<ThemesEdge>;
};


/** The output of our create `Theme` mutation. */
export type CreateThemePayloadThemeEdgeArgs = {
  orderBy?: InputMaybe<Array<ThemesOrderBy>>;
};

/** All input for the create `TriggerEvent` mutation. */
export type CreateTriggerEventInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `TriggerEvent` to be created by this mutation. */
  triggerEvent: TriggerEventInput;
};

/** The output of our create `TriggerEvent` mutation. */
export type CreateTriggerEventPayload = {
  __typename?: 'CreateTriggerEventPayload';
  /** Reads a single `ActionFlowConfigVersion` that is related to this `TriggerEvent`. */
  actionFlowConfigVersionByEnvironmentIdAndFlowConfigIdAndFlowConfigVersion?: Maybe<ActionFlowConfigVersion>;
  /** Reads a single `CardTemplateVersion` that is related to this `TriggerEvent`. */
  cardTemplateVersionByEnvironmentIdAndCardTemplateIdAndCardTemplateVersion?: Maybe<CardTemplateVersion>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Environment` that is related to this `TriggerEvent`. */
  environment?: Maybe<Environment>;
  /** Reads a single `Stream` that is related to this `TriggerEvent`. */
  environmentStream?: Maybe<Stream>;
  /** Reads a single `EventDefinitionVersion` that is related to this `TriggerEvent`. */
  eventDefinitionVersionByEnvironmentIdAndEventDefinitionIdAndEventDefinitionVersion?: Maybe<EventDefinitionVersion>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TriggerEvent` that was created by this mutation. */
  triggerEvent?: Maybe<TriggerEvent>;
  /** An edge for our `TriggerEvent`. May be used by Relay 1. */
  triggerEventEdge?: Maybe<TriggerEventsEdge>;
};


/** The output of our create `TriggerEvent` mutation. */
export type CreateTriggerEventPayloadTriggerEventEdgeArgs = {
  orderBy?: InputMaybe<Array<TriggerEventsOrderBy>>;
};

/** All input for the create `WebhookCredential` mutation. */
export type CreateWebhookCredentialInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `WebhookCredential` to be created by this mutation. */
  webhookCredential: WebhookCredentialInput;
};

/** The output of our create `WebhookCredential` mutation. */
export type CreateWebhookCredentialPayload = {
  __typename?: 'CreateWebhookCredentialPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Environment` that is related to this `WebhookCredential`. */
  environment?: Maybe<Environment>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `WebhookCredential` that was created by this mutation. */
  webhookCredential?: Maybe<WebhookCredential>;
  /** An edge for our `WebhookCredential`. May be used by Relay 1. */
  webhookCredentialEdge?: Maybe<WebhookCredentialsEdge>;
};


/** The output of our create `WebhookCredential` mutation. */
export type CreateWebhookCredentialPayloadWebhookCredentialEdgeArgs = {
  orderBy?: InputMaybe<Array<WebhookCredentialsOrderBy>>;
};

/** All input for the create `WebhookEndpoint` mutation. */
export type CreateWebhookEndpointInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `WebhookEndpoint` to be created by this mutation. */
  webhookEndpoint: WebhookEndpointInput;
};

/** The output of our create `WebhookEndpoint` mutation. */
export type CreateWebhookEndpointPayload = {
  __typename?: 'CreateWebhookEndpointPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Environment` that is related to this `WebhookEndpoint`. */
  environment?: Maybe<Environment>;
  /** Reads a single `WebhookCredential` that is related to this `WebhookEndpoint`. */
  environmentWebhookCredential?: Maybe<WebhookCredential>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `WebhookEndpoint` that was created by this mutation. */
  webhookEndpoint?: Maybe<WebhookEndpoint>;
  /** An edge for our `WebhookEndpoint`. May be used by Relay 1. */
  webhookEndpointEdge?: Maybe<WebhookEndpointsEdge>;
};


/** The output of our create `WebhookEndpoint` mutation. */
export type CreateWebhookEndpointPayloadWebhookEndpointEdgeArgs = {
  orderBy?: InputMaybe<Array<WebhookEndpointsOrderBy>>;
};

/** All input for the create `WorkbenchFolder` mutation. */
export type CreateWorkbenchFolderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `WorkbenchFolder` to be created by this mutation. */
  workbenchFolder: WorkbenchFolderInput;
};

/** The output of our create `WorkbenchFolder` mutation. */
export type CreateWorkbenchFolderPayload = {
  __typename?: 'CreateWorkbenchFolderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Environment` that is related to this `WorkbenchFolder`. */
  environment?: Maybe<Environment>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `WorkbenchFolder` that was created by this mutation. */
  workbenchFolder?: Maybe<WorkbenchFolder>;
  /** An edge for our `WorkbenchFolder`. May be used by Relay 1. */
  workbenchFolderEdge?: Maybe<WorkbenchFoldersEdge>;
};


/** The output of our create `WorkbenchFolder` mutation. */
export type CreateWorkbenchFolderPayloadWorkbenchFolderEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkbenchFoldersOrderBy>>;
};

export enum CredentialRole {
  Auth = 'AUTH',
  Events = 'EVENTS',
  Workbench = 'WORKBENCH'
}

export enum CsvUploadStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

/** A filter to be used against CsvUploadStatus fields. All fields are combined with a logical ‘and.’ */
export type CsvUploadStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<CsvUploadStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<CsvUploadStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<CsvUploadStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<CsvUploadStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<CsvUploadStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<CsvUploadStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<CsvUploadStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<CsvUploadStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<CsvUploadStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<CsvUploadStatus>>;
};

/** Processing status of a customer CSV import or AF CSV batch send */
export type CsvUploadTask = Node & {
  __typename?: 'CsvUploadTask';
  created: Scalars['Datetime']['output'];
  environmentId: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  /** Filename that is stores in S3 */
  filenameKey: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isTest: Scalars['Boolean']['output'];
  metadata: Scalars['JSON']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organisation` that is related to this `CsvUploadTask`. */
  organisation?: Maybe<Organisation>;
  organisationId: Scalars['String']['output'];
  processFrom?: Maybe<Scalars['Datetime']['output']>;
  processTo?: Maybe<Scalars['Datetime']['output']>;
  /** Number of rows that have been processed. */
  processedRowCount: Scalars['Int']['output'];
  rowCount: Scalars['Int']['output'];
  status: CsvUploadStatus;
  taskType: CsvUploadTaskType;
  updated: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `CsvUploadTask` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CsvUploadTaskCondition = {
  /** Checks for equality with the object’s `created` field. */
  created?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `organisationId` field. */
  organisationId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<CsvUploadStatus>;
  /** Checks for equality with the object’s `taskType` field. */
  taskType?: InputMaybe<CsvUploadTaskType>;
};

/** A filter to be used against `CsvUploadTask` object types. All fields are combined with a logical ‘and.’ */
export type CsvUploadTaskFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CsvUploadTaskFilter>>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CsvUploadTaskFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CsvUploadTaskFilter>>;
  /** Filter by the object’s `organisationId` field. */
  organisationId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<CsvUploadStatusFilter>;
  /** Filter by the object’s `taskType` field. */
  taskType?: InputMaybe<CsvUploadTaskTypeFilter>;
};

/** An input for mutations affecting `CsvUploadTask` */
export type CsvUploadTaskInput = {
  environmentId: Scalars['String']['input'];
  filename?: InputMaybe<Scalars['String']['input']>;
  /** Filename that is stores in S3 */
  filenameKey?: InputMaybe<Scalars['String']['input']>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  organisationId: Scalars['String']['input'];
  rowCount?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<CsvUploadStatus>;
  taskType?: InputMaybe<CsvUploadTaskType>;
};

export enum CsvUploadTaskType {
  AfBulkSend = 'AF_BULK_SEND',
  CustomerImport = 'CUSTOMER_IMPORT'
}

/** A filter to be used against CsvUploadTaskType fields. All fields are combined with a logical ‘and.’ */
export type CsvUploadTaskTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<CsvUploadTaskType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<CsvUploadTaskType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<CsvUploadTaskType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<CsvUploadTaskType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<CsvUploadTaskType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<CsvUploadTaskType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<CsvUploadTaskType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<CsvUploadTaskType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<CsvUploadTaskType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<CsvUploadTaskType>>;
};

/** A connection to a list of `CsvUploadTask` values. */
export type CsvUploadTasksConnection = {
  __typename?: 'CsvUploadTasksConnection';
  /** A list of edges which contains the `CsvUploadTask` and cursor to aid in pagination. */
  edges: Array<CsvUploadTasksEdge>;
  /** A list of `CsvUploadTask` objects. */
  nodes: Array<CsvUploadTask>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CsvUploadTask` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CsvUploadTask` edge in the connection. */
export type CsvUploadTasksEdge = {
  __typename?: 'CsvUploadTasksEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CsvUploadTask` at the end of the edge. */
  node: CsvUploadTask;
};

/** Methods to use when ordering `CsvUploadTask`. */
export enum CsvUploadTasksOrderBy {
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OrganisationIdAsc = 'ORGANISATION_ID_ASC',
  OrganisationIdDesc = 'ORGANISATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  TaskTypeAsc = 'TASK_TYPE_ASC',
  TaskTypeDesc = 'TASK_TYPE_DESC'
}

/** A `CurrentBusinessUserGroupIdsRecord` edge in the connection. */
export type CurrentBusinessUserGroupIdEdge = {
  __typename?: 'CurrentBusinessUserGroupIdEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CurrentBusinessUserGroupIdsRecord` at the end of the edge. */
  node: CurrentBusinessUserGroupIdsRecord;
};

/** A connection to a list of `CurrentBusinessUserGroupIdsRecord` values. */
export type CurrentBusinessUserGroupIdsConnection = {
  __typename?: 'CurrentBusinessUserGroupIdsConnection';
  /** A list of edges which contains the `CurrentBusinessUserGroupIdsRecord` and cursor to aid in pagination. */
  edges: Array<CurrentBusinessUserGroupIdEdge>;
  /** A list of `CurrentBusinessUserGroupIdsRecord` objects. */
  nodes: Array<CurrentBusinessUserGroupIdsRecord>;
  /** The count of *all* `CurrentBusinessUserGroupIdsRecord` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** The return type of our `currentBusinessUserGroupIds` query. */
export type CurrentBusinessUserGroupIdsRecord = {
  __typename?: 'CurrentBusinessUserGroupIdsRecord';
  fromSsoMapping?: Maybe<Scalars['Boolean']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
};

/** A filter to be used against `CurrentBusinessUserGroupIdsRecord` object types. All fields are combined with a logical ‘and.’ */
export type CurrentBusinessUserGroupIdsRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CurrentBusinessUserGroupIdsRecordFilter>>;
  /** Filter by the object’s `fromSsoMapping` field. */
  fromSsoMapping?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `groupId` field. */
  groupId?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CurrentBusinessUserGroupIdsRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CurrentBusinessUserGroupIdsRecordFilter>>;
};

export type CustomEndUserType = {
  __typename?: 'CustomEndUserType';
  allowTest: Scalars['Boolean']['output'];
  authSecret?: Maybe<Scalars['String']['output']>;
  businessUserAccountId?: Maybe<Scalars['Int']['output']>;
  created: Scalars['String']['output'];
  environmentId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  nickname: Scalars['String']['output'];
  organisationBusinessUserAccount?: Maybe<BusinessUserAccount>;
  organisationId?: Maybe<Scalars['String']['output']>;
  profile: Scalars['JSON']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type CustomEventConfig = Node & {
  __typename?: 'CustomEventConfig';
  created: Scalars['Datetime']['output'];
  environmentId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  organisationId: Scalars['String']['output'];
  properties: Scalars['JSON']['output'];
  updated?: Maybe<Scalars['Datetime']['output']>;
};

/**
 * A condition to be used against `CustomEventConfig` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CustomEventConfigCondition = {
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organisationId` field. */
  organisationId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `CustomEventConfig` object types. All fields are combined with a logical ‘and.’ */
export type CustomEventConfigFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CustomEventConfigFilter>>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CustomEventConfigFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CustomEventConfigFilter>>;
  /** Filter by the object’s `organisationId` field. */
  organisationId?: InputMaybe<StringFilter>;
};

/** A connection to a list of `CustomEventConfig` values. */
export type CustomEventConfigsConnection = {
  __typename?: 'CustomEventConfigsConnection';
  /** A list of edges which contains the `CustomEventConfig` and cursor to aid in pagination. */
  edges: Array<CustomEventConfigsEdge>;
  /** A list of `CustomEventConfig` objects. */
  nodes: Array<CustomEventConfig>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CustomEventConfig` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CustomEventConfig` edge in the connection. */
export type CustomEventConfigsEdge = {
  __typename?: 'CustomEventConfigsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CustomEventConfig` at the end of the edge. */
  node: CustomEventConfig;
};

/** Methods to use when ordering `CustomEventConfig`. */
export enum CustomEventConfigsOrderBy {
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  Natural = 'NATURAL',
  OrganisationIdAsc = 'ORGANISATION_ID_ASC',
  OrganisationIdDesc = 'ORGANISATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type CustomRole = Node & {
  __typename?: 'CustomRole';
  description?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `Grant`. */
  grantsByOrganisationIdAndRoleId: GrantsConnection;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organisation` that is related to this `CustomRole`. */
  organisation?: Maybe<Organisation>;
  organisationId: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `RolePermission`. */
  rolePermissionsByOrganisationIdAndRoleId: RolePermissionsConnection;
};


export type CustomRoleGrantsByOrganisationIdAndRoleIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GrantCondition>;
  filter?: InputMaybe<GrantFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GrantsOrderBy>>;
};


export type CustomRoleRolePermissionsByOrganisationIdAndRoleIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RolePermissionCondition>;
  filter?: InputMaybe<RolePermissionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RolePermissionsOrderBy>>;
};

/**
 * A condition to be used against `CustomRole` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type CustomRoleCondition = {
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organisationId` field. */
  organisationId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `CustomRole` object types. All fields are combined with a logical ‘and.’ */
export type CustomRoleFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CustomRoleFilter>>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CustomRoleFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CustomRoleFilter>>;
  /** Filter by the object’s `organisationId` field. */
  organisationId?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `CustomRole` */
export type CustomRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
};

/** Represents an update to a `CustomRole`. Fields that are set will be updated. */
export type CustomRolePatch = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `CustomRole` values. */
export type CustomRolesConnection = {
  __typename?: 'CustomRolesConnection';
  /** A list of edges which contains the `CustomRole` and cursor to aid in pagination. */
  edges: Array<CustomRolesEdge>;
  /** A list of `CustomRole` objects. */
  nodes: Array<CustomRole>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CustomRole` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CustomRole` edge in the connection. */
export type CustomRolesEdge = {
  __typename?: 'CustomRolesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CustomRole` at the end of the edge. */
  node: CustomRole;
};

/** Methods to use when ordering `CustomRole`. */
export enum CustomRolesOrderBy {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  OrganisationIdAsc = 'ORGANISATION_ID_ASC',
  OrganisationIdDesc = 'ORGANISATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** Stores mapping between client id (from cognito) and environment id */
export type CustomerToken = Node & {
  __typename?: 'CustomerToken';
  clientId: Scalars['String']['output'];
  created: Scalars['Datetime']['output'];
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** Reads a single `Environment` that is related to this `CustomerToken`. */
  environment?: Maybe<Environment>;
  environmentId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  organisationId: Scalars['String']['output'];
  role: CredentialRole;
  updated: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `CustomerToken` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CustomerTokenCondition = {
  /** Checks for equality with the object’s `clientId` field. */
  clientId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `CustomerToken` object types. All fields are combined with a logical ‘and.’ */
export type CustomerTokenFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CustomerTokenFilter>>;
  /** Filter by the object’s `clientId` field. */
  clientId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CustomerTokenFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CustomerTokenFilter>>;
};

/** Represents an update to a `CustomerToken`. Fields that are set will be updated. */
export type CustomerTokenPatch = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `CustomerToken` values. */
export type CustomerTokensConnection = {
  __typename?: 'CustomerTokensConnection';
  /** A list of edges which contains the `CustomerToken` and cursor to aid in pagination. */
  edges: Array<CustomerTokensEdge>;
  /** A list of `CustomerToken` objects. */
  nodes: Array<CustomerToken>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CustomerToken` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CustomerToken` edge in the connection. */
export type CustomerTokensEdge = {
  __typename?: 'CustomerTokensEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CustomerToken` at the end of the edge. */
  node: CustomerToken;
};

/** Methods to use when ordering `CustomerToken`. */
export enum CustomerTokensOrderBy {
  ClientIdAsc = 'CLIENT_ID_ASC',
  ClientIdDesc = 'CLIENT_ID_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A filter to be used against Datetime fields. All fields are combined with a logical ‘and.’ */
export type DatetimeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Datetime']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Datetime']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Datetime']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Datetime']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Datetime']['input']>>;
};

/** A range of `Datetime`. */
export type DatetimeRange = {
  __typename?: 'DatetimeRange';
  /** The ending bound of our range. */
  end?: Maybe<DatetimeRangeBound>;
  /** The starting bound of our range. */
  start?: Maybe<DatetimeRangeBound>;
};

/** The value at one end of a range. A range can either include this value, or not. */
export type DatetimeRangeBound = {
  __typename?: 'DatetimeRangeBound';
  /** Whether or not the value of this bound is included in the range. */
  inclusive: Scalars['Boolean']['output'];
  /** The value at one end of our range. */
  value: Scalars['Datetime']['output'];
};

/** The value at one end of a range. A range can either include this value, or not. */
export type DatetimeRangeBoundInput = {
  /** Whether or not the value of this bound is included in the range. */
  inclusive: Scalars['Boolean']['input'];
  /** The value at one end of our range. */
  value: Scalars['Datetime']['input'];
};

/** A filter to be used against DatetimeRange fields. All fields are combined with a logical ‘and.’ */
export type DatetimeRangeFilter = {
  /** Adjacent to the specified range. */
  adjacentTo?: InputMaybe<DatetimeRangeInput>;
  /** Contained by the specified range. */
  containedBy?: InputMaybe<DatetimeRangeInput>;
  /** Contains the specified range. */
  contains?: InputMaybe<DatetimeRangeInput>;
  /** Contains the specified value. */
  containsElement?: InputMaybe<Scalars['Datetime']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<DatetimeRangeInput>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<DatetimeRangeInput>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<DatetimeRangeInput>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<DatetimeRangeInput>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<DatetimeRangeInput>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<DatetimeRangeInput>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<DatetimeRangeInput>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<DatetimeRangeInput>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<DatetimeRangeInput>;
  /** Does not extend left of the specified range. */
  notExtendsLeftOf?: InputMaybe<DatetimeRangeInput>;
  /** Does not extend right of the specified range. */
  notExtendsRightOf?: InputMaybe<DatetimeRangeInput>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<DatetimeRangeInput>>;
  /** Overlaps the specified range. */
  overlaps?: InputMaybe<DatetimeRangeInput>;
  /** Strictly left of the specified range. */
  strictlyLeftOf?: InputMaybe<DatetimeRangeInput>;
  /** Strictly right of the specified range. */
  strictlyRightOf?: InputMaybe<DatetimeRangeInput>;
};

/** A range of `Datetime`. */
export type DatetimeRangeInput = {
  /** The ending bound of our range. */
  end?: InputMaybe<DatetimeRangeBoundInput>;
  /** The starting bound of our range. */
  start?: InputMaybe<DatetimeRangeBoundInput>;
};

/** All input for the `deleteActionFlowApprovalByNodeId` mutation. */
export type DeleteActionFlowApprovalByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ActionFlowApproval` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteActionFlowApproval` mutation. */
export type DeleteActionFlowApprovalInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** The output of our delete `ActionFlowApproval` mutation. */
export type DeleteActionFlowApprovalPayload = {
  __typename?: 'DeleteActionFlowApprovalPayload';
  /** The `ActionFlowApproval` that was deleted by this mutation. */
  actionFlowApproval?: Maybe<ActionFlowApproval>;
  /** An edge for our `ActionFlowApproval`. May be used by Relay 1. */
  actionFlowApprovalEdge?: Maybe<ActionFlowApprovalsEdge>;
  /** Reads a single `ActionFlowConfigVersion` that is related to this `ActionFlowApproval`. */
  actionFlowConfigVersionByEnvironmentIdAndFlowConfigIdAndFlowConfigVersion?: Maybe<ActionFlowConfigVersion>;
  /** Reads a single `BusinessUser` that is related to this `ActionFlowApproval`. */
  businessUserByOrganisationIdAndApprovedBy?: Maybe<BusinessUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedActionFlowApprovalNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organisation` that is related to this `ActionFlowApproval`. */
  organisation?: Maybe<Organisation>;
  /** Reads a single `Group` that is related to this `ActionFlowApproval`. */
  organisationGroup?: Maybe<Group>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `ActionFlowApproval` mutation. */
export type DeleteActionFlowApprovalPayloadActionFlowApprovalEdgeArgs = {
  orderBy?: InputMaybe<Array<ActionFlowApprovalsOrderBy>>;
};

/** All input for the `deleteActionFlowApprovalRequestByNodeId` mutation. */
export type DeleteActionFlowApprovalRequestByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ActionFlowApprovalRequest` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteActionFlowApprovalRequest` mutation. */
export type DeleteActionFlowApprovalRequestInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** The output of our delete `ActionFlowApprovalRequest` mutation. */
export type DeleteActionFlowApprovalRequestPayload = {
  __typename?: 'DeleteActionFlowApprovalRequestPayload';
  /** The `ActionFlowApprovalRequest` that was deleted by this mutation. */
  actionFlowApprovalRequest?: Maybe<ActionFlowApprovalRequest>;
  /** An edge for our `ActionFlowApprovalRequest`. May be used by Relay 1. */
  actionFlowApprovalRequestEdge?: Maybe<ActionFlowApprovalRequestsEdge>;
  /** Reads a single `ActionFlowConfigVersion` that is related to this `ActionFlowApprovalRequest`. */
  actionFlowConfigVersionByEnvironmentIdAndFlowConfigIdAndFlowConfigVersion?: Maybe<ActionFlowConfigVersion>;
  /** Reads a single `BusinessUser` that is related to this `ActionFlowApprovalRequest`. */
  businessUserByOrganisationIdAndRequestedBy?: Maybe<BusinessUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedActionFlowApprovalRequestNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organisation` that is related to this `ActionFlowApprovalRequest`. */
  organisation?: Maybe<Organisation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `ActionFlowApprovalRequest` mutation. */
export type DeleteActionFlowApprovalRequestPayloadActionFlowApprovalRequestEdgeArgs = {
  orderBy?: InputMaybe<Array<ActionFlowApprovalRequestsOrderBy>>;
};

/** All input for the `deleteActionFlowApprovals` mutation. */
export type DeleteActionFlowApprovalsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  flowConfigId: Scalars['String']['input'];
  flowConfigVersion: Scalars['Int']['input'];
};

/** The output of our `deleteActionFlowApprovals` mutation. */
export type DeleteActionFlowApprovalsPayload = {
  __typename?: 'DeleteActionFlowApprovalsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `deleteActionFlowConfigByNodeId` mutation. */
export type DeleteActionFlowConfigByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ActionFlowConfig` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteActionFlowConfig` mutation. */
export type DeleteActionFlowConfigInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

/** The output of our delete `ActionFlowConfig` mutation. */
export type DeleteActionFlowConfigPayload = {
  __typename?: 'DeleteActionFlowConfigPayload';
  /** The `ActionFlowConfig` that was deleted by this mutation. */
  actionFlowConfig?: Maybe<ActionFlowConfig>;
  /** An edge for our `ActionFlowConfig`. May be used by Relay 1. */
  actionFlowConfigEdge?: Maybe<ActionFlowConfigsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedActionFlowConfigNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organisation` that is related to this `ActionFlowConfig`. */
  organisation?: Maybe<Organisation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `ActionFlowConfig` mutation. */
export type DeleteActionFlowConfigPayloadActionFlowConfigEdgeArgs = {
  orderBy?: InputMaybe<Array<ActionFlowConfigsOrderBy>>;
};

/** All input for the `deleteBusinessUserByInviteSecret` mutation. */
export type DeleteBusinessUserByInviteSecretInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  inviteSecret: Scalars['String']['input'];
};

/** All input for the `deleteBusinessUserByNodeId` mutation. */
export type DeleteBusinessUserByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `BusinessUser` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteBusinessUserByOrganisationIdAndId` mutation. */
export type DeleteBusinessUserByOrganisationIdAndIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
};

/** All input for the `deleteBusinessUser` mutation. */
export type DeleteBusinessUserInput = {
  accountId: Scalars['Int']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organisationId: Scalars['String']['input'];
};

/** The output of our delete `BusinessUser` mutation. */
export type DeleteBusinessUserPayload = {
  __typename?: 'DeleteBusinessUserPayload';
  /** Reads a single `Account` that is related to this `BusinessUser`. */
  account?: Maybe<Account>;
  /** The `BusinessUser` that was deleted by this mutation. */
  businessUser?: Maybe<BusinessUser>;
  /** An edge for our `BusinessUser`. May be used by Relay 1. */
  businessUserEdge?: Maybe<BusinessUsersEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedBusinessUserNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organisation` that is related to this `BusinessUser`. */
  organisation?: Maybe<Organisation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `BusinessUser` mutation. */
export type DeleteBusinessUserPayloadBusinessUserEdgeArgs = {
  orderBy?: InputMaybe<Array<BusinessUsersOrderBy>>;
};

/** All input for the `deleteCardApprovalByNodeId` mutation. */
export type DeleteCardApprovalByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CardApproval` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteCardApproval` mutation. */
export type DeleteCardApprovalInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** The output of our delete `CardApproval` mutation. */
export type DeleteCardApprovalPayload = {
  __typename?: 'DeleteCardApprovalPayload';
  /** Reads a single `BusinessUser` that is related to this `CardApproval`. */
  businessUserByOrganisationIdAndApprovedBy?: Maybe<BusinessUser>;
  /** The `CardApproval` that was deleted by this mutation. */
  cardApproval?: Maybe<CardApproval>;
  /** An edge for our `CardApproval`. May be used by Relay 1. */
  cardApprovalEdge?: Maybe<CardApprovalsEdge>;
  /** Reads a single `CardTemplateVersion` that is related to this `CardApproval`. */
  cardTemplateVersionByEnvironmentIdAndCardTemplateIdAndCardTemplateVersion?: Maybe<CardTemplateVersion>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedCardApprovalNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organisation` that is related to this `CardApproval`. */
  organisation?: Maybe<Organisation>;
  /** Reads a single `Group` that is related to this `CardApproval`. */
  organisationGroup?: Maybe<Group>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `CardApproval` mutation. */
export type DeleteCardApprovalPayloadCardApprovalEdgeArgs = {
  orderBy?: InputMaybe<Array<CardApprovalsOrderBy>>;
};

/** All input for the `deleteCardApprovalRequestByNodeId` mutation. */
export type DeleteCardApprovalRequestByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CardApprovalRequest` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteCardApprovalRequest` mutation. */
export type DeleteCardApprovalRequestInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** The output of our delete `CardApprovalRequest` mutation. */
export type DeleteCardApprovalRequestPayload = {
  __typename?: 'DeleteCardApprovalRequestPayload';
  /** Reads a single `BusinessUser` that is related to this `CardApprovalRequest`. */
  businessUserByOrganisationIdAndRequestedBy?: Maybe<BusinessUser>;
  /** The `CardApprovalRequest` that was deleted by this mutation. */
  cardApprovalRequest?: Maybe<CardApprovalRequest>;
  /** An edge for our `CardApprovalRequest`. May be used by Relay 1. */
  cardApprovalRequestEdge?: Maybe<CardApprovalRequestsEdge>;
  /** Reads a single `CardTemplateVersion` that is related to this `CardApprovalRequest`. */
  cardTemplateVersionByEnvironmentIdAndCardTemplateIdAndCardTemplateVersion?: Maybe<CardTemplateVersion>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedCardApprovalRequestNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organisation` that is related to this `CardApprovalRequest`. */
  organisation?: Maybe<Organisation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `CardApprovalRequest` mutation. */
export type DeleteCardApprovalRequestPayloadCardApprovalRequestEdgeArgs = {
  orderBy?: InputMaybe<Array<CardApprovalRequestsOrderBy>>;
};

/** All input for the `deleteCardApprovals` mutation. */
export type DeleteCardApprovalsInput = {
  cardTemplateId: Scalars['String']['input'];
  cardTemplateVersion: Scalars['Int']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
};

/** The output of our `deleteCardApprovals` mutation. */
export type DeleteCardApprovalsPayload = {
  __typename?: 'DeleteCardApprovalsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `deleteCardTemplateByNodeId` mutation. */
export type DeleteCardTemplateByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CardTemplate` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteCardTemplate` mutation. */
export type DeleteCardTemplateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

/** The output of our delete `CardTemplate` mutation. */
export type DeleteCardTemplatePayload = {
  __typename?: 'DeleteCardTemplatePayload';
  /** The `CardTemplate` that was deleted by this mutation. */
  cardTemplate?: Maybe<CardTemplate>;
  /** An edge for our `CardTemplate`. May be used by Relay 1. */
  cardTemplateEdge?: Maybe<CardTemplatesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedCardTemplateNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Environment` that is related to this `CardTemplate`. */
  environment?: Maybe<Environment>;
  /** Reads a single `ActionFlowConfig` that is related to this `CardTemplate`. */
  environmentFlowConfig?: Maybe<ActionFlowConfig>;
  /** Reads a single `Organisation` that is related to this `CardTemplate`. */
  organisation?: Maybe<Organisation>;
  /** Reads a single `Environment` that is related to this `CardTemplate`. */
  organisationEnvironment?: Maybe<Environment>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `CardTemplate` mutation. */
export type DeleteCardTemplatePayloadCardTemplateEdgeArgs = {
  orderBy?: InputMaybe<Array<CardTemplatesOrderBy>>;
};

/** All input for the `deleteClientKeyByApiKey` mutation. */
export type DeleteClientKeyByApiKeyInput = {
  apiKey: Scalars['String']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** All input for the `deleteClientKeyByNodeId` mutation. */
export type DeleteClientKeyByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ClientKey` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteClientKey` mutation. */
export type DeleteClientKeyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

/** The output of our delete `ClientKey` mutation. */
export type DeleteClientKeyPayload = {
  __typename?: 'DeleteClientKeyPayload';
  /** The `ClientKey` that was deleted by this mutation. */
  clientKey?: Maybe<ClientKey>;
  /** An edge for our `ClientKey`. May be used by Relay 1. */
  clientKeyEdge?: Maybe<ClientKeysEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedClientKeyNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Environment` that is related to this `ClientKey`. */
  environment?: Maybe<Environment>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `ClientKey` mutation. */
export type DeleteClientKeyPayloadClientKeyEdgeArgs = {
  orderBy?: InputMaybe<Array<ClientKeysOrderBy>>;
};

/** All input for the `deleteConnectorRuntimeByEnvironmentIdAndSecret` mutation. */
export type DeleteConnectorRuntimeByEnvironmentIdAndSecretInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  secret: Scalars['String']['input'];
};

/** All input for the `deleteConnectorRuntimeByNodeId` mutation. */
export type DeleteConnectorRuntimeByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ConnectorRuntime` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteConnectorRuntime` mutation. */
export type DeleteConnectorRuntimeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  flowConfigId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

/** The output of our delete `ConnectorRuntime` mutation. */
export type DeleteConnectorRuntimePayload = {
  __typename?: 'DeleteConnectorRuntimePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `ConnectorRuntime` that was deleted by this mutation. */
  connectorRuntime?: Maybe<ConnectorRuntime>;
  /** An edge for our `ConnectorRuntime`. May be used by Relay 1. */
  connectorRuntimeEdge?: Maybe<ConnectorRuntimesEdge>;
  deletedConnectorRuntimeNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Environment` that is related to this `ConnectorRuntime`. */
  environment?: Maybe<Environment>;
  /** Reads a single `ActionFlowConfig` that is related to this `ConnectorRuntime`. */
  environmentFlowConfig?: Maybe<ActionFlowConfig>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `ConnectorRuntime` mutation. */
export type DeleteConnectorRuntimePayloadConnectorRuntimeEdgeArgs = {
  orderBy?: InputMaybe<Array<ConnectorRuntimesOrderBy>>;
};

/** All input for the `deleteCustomRoleByNodeId` mutation. */
export type DeleteCustomRoleByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CustomRole` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteCustomRoleByOrganisationIdAndName` mutation. */
export type DeleteCustomRoleByOrganisationIdAndNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
};

/** All input for the `deleteCustomRole` mutation. */
export type DeleteCustomRoleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
};

/** The output of our delete `CustomRole` mutation. */
export type DeleteCustomRolePayload = {
  __typename?: 'DeleteCustomRolePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `CustomRole` that was deleted by this mutation. */
  customRole?: Maybe<CustomRole>;
  /** An edge for our `CustomRole`. May be used by Relay 1. */
  customRoleEdge?: Maybe<CustomRolesEdge>;
  deletedCustomRoleNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organisation` that is related to this `CustomRole`. */
  organisation?: Maybe<Organisation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `CustomRole` mutation. */
export type DeleteCustomRolePayloadCustomRoleEdgeArgs = {
  orderBy?: InputMaybe<Array<CustomRolesOrderBy>>;
};

/** All input for the `deleteCustomerTokenByClientIdAndEnvironmentId` mutation. */
export type DeleteCustomerTokenByClientIdAndEnvironmentIdInput = {
  clientId: Scalars['String']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
};

/** All input for the `deleteCustomerTokenByNodeId` mutation. */
export type DeleteCustomerTokenByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CustomerToken` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteCustomerToken` mutation. */
export type DeleteCustomerTokenInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

/** The output of our delete `CustomerToken` mutation. */
export type DeleteCustomerTokenPayload = {
  __typename?: 'DeleteCustomerTokenPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `CustomerToken` that was deleted by this mutation. */
  customerToken?: Maybe<CustomerToken>;
  /** An edge for our `CustomerToken`. May be used by Relay 1. */
  customerTokenEdge?: Maybe<CustomerTokensEdge>;
  deletedCustomerTokenNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Environment` that is related to this `CustomerToken`. */
  environment?: Maybe<Environment>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `CustomerToken` mutation. */
export type DeleteCustomerTokenPayloadCustomerTokenEdgeArgs = {
  orderBy?: InputMaybe<Array<CustomerTokensOrderBy>>;
};

/** All input for the `deleteEndUserSegmentByEnvironmentIdAndName` mutation. */
export type DeleteEndUserSegmentByEnvironmentIdAndNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

/** All input for the `deleteEndUserSegmentByNodeId` mutation. */
export type DeleteEndUserSegmentByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `EndUserSegment` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteEndUserSegment` mutation. */
export type DeleteEndUserSegmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

/** The output of our delete `EndUserSegment` mutation. */
export type DeleteEndUserSegmentPayload = {
  __typename?: 'DeleteEndUserSegmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedEndUserSegmentNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `EndUserSegment` that was deleted by this mutation. */
  endUserSegment?: Maybe<EndUserSegment>;
  /** An edge for our `EndUserSegment`. May be used by Relay 1. */
  endUserSegmentEdge?: Maybe<EndUserSegmentsEdge>;
  /** Reads a single `Environment` that is related to this `EndUserSegment`. */
  environment?: Maybe<Environment>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `EndUserSegment` mutation. */
export type DeleteEndUserSegmentPayloadEndUserSegmentEdgeArgs = {
  orderBy?: InputMaybe<Array<EndUserSegmentsOrderBy>>;
};

/** All input for the `deleteEventDefinitionByEnvironmentIdAndEventName` mutation. */
export type DeleteEventDefinitionByEnvironmentIdAndEventNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  eventName: Scalars['EventName']['input'];
};

/** All input for the `deleteEventDefinitionByNodeId` mutation. */
export type DeleteEventDefinitionByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `EventDefinition` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteEventDefinition` mutation. */
export type DeleteEventDefinitionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

/** The output of our delete `EventDefinition` mutation. */
export type DeleteEventDefinitionPayload = {
  __typename?: 'DeleteEventDefinitionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedEventDefinitionNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Environment` that is related to this `EventDefinition`. */
  environment?: Maybe<Environment>;
  /** The `EventDefinition` that was deleted by this mutation. */
  eventDefinition?: Maybe<EventDefinition>;
  /** An edge for our `EventDefinition`. May be used by Relay 1. */
  eventDefinitionEdge?: Maybe<EventDefinitionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `EventDefinition` mutation. */
export type DeleteEventDefinitionPayloadEventDefinitionEdgeArgs = {
  orderBy?: InputMaybe<Array<EventDefinitionsOrderBy>>;
};

/** All input for the `deleteEventDefinitionVersionByNodeId` mutation. */
export type DeleteEventDefinitionVersionByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `EventDefinitionVersion` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteEventDefinitionVersion` mutation. */
export type DeleteEventDefinitionVersionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  eventDefinitionId: Scalars['String']['input'];
  version: Scalars['Int']['input'];
};

/** The output of our delete `EventDefinitionVersion` mutation. */
export type DeleteEventDefinitionVersionPayload = {
  __typename?: 'DeleteEventDefinitionVersionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedEventDefinitionVersionNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `EventDefinition` that is related to this `EventDefinitionVersion`. */
  environmentEventDefinition?: Maybe<EventDefinition>;
  /** The `EventDefinitionVersion` that was deleted by this mutation. */
  eventDefinitionVersion?: Maybe<EventDefinitionVersion>;
  /** An edge for our `EventDefinitionVersion`. May be used by Relay 1. */
  eventDefinitionVersionEdge?: Maybe<EventDefinitionVersionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `EventDefinitionVersion` mutation. */
export type DeleteEventDefinitionVersionPayloadEventDefinitionVersionEdgeArgs = {
  orderBy?: InputMaybe<Array<EventDefinitionVersionsOrderBy>>;
};

/** All input for the `deleteGrantByNodeId` mutation. */
export type DeleteGrantByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Grant` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteGrant` mutation. */
export type DeleteGrantInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
};

/** The output of our delete `Grant` mutation. */
export type DeleteGrantPayload = {
  __typename?: 'DeleteGrantPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedGrantNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Environment` that is related to this `Grant`. */
  environment?: Maybe<Environment>;
  /** The `Grant` that was deleted by this mutation. */
  grant?: Maybe<Grant>;
  /** An edge for our `Grant`. May be used by Relay 1. */
  grantEdge?: Maybe<GrantsEdge>;
  /** Reads a single `Organisation` that is related to this `Grant`. */
  organisation?: Maybe<Organisation>;
  /** Reads a single `Group` that is related to this `Grant`. */
  organisationGroup?: Maybe<Group>;
  /** Reads a single `CustomRole` that is related to this `Grant`. */
  organisationRole?: Maybe<CustomRole>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `Grant` mutation. */
export type DeleteGrantPayloadGrantEdgeArgs = {
  orderBy?: InputMaybe<Array<GrantsOrderBy>>;
};

/** All input for the `deleteGroupByNodeId` mutation. */
export type DeleteGroupByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Group` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteGroupByOrganisationIdAndName` mutation. */
export type DeleteGroupByOrganisationIdAndNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
};

/** All input for the `deleteGroup` mutation. */
export type DeleteGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
};

/** The output of our delete `Group` mutation. */
export type DeleteGroupPayload = {
  __typename?: 'DeleteGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedGroupNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `Group` that was deleted by this mutation. */
  group?: Maybe<Group>;
  /** An edge for our `Group`. May be used by Relay 1. */
  groupEdge?: Maybe<GroupsEdge>;
  /** Reads a single `Organisation` that is related to this `Group`. */
  organisation?: Maybe<Organisation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `Group` mutation. */
export type DeleteGroupPayloadGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};

/** All input for the `deleteInsightsReportByNodeId` mutation. */
export type DeleteInsightsReportByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `InsightsReport` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteInsightsReport` mutation. */
export type DeleteInsightsReportInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

/** The output of our delete `InsightsReport` mutation. */
export type DeleteInsightsReportPayload = {
  __typename?: 'DeleteInsightsReportPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedInsightsReportNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Environment` that is related to this `InsightsReport`. */
  environment?: Maybe<Environment>;
  /** The `InsightsReport` that was deleted by this mutation. */
  insightsReport?: Maybe<InsightsReport>;
  /** An edge for our `InsightsReport`. May be used by Relay 1. */
  insightsReportEdge?: Maybe<InsightsReportsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `InsightsReport` mutation. */
export type DeleteInsightsReportPayloadInsightsReportEdgeArgs = {
  orderBy?: InputMaybe<Array<InsightsReportsOrderBy>>;
};

/** All input for the `deleteIntegrationConfigurationByNodeId` mutation. */
export type DeleteIntegrationConfigurationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `IntegrationConfiguration` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteIntegrationConfiguration` mutation. */
export type DeleteIntegrationConfigurationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

/** The output of our delete `IntegrationConfiguration` mutation. */
export type DeleteIntegrationConfigurationPayload = {
  __typename?: 'DeleteIntegrationConfigurationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedIntegrationConfigurationNodeId?: Maybe<Scalars['ID']['output']>;
  /** The `IntegrationConfiguration` that was deleted by this mutation. */
  integrationConfiguration?: Maybe<IntegrationConfiguration>;
  /** An edge for our `IntegrationConfiguration`. May be used by Relay 1. */
  integrationConfigurationEdge?: Maybe<IntegrationConfigurationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `IntegrationConfiguration` mutation. */
export type DeleteIntegrationConfigurationPayloadIntegrationConfigurationEdgeArgs = {
  orderBy?: InputMaybe<Array<IntegrationConfigurationsOrderBy>>;
};

/** All input for the `deleteResourceUserByNodeId` mutation. */
export type DeleteResourceUserByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ResourceUser` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteResourceUser` mutation. */
export type DeleteResourceUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  resourceId: Scalars['String']['input'];
  resourceType: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
  sub: Scalars['UUID']['input'];
};

/** The output of our delete `ResourceUser` mutation. */
export type DeleteResourceUserPayload = {
  __typename?: 'DeleteResourceUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedResourceUserNodeId?: Maybe<Scalars['ID']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `ResourceUser` that was deleted by this mutation. */
  resourceUser?: Maybe<ResourceUser>;
  /** An edge for our `ResourceUser`. May be used by Relay 1. */
  resourceUserEdge?: Maybe<ResourceUsersEdge>;
};


/** The output of our delete `ResourceUser` mutation. */
export type DeleteResourceUserPayloadResourceUserEdgeArgs = {
  orderBy?: InputMaybe<Array<ResourceUsersOrderBy>>;
};

/** All input for the `deleteRolePermissionByNodeId` mutation. */
export type DeleteRolePermissionByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `RolePermission` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteRolePermission` mutation. */
export type DeleteRolePermissionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organisationId: Scalars['String']['input'];
  resource: PermissionResource;
  roleId: Scalars['String']['input'];
};

/** The output of our delete `RolePermission` mutation. */
export type DeleteRolePermissionPayload = {
  __typename?: 'DeleteRolePermissionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedRolePermissionNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Organisation` that is related to this `RolePermission`. */
  organisation?: Maybe<Organisation>;
  /** Reads a single `CustomRole` that is related to this `RolePermission`. */
  organisationRole?: Maybe<CustomRole>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RolePermission` that was deleted by this mutation. */
  rolePermission?: Maybe<RolePermission>;
  /** An edge for our `RolePermission`. May be used by Relay 1. */
  rolePermissionEdge?: Maybe<RolePermissionsEdge>;
};


/** The output of our delete `RolePermission` mutation. */
export type DeleteRolePermissionPayloadRolePermissionEdgeArgs = {
  orderBy?: InputMaybe<Array<RolePermissionsOrderBy>>;
};

export type DeleteRoleResponse = {
  __typename?: 'DeleteRoleResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteSegmentTriggerInput = {
  cardTemplateId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  flowConfigId: Scalars['String']['input'];
  triggerId: Scalars['String']['input'];
};

/** All input for the `deleteStreamContainerByNodeId` mutation. */
export type DeleteStreamContainerByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `StreamContainer` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteStreamContainer` mutation. */
export type DeleteStreamContainerInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

/** The output of our delete `StreamContainer` mutation. */
export type DeleteStreamContainerPayload = {
  __typename?: 'DeleteStreamContainerPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedStreamContainerNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Theme` that is related to this `StreamContainer`. */
  environmentDarkTheme?: Maybe<Theme>;
  /** Reads a single `Stream` that is related to this `StreamContainer`. */
  environmentStream?: Maybe<Stream>;
  /** Reads a single `Theme` that is related to this `StreamContainer`. */
  environmentTheme?: Maybe<Theme>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `StreamContainer` that was deleted by this mutation. */
  streamContainer?: Maybe<StreamContainer>;
  /** An edge for our `StreamContainer`. May be used by Relay 1. */
  streamContainerEdge?: Maybe<StreamContainersEdge>;
};


/** The output of our delete `StreamContainer` mutation. */
export type DeleteStreamContainerPayloadStreamContainerEdgeArgs = {
  orderBy?: InputMaybe<Array<StreamContainersOrderBy>>;
};

/** All input for the `deleteThemeByNodeId` mutation. */
export type DeleteThemeByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Theme` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteTheme` mutation. */
export type DeleteThemeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

/** The output of our delete `Theme` mutation. */
export type DeleteThemePayload = {
  __typename?: 'DeleteThemePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedThemeNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Environment` that is related to this `Theme`. */
  environment?: Maybe<Environment>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Theme` that was deleted by this mutation. */
  theme?: Maybe<Theme>;
  /** An edge for our `Theme`. May be used by Relay 1. */
  themeEdge?: Maybe<ThemesEdge>;
};


/** The output of our delete `Theme` mutation. */
export type DeleteThemePayloadThemeEdgeArgs = {
  orderBy?: InputMaybe<Array<ThemesOrderBy>>;
};

/** All input for the `deleteTriggerEventByEnvironmentIdAndStreamIdAndEventDefinitionIdAndEventDefinitionVersionAndCardTemplateIdAndCardTemplateVersion` mutation. */
export type DeleteTriggerEventByEnvironmentIdAndStreamIdAndEventDefinitionIdAndEventDefinitionVersionAndCardTemplateIdAndCardTemplateVersionInput = {
  cardTemplateId: Scalars['String']['input'];
  cardTemplateVersion: Scalars['Int']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  eventDefinitionId: Scalars['String']['input'];
  eventDefinitionVersion: Scalars['Int']['input'];
  streamId: Scalars['String']['input'];
};

/** All input for the `deleteTriggerEventByNodeId` mutation. */
export type DeleteTriggerEventByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `TriggerEvent` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteTriggerEvent` mutation. */
export type DeleteTriggerEventInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

/** The output of our delete `TriggerEvent` mutation. */
export type DeleteTriggerEventPayload = {
  __typename?: 'DeleteTriggerEventPayload';
  /** Reads a single `ActionFlowConfigVersion` that is related to this `TriggerEvent`. */
  actionFlowConfigVersionByEnvironmentIdAndFlowConfigIdAndFlowConfigVersion?: Maybe<ActionFlowConfigVersion>;
  /** Reads a single `CardTemplateVersion` that is related to this `TriggerEvent`. */
  cardTemplateVersionByEnvironmentIdAndCardTemplateIdAndCardTemplateVersion?: Maybe<CardTemplateVersion>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedTriggerEventNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Environment` that is related to this `TriggerEvent`. */
  environment?: Maybe<Environment>;
  /** Reads a single `Stream` that is related to this `TriggerEvent`. */
  environmentStream?: Maybe<Stream>;
  /** Reads a single `EventDefinitionVersion` that is related to this `TriggerEvent`. */
  eventDefinitionVersionByEnvironmentIdAndEventDefinitionIdAndEventDefinitionVersion?: Maybe<EventDefinitionVersion>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TriggerEvent` that was deleted by this mutation. */
  triggerEvent?: Maybe<TriggerEvent>;
  /** An edge for our `TriggerEvent`. May be used by Relay 1. */
  triggerEventEdge?: Maybe<TriggerEventsEdge>;
};


/** The output of our delete `TriggerEvent` mutation. */
export type DeleteTriggerEventPayloadTriggerEventEdgeArgs = {
  orderBy?: InputMaybe<Array<TriggerEventsOrderBy>>;
};

/** All input for the `deleteWebhookCredentialByNodeId` mutation. */
export type DeleteWebhookCredentialByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `WebhookCredential` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteWebhookCredential` mutation. */
export type DeleteWebhookCredentialInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

/** The output of our delete `WebhookCredential` mutation. */
export type DeleteWebhookCredentialPayload = {
  __typename?: 'DeleteWebhookCredentialPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedWebhookCredentialNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Environment` that is related to this `WebhookCredential`. */
  environment?: Maybe<Environment>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `WebhookCredential` that was deleted by this mutation. */
  webhookCredential?: Maybe<WebhookCredential>;
  /** An edge for our `WebhookCredential`. May be used by Relay 1. */
  webhookCredentialEdge?: Maybe<WebhookCredentialsEdge>;
};


/** The output of our delete `WebhookCredential` mutation. */
export type DeleteWebhookCredentialPayloadWebhookCredentialEdgeArgs = {
  orderBy?: InputMaybe<Array<WebhookCredentialsOrderBy>>;
};

/** All input for the `deleteWebhookEndpointByNodeId` mutation. */
export type DeleteWebhookEndpointByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `WebhookEndpoint` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteWebhookEndpoint` mutation. */
export type DeleteWebhookEndpointInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

/** The output of our delete `WebhookEndpoint` mutation. */
export type DeleteWebhookEndpointPayload = {
  __typename?: 'DeleteWebhookEndpointPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedWebhookEndpointNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Environment` that is related to this `WebhookEndpoint`. */
  environment?: Maybe<Environment>;
  /** Reads a single `WebhookCredential` that is related to this `WebhookEndpoint`. */
  environmentWebhookCredential?: Maybe<WebhookCredential>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `WebhookEndpoint` that was deleted by this mutation. */
  webhookEndpoint?: Maybe<WebhookEndpoint>;
  /** An edge for our `WebhookEndpoint`. May be used by Relay 1. */
  webhookEndpointEdge?: Maybe<WebhookEndpointsEdge>;
};


/** The output of our delete `WebhookEndpoint` mutation. */
export type DeleteWebhookEndpointPayloadWebhookEndpointEdgeArgs = {
  orderBy?: InputMaybe<Array<WebhookEndpointsOrderBy>>;
};

/** All input for the `deleteWorkbenchFolderByEnvironmentIdAndName` mutation. */
export type DeleteWorkbenchFolderByEnvironmentIdAndNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

/** All input for the `deleteWorkbenchFolderByNodeId` mutation. */
export type DeleteWorkbenchFolderByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `WorkbenchFolder` to be deleted. */
  nodeId: Scalars['ID']['input'];
};

/** All input for the `deleteWorkbenchFolder` mutation. */
export type DeleteWorkbenchFolderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

/** The output of our delete `WorkbenchFolder` mutation. */
export type DeleteWorkbenchFolderPayload = {
  __typename?: 'DeleteWorkbenchFolderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  deletedWorkbenchFolderNodeId?: Maybe<Scalars['ID']['output']>;
  /** Reads a single `Environment` that is related to this `WorkbenchFolder`. */
  environment?: Maybe<Environment>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `WorkbenchFolder` that was deleted by this mutation. */
  workbenchFolder?: Maybe<WorkbenchFolder>;
  /** An edge for our `WorkbenchFolder`. May be used by Relay 1. */
  workbenchFolderEdge?: Maybe<WorkbenchFoldersEdge>;
};


/** The output of our delete `WorkbenchFolder` mutation. */
export type DeleteWorkbenchFolderPayloadWorkbenchFolderEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkbenchFoldersOrderBy>>;
};

/** All input for the `deleteWorkbenchGroups` mutation. */
export type DeleteWorkbenchGroupsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
};

/** The output of our `deleteWorkbenchGroups` mutation. */
export type DeleteWorkbenchGroupsPayload = {
  __typename?: 'DeleteWorkbenchGroupsPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `discardActionFlowDraft` mutation. */
export type DiscardActionFlowDraftInput = {
  _environmentId: Scalars['String']['input'];
  _flowConfigId: Scalars['String']['input'];
  _version: Scalars['Int']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `discardActionFlowDraft` mutation. */
export type DiscardActionFlowDraftPayload = {
  __typename?: 'DiscardActionFlowDraftPayload';
  actionFlowConfigVersion?: Maybe<ActionFlowConfigVersion>;
  /** An edge for our `ActionFlowConfigVersion`. May be used by Relay 1. */
  actionFlowConfigVersionEdge?: Maybe<ActionFlowConfigVersionsEdge>;
  /** Reads a single `BusinessUser` that is related to this `ActionFlowConfigVersion`. */
  businessUserByOrganisationIdAndPublishedBy?: Maybe<BusinessUser>;
  /** Reads a single `BusinessUser` that is related to this `ActionFlowConfigVersion`. */
  businessUserByOrganisationIdAndUpdatedBy?: Maybe<BusinessUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `ActionFlowConfig` that is related to this `ActionFlowConfigVersion`. */
  environmentFlowConfig?: Maybe<ActionFlowConfig>;
  /** Reads a single `Organisation` that is related to this `ActionFlowConfigVersion`. */
  organisation?: Maybe<Organisation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `discardActionFlowDraft` mutation. */
export type DiscardActionFlowDraftPayloadActionFlowConfigVersionEdgeArgs = {
  orderBy?: InputMaybe<Array<ActionFlowConfigVersionsOrderBy>>;
};

/** All input for the `discardCardTemplateDraft` mutation. */
export type DiscardCardTemplateDraftInput = {
  _cardTemplateId: Scalars['String']['input'];
  _environmentId: Scalars['String']['input'];
  _version: Scalars['Int']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `discardCardTemplateDraft` mutation. */
export type DiscardCardTemplateDraftPayload = {
  __typename?: 'DiscardCardTemplateDraftPayload';
  /** Reads a single `BusinessUser` that is related to this `CardTemplateVersion`. */
  businessUserByOrganisationIdAndPublishedBy?: Maybe<BusinessUser>;
  /** Reads a single `BusinessUser` that is related to this `CardTemplateVersion`. */
  businessUserByOrganisationIdAndUpdatedBy?: Maybe<BusinessUser>;
  cardTemplateVersion?: Maybe<CardTemplateVersion>;
  /** An edge for our `CardTemplateVersion`. May be used by Relay 1. */
  cardTemplateVersionEdge?: Maybe<CardTemplateVersionsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CardTemplate` that is related to this `CardTemplateVersion`. */
  environmentCardTemplate?: Maybe<CardTemplate>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `discardCardTemplateDraft` mutation. */
export type DiscardCardTemplateDraftPayloadCardTemplateVersionEdgeArgs = {
  orderBy?: InputMaybe<Array<CardTemplateVersionsOrderBy>>;
};

export type DuplicateCardInput = {
  cardTemplateId: Scalars['String']['input'];
  environmentId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type DuplicateCardPayload = {
  __typename?: 'DuplicateCardPayload';
  cardTemplateVersion?: Maybe<CardTemplateVersion>;
  query?: Maybe<Query>;
};

/** A filter to be used against Email fields. All fields are combined with a logical ‘and.’ */
export type EmailFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Email']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value (case-insensitive). */
  distinctFromInsensitive?: InputMaybe<Scalars['Email']['input']>;
  /** Ends with the specified string (case-sensitive). */
  endsWith?: InputMaybe<Scalars['Email']['input']>;
  /** Ends with the specified string (case-insensitive). */
  endsWithInsensitive?: InputMaybe<Scalars['Email']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Email']['input']>;
  /** Equal to the specified value (case-insensitive). */
  equalToInsensitive?: InputMaybe<Scalars['Email']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Email']['input']>;
  /** Greater than the specified value (case-insensitive). */
  greaterThanInsensitive?: InputMaybe<Scalars['Email']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Email']['input']>;
  /** Greater than or equal to the specified value (case-insensitive). */
  greaterThanOrEqualToInsensitive?: InputMaybe<Scalars['Email']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Email']['input']>>;
  /** Included in the specified list (case-insensitive). */
  inInsensitive?: InputMaybe<Array<Scalars['Email']['input']>>;
  /** Contains the specified string (case-sensitive). */
  includes?: InputMaybe<Scalars['Email']['input']>;
  /** Contains the specified string (case-insensitive). */
  includesInsensitive?: InputMaybe<Scalars['Email']['input']>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Email']['input']>;
  /** Less than the specified value (case-insensitive). */
  lessThanInsensitive?: InputMaybe<Scalars['Email']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Email']['input']>;
  /** Less than or equal to the specified value (case-insensitive). */
  lessThanOrEqualToInsensitive?: InputMaybe<Scalars['Email']['input']>;
  /** Matches the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  like?: InputMaybe<Scalars['Email']['input']>;
  /** Matches the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  likeInsensitive?: InputMaybe<Scalars['Email']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Email']['input']>;
  /** Equal to the specified value, treating null like an ordinary value (case-insensitive). */
  notDistinctFromInsensitive?: InputMaybe<Scalars['Email']['input']>;
  /** Does not end with the specified string (case-sensitive). */
  notEndsWith?: InputMaybe<Scalars['Email']['input']>;
  /** Does not end with the specified string (case-insensitive). */
  notEndsWithInsensitive?: InputMaybe<Scalars['Email']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Email']['input']>;
  /** Not equal to the specified value (case-insensitive). */
  notEqualToInsensitive?: InputMaybe<Scalars['Email']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Email']['input']>>;
  /** Not included in the specified list (case-insensitive). */
  notInInsensitive?: InputMaybe<Array<Scalars['Email']['input']>>;
  /** Does not contain the specified string (case-sensitive). */
  notIncludes?: InputMaybe<Scalars['Email']['input']>;
  /** Does not contain the specified string (case-insensitive). */
  notIncludesInsensitive?: InputMaybe<Scalars['Email']['input']>;
  /** Does not match the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLike?: InputMaybe<Scalars['Email']['input']>;
  /** Does not match the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLikeInsensitive?: InputMaybe<Scalars['Email']['input']>;
  /** Does not start with the specified string (case-sensitive). */
  notStartsWith?: InputMaybe<Scalars['Email']['input']>;
  /** Does not start with the specified string (case-insensitive). */
  notStartsWithInsensitive?: InputMaybe<Scalars['Email']['input']>;
  /** Starts with the specified string (case-sensitive). */
  startsWith?: InputMaybe<Scalars['Email']['input']>;
  /** Starts with the specified string (case-insensitive). */
  startsWithInsensitive?: InputMaybe<Scalars['Email']['input']>;
};

export type EndUserDeleteResponse = {
  __typename?: 'EndUserDeleteResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type EndUserListResponse = {
  __typename?: 'EndUserListResponse';
  edges: Array<Maybe<SyncedEndUserNodes>>;
  pagination?: Maybe<SyncedEndUserPaginationResponse>;
  totalCount: Scalars['Int']['output'];
};

export type EndUserRow = {
  id: Scalars['String']['input'];
  preferences?: InputMaybe<Preferences>;
  profile?: InputMaybe<Scalars['JSON']['input']>;
};

export type EndUserSegment = Node & {
  __typename?: 'EndUserSegment';
  associatedActionFlows: Array<ActionFlowSegmentSummary>;
  created: Scalars['Datetime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Environment` that is related to this `EndUserSegment`. */
  environment?: Maybe<Environment>;
  environmentId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nestedFilterConditions: Scalars['JSON']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  updated?: Maybe<Scalars['Datetime']['output']>;
};

/**
 * A condition to be used against `EndUserSegment` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type EndUserSegmentCondition = {
  /** Checks for equality with the object’s `created` field. */
  created?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `EndUserSegment` object types. All fields are combined with a logical ‘and.’ */
export type EndUserSegmentFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EndUserSegmentFilter>>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EndUserSegmentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EndUserSegmentFilter>>;
};

/** An input for mutations affecting `EndUserSegment` */
export type EndUserSegmentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  nestedFilterConditions?: InputMaybe<Scalars['JSON']['input']>;
};

/** Represents an update to a `EndUserSegment`. Fields that are set will be updated. */
export type EndUserSegmentPatch = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nestedFilterConditions?: InputMaybe<Scalars['JSON']['input']>;
};

/** A connection to a list of `EndUserSegment` values. */
export type EndUserSegmentsConnection = {
  __typename?: 'EndUserSegmentsConnection';
  /** A list of edges which contains the `EndUserSegment` and cursor to aid in pagination. */
  edges: Array<EndUserSegmentsEdge>;
  /** A list of `EndUserSegment` objects. */
  nodes: Array<EndUserSegment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EndUserSegment` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `EndUserSegment` edge in the connection. */
export type EndUserSegmentsEdge = {
  __typename?: 'EndUserSegmentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `EndUserSegment` at the end of the edge. */
  node: EndUserSegment;
};

/** Methods to use when ordering `EndUserSegment`. */
export enum EndUserSegmentsOrderBy {
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** A deployed environment within an organisation, i.e. production or staging */
export type Environment = Node & {
  __typename?: 'Environment';
  actionConfiguration: Scalars['JSON']['output'];
  /** Reads and enables pagination through a set of `ActionFlowConfigVersionAnalytic`. */
  actionFlowConfigVersionAnalytics: ActionFlowConfigVersionAnalyticsConnection;
  active: Scalars['Boolean']['output'];
  /** Computed column returning a list of active stream containers for an environment */
  activeStreamContainers: EnvironmentActiveStreamContainersConnection;
  /** Reads and enables pagination through a set of `AnalyticsBatch`. */
  analyticsBatches: AnalyticsBatchesConnection;
  /** computed column, connection to groups a business member must belong to in order to approve card templates */
  approvalRequiredGroups: GroupsConnection;
  /** computed column, true if card template approvals are enabled in configuration */
  approvalsEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Reads and enables pagination through a set of `CardTemplate`. */
  cardTemplates: CardTemplatesConnection;
  /** Reads and enables pagination through a set of `CardTemplate`. */
  cardTemplatesByOrganisationIdAndEnvironmentId: CardTemplatesConnection;
  /** Reads and enables pagination through a set of `ClientKey`. */
  clientKeys: ClientKeysConnection;
  /** Reads and enables pagination through a set of `ConnectorRuntime`. */
  connectorRuntimes: ConnectorRuntimesConnection;
  created: Scalars['Datetime']['output'];
  /** Get information for current user in this environment */
  currentBusinessUser?: Maybe<BusinessUser>;
  /** Get current users test synced user - computed column */
  currentSyncedEndUser?: Maybe<SyncedEndUser>;
  /** Reads and enables pagination through a set of `CustomerToken`. */
  customerTokens: CustomerTokensConnection;
  /** Reads and enables pagination through a set of `EndUserSegment`. */
  endUserSegments: EndUserSegmentsConnection;
  /** Reads and enables pagination through a set of `EventDefinition`. */
  eventDefinitions: EventDefinitionsConnection;
  /** Reads and enables pagination through a set of `Grant`. */
  grants: GrantsConnection;
  id: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `InsightsReport`. */
  insightsReports: InsightsReportsConnection;
  /** Reads and enables pagination through a set of `MagicLink`. */
  magicLinks: MagicLinksConnection;
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organisation` that is related to this `Environment`. */
  organisation?: Maybe<Organisation>;
  organisationId: Scalars['String']['output'];
  preferences: Scalars['JSON']['output'];
  /** @deprecated this implementation should be replaced with a function that returns a stream_container record instead of a custom table definition */
  streamContainers: EnvironmentStreamContainersConnection;
  /** Reads and enables pagination through a set of `Stream`. */
  streams: StreamsConnection;
  /** Reads and enables pagination through a set of `SyncedEndUser`. */
  syncedEndUsers: SyncedEndUsersConnection;
  /** Reads and enables pagination through a set of `Tag`. */
  tags: TagsConnection;
  /** Reads and enables pagination through a set of `Theme`. */
  themes: ThemesConnection;
  /** Reads and enables pagination through a set of `TriggerEvent`. */
  triggerEvents: TriggerEventsConnection;
  updated: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `WebhookCredential`. */
  webhookCredentials: WebhookCredentialsConnection;
  /** Reads and enables pagination through a set of `WebhookEndpoint`. */
  webhookEndpoints: WebhookEndpointsConnection;
  /** Reads and enables pagination through a set of `WorkbenchFolder`. */
  workbenchFolders: WorkbenchFoldersConnection;
};


/** A deployed environment within an organisation, i.e. production or staging */
export type EnvironmentActionFlowConfigVersionAnalyticsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ActionFlowConfigVersionAnalyticCondition>;
  filter?: InputMaybe<ActionFlowConfigVersionAnalyticFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActionFlowConfigVersionAnalyticsOrderBy>>;
};


/** A deployed environment within an organisation, i.e. production or staging */
export type EnvironmentActiveStreamContainersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<EnvironmentActiveStreamContainersRecordFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** A deployed environment within an organisation, i.e. production or staging */
export type EnvironmentAnalyticsBatchesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AnalyticsBatchCondition>;
  filter?: InputMaybe<AnalyticsBatchFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AnalyticsBatchesOrderBy>>;
};


/** A deployed environment within an organisation, i.e. production or staging */
export type EnvironmentApprovalRequiredGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<GroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** A deployed environment within an organisation, i.e. production or staging */
export type EnvironmentCardTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CardTemplateCondition>;
  filter?: InputMaybe<CardTemplateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CardTemplatesOrderBy>>;
};


/** A deployed environment within an organisation, i.e. production or staging */
export type EnvironmentCardTemplatesByOrganisationIdAndEnvironmentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CardTemplateCondition>;
  filter?: InputMaybe<CardTemplateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CardTemplatesOrderBy>>;
};


/** A deployed environment within an organisation, i.e. production or staging */
export type EnvironmentClientKeysArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ClientKeyCondition>;
  filter?: InputMaybe<ClientKeyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ClientKeysOrderBy>>;
};


/** A deployed environment within an organisation, i.e. production or staging */
export type EnvironmentConnectorRuntimesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ConnectorRuntimeCondition>;
  filter?: InputMaybe<ConnectorRuntimeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ConnectorRuntimesOrderBy>>;
};


/** A deployed environment within an organisation, i.e. production or staging */
export type EnvironmentCustomerTokensArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CustomerTokenCondition>;
  filter?: InputMaybe<CustomerTokenFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CustomerTokensOrderBy>>;
};


/** A deployed environment within an organisation, i.e. production or staging */
export type EnvironmentEndUserSegmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EndUserSegmentCondition>;
  filter?: InputMaybe<EndUserSegmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EndUserSegmentsOrderBy>>;
};


/** A deployed environment within an organisation, i.e. production or staging */
export type EnvironmentEventDefinitionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EventDefinitionCondition>;
  filter?: InputMaybe<EventDefinitionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EventDefinitionsOrderBy>>;
};


/** A deployed environment within an organisation, i.e. production or staging */
export type EnvironmentGrantsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GrantCondition>;
  filter?: InputMaybe<GrantFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GrantsOrderBy>>;
};


/** A deployed environment within an organisation, i.e. production or staging */
export type EnvironmentInsightsReportsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<InsightsReportCondition>;
  filter?: InputMaybe<InsightsReportFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InsightsReportsOrderBy>>;
};


/** A deployed environment within an organisation, i.e. production or staging */
export type EnvironmentMagicLinksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MagicLinkCondition>;
  filter?: InputMaybe<MagicLinkFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MagicLinksOrderBy>>;
};


/** A deployed environment within an organisation, i.e. production or staging */
export type EnvironmentStreamContainersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<EnvironmentStreamContainersRecordFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** A deployed environment within an organisation, i.e. production or staging */
export type EnvironmentStreamsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<StreamCondition>;
  filter?: InputMaybe<StreamFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<StreamsOrderBy>>;
};


/** A deployed environment within an organisation, i.e. production or staging */
export type EnvironmentSyncedEndUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SyncedEndUserCondition>;
  filter?: InputMaybe<SyncedEndUserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SyncedEndUsersOrderBy>>;
};


/** A deployed environment within an organisation, i.e. production or staging */
export type EnvironmentTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TagCondition>;
  filter?: InputMaybe<TagFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagsOrderBy>>;
};


/** A deployed environment within an organisation, i.e. production or staging */
export type EnvironmentThemesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ThemeCondition>;
  filter?: InputMaybe<ThemeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ThemesOrderBy>>;
};


/** A deployed environment within an organisation, i.e. production or staging */
export type EnvironmentTriggerEventsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TriggerEventCondition>;
  filter?: InputMaybe<TriggerEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TriggerEventsOrderBy>>;
};


/** A deployed environment within an organisation, i.e. production or staging */
export type EnvironmentWebhookCredentialsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<WebhookCredentialCondition>;
  filter?: InputMaybe<WebhookCredentialFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WebhookCredentialsOrderBy>>;
};


/** A deployed environment within an organisation, i.e. production or staging */
export type EnvironmentWebhookEndpointsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<WebhookEndpointCondition>;
  filter?: InputMaybe<WebhookEndpointFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WebhookEndpointsOrderBy>>;
};


/** A deployed environment within an organisation, i.e. production or staging */
export type EnvironmentWorkbenchFoldersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<WorkbenchFolderCondition>;
  filter?: InputMaybe<WorkbenchFolderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WorkbenchFoldersOrderBy>>;
};

/** A `EnvironmentActiveStreamContainersRecord` edge in the connection. */
export type EnvironmentActiveStreamContainerEdge = {
  __typename?: 'EnvironmentActiveStreamContainerEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `EnvironmentActiveStreamContainersRecord` at the end of the edge. */
  node: EnvironmentActiveStreamContainersRecord;
};

/** A connection to a list of `EnvironmentActiveStreamContainersRecord` values. */
export type EnvironmentActiveStreamContainersConnection = {
  __typename?: 'EnvironmentActiveStreamContainersConnection';
  /** A list of edges which contains the `EnvironmentActiveStreamContainersRecord` and cursor to aid in pagination. */
  edges: Array<EnvironmentActiveStreamContainerEdge>;
  /** A list of `EnvironmentActiveStreamContainersRecord` objects. */
  nodes: Array<EnvironmentActiveStreamContainersRecord>;
  /** The count of *all* `EnvironmentActiveStreamContainersRecord` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** The return type of our `activeStreamContainers` query. */
export type EnvironmentActiveStreamContainersRecord = {
  __typename?: 'EnvironmentActiveStreamContainersRecord';
  id?: Maybe<Scalars['String']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  streamId?: Maybe<Scalars['String']['output']>;
  streamName?: Maybe<Scalars['String']['output']>;
};

/** A filter to be used against `EnvironmentActiveStreamContainersRecord` object types. All fields are combined with a logical ‘and.’ */
export type EnvironmentActiveStreamContainersRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EnvironmentActiveStreamContainersRecordFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `isDefault` field. */
  isDefault?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EnvironmentActiveStreamContainersRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EnvironmentActiveStreamContainersRecordFilter>>;
  /** Filter by the object’s `streamId` field. */
  streamId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `streamName` field. */
  streamName?: InputMaybe<StringFilter>;
};

/**
 * A condition to be used against `Environment` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type EnvironmentCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organisationId` field. */
  organisationId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `Environment` object types. All fields are combined with a logical ‘and.’ */
export type EnvironmentFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EnvironmentFilter>>;
  /** Filter by the object’s `approvalsEnabled` field. */
  approvalsEnabled?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EnvironmentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EnvironmentFilter>>;
  /** Filter by the object’s `organisationId` field. */
  organisationId?: InputMaybe<StringFilter>;
};

/** Represents an update to a `Environment`. Fields that are set will be updated. */
export type EnvironmentPatch = {
  actionConfiguration?: InputMaybe<Scalars['JSON']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  preferences?: InputMaybe<Scalars['JSON']['input']>;
};

/** A `EnvironmentStreamContainersRecord` edge in the connection. */
export type EnvironmentStreamContainerEdge = {
  __typename?: 'EnvironmentStreamContainerEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `EnvironmentStreamContainersRecord` at the end of the edge. */
  node: EnvironmentStreamContainersRecord;
};

/** A connection to a list of `EnvironmentStreamContainersRecord` values. */
export type EnvironmentStreamContainersConnection = {
  __typename?: 'EnvironmentStreamContainersConnection';
  /** A list of edges which contains the `EnvironmentStreamContainersRecord` and cursor to aid in pagination. */
  edges: Array<EnvironmentStreamContainerEdge>;
  /** A list of `EnvironmentStreamContainersRecord` objects. */
  nodes: Array<EnvironmentStreamContainersRecord>;
  /** The count of *all* `EnvironmentStreamContainersRecord` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** The return type of our `streamContainers` query. */
export type EnvironmentStreamContainersRecord = {
  __typename?: 'EnvironmentStreamContainersRecord';
  id?: Maybe<Scalars['String']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  streamId?: Maybe<Scalars['String']['output']>;
  streamName?: Maybe<Scalars['String']['output']>;
};

/** A filter to be used against `EnvironmentStreamContainersRecord` object types. All fields are combined with a logical ‘and.’ */
export type EnvironmentStreamContainersRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EnvironmentStreamContainersRecordFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `isDefault` field. */
  isDefault?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EnvironmentStreamContainersRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EnvironmentStreamContainersRecordFilter>>;
  /** Filter by the object’s `streamId` field. */
  streamId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `streamName` field. */
  streamName?: InputMaybe<StringFilter>;
};

/** A connection to a list of `Environment` values. */
export type EnvironmentsConnection = {
  __typename?: 'EnvironmentsConnection';
  /** A list of edges which contains the `Environment` and cursor to aid in pagination. */
  edges: Array<EnvironmentsEdge>;
  /** A list of `Environment` objects. */
  nodes: Array<Environment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Environment` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Environment` edge in the connection. */
export type EnvironmentsEdge = {
  __typename?: 'EnvironmentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Environment` at the end of the edge. */
  node: Environment;
};

/** Methods to use when ordering `Environment`. */
export enum EnvironmentsOrderBy {
  ActiveAsc = 'ACTIVE_ASC',
  ActiveDesc = 'ACTIVE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OrganisationIdAsc = 'ORGANISATION_ID_ASC',
  OrganisationIdDesc = 'ORGANISATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** Defines an event which may be used to trigger card instance creation */
export type EventDefinition = Node & {
  __typename?: 'EventDefinition';
  created: Scalars['Datetime']['output'];
  draftVersion?: Maybe<EventDefinitionVersion>;
  draftVersionNumber?: Maybe<Scalars['Int']['output']>;
  /** Returns either the current draft, or the most recently published version, we use this to display the "current" schema in the editor */
  editVersion?: Maybe<EventDefinitionVersion>;
  /** Reads a single `Environment` that is related to this `EventDefinition`. */
  environment?: Maybe<Environment>;
  environmentId: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `EventDefinitionVersion`. */
  eventDefinitionVersionsByEnvironmentIdAndEventDefinitionId: EventDefinitionVersionsConnection;
  eventName: Scalars['EventName']['output'];
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  lastUpdated?: Maybe<Scalars['Datetime']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `EventDefinitionVersion`. */
  publishedVersions: EventDefinitionVersionsConnection;
  status?: Maybe<EventDefinitionStatus>;
};


/** Defines an event which may be used to trigger card instance creation */
export type EventDefinitionEventDefinitionVersionsByEnvironmentIdAndEventDefinitionIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EventDefinitionVersionCondition>;
  filter?: InputMaybe<EventDefinitionVersionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EventDefinitionVersionsOrderBy>>;
};


/** Defines an event which may be used to trigger card instance creation */
export type EventDefinitionPublishedVersionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<EventDefinitionVersionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A condition to be used against `EventDefinition` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type EventDefinitionCondition = {
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `eventName` field. */
  eventName?: InputMaybe<Scalars['EventName']['input']>;
  /** Checks for equality with the object’s `isDefault` field. */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<EventDefinitionStatus>;
};

/** A filter to be used against `EventDefinition` object types. All fields are combined with a logical ‘and.’ */
export type EventDefinitionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EventDefinitionFilter>>;
  /** Filter by the object’s `draftVersionNumber` field. */
  draftVersionNumber?: InputMaybe<IntFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `eventName` field. */
  eventName?: InputMaybe<EventNameFilter>;
  /** Filter by the object’s `isDefault` field. */
  isDefault?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `lastUpdated` field. */
  lastUpdated?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EventDefinitionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EventDefinitionFilter>>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<EventDefinitionStatusFilter>;
};

/** An input for mutations affecting `EventDefinition` */
export type EventDefinitionInput = {
  environmentId: Scalars['String']['input'];
  eventName: Scalars['EventName']['input'];
};

export enum EventDefinitionStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

/** A filter to be used against EventDefinitionStatus fields. All fields are combined with a logical ‘and.’ */
export type EventDefinitionStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<EventDefinitionStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<EventDefinitionStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<EventDefinitionStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<EventDefinitionStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<EventDefinitionStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<EventDefinitionStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<EventDefinitionStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<EventDefinitionStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<EventDefinitionStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<EventDefinitionStatus>>;
};

/** A version of a card template - immutable if published */
export type EventDefinitionVersion = Node & {
  __typename?: 'EventDefinitionVersion';
  clientTriggerEnabled: Scalars['Boolean']['output'];
  created: Scalars['Datetime']['output'];
  detailSchema?: Maybe<Scalars['JSON']['output']>;
  /** Reads a single `EventDefinition` that is related to this `EventDefinitionVersion`. */
  environmentEventDefinition?: Maybe<EventDefinition>;
  environmentId: Scalars['String']['output'];
  eventDefinitionId: Scalars['String']['output'];
  eventName?: Maybe<Scalars['String']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  status: EventDefinitionStatus;
  sysPeriod: DatetimeRange;
  /** Reads and enables pagination through a set of `TriggerEvent`. */
  triggerEventsByEnvironmentIdAndEventDefinitionIdAndEventDefinitionVersion: TriggerEventsConnection;
  updated: Scalars['Datetime']['output'];
  version: Scalars['Int']['output'];
};


/** A version of a card template - immutable if published */
export type EventDefinitionVersionTriggerEventsByEnvironmentIdAndEventDefinitionIdAndEventDefinitionVersionArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TriggerEventCondition>;
  filter?: InputMaybe<TriggerEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TriggerEventsOrderBy>>;
};

/**
 * A condition to be used against `EventDefinitionVersion` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type EventDefinitionVersionCondition = {
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
};

/** A filter to be used against `EventDefinitionVersion` object types. All fields are combined with a logical ‘and.’ */
export type EventDefinitionVersionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EventDefinitionVersionFilter>>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `eventName` field. */
  eventName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `isDefault` field. */
  isDefault?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EventDefinitionVersionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EventDefinitionVersionFilter>>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
};

/** An input for mutations affecting `EventDefinitionVersion` */
export type EventDefinitionVersionInput = {
  clientTriggerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  detailSchema?: InputMaybe<Scalars['JSON']['input']>;
  environmentId: Scalars['String']['input'];
  eventDefinitionId: Scalars['String']['input'];
  status?: InputMaybe<EventDefinitionStatus>;
  version: Scalars['Int']['input'];
};

/** Represents an update to a `EventDefinitionVersion`. Fields that are set will be updated. */
export type EventDefinitionVersionPatch = {
  clientTriggerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  detailSchema?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<EventDefinitionStatus>;
};

/** A connection to a list of `EventDefinitionVersion` values. */
export type EventDefinitionVersionsConnection = {
  __typename?: 'EventDefinitionVersionsConnection';
  /** A list of edges which contains the `EventDefinitionVersion` and cursor to aid in pagination. */
  edges: Array<EventDefinitionVersionsEdge>;
  /** A list of `EventDefinitionVersion` objects. */
  nodes: Array<EventDefinitionVersion>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EventDefinitionVersion` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `EventDefinitionVersion` edge in the connection. */
export type EventDefinitionVersionsEdge = {
  __typename?: 'EventDefinitionVersionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `EventDefinitionVersion` at the end of the edge. */
  node: EventDefinitionVersion;
};

/** Methods to use when ordering `EventDefinitionVersion`. */
export enum EventDefinitionVersionsOrderBy {
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SysPeriodAsc = 'SYS_PERIOD_ASC',
  SysPeriodDesc = 'SYS_PERIOD_DESC'
}

/** A connection to a list of `EventDefinition` values. */
export type EventDefinitionsConnection = {
  __typename?: 'EventDefinitionsConnection';
  /** A list of edges which contains the `EventDefinition` and cursor to aid in pagination. */
  edges: Array<EventDefinitionsEdge>;
  /** A list of `EventDefinition` objects. */
  nodes: Array<EventDefinition>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EventDefinition` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `EventDefinition` edge in the connection. */
export type EventDefinitionsEdge = {
  __typename?: 'EventDefinitionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `EventDefinition` at the end of the edge. */
  node: EventDefinition;
};

/** Methods to use when ordering `EventDefinition`. */
export enum EventDefinitionsOrderBy {
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  EventNameAsc = 'EVENT_NAME_ASC',
  EventNameDesc = 'EVENT_NAME_DESC',
  IsDefaultAsc = 'IS_DEFAULT_ASC',
  IsDefaultDesc = 'IS_DEFAULT_DESC',
  LastUpdatedAsc = 'LAST_UPDATED_ASC',
  LastUpdatedDesc = 'LAST_UPDATED_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC'
}

/** A filter to be used against EventName fields. All fields are combined with a logical ‘and.’ */
export type EventNameFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['EventName']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value (case-insensitive). */
  distinctFromInsensitive?: InputMaybe<Scalars['EventName']['input']>;
  /** Ends with the specified string (case-sensitive). */
  endsWith?: InputMaybe<Scalars['EventName']['input']>;
  /** Ends with the specified string (case-insensitive). */
  endsWithInsensitive?: InputMaybe<Scalars['EventName']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['EventName']['input']>;
  /** Equal to the specified value (case-insensitive). */
  equalToInsensitive?: InputMaybe<Scalars['EventName']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['EventName']['input']>;
  /** Greater than the specified value (case-insensitive). */
  greaterThanInsensitive?: InputMaybe<Scalars['EventName']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['EventName']['input']>;
  /** Greater than or equal to the specified value (case-insensitive). */
  greaterThanOrEqualToInsensitive?: InputMaybe<Scalars['EventName']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['EventName']['input']>>;
  /** Included in the specified list (case-insensitive). */
  inInsensitive?: InputMaybe<Array<Scalars['EventName']['input']>>;
  /** Contains the specified string (case-sensitive). */
  includes?: InputMaybe<Scalars['EventName']['input']>;
  /** Contains the specified string (case-insensitive). */
  includesInsensitive?: InputMaybe<Scalars['EventName']['input']>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['EventName']['input']>;
  /** Less than the specified value (case-insensitive). */
  lessThanInsensitive?: InputMaybe<Scalars['EventName']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['EventName']['input']>;
  /** Less than or equal to the specified value (case-insensitive). */
  lessThanOrEqualToInsensitive?: InputMaybe<Scalars['EventName']['input']>;
  /** Matches the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  like?: InputMaybe<Scalars['EventName']['input']>;
  /** Matches the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  likeInsensitive?: InputMaybe<Scalars['EventName']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['EventName']['input']>;
  /** Equal to the specified value, treating null like an ordinary value (case-insensitive). */
  notDistinctFromInsensitive?: InputMaybe<Scalars['EventName']['input']>;
  /** Does not end with the specified string (case-sensitive). */
  notEndsWith?: InputMaybe<Scalars['EventName']['input']>;
  /** Does not end with the specified string (case-insensitive). */
  notEndsWithInsensitive?: InputMaybe<Scalars['EventName']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['EventName']['input']>;
  /** Not equal to the specified value (case-insensitive). */
  notEqualToInsensitive?: InputMaybe<Scalars['EventName']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['EventName']['input']>>;
  /** Not included in the specified list (case-insensitive). */
  notInInsensitive?: InputMaybe<Array<Scalars['EventName']['input']>>;
  /** Does not contain the specified string (case-sensitive). */
  notIncludes?: InputMaybe<Scalars['EventName']['input']>;
  /** Does not contain the specified string (case-insensitive). */
  notIncludesInsensitive?: InputMaybe<Scalars['EventName']['input']>;
  /** Does not match the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLike?: InputMaybe<Scalars['EventName']['input']>;
  /** Does not match the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLikeInsensitive?: InputMaybe<Scalars['EventName']['input']>;
  /** Does not start with the specified string (case-sensitive). */
  notStartsWith?: InputMaybe<Scalars['EventName']['input']>;
  /** Does not start with the specified string (case-insensitive). */
  notStartsWithInsensitive?: InputMaybe<Scalars['EventName']['input']>;
  /** Starts with the specified string (case-sensitive). */
  startsWith?: InputMaybe<Scalars['EventName']['input']>;
  /** Starts with the specified string (case-insensitive). */
  startsWithInsensitive?: InputMaybe<Scalars['EventName']['input']>;
};

export enum EventSource {
  Live = 'LIVE',
  Test = 'TEST'
}

export type FeatureFlags = {
  __typename?: 'FeatureFlags';
  deprecatedEvents?: Maybe<Scalars['Boolean']['output']>;
  experimentalWebhooks?: Maybe<Scalars['Boolean']['output']>;
  featurePreview?: Maybe<Scalars['Boolean']['output']>;
  isInternal?: Maybe<Scalars['Boolean']['output']>;
};

export type FlowInstanceOutput = {
  __typename?: 'FlowInstanceOutput';
  flowInstance?: Maybe<Scalars['JSON']['output']>;
  stepOutput?: Maybe<Scalars['JSON']['output']>;
};

export type GetActionFlowInstanceOutput = {
  __typename?: 'GetActionFlowInstanceOutput';
  instances?: Maybe<Array<Maybe<FlowInstanceOutput>>>;
};

export type Grant = Node & {
  __typename?: 'Grant';
  /** Reads a single `Environment` that is related to this `Grant`. */
  environment?: Maybe<Environment>;
  environmentId?: Maybe<Scalars['String']['output']>;
  groupId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organisation` that is related to this `Grant`. */
  organisation?: Maybe<Organisation>;
  /** Reads a single `Group` that is related to this `Grant`. */
  organisationGroup?: Maybe<Group>;
  organisationId: Scalars['String']['output'];
  /** Reads a single `CustomRole` that is related to this `Grant`. */
  organisationRole?: Maybe<CustomRole>;
  roleId: Scalars['String']['output'];
};

/** A condition to be used against `Grant` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type GrantCondition = {
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organisationId` field. */
  organisationId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `Grant` object types. All fields are combined with a logical ‘and.’ */
export type GrantFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GrantFilter>>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GrantFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GrantFilter>>;
  /** Filter by the object’s `organisationId` field. */
  organisationId?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `Grant` */
export type GrantInput = {
  environmentId?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
  roleId: Scalars['String']['input'];
};

/** Represents an update to a `Grant`. Fields that are set will be updated. */
export type GrantPatch = {
  environmentId?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
};

export type Grants = {
  environmentId?: InputMaybe<Scalars['String']['input']>;
  roleId: Scalars['String']['input'];
};

/** A connection to a list of `Grant` values. */
export type GrantsConnection = {
  __typename?: 'GrantsConnection';
  /** A list of edges which contains the `Grant` and cursor to aid in pagination. */
  edges: Array<GrantsEdge>;
  /** A list of `Grant` objects. */
  nodes: Array<Grant>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Grant` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Grant` edge in the connection. */
export type GrantsEdge = {
  __typename?: 'GrantsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Grant` at the end of the edge. */
  node: Grant;
};

/** Methods to use when ordering `Grant`. */
export enum GrantsOrderBy {
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  Natural = 'NATURAL',
  OrganisationIdAsc = 'ORGANISATION_ID_ASC',
  OrganisationIdDesc = 'ORGANISATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type Group = Node & {
  __typename?: 'Group';
  /** Reads and enables pagination through a set of `ActionFlowApproval`. */
  actionFlowApprovalsByOrganisationIdAndGroupId: ActionFlowApprovalsConnection;
  /** Reads and enables pagination through a set of `BusinessUserGroup`. */
  businessUserGroupsByOrganisationIdAndGroupId: BusinessUserGroupsConnection;
  /** Reads and enables pagination through a set of `CardApproval`. */
  cardApprovalsByOrganisationIdAndGroupId: CardApprovalsConnection;
  description?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `Grant`. */
  grantsByOrganisationIdAndGroupId: GrantsConnection;
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organisation` that is related to this `Group`. */
  organisation?: Maybe<Organisation>;
  organisationId: Scalars['String']['output'];
};


export type GroupActionFlowApprovalsByOrganisationIdAndGroupIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ActionFlowApprovalCondition>;
  filter?: InputMaybe<ActionFlowApprovalFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActionFlowApprovalsOrderBy>>;
};


export type GroupBusinessUserGroupsByOrganisationIdAndGroupIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BusinessUserGroupCondition>;
  filter?: InputMaybe<BusinessUserGroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessUserGroupsOrderBy>>;
};


export type GroupCardApprovalsByOrganisationIdAndGroupIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CardApprovalCondition>;
  filter?: InputMaybe<CardApprovalFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CardApprovalsOrderBy>>;
};


export type GroupGrantsByOrganisationIdAndGroupIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GrantCondition>;
  filter?: InputMaybe<GrantFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GrantsOrderBy>>;
};

/** A condition to be used against `Group` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type GroupCondition = {
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `organisationId` field. */
  organisationId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `Group` object types. All fields are combined with a logical ‘and.’ */
export type GroupFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GroupFilter>>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GroupFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GroupFilter>>;
  /** Filter by the object’s `organisationId` field. */
  organisationId?: InputMaybe<StringFilter>;
};

export type GroupGrantsInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  grants?: InputMaybe<Array<Grants>>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
};

export type GroupGrantsPayload = {
  __typename?: 'GroupGrantsPayload';
  group?: Maybe<Group>;
};

/** An input for mutations affecting `Group` */
export type GroupInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
};

/** Represents an update to a `Group`. Fields that are set will be updated. */
export type GroupPatch = {
  description?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `Group` values. */
export type GroupsConnection = {
  __typename?: 'GroupsConnection';
  /** A list of edges which contains the `Group` and cursor to aid in pagination. */
  edges: Array<GroupsEdge>;
  /** A list of `Group` objects. */
  nodes: Array<Group>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Group` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Group` edge in the connection. */
export type GroupsEdge = {
  __typename?: 'GroupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Group` at the end of the edge. */
  node: Group;
};

/** Methods to use when ordering `Group`. */
export enum GroupsOrderBy {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  OrganisationIdAsc = 'ORGANISATION_ID_ASC',
  OrganisationIdDesc = 'ORGANISATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type Insights = {
  __typename?: 'Insights';
  cardAnalyticsCounts: Scalars['JSON']['output'];
  cardAnalyticsTrends: Array<Maybe<Scalars['JSON']['output']>>;
  resolution: Scalars['String']['output'];
};

export type InsightsReport = Node & {
  __typename?: 'InsightsReport';
  counts: Scalars['JSON']['output'];
  created: Scalars['Datetime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Environment` that is related to this `InsightsReport`. */
  environment?: Maybe<Environment>;
  environmentId: Scalars['String']['output'];
  filters: Scalars['JSON']['output'];
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  regeneratedAt?: Maybe<Scalars['Datetime']['output']>;
  status: InsightsReportStatus;
  trends: Scalars['JSON']['output'];
  triggeredBy?: Maybe<Scalars['Int']['output']>;
  updated: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `InsightsReport` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type InsightsReportCondition = {
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updated` field. */
  updated?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `InsightsReport` object types. All fields are combined with a logical ‘and.’ */
export type InsightsReportFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<InsightsReportFilter>>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<InsightsReportFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<InsightsReportFilter>>;
  /** Filter by the object’s `updated` field. */
  updated?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `InsightsReport` */
export type InsightsReportInput = {
  counts?: InputMaybe<Scalars['JSON']['input']>;
  created?: InputMaybe<Scalars['Datetime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  filters: Scalars['JSON']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  regeneratedAt?: InputMaybe<Scalars['Datetime']['input']>;
  status?: InputMaybe<InsightsReportStatus>;
  trends?: InputMaybe<Scalars['JSON']['input']>;
  triggeredBy?: InputMaybe<Scalars['Int']['input']>;
  updated?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Represents an update to a `InsightsReport`. Fields that are set will be updated. */
export type InsightsReportPatch = {
  regeneratedAt?: InputMaybe<Scalars['Datetime']['input']>;
  status?: InputMaybe<InsightsReportStatus>;
};

export enum InsightsReportStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

/** A connection to a list of `InsightsReport` values. */
export type InsightsReportsConnection = {
  __typename?: 'InsightsReportsConnection';
  /** A list of edges which contains the `InsightsReport` and cursor to aid in pagination. */
  edges: Array<InsightsReportsEdge>;
  /** A list of `InsightsReport` objects. */
  nodes: Array<InsightsReport>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `InsightsReport` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `InsightsReport` edge in the connection. */
export type InsightsReportsEdge = {
  __typename?: 'InsightsReportsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `InsightsReport` at the end of the edge. */
  node: InsightsReport;
};

/** Methods to use when ordering `InsightsReport`. */
export enum InsightsReportsOrderBy {
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAsc = 'UPDATED_ASC',
  UpdatedDesc = 'UPDATED_DESC'
}

export type InsightsResponse = {
  __typename?: 'InsightsResponse';
  insights?: Maybe<Insights>;
};

/** A filter to be used against Int fields. All fields are combined with a logical ‘and.’ */
export type IntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Int']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntegrationConfiguration = Node & {
  __typename?: 'IntegrationConfiguration';
  associatedActionFlows: Array<ActionFlowIntegrationSummary>;
  configuration: Scalars['JSON']['output'];
  created: Scalars['Datetime']['output'];
  enabled?: Maybe<Scalars['Boolean']['output']>;
  environmentId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  integrationType: IntegrationType;
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  organisationId: Scalars['String']['output'];
  updated: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `IntegrationConfiguration` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type IntegrationConfigurationCondition = {
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `integrationType` field. */
  integrationType?: InputMaybe<IntegrationType>;
};

/** A filter to be used against `IntegrationConfiguration` object types. All fields are combined with a logical ‘and.’ */
export type IntegrationConfigurationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<IntegrationConfigurationFilter>>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `integrationType` field. */
  integrationType?: InputMaybe<IntegrationTypeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<IntegrationConfigurationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<IntegrationConfigurationFilter>>;
};

/** An input for mutations affecting `IntegrationConfiguration` */
export type IntegrationConfigurationInput = {
  configuration: Scalars['JSON']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  environmentId: Scalars['String']['input'];
  integrationType: IntegrationType;
  name: Scalars['String']['input'];
};

/** Represents an update to a `IntegrationConfiguration`. Fields that are set will be updated. */
export type IntegrationConfigurationPatch = {
  configuration?: InputMaybe<Scalars['JSON']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `IntegrationConfiguration` values. */
export type IntegrationConfigurationsConnection = {
  __typename?: 'IntegrationConfigurationsConnection';
  /** A list of edges which contains the `IntegrationConfiguration` and cursor to aid in pagination. */
  edges: Array<IntegrationConfigurationsEdge>;
  /** A list of `IntegrationConfiguration` objects. */
  nodes: Array<IntegrationConfiguration>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `IntegrationConfiguration` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `IntegrationConfiguration` edge in the connection. */
export type IntegrationConfigurationsEdge = {
  __typename?: 'IntegrationConfigurationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `IntegrationConfiguration` at the end of the edge. */
  node: IntegrationConfiguration;
};

/** Methods to use when ordering `IntegrationConfiguration`. */
export enum IntegrationConfigurationsOrderBy {
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  IntegrationTypeAsc = 'INTEGRATION_TYPE_ASC',
  IntegrationTypeDesc = 'INTEGRATION_TYPE_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export enum IntegrationType {
  MarketoSsfs = 'MARKETO_SSFS',
  SfmcJb = 'SFMC_JB'
}

/** A filter to be used against IntegrationType fields. All fields are combined with a logical ‘and.’ */
export type IntegrationTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<IntegrationType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<IntegrationType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<IntegrationType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<IntegrationType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<IntegrationType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<IntegrationType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<IntegrationType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<IntegrationType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<IntegrationType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<IntegrationType>>;
};

/** An interval of time that has passed where the smallest distinct unit is a second. */
export type Interval = {
  __typename?: 'Interval';
  /** A quantity of days. */
  days?: Maybe<Scalars['Int']['output']>;
  /** A quantity of hours. */
  hours?: Maybe<Scalars['Int']['output']>;
  /** A quantity of minutes. */
  minutes?: Maybe<Scalars['Int']['output']>;
  /** A quantity of months. */
  months?: Maybe<Scalars['Int']['output']>;
  /**
   * A quantity of seconds. This is the only non-integer field, as all the other
   * fields will dump their overflow into a smaller unit of time. Intervals don’t
   * have a smaller unit than seconds.
   */
  seconds?: Maybe<Scalars['Float']['output']>;
  /** A quantity of years. */
  years?: Maybe<Scalars['Int']['output']>;
};

/** An interval of time that has passed where the smallest distinct unit is a second. */
export type IntervalInput = {
  /** A quantity of days. */
  days?: InputMaybe<Scalars['Int']['input']>;
  /** A quantity of hours. */
  hours?: InputMaybe<Scalars['Int']['input']>;
  /** A quantity of minutes. */
  minutes?: InputMaybe<Scalars['Int']['input']>;
  /** A quantity of months. */
  months?: InputMaybe<Scalars['Int']['input']>;
  /**
   * A quantity of seconds. This is the only non-integer field, as all the other
   * fields will dump their overflow into a smaller unit of time. Intervals don’t
   * have a smaller unit than seconds.
   */
  seconds?: InputMaybe<Scalars['Float']['input']>;
  /** A quantity of years. */
  years?: InputMaybe<Scalars['Int']['input']>;
};

/** All input for the `inviteBusinessUser` mutation. */
export type InviteBusinessUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  organisationId: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `inviteBusinessUser` mutation. */
export type InviteBusinessUserPayload = {
  __typename?: 'InviteBusinessUserPayload';
  /** Reads a single `Account` that is related to this `BusinessUser`. */
  account?: Maybe<Account>;
  businessUser?: Maybe<BusinessUser>;
  /** An edge for our `BusinessUser`. May be used by Relay 1. */
  businessUserEdge?: Maybe<BusinessUsersEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organisation` that is related to this `BusinessUser`. */
  organisation?: Maybe<Organisation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `inviteBusinessUser` mutation. */
export type InviteBusinessUserPayloadBusinessUserEdgeArgs = {
  orderBy?: InputMaybe<Array<BusinessUsersOrderBy>>;
};

/** A filter to be used against JSON fields. All fields are combined with a logical ‘and.’ */
export type JsonFilter = {
  /** Contained by the specified JSON. */
  containedBy?: InputMaybe<Scalars['JSON']['input']>;
  /** Contains the specified JSON. */
  contains?: InputMaybe<Scalars['JSON']['input']>;
  /** Contains all of the specified keys. */
  containsAllKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains any of the specified keys. */
  containsAnyKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains the specified key. */
  containsKey?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['JSON']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['JSON']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['JSON']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['JSON']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['JSON']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
};

export type LastSyncedEndUser = {
  __typename?: 'LastSyncedEndUser';
  id: Scalars['String']['output'];
  profile: Scalars['JSON']['output'];
};

export type LastSyncedEndUserInput = {
  id: Scalars['String']['input'];
  profile: Scalars['JSON']['input'];
};

export type MagicLink = Node & {
  __typename?: 'MagicLink';
  authSecret?: Maybe<Scalars['String']['output']>;
  created: Scalars['Datetime']['output'];
  endUserId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Environment` that is related to this `MagicLink`. */
  environment?: Maybe<Environment>;
  environmentId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  streamContainerId: Scalars['String']['output'];
  targetEndUserAuthSecret?: Maybe<Scalars['String']['output']>;
  targetEndUserId?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `MagicLink` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type MagicLinkCondition = {
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `MagicLink` object types. All fields are combined with a logical ‘and.’ */
export type MagicLinkFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MagicLinkFilter>>;
  /** Filter by the object’s `authSecret` field. */
  authSecret?: InputMaybe<StringFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MagicLinkFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MagicLinkFilter>>;
  /** Filter by the object’s `targetEndUserAuthSecret` field. */
  targetEndUserAuthSecret?: InputMaybe<StringFilter>;
  /** Filter by the object’s `targetEndUserId` field. */
  targetEndUserId?: InputMaybe<StringFilter>;
};

export type MagicLinkResult = {
  __typename?: 'MagicLinkResult';
  magicLink?: Maybe<MagicLink>;
};

/** A connection to a list of `MagicLink` values. */
export type MagicLinksConnection = {
  __typename?: 'MagicLinksConnection';
  /** A list of edges which contains the `MagicLink` and cursor to aid in pagination. */
  edges: Array<MagicLinksEdge>;
  /** A list of `MagicLink` objects. */
  nodes: Array<MagicLink>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MagicLink` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `MagicLink` edge in the connection. */
export type MagicLinksEdge = {
  __typename?: 'MagicLinksEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `MagicLink` at the end of the edge. */
  node: MagicLink;
};

/** Methods to use when ordering `MagicLink`. */
export enum MagicLinksOrderBy {
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type MarketoIntegrationConfiguration = {
  __typename?: 'MarketoIntegrationConfiguration';
  configuration: Scalars['JSON']['output'];
  created: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  environmentId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  integrationType: IntegrationType;
  name: Scalars['String']['output'];
};

/** All input for the `migrateCardTemplateToActionFlow` mutation. */
export type MigrateCardTemplateToActionFlowInput = {
  cardEnvironmentId: Scalars['String']['input'];
  cardTemplateId: Scalars['String']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  flowConfigId: Scalars['String']['input'];
};

/** The output of our `migrateCardTemplateToActionFlow` mutation. */
export type MigrateCardTemplateToActionFlowPayload = {
  __typename?: 'MigrateCardTemplateToActionFlowPayload';
  /** Reads a single `BusinessUser` that is related to this `CardTemplateVersion`. */
  businessUserByOrganisationIdAndPublishedBy?: Maybe<BusinessUser>;
  /** Reads a single `BusinessUser` that is related to this `CardTemplateVersion`. */
  businessUserByOrganisationIdAndUpdatedBy?: Maybe<BusinessUser>;
  cardTemplateVersion?: Maybe<CardTemplateVersion>;
  /** An edge for our `CardTemplateVersion`. May be used by Relay 1. */
  cardTemplateVersionEdge?: Maybe<CardTemplateVersionsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CardTemplate` that is related to this `CardTemplateVersion`. */
  environmentCardTemplate?: Maybe<CardTemplate>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `migrateCardTemplateToActionFlow` mutation. */
export type MigrateCardTemplateToActionFlowPayloadCardTemplateVersionEdgeArgs = {
  orderBy?: InputMaybe<Array<CardTemplateVersionsOrderBy>>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type Mutation = {
  __typename?: 'Mutation';
  /** Activate an invited business_user and account (if needed) */
  activateInvitedBusinessUserAccount?: Maybe<ActivateInvitedBusinessUserAccountPayload>;
  /** Adds a card template and first draft version */
  addCardTemplateWithVersion?: Maybe<AddCardTemplateWithVersionPayload>;
  addEventDefinitionWithVersion?: Maybe<AddEventDefinitionWithVersionPayload>;
  addTriggerEvent?: Maybe<AddTriggerEventPayload>;
  /** Processes a batch of action flow analytics events, aggregating them into the action_flow_config_version_analytics table and updating the cursor */
  aggregateActionFlowAnalytics?: Maybe<AggregateActionFlowAnalyticsPayload>;
  /** custom mutation, logs a action flow approval against the current user */
  approveActionFlow?: Maybe<ApproveActionFlowPayload>;
  approveActionFlowGroups?: Maybe<ApproveActionFlowGroupsPayload>;
  /** custom mutation, logs a card approval against the current user */
  approveCardTemplate?: Maybe<ApproveCardTemplatePayload>;
  approveCardTemplateGroups?: Maybe<ApproveCardTemplateGroupsPayload>;
  /** Sets active card template versions to archived */
  archiveActionFlowConfigVersions?: Maybe<ArchiveActionFlowConfigVersionsPayload>;
  /** Sets active card template versions to archived */
  archiveCardTemplateVersions?: Maybe<ArchiveCardTemplateVersionsPayload>;
  archiveEventDefinitions?: Maybe<ArchiveEventDefinitionsPayload>;
  /** Copies trigger_events from one card_template_version to another */
  copyCardTemplateEvents?: Maybe<CopyCardTemplateEventsPayload>;
  createActionFlowShareLink?: Maybe<ActionFlowShareLinkPayload>;
  /** Creates a single `BusinessUser`. */
  createBusinessUser?: Maybe<CreateBusinessUserPayload>;
  /** Creates a single `CardCancelTask`. */
  createCardCancelTask?: Maybe<CreateCardCancelTaskPayload>;
  /** Creates a single `CardTemplate`. */
  createCardTemplate?: Maybe<CreateCardTemplatePayload>;
  /** Creates a single `CardTemplateVersion`. */
  createCardTemplateVersion?: Maybe<CreateCardTemplateVersionPayload>;
  /** Creates a single `ClientKey`. */
  createClientKey?: Maybe<CreateClientKeyPayload>;
  /** Creates a single `ConnectorRuntime`. */
  createConnectorRuntime?: Maybe<CreateConnectorRuntimePayload>;
  /** Creates a single `CsvUploadTask`. */
  createCsvUploadTask?: Maybe<CreateCsvUploadTaskPayload>;
  /** Creates a single `CustomRole`. */
  createCustomRole?: Maybe<CreateCustomRolePayload>;
  /** Creates a single `EndUserSegment`. */
  createEndUserSegment?: Maybe<CreateEndUserSegmentPayload>;
  /** Create a new site ( environment ) with a generated id */
  createEnvironment?: Maybe<CreateEnvironmentPayload>;
  /** Creates a single `EventDefinition`. */
  createEventDefinition?: Maybe<CreateEventDefinitionPayload>;
  /** Creates a single `EventDefinitionVersion`. */
  createEventDefinitionVersion?: Maybe<CreateEventDefinitionVersionPayload>;
  /** Creates a single `Grant`. */
  createGrant?: Maybe<CreateGrantPayload>;
  /** Creates a single `Group`. */
  createGroup?: Maybe<CreateGroupPayload>;
  /** Creates a single `InsightsReport`. */
  createInsightsReport?: Maybe<CreateInsightsReportPayload>;
  /** Creates a single `IntegrationConfiguration`. */
  createIntegrationConfiguration?: Maybe<CreateIntegrationConfigurationPayload>;
  createMarketoIntegrationConfiguration?: Maybe<CreateMarketoIntegrationConfigurationPayload>;
  /** Creates a single `ResourceUser`. */
  createResourceUser?: Maybe<CreateResourceUserPayload>;
  /** Creates a single `RolePermission`. */
  createRolePermission?: Maybe<CreateRolePermissionPayload>;
  /** Creates a single `Stream`. */
  createStream?: Maybe<CreateStreamPayload>;
  /** Creates a single `StreamContainer`. */
  createStreamContainer?: Maybe<CreateStreamContainerPayload>;
  /** Creates a single `Tag`. */
  createTag?: Maybe<CreateTagPayload>;
  createTestEndUser?: Maybe<CreateTestEndUserResponse>;
  /** Creates a single `Theme`. */
  createTheme?: Maybe<CreateThemePayload>;
  /** Creates a single `TriggerEvent`. */
  createTriggerEvent?: Maybe<CreateTriggerEventPayload>;
  /** Creates a single `WebhookCredential`. */
  createWebhookCredential?: Maybe<CreateWebhookCredentialPayload>;
  /** Creates a single `WebhookEndpoint`. */
  createWebhookEndpoint?: Maybe<CreateWebhookEndpointPayload>;
  /** Creates a single `WorkbenchFolder`. */
  createWorkbenchFolder?: Maybe<CreateWorkbenchFolderPayload>;
  /** Deletes a single `ActionFlowApproval` using a unique key. */
  deleteActionFlowApproval?: Maybe<DeleteActionFlowApprovalPayload>;
  /** Deletes a single `ActionFlowApproval` using its globally unique id. */
  deleteActionFlowApprovalByNodeId?: Maybe<DeleteActionFlowApprovalPayload>;
  /** Deletes a single `ActionFlowApprovalRequest` using a unique key. */
  deleteActionFlowApprovalRequest?: Maybe<DeleteActionFlowApprovalRequestPayload>;
  /** Deletes a single `ActionFlowApprovalRequest` using its globally unique id. */
  deleteActionFlowApprovalRequestByNodeId?: Maybe<DeleteActionFlowApprovalRequestPayload>;
  /** delete logged approvals for a action flow */
  deleteActionFlowApprovals?: Maybe<DeleteActionFlowApprovalsPayload>;
  /** Deletes a single `ActionFlowConfig` using a unique key. */
  deleteActionFlowConfig?: Maybe<DeleteActionFlowConfigPayload>;
  /** Deletes a single `ActionFlowConfig` using its globally unique id. */
  deleteActionFlowConfigByNodeId?: Maybe<DeleteActionFlowConfigPayload>;
  /** Deletes a single `BusinessUser` using a unique key. */
  deleteBusinessUser?: Maybe<DeleteBusinessUserPayload>;
  /** Deletes a single `BusinessUser` using a unique key. */
  deleteBusinessUserByInviteSecret?: Maybe<DeleteBusinessUserPayload>;
  /** Deletes a single `BusinessUser` using its globally unique id. */
  deleteBusinessUserByNodeId?: Maybe<DeleteBusinessUserPayload>;
  /** Deletes a single `BusinessUser` using a unique key. */
  deleteBusinessUserByOrganisationIdAndId?: Maybe<DeleteBusinessUserPayload>;
  /** Deletes a single `CardApproval` using a unique key. */
  deleteCardApproval?: Maybe<DeleteCardApprovalPayload>;
  /** Deletes a single `CardApproval` using its globally unique id. */
  deleteCardApprovalByNodeId?: Maybe<DeleteCardApprovalPayload>;
  /** Deletes a single `CardApprovalRequest` using a unique key. */
  deleteCardApprovalRequest?: Maybe<DeleteCardApprovalRequestPayload>;
  /** Deletes a single `CardApprovalRequest` using its globally unique id. */
  deleteCardApprovalRequestByNodeId?: Maybe<DeleteCardApprovalRequestPayload>;
  /** delete logged approvals for a card template */
  deleteCardApprovals?: Maybe<DeleteCardApprovalsPayload>;
  /** Deletes a single `CardTemplate` using a unique key. */
  deleteCardTemplate?: Maybe<DeleteCardTemplatePayload>;
  /** Deletes a single `CardTemplate` using its globally unique id. */
  deleteCardTemplateByNodeId?: Maybe<DeleteCardTemplatePayload>;
  /** Deletes a single `ClientKey` using a unique key. */
  deleteClientKey?: Maybe<DeleteClientKeyPayload>;
  /** Deletes a single `ClientKey` using a unique key. */
  deleteClientKeyByApiKey?: Maybe<DeleteClientKeyPayload>;
  /** Deletes a single `ClientKey` using its globally unique id. */
  deleteClientKeyByNodeId?: Maybe<DeleteClientKeyPayload>;
  /** Deletes a single `ConnectorRuntime` using a unique key. */
  deleteConnectorRuntime?: Maybe<DeleteConnectorRuntimePayload>;
  /** Deletes a single `ConnectorRuntime` using a unique key. */
  deleteConnectorRuntimeByEnvironmentIdAndSecret?: Maybe<DeleteConnectorRuntimePayload>;
  /** Deletes a single `ConnectorRuntime` using its globally unique id. */
  deleteConnectorRuntimeByNodeId?: Maybe<DeleteConnectorRuntimePayload>;
  /** Deletes a single `CustomRole` using a unique key. */
  deleteCustomRole?: Maybe<DeleteCustomRolePayload>;
  /** Deletes a single `CustomRole` using its globally unique id. */
  deleteCustomRoleByNodeId?: Maybe<DeleteCustomRolePayload>;
  /** Deletes a single `CustomRole` using a unique key. */
  deleteCustomRoleByOrganisationIdAndName?: Maybe<DeleteCustomRolePayload>;
  /** Deletes a single `CustomerToken` using a unique key. */
  deleteCustomerToken?: Maybe<DeleteCustomerTokenPayload>;
  /** Deletes a single `CustomerToken` using a unique key. */
  deleteCustomerTokenByClientIdAndEnvironmentId?: Maybe<DeleteCustomerTokenPayload>;
  /** Deletes a single `CustomerToken` using its globally unique id. */
  deleteCustomerTokenByNodeId?: Maybe<DeleteCustomerTokenPayload>;
  /** Deletes a single `EndUserSegment` using a unique key. */
  deleteEndUserSegment?: Maybe<DeleteEndUserSegmentPayload>;
  /** Deletes a single `EndUserSegment` using a unique key. */
  deleteEndUserSegmentByEnvironmentIdAndName?: Maybe<DeleteEndUserSegmentPayload>;
  /** Deletes a single `EndUserSegment` using its globally unique id. */
  deleteEndUserSegmentByNodeId?: Maybe<DeleteEndUserSegmentPayload>;
  /** Deletes a single `EventDefinition` using a unique key. */
  deleteEventDefinition?: Maybe<DeleteEventDefinitionPayload>;
  /** Deletes a single `EventDefinition` using a unique key. */
  deleteEventDefinitionByEnvironmentIdAndEventName?: Maybe<DeleteEventDefinitionPayload>;
  /** Deletes a single `EventDefinition` using its globally unique id. */
  deleteEventDefinitionByNodeId?: Maybe<DeleteEventDefinitionPayload>;
  /** Deletes a single `EventDefinitionVersion` using a unique key. */
  deleteEventDefinitionVersion?: Maybe<DeleteEventDefinitionVersionPayload>;
  /** Deletes a single `EventDefinitionVersion` using its globally unique id. */
  deleteEventDefinitionVersionByNodeId?: Maybe<DeleteEventDefinitionVersionPayload>;
  /** Deletes a single `Grant` using a unique key. */
  deleteGrant?: Maybe<DeleteGrantPayload>;
  /** Deletes a single `Grant` using its globally unique id. */
  deleteGrantByNodeId?: Maybe<DeleteGrantPayload>;
  /** Deletes a single `Group` using a unique key. */
  deleteGroup?: Maybe<DeleteGroupPayload>;
  /** Deletes a single `Group` using its globally unique id. */
  deleteGroupByNodeId?: Maybe<DeleteGroupPayload>;
  /** Deletes a single `Group` using a unique key. */
  deleteGroupByOrganisationIdAndName?: Maybe<DeleteGroupPayload>;
  /** Deletes a single `InsightsReport` using a unique key. */
  deleteInsightsReport?: Maybe<DeleteInsightsReportPayload>;
  /** Deletes a single `InsightsReport` using its globally unique id. */
  deleteInsightsReportByNodeId?: Maybe<DeleteInsightsReportPayload>;
  /** Deletes a single `IntegrationConfiguration` using a unique key. */
  deleteIntegrationConfiguration?: Maybe<DeleteIntegrationConfigurationPayload>;
  /** Deletes a single `IntegrationConfiguration` using its globally unique id. */
  deleteIntegrationConfigurationByNodeId?: Maybe<DeleteIntegrationConfigurationPayload>;
  /** Deletes a single `ResourceUser` using a unique key. */
  deleteResourceUser?: Maybe<DeleteResourceUserPayload>;
  /** Deletes a single `ResourceUser` using its globally unique id. */
  deleteResourceUserByNodeId?: Maybe<DeleteResourceUserPayload>;
  /** Deletes a single `RolePermission` using a unique key. */
  deleteRolePermission?: Maybe<DeleteRolePermissionPayload>;
  /** Deletes a single `RolePermission` using its globally unique id. */
  deleteRolePermissionByNodeId?: Maybe<DeleteRolePermissionPayload>;
  deleteSegmentTrigger?: Maybe<SaveSegmentTriggerPayload>;
  /** Deletes a single `StreamContainer` using a unique key. */
  deleteStreamContainer?: Maybe<DeleteStreamContainerPayload>;
  /** Deletes a single `StreamContainer` using its globally unique id. */
  deleteStreamContainerByNodeId?: Maybe<DeleteStreamContainerPayload>;
  /** Deletes a single `Theme` using a unique key. */
  deleteTheme?: Maybe<DeleteThemePayload>;
  /** Deletes a single `Theme` using its globally unique id. */
  deleteThemeByNodeId?: Maybe<DeleteThemePayload>;
  /** Deletes a single `TriggerEvent` using a unique key. */
  deleteTriggerEvent?: Maybe<DeleteTriggerEventPayload>;
  /** Deletes a single `TriggerEvent` using a unique key. */
  deleteTriggerEventByEnvironmentIdAndStreamIdAndEventDefinitionIdAndEventDefinitionVersionAndCardTemplateIdAndCardTemplateVersion?: Maybe<DeleteTriggerEventPayload>;
  /** Deletes a single `TriggerEvent` using its globally unique id. */
  deleteTriggerEventByNodeId?: Maybe<DeleteTriggerEventPayload>;
  /** Deletes a single `WebhookCredential` using a unique key. */
  deleteWebhookCredential?: Maybe<DeleteWebhookCredentialPayload>;
  /** Deletes a single `WebhookCredential` using its globally unique id. */
  deleteWebhookCredentialByNodeId?: Maybe<DeleteWebhookCredentialPayload>;
  /** Deletes a single `WebhookEndpoint` using a unique key. */
  deleteWebhookEndpoint?: Maybe<DeleteWebhookEndpointPayload>;
  /** Deletes a single `WebhookEndpoint` using its globally unique id. */
  deleteWebhookEndpointByNodeId?: Maybe<DeleteWebhookEndpointPayload>;
  /** Deletes a single `WorkbenchFolder` using a unique key. */
  deleteWorkbenchFolder?: Maybe<DeleteWorkbenchFolderPayload>;
  /** Deletes a single `WorkbenchFolder` using a unique key. */
  deleteWorkbenchFolderByEnvironmentIdAndName?: Maybe<DeleteWorkbenchFolderPayload>;
  /** Deletes a single `WorkbenchFolder` using its globally unique id. */
  deleteWorkbenchFolderByNodeId?: Maybe<DeleteWorkbenchFolderPayload>;
  deleteWorkbenchGroups?: Maybe<DeleteWorkbenchGroupsPayload>;
  /** Discards current draft changes, resetting content to the previous value. */
  discardActionFlowDraft?: Maybe<DiscardActionFlowDraftPayload>;
  /** Discards current draft changes, resetting content to the previous value. */
  discardCardTemplateDraft?: Maybe<DiscardCardTemplateDraftPayload>;
  duplicateCard?: Maybe<DuplicateCardPayload>;
  endUserDeleteWithDynamo?: Maybe<EndUserDeleteResponse>;
  endUsersBulkCreationMutation?: Maybe<Scalars['Boolean']['output']>;
  inviteBusinessUser?: Maybe<InviteBusinessUserPayload>;
  migrateCardTemplateToActionFlow?: Maybe<MigrateCardTemplateToActionFlowPayload>;
  organisationUpdatePreferences?: Maybe<OrganisationUpdatePreferencesPayload>;
  publishActionFlow?: Maybe<ActionFlowConfigurationPayload>;
  /** custom mutation, delete a requests for approval for a action flow */
  removeActionFlowApprovalRequest?: Maybe<RemoveActionFlowApprovalRequestPayload>;
  /** custom mutation, delete a requests for approval for a card template */
  removeCardApprovalRequest?: Maybe<RemoveCardApprovalRequestPayload>;
  removeCustomRoleMutation?: Maybe<DeleteRoleResponse>;
  removeTriggerEvent?: Maybe<RemoveTriggerEventPayload>;
  /** log a request for approval for a action flow */
  requestActionFlowApproval?: Maybe<RequestActionFlowApprovalPayload>;
  /** log a request for approval for a card template */
  requestCardApproval?: Maybe<RequestCardApprovalPayload>;
  /** Queues an invite email to be sent to an invited business user */
  resendInviteEmail?: Maybe<ResendInviteEmailPayload>;
  /** Queues an invite email to be sent to an invited business user */
  resendInviteEmailById?: Maybe<ResendInviteEmailByIdPayload>;
  /** Restores an archived card_template by creating a new draft from the last saved version */
  restoreCardTemplate?: Maybe<RestoreCardTemplatePayload>;
  revertActionFlowMigration?: Maybe<RevertActionFlowMigrationPayload>;
  revokeActionFlowShareLink?: Maybe<RevokeActionFlowShareLinkResponse>;
  saveActionFlowConfiguration?: Maybe<ActionFlowConfigurationPayload>;
  saveApprovalConfiguration?: Maybe<ApprovalConfigurationResponse>;
  saveBusinessUser?: Maybe<SaveBusinessUserPayload>;
  /** Updates current card template version, inserting if none exist */
  saveCardTemplateVersion?: Maybe<SaveCardTemplateVersionPayload>;
  saveEventDefinitionVersion?: Maybe<SaveEventDefinitionVersionPayload>;
  /** Sets default stream container, unsetting the current default */
  setDefaultStreamContainer?: Maybe<SetDefaultStreamContainerPayload>;
  /** Sets default theme, unsetting the current default */
  setDefaultTheme?: Maybe<SetDefaultThemePayload>;
  setGroupGrants?: Maybe<GroupGrantsPayload>;
  setRolePermissions?: Maybe<SetRolesPayload>;
  setUserTagsNested?: Maybe<SetUserTagsPayload>;
  storeSegmentTrigger?: Maybe<SaveSegmentTriggerPayload>;
  tagUsersMutation?: Maybe<TagUsersMutationResponse>;
  triggerInceptionEvent?: Maybe<TriggerInceptionEventResponse>;
  /** Sets latest archived card template version to draft */
  unarchiveActionFlowConfigVersion?: Maybe<UnarchiveActionFlowConfigVersionPayload>;
  untagUsersMutation?: Maybe<UntagUsersMutationResponse>;
  updateActionFlowFolder?: Maybe<ActionFlowConfigurationPayload>;
  /** Updates a single `AppClient` using a unique key and a patch. */
  updateAppClient?: Maybe<UpdateAppClientPayload>;
  /** Updates a single `AppClient` using its globally unique id and a patch. */
  updateAppClientByNodeId?: Maybe<UpdateAppClientPayload>;
  /** Updates a single `AuthAccount` using a unique key and a patch. */
  updateAuthAccount?: Maybe<UpdateAuthAccountPayload>;
  /** Updates a single `AuthAccount` using a unique key and a patch. */
  updateAuthAccountByAccountIdAndAppClientId?: Maybe<UpdateAuthAccountPayload>;
  /** Updates a single `AuthAccount` using its globally unique id and a patch. */
  updateAuthAccountByNodeId?: Maybe<UpdateAuthAccountPayload>;
  /** Updates a single `AuthAccount` using a unique key and a patch. */
  updateAuthAccountBySubAndAppClientId?: Maybe<UpdateAuthAccountPayload>;
  /** Updates a single `BusinessUser` using a unique key and a patch. */
  updateBusinessUser?: Maybe<UpdateBusinessUserPayload>;
  /** Updates a single `BusinessUser` using a unique key and a patch. */
  updateBusinessUserByInviteSecret?: Maybe<UpdateBusinessUserPayload>;
  /** Updates a single `BusinessUser` using its globally unique id and a patch. */
  updateBusinessUserByNodeId?: Maybe<UpdateBusinessUserPayload>;
  /** Updates a single `BusinessUser` using a unique key and a patch. */
  updateBusinessUserByOrganisationIdAndId?: Maybe<UpdateBusinessUserPayload>;
  /** Updates a single `CardTemplate` using a unique key and a patch. */
  updateCardTemplate?: Maybe<UpdateCardTemplatePayload>;
  /** Updates a single `CardTemplate` using its globally unique id and a patch. */
  updateCardTemplateByNodeId?: Maybe<UpdateCardTemplatePayload>;
  /** Updates a single `CardTemplateVersion` using a unique key and a patch. */
  updateCardTemplateVersion?: Maybe<UpdateCardTemplateVersionPayload>;
  /** Updates a single `CardTemplateVersion` using its globally unique id and a patch. */
  updateCardTemplateVersionByNodeId?: Maybe<UpdateCardTemplateVersionPayload>;
  /** Updates a single `ClientKey` using a unique key and a patch. */
  updateClientKey?: Maybe<UpdateClientKeyPayload>;
  /** Updates a single `ClientKey` using a unique key and a patch. */
  updateClientKeyByApiKey?: Maybe<UpdateClientKeyPayload>;
  /** Updates a single `ClientKey` using its globally unique id and a patch. */
  updateClientKeyByNodeId?: Maybe<UpdateClientKeyPayload>;
  /** Updates a single `ConnectorRuntime` using a unique key and a patch. */
  updateConnectorRuntime?: Maybe<UpdateConnectorRuntimePayload>;
  /** Updates a single `ConnectorRuntime` using a unique key and a patch. */
  updateConnectorRuntimeByEnvironmentIdAndSecret?: Maybe<UpdateConnectorRuntimePayload>;
  /** Updates a single `ConnectorRuntime` using its globally unique id and a patch. */
  updateConnectorRuntimeByNodeId?: Maybe<UpdateConnectorRuntimePayload>;
  /** Updates the current account email, creating the auth account and business user if they don't exist and returning account details */
  updateCurrentAccounts?: Maybe<UpdateCurrentAccountsPayload>;
  /** Updates a single `CustomRole` using a unique key and a patch. */
  updateCustomRole?: Maybe<UpdateCustomRolePayload>;
  /** Updates a single `CustomRole` using its globally unique id and a patch. */
  updateCustomRoleByNodeId?: Maybe<UpdateCustomRolePayload>;
  /** Updates a single `CustomRole` using a unique key and a patch. */
  updateCustomRoleByOrganisationIdAndName?: Maybe<UpdateCustomRolePayload>;
  /** Updates a single `CustomerToken` using a unique key and a patch. */
  updateCustomerToken?: Maybe<UpdateCustomerTokenPayload>;
  /** Updates a single `CustomerToken` using a unique key and a patch. */
  updateCustomerTokenByClientIdAndEnvironmentId?: Maybe<UpdateCustomerTokenPayload>;
  /** Updates a single `CustomerToken` using its globally unique id and a patch. */
  updateCustomerTokenByNodeId?: Maybe<UpdateCustomerTokenPayload>;
  updateEndUserMutation?: Maybe<UpdateEndUserResponse>;
  /** Updates a single `EndUserSegment` using a unique key and a patch. */
  updateEndUserSegment?: Maybe<UpdateEndUserSegmentPayload>;
  /** Updates a single `EndUserSegment` using a unique key and a patch. */
  updateEndUserSegmentByEnvironmentIdAndName?: Maybe<UpdateEndUserSegmentPayload>;
  /** Updates a single `EndUserSegment` using its globally unique id and a patch. */
  updateEndUserSegmentByNodeId?: Maybe<UpdateEndUserSegmentPayload>;
  /** Updates a single `Environment` using a unique key and a patch. */
  updateEnvironment?: Maybe<UpdateEnvironmentPayload>;
  /** Updates a single `Environment` using its globally unique id and a patch. */
  updateEnvironmentByNodeId?: Maybe<UpdateEnvironmentPayload>;
  /** Updates a single `Environment` using a unique key and a patch. */
  updateEnvironmentByOrganisationIdAndId?: Maybe<UpdateEnvironmentPayload>;
  updateEnvironmentName?: Maybe<UpdateEnvironmentNamePayload>;
  /** Updates a single `EventDefinitionVersion` using a unique key and a patch. */
  updateEventDefinitionVersion?: Maybe<UpdateEventDefinitionVersionPayload>;
  /** Updates a single `EventDefinitionVersion` using its globally unique id and a patch. */
  updateEventDefinitionVersionByNodeId?: Maybe<UpdateEventDefinitionVersionPayload>;
  /** Updates a single `Grant` using a unique key and a patch. */
  updateGrant?: Maybe<UpdateGrantPayload>;
  /** Updates a single `Grant` using its globally unique id and a patch. */
  updateGrantByNodeId?: Maybe<UpdateGrantPayload>;
  /** Updates a single `Group` using a unique key and a patch. */
  updateGroup?: Maybe<UpdateGroupPayload>;
  /** Updates a single `Group` using its globally unique id and a patch. */
  updateGroupByNodeId?: Maybe<UpdateGroupPayload>;
  /** Updates a single `Group` using a unique key and a patch. */
  updateGroupByOrganisationIdAndName?: Maybe<UpdateGroupPayload>;
  /** Updates a single `InsightsReport` using a unique key and a patch. */
  updateInsightsReport?: Maybe<UpdateInsightsReportPayload>;
  /** Updates a single `InsightsReport` using its globally unique id and a patch. */
  updateInsightsReportByNodeId?: Maybe<UpdateInsightsReportPayload>;
  /** Updates a single `IntegrationConfiguration` using a unique key and a patch. */
  updateIntegrationConfiguration?: Maybe<UpdateIntegrationConfigurationPayload>;
  /** Updates a single `IntegrationConfiguration` using its globally unique id and a patch. */
  updateIntegrationConfigurationByNodeId?: Maybe<UpdateIntegrationConfigurationPayload>;
  /** Updates a single `Organisation` using a unique key and a patch. */
  updateOrganisation?: Maybe<UpdateOrganisationPayload>;
  /** Updates a single `Organisation` using its globally unique id and a patch. */
  updateOrganisationByNodeId?: Maybe<UpdateOrganisationPayload>;
  updateOrganisationPurgeDays?: Maybe<OrganisationPayload>;
  updateOwnBusinessUserPreferences?: Maybe<UpdateOwnBusinessUserPreferencesPayload>;
  updateOwnBusinessUserProfile?: Maybe<UpdateOwnBusinessUserProfilePayload>;
  /** Updates a single `ResourceUser` using a unique key and a patch. */
  updateResourceUser?: Maybe<UpdateResourceUserPayload>;
  /** Updates a single `ResourceUser` using its globally unique id and a patch. */
  updateResourceUserByNodeId?: Maybe<UpdateResourceUserPayload>;
  /** Updates a single `RolePermission` using a unique key and a patch. */
  updateRolePermission?: Maybe<UpdateRolePermissionPayload>;
  /** Updates a single `RolePermission` using its globally unique id and a patch. */
  updateRolePermissionByNodeId?: Maybe<UpdateRolePermissionPayload>;
  /** Updates a single `Stream` using a unique key and a patch. */
  updateStream?: Maybe<UpdateStreamPayload>;
  /** Updates a single `Stream` using its globally unique id and a patch. */
  updateStreamByNodeId?: Maybe<UpdateStreamPayload>;
  /** Updates a single `StreamContainer` using a unique key and a patch. */
  updateStreamContainer?: Maybe<UpdateStreamContainerPayload>;
  /** Updates a single `StreamContainer` using its globally unique id and a patch. */
  updateStreamContainerByNodeId?: Maybe<UpdateStreamContainerPayload>;
  /** Updates a single `Tag` using a unique key and a patch. */
  updateTag?: Maybe<UpdateTagPayload>;
  /** Updates a single `Tag` using a unique key and a patch. */
  updateTagByEnvironmentIdAndName?: Maybe<UpdateTagPayload>;
  /** Updates a single `Tag` using its globally unique id and a patch. */
  updateTagByNodeId?: Maybe<UpdateTagPayload>;
  /** Updates a single `Theme` using a unique key and a patch. */
  updateTheme?: Maybe<UpdateThemePayload>;
  /** Updates a single `Theme` using its globally unique id and a patch. */
  updateThemeByNodeId?: Maybe<UpdateThemePayload>;
  /** Updates a single `TriggerEvent` using a unique key and a patch. */
  updateTriggerEvent?: Maybe<UpdateTriggerEventPayload>;
  /** Updates a single `TriggerEvent` using a unique key and a patch. */
  updateTriggerEventByEnvironmentIdAndStreamIdAndEventDefinitionIdAndEventDefinitionVersionAndCardTemplateIdAndCardTemplateVersion?: Maybe<UpdateTriggerEventPayload>;
  /** Updates a single `TriggerEvent` using its globally unique id and a patch. */
  updateTriggerEventByNodeId?: Maybe<UpdateTriggerEventPayload>;
  /** Updates a single `WebhookCredential` using a unique key and a patch. */
  updateWebhookCredential?: Maybe<UpdateWebhookCredentialPayload>;
  /** Updates a single `WebhookCredential` using its globally unique id and a patch. */
  updateWebhookCredentialByNodeId?: Maybe<UpdateWebhookCredentialPayload>;
  /** Updates a single `WebhookEndpoint` using a unique key and a patch. */
  updateWebhookEndpoint?: Maybe<UpdateWebhookEndpointPayload>;
  /** Updates a single `WebhookEndpoint` using its globally unique id and a patch. */
  updateWebhookEndpointByNodeId?: Maybe<UpdateWebhookEndpointPayload>;
  /** Updates a single `WorkbenchFolder` using a unique key and a patch. */
  updateWorkbenchFolder?: Maybe<UpdateWorkbenchFolderPayload>;
  /** Updates a single `WorkbenchFolder` using a unique key and a patch. */
  updateWorkbenchFolderByEnvironmentIdAndName?: Maybe<UpdateWorkbenchFolderPayload>;
  /** Updates a single `WorkbenchFolder` using its globally unique id and a patch. */
  updateWorkbenchFolderByNodeId?: Maybe<UpdateWorkbenchFolderPayload>;
  upsertMagicLink?: Maybe<MagicLinkResult>;
  webhookEndpointTestMutation?: Maybe<Scalars['Boolean']['output']>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationActivateInvitedBusinessUserAccountArgs = {
  input: ActivateInvitedBusinessUserAccountInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddCardTemplateWithVersionArgs = {
  input: AddCardTemplateWithVersionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddEventDefinitionWithVersionArgs = {
  input: AddEventDefinitionWithVersionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAddTriggerEventArgs = {
  input: AddTriggerEventInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAggregateActionFlowAnalyticsArgs = {
  input: AggregateActionFlowAnalyticsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationApproveActionFlowArgs = {
  input: ApproveActionFlowInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationApproveActionFlowGroupsArgs = {
  input: ApproveActionFlowGroupsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationApproveCardTemplateArgs = {
  input: ApproveCardTemplateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationApproveCardTemplateGroupsArgs = {
  input: ApproveCardTemplateGroupsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationArchiveActionFlowConfigVersionsArgs = {
  input: ArchiveActionFlowConfigVersionsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationArchiveCardTemplateVersionsArgs = {
  input: ArchiveCardTemplateVersionsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationArchiveEventDefinitionsArgs = {
  input: ArchiveEventDefinitionsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCopyCardTemplateEventsArgs = {
  input: CopyCardTemplateEventsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateActionFlowShareLinkArgs = {
  input?: InputMaybe<CreateActionFlowShareLinkInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBusinessUserArgs = {
  input: CreateBusinessUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCardCancelTaskArgs = {
  input: CreateCardCancelTaskInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCardTemplateArgs = {
  input: CreateCardTemplateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCardTemplateVersionArgs = {
  input: CreateCardTemplateVersionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateClientKeyArgs = {
  input: CreateClientKeyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateConnectorRuntimeArgs = {
  input: CreateConnectorRuntimeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCsvUploadTaskArgs = {
  input: CreateCsvUploadTaskInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCustomRoleArgs = {
  input: CreateCustomRoleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateEndUserSegmentArgs = {
  input: CreateEndUserSegmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateEnvironmentArgs = {
  input: CreateEnvironmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateEventDefinitionArgs = {
  input: CreateEventDefinitionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateEventDefinitionVersionArgs = {
  input: CreateEventDefinitionVersionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateGrantArgs = {
  input: CreateGrantInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateGroupArgs = {
  input: CreateGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateInsightsReportArgs = {
  input: CreateInsightsReportInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateIntegrationConfigurationArgs = {
  input: CreateIntegrationConfigurationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMarketoIntegrationConfigurationArgs = {
  input: CreateMarketoIntegrationConfigurationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateResourceUserArgs = {
  input: CreateResourceUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRolePermissionArgs = {
  input: CreateRolePermissionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateStreamArgs = {
  input: CreateStreamInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateStreamContainerArgs = {
  input: CreateStreamContainerInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTagArgs = {
  input: CreateTagInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTestEndUserArgs = {
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  nickname: Scalars['String']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateThemeArgs = {
  input: CreateThemeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTriggerEventArgs = {
  input: CreateTriggerEventInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateWebhookCredentialArgs = {
  input: CreateWebhookCredentialInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateWebhookEndpointArgs = {
  input: CreateWebhookEndpointInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateWorkbenchFolderArgs = {
  input: CreateWorkbenchFolderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteActionFlowApprovalArgs = {
  input: DeleteActionFlowApprovalInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteActionFlowApprovalByNodeIdArgs = {
  input: DeleteActionFlowApprovalByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteActionFlowApprovalRequestArgs = {
  input: DeleteActionFlowApprovalRequestInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteActionFlowApprovalRequestByNodeIdArgs = {
  input: DeleteActionFlowApprovalRequestByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteActionFlowApprovalsArgs = {
  input: DeleteActionFlowApprovalsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteActionFlowConfigArgs = {
  input: DeleteActionFlowConfigInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteActionFlowConfigByNodeIdArgs = {
  input: DeleteActionFlowConfigByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBusinessUserArgs = {
  input: DeleteBusinessUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBusinessUserByInviteSecretArgs = {
  input: DeleteBusinessUserByInviteSecretInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBusinessUserByNodeIdArgs = {
  input: DeleteBusinessUserByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBusinessUserByOrganisationIdAndIdArgs = {
  input: DeleteBusinessUserByOrganisationIdAndIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCardApprovalArgs = {
  input: DeleteCardApprovalInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCardApprovalByNodeIdArgs = {
  input: DeleteCardApprovalByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCardApprovalRequestArgs = {
  input: DeleteCardApprovalRequestInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCardApprovalRequestByNodeIdArgs = {
  input: DeleteCardApprovalRequestByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCardApprovalsArgs = {
  input: DeleteCardApprovalsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCardTemplateArgs = {
  input: DeleteCardTemplateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCardTemplateByNodeIdArgs = {
  input: DeleteCardTemplateByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteClientKeyArgs = {
  input: DeleteClientKeyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteClientKeyByApiKeyArgs = {
  input: DeleteClientKeyByApiKeyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteClientKeyByNodeIdArgs = {
  input: DeleteClientKeyByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteConnectorRuntimeArgs = {
  input: DeleteConnectorRuntimeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteConnectorRuntimeByEnvironmentIdAndSecretArgs = {
  input: DeleteConnectorRuntimeByEnvironmentIdAndSecretInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteConnectorRuntimeByNodeIdArgs = {
  input: DeleteConnectorRuntimeByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCustomRoleArgs = {
  input: DeleteCustomRoleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCustomRoleByNodeIdArgs = {
  input: DeleteCustomRoleByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCustomRoleByOrganisationIdAndNameArgs = {
  input: DeleteCustomRoleByOrganisationIdAndNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCustomerTokenArgs = {
  input: DeleteCustomerTokenInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCustomerTokenByClientIdAndEnvironmentIdArgs = {
  input: DeleteCustomerTokenByClientIdAndEnvironmentIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCustomerTokenByNodeIdArgs = {
  input: DeleteCustomerTokenByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEndUserSegmentArgs = {
  input: DeleteEndUserSegmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEndUserSegmentByEnvironmentIdAndNameArgs = {
  input: DeleteEndUserSegmentByEnvironmentIdAndNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEndUserSegmentByNodeIdArgs = {
  input: DeleteEndUserSegmentByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEventDefinitionArgs = {
  input: DeleteEventDefinitionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEventDefinitionByEnvironmentIdAndEventNameArgs = {
  input: DeleteEventDefinitionByEnvironmentIdAndEventNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEventDefinitionByNodeIdArgs = {
  input: DeleteEventDefinitionByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEventDefinitionVersionArgs = {
  input: DeleteEventDefinitionVersionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEventDefinitionVersionByNodeIdArgs = {
  input: DeleteEventDefinitionVersionByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteGrantArgs = {
  input: DeleteGrantInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteGrantByNodeIdArgs = {
  input: DeleteGrantByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteGroupArgs = {
  input: DeleteGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteGroupByNodeIdArgs = {
  input: DeleteGroupByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteGroupByOrganisationIdAndNameArgs = {
  input: DeleteGroupByOrganisationIdAndNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteInsightsReportArgs = {
  input: DeleteInsightsReportInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteInsightsReportByNodeIdArgs = {
  input: DeleteInsightsReportByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteIntegrationConfigurationArgs = {
  input: DeleteIntegrationConfigurationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteIntegrationConfigurationByNodeIdArgs = {
  input: DeleteIntegrationConfigurationByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteResourceUserArgs = {
  input: DeleteResourceUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteResourceUserByNodeIdArgs = {
  input: DeleteResourceUserByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRolePermissionArgs = {
  input: DeleteRolePermissionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRolePermissionByNodeIdArgs = {
  input: DeleteRolePermissionByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSegmentTriggerArgs = {
  input?: InputMaybe<DeleteSegmentTriggerInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteStreamContainerArgs = {
  input: DeleteStreamContainerInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteStreamContainerByNodeIdArgs = {
  input: DeleteStreamContainerByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteThemeArgs = {
  input: DeleteThemeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteThemeByNodeIdArgs = {
  input: DeleteThemeByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTriggerEventArgs = {
  input: DeleteTriggerEventInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTriggerEventByEnvironmentIdAndStreamIdAndEventDefinitionIdAndEventDefinitionVersionAndCardTemplateIdAndCardTemplateVersionArgs = {
  input: DeleteTriggerEventByEnvironmentIdAndStreamIdAndEventDefinitionIdAndEventDefinitionVersionAndCardTemplateIdAndCardTemplateVersionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTriggerEventByNodeIdArgs = {
  input: DeleteTriggerEventByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWebhookCredentialArgs = {
  input: DeleteWebhookCredentialInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWebhookCredentialByNodeIdArgs = {
  input: DeleteWebhookCredentialByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWebhookEndpointArgs = {
  input: DeleteWebhookEndpointInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWebhookEndpointByNodeIdArgs = {
  input: DeleteWebhookEndpointByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWorkbenchFolderArgs = {
  input: DeleteWorkbenchFolderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWorkbenchFolderByEnvironmentIdAndNameArgs = {
  input: DeleteWorkbenchFolderByEnvironmentIdAndNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWorkbenchFolderByNodeIdArgs = {
  input: DeleteWorkbenchFolderByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteWorkbenchGroupsArgs = {
  input: DeleteWorkbenchGroupsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDiscardActionFlowDraftArgs = {
  input: DiscardActionFlowDraftInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDiscardCardTemplateDraftArgs = {
  input: DiscardCardTemplateDraftInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDuplicateCardArgs = {
  input?: InputMaybe<DuplicateCardInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationEndUserDeleteWithDynamoArgs = {
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationEndUsersBulkCreationMutationArgs = {
  environmentId: Scalars['String']['input'];
  rows: Array<EndUserRow>;
  tag?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationInviteBusinessUserArgs = {
  input: InviteBusinessUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMigrateCardTemplateToActionFlowArgs = {
  input: MigrateCardTemplateToActionFlowInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationOrganisationUpdatePreferencesArgs = {
  input: OrganisationUpdatePreferencesInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationPublishActionFlowArgs = {
  input?: InputMaybe<PublishActionFlowInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRemoveActionFlowApprovalRequestArgs = {
  input: RemoveActionFlowApprovalRequestInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRemoveCardApprovalRequestArgs = {
  input: RemoveCardApprovalRequestInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRemoveCustomRoleMutationArgs = {
  id: Scalars['String']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRemoveTriggerEventArgs = {
  input: RemoveTriggerEventInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRequestActionFlowApprovalArgs = {
  input: RequestActionFlowApprovalInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRequestCardApprovalArgs = {
  input: RequestCardApprovalInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationResendInviteEmailArgs = {
  input: ResendInviteEmailInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationResendInviteEmailByIdArgs = {
  input: ResendInviteEmailByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRestoreCardTemplateArgs = {
  input: RestoreCardTemplateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRevertActionFlowMigrationArgs = {
  input: RevertActionFlowMigrationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRevokeActionFlowShareLinkArgs = {
  input?: InputMaybe<CreateActionFlowShareLinkInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSaveActionFlowConfigurationArgs = {
  input?: InputMaybe<SaveActionFlowConfigurationInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSaveApprovalConfigurationArgs = {
  configuration: ApprovalConfigurationInput;
  environmentId: Scalars['String']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSaveBusinessUserArgs = {
  input?: InputMaybe<SaveBusinessUserInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSaveCardTemplateVersionArgs = {
  input: SaveCardTemplateVersionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSaveEventDefinitionVersionArgs = {
  input: SaveEventDefinitionVersionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetDefaultStreamContainerArgs = {
  input: SetDefaultStreamContainerInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetDefaultThemeArgs = {
  input: SetDefaultThemeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetGroupGrantsArgs = {
  input?: InputMaybe<GroupGrantsInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetRolePermissionsArgs = {
  input?: InputMaybe<RolePermissionsInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetUserTagsNestedArgs = {
  input: SetTagsInputNested;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationStoreSegmentTriggerArgs = {
  input?: InputMaybe<StoreSegmentTriggerInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationTagUsersMutationArgs = {
  endUserIds: Array<InputMaybe<Scalars['String']['input']>>;
  environmentId: Scalars['String']['input'];
  tags: Array<InputMaybe<Scalars['String']['input']>>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationTriggerInceptionEventArgs = {
  input: TriggerInceptionEventInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUnarchiveActionFlowConfigVersionArgs = {
  input: UnarchiveActionFlowConfigVersionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUntagUsersMutationArgs = {
  endUserId: Scalars['String']['input'];
  environmentId: Scalars['String']['input'];
  tagId: Scalars['String']['input'];
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateActionFlowFolderArgs = {
  input?: InputMaybe<UpdateActionFlowFolderInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAppClientArgs = {
  input: UpdateAppClientInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAppClientByNodeIdArgs = {
  input: UpdateAppClientByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAuthAccountArgs = {
  input: UpdateAuthAccountInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAuthAccountByAccountIdAndAppClientIdArgs = {
  input: UpdateAuthAccountByAccountIdAndAppClientIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAuthAccountByNodeIdArgs = {
  input: UpdateAuthAccountByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAuthAccountBySubAndAppClientIdArgs = {
  input: UpdateAuthAccountBySubAndAppClientIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBusinessUserArgs = {
  input: UpdateBusinessUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBusinessUserByInviteSecretArgs = {
  input: UpdateBusinessUserByInviteSecretInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBusinessUserByNodeIdArgs = {
  input: UpdateBusinessUserByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBusinessUserByOrganisationIdAndIdArgs = {
  input: UpdateBusinessUserByOrganisationIdAndIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCardTemplateArgs = {
  input: UpdateCardTemplateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCardTemplateByNodeIdArgs = {
  input: UpdateCardTemplateByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCardTemplateVersionArgs = {
  input: UpdateCardTemplateVersionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCardTemplateVersionByNodeIdArgs = {
  input: UpdateCardTemplateVersionByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateClientKeyArgs = {
  input: UpdateClientKeyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateClientKeyByApiKeyArgs = {
  input: UpdateClientKeyByApiKeyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateClientKeyByNodeIdArgs = {
  input: UpdateClientKeyByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateConnectorRuntimeArgs = {
  input: UpdateConnectorRuntimeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateConnectorRuntimeByEnvironmentIdAndSecretArgs = {
  input: UpdateConnectorRuntimeByEnvironmentIdAndSecretInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateConnectorRuntimeByNodeIdArgs = {
  input: UpdateConnectorRuntimeByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCurrentAccountsArgs = {
  input: UpdateCurrentAccountsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCustomRoleArgs = {
  input: UpdateCustomRoleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCustomRoleByNodeIdArgs = {
  input: UpdateCustomRoleByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCustomRoleByOrganisationIdAndNameArgs = {
  input: UpdateCustomRoleByOrganisationIdAndNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCustomerTokenArgs = {
  input: UpdateCustomerTokenInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCustomerTokenByClientIdAndEnvironmentIdArgs = {
  input: UpdateCustomerTokenByClientIdAndEnvironmentIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCustomerTokenByNodeIdArgs = {
  input: UpdateCustomerTokenByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEndUserMutationArgs = {
  allowTest?: InputMaybe<Scalars['Boolean']['input']>;
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  nickname?: InputMaybe<Scalars['String']['input']>;
  profile?: InputMaybe<Scalars['JSON']['input']>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEndUserSegmentArgs = {
  input: UpdateEndUserSegmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEndUserSegmentByEnvironmentIdAndNameArgs = {
  input: UpdateEndUserSegmentByEnvironmentIdAndNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEndUserSegmentByNodeIdArgs = {
  input: UpdateEndUserSegmentByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEnvironmentArgs = {
  input: UpdateEnvironmentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEnvironmentByNodeIdArgs = {
  input: UpdateEnvironmentByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEnvironmentByOrganisationIdAndIdArgs = {
  input: UpdateEnvironmentByOrganisationIdAndIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEnvironmentNameArgs = {
  input: UpdateEnvironmentNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEventDefinitionVersionArgs = {
  input: UpdateEventDefinitionVersionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEventDefinitionVersionByNodeIdArgs = {
  input: UpdateEventDefinitionVersionByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateGrantArgs = {
  input: UpdateGrantInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateGrantByNodeIdArgs = {
  input: UpdateGrantByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateGroupArgs = {
  input: UpdateGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateGroupByNodeIdArgs = {
  input: UpdateGroupByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateGroupByOrganisationIdAndNameArgs = {
  input: UpdateGroupByOrganisationIdAndNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInsightsReportArgs = {
  input: UpdateInsightsReportInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateInsightsReportByNodeIdArgs = {
  input: UpdateInsightsReportByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateIntegrationConfigurationArgs = {
  input: UpdateIntegrationConfigurationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateIntegrationConfigurationByNodeIdArgs = {
  input: UpdateIntegrationConfigurationByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrganisationArgs = {
  input: UpdateOrganisationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrganisationByNodeIdArgs = {
  input: UpdateOrganisationByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOrganisationPurgeDaysArgs = {
  input?: InputMaybe<UpdateOrganisationPurgeDaysInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOwnBusinessUserPreferencesArgs = {
  input: UpdateOwnBusinessUserPreferencesInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOwnBusinessUserProfileArgs = {
  input: UpdateOwnBusinessUserProfileInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateResourceUserArgs = {
  input: UpdateResourceUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateResourceUserByNodeIdArgs = {
  input: UpdateResourceUserByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRolePermissionArgs = {
  input: UpdateRolePermissionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRolePermissionByNodeIdArgs = {
  input: UpdateRolePermissionByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateStreamArgs = {
  input: UpdateStreamInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateStreamByNodeIdArgs = {
  input: UpdateStreamByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateStreamContainerArgs = {
  input: UpdateStreamContainerInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateStreamContainerByNodeIdArgs = {
  input: UpdateStreamContainerByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTagArgs = {
  input: UpdateTagInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTagByEnvironmentIdAndNameArgs = {
  input: UpdateTagByEnvironmentIdAndNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTagByNodeIdArgs = {
  input: UpdateTagByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateThemeArgs = {
  input: UpdateThemeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateThemeByNodeIdArgs = {
  input: UpdateThemeByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTriggerEventArgs = {
  input: UpdateTriggerEventInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTriggerEventByEnvironmentIdAndStreamIdAndEventDefinitionIdAndEventDefinitionVersionAndCardTemplateIdAndCardTemplateVersionArgs = {
  input: UpdateTriggerEventByEnvironmentIdAndStreamIdAndEventDefinitionIdAndEventDefinitionVersionAndCardTemplateIdAndCardTemplateVersionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTriggerEventByNodeIdArgs = {
  input: UpdateTriggerEventByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWebhookCredentialArgs = {
  input: UpdateWebhookCredentialInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWebhookCredentialByNodeIdArgs = {
  input: UpdateWebhookCredentialByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWebhookEndpointArgs = {
  input: UpdateWebhookEndpointInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWebhookEndpointByNodeIdArgs = {
  input: UpdateWebhookEndpointByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWorkbenchFolderArgs = {
  input: UpdateWorkbenchFolderInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWorkbenchFolderByEnvironmentIdAndNameArgs = {
  input: UpdateWorkbenchFolderByEnvironmentIdAndNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateWorkbenchFolderByNodeIdArgs = {
  input: UpdateWorkbenchFolderByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertMagicLinkArgs = {
  input: UpsertMagicLinkInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationWebhookEndpointTestMutationArgs = {
  endpointId: Scalars['String']['input'];
  environmentId: Scalars['String']['input'];
  scriptMappingOverride?: InputMaybe<Scalars['String']['input']>;
};

/** An object with a globally unique `ID`. */
export type Node = {
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

/** An actions cards customer organisation */
export type Organisation = Node & {
  __typename?: 'Organisation';
  /** Reads and enables pagination through a set of `ActionFlowApprovalRequest`. */
  actionFlowApprovalRequests: ActionFlowApprovalRequestsConnection;
  /** Reads and enables pagination through a set of `ActionFlowApproval`. */
  actionFlowApprovals: ActionFlowApprovalsConnection;
  /** Reads and enables pagination through a set of `ActionFlowConfigVersion`. */
  actionFlowConfigVersions: ActionFlowConfigVersionsConnection;
  /** Reads and enables pagination through a set of `ActionFlowConfig`. */
  actionFlowConfigs: ActionFlowConfigsConnection;
  allowDefaultAppClient: Scalars['Boolean']['output'];
  /** Reads and enables pagination through a set of `AppClient`. */
  appClients: AppClientsConnection;
  /** Reads and enables pagination through a set of `BusinessUserGroup`. */
  businessUserGroups: BusinessUserGroupsConnection;
  /** Reads and enables pagination through a set of `BusinessUser`. */
  businessUsers: BusinessUsersConnection;
  /** Reads and enables pagination through a set of `CardApprovalRequest`. */
  cardApprovalRequests: CardApprovalRequestsConnection;
  /** Reads and enables pagination through a set of `CardApproval`. */
  cardApprovals: CardApprovalsConnection;
  cardOpsLimit?: Maybe<Scalars['Int']['output']>;
  /** Reads and enables pagination through a set of `CardTemplate`. */
  cardTemplates: CardTemplatesConnection;
  created: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `CsvUploadTask`. */
  csvUploadTasks: CsvUploadTasksConnection;
  /** Get information for current user in this organisation */
  currentBusinessUser?: Maybe<BusinessUser>;
  /** Reads and enables pagination through a set of `CustomRole`. */
  customRoles: CustomRolesConnection;
  /** Reads and enables pagination through a set of `Environment`. */
  environments: EnvironmentsConnection;
  /** Reads and enables pagination through a set of `Grant`. */
  grants: GrantsConnection;
  /** Reads and enables pagination through a set of `Group`. */
  groups: GroupsConnection;
  id: Scalars['String']['output'];
  legacyCardsEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Retrieve permissions granted to the current user for this organisation. If environment is non null then the permission is only granted within that environment */
  permissions: OrganisationPermissionsConnection;
  preferences: Scalars['JSON']['output'];
  purgeDays?: Maybe<Scalars['Int']['output']>;
  /** Reads and enables pagination through a set of `RolePermission`. */
  rolePermissions: RolePermissionsConnection;
  updated: Scalars['Datetime']['output'];
};


/** An actions cards customer organisation */
export type OrganisationActionFlowApprovalRequestsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ActionFlowApprovalRequestCondition>;
  filter?: InputMaybe<ActionFlowApprovalRequestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActionFlowApprovalRequestsOrderBy>>;
};


/** An actions cards customer organisation */
export type OrganisationActionFlowApprovalsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ActionFlowApprovalCondition>;
  filter?: InputMaybe<ActionFlowApprovalFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActionFlowApprovalsOrderBy>>;
};


/** An actions cards customer organisation */
export type OrganisationActionFlowConfigVersionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ActionFlowConfigVersionCondition>;
  filter?: InputMaybe<ActionFlowConfigVersionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActionFlowConfigVersionsOrderBy>>;
};


/** An actions cards customer organisation */
export type OrganisationActionFlowConfigsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ActionFlowConfigCondition>;
  filter?: InputMaybe<ActionFlowConfigFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActionFlowConfigsOrderBy>>;
};


/** An actions cards customer organisation */
export type OrganisationAppClientsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AppClientCondition>;
  filter?: InputMaybe<AppClientFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AppClientsOrderBy>>;
};


/** An actions cards customer organisation */
export type OrganisationBusinessUserGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BusinessUserGroupCondition>;
  filter?: InputMaybe<BusinessUserGroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessUserGroupsOrderBy>>;
};


/** An actions cards customer organisation */
export type OrganisationBusinessUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BusinessUserCondition>;
  filter?: InputMaybe<BusinessUserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessUsersOrderBy>>;
};


/** An actions cards customer organisation */
export type OrganisationCardApprovalRequestsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CardApprovalRequestCondition>;
  filter?: InputMaybe<CardApprovalRequestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CardApprovalRequestsOrderBy>>;
};


/** An actions cards customer organisation */
export type OrganisationCardApprovalsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CardApprovalCondition>;
  filter?: InputMaybe<CardApprovalFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CardApprovalsOrderBy>>;
};


/** An actions cards customer organisation */
export type OrganisationCardTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CardTemplateCondition>;
  filter?: InputMaybe<CardTemplateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CardTemplatesOrderBy>>;
};


/** An actions cards customer organisation */
export type OrganisationCsvUploadTasksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CsvUploadTaskCondition>;
  filter?: InputMaybe<CsvUploadTaskFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CsvUploadTasksOrderBy>>;
};


/** An actions cards customer organisation */
export type OrganisationCustomRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CustomRoleCondition>;
  filter?: InputMaybe<CustomRoleFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CustomRolesOrderBy>>;
};


/** An actions cards customer organisation */
export type OrganisationEnvironmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EnvironmentCondition>;
  filter?: InputMaybe<EnvironmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EnvironmentsOrderBy>>;
};


/** An actions cards customer organisation */
export type OrganisationGrantsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GrantCondition>;
  filter?: InputMaybe<GrantFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GrantsOrderBy>>;
};


/** An actions cards customer organisation */
export type OrganisationGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GroupCondition>;
  filter?: InputMaybe<GroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};


/** An actions cards customer organisation */
export type OrganisationPermissionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<OrganisationPermissionsRecordFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** An actions cards customer organisation */
export type OrganisationRolePermissionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RolePermissionCondition>;
  filter?: InputMaybe<RolePermissionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RolePermissionsOrderBy>>;
};

export type OrganisationAccess = {
  __typename?: 'OrganisationAccess';
  currentBusinessUser?: Maybe<BusinessUser>;
  environments?: Maybe<Array<Maybe<OrganisationAccessEnvironment>>>;
  id: Scalars['String']['output'];
  legacyCardsEnabled?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  permissions?: Maybe<Array<Maybe<OrganisationAccessPermission>>>;
  preferences?: Maybe<Scalars['JSON']['output']>;
};

export type OrganisationAccessEnvironment = {
  __typename?: 'OrganisationAccessEnvironment';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type OrganisationAccessPermission = {
  __typename?: 'OrganisationAccessPermission';
  action: PermissionAction;
  environmentId?: Maybe<Scalars['String']['output']>;
  resource: PermissionResource;
};

/**
 * A condition to be used against `Organisation` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type OrganisationCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `Organisation` object types. All fields are combined with a logical ‘and.’ */
export type OrganisationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OrganisationFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OrganisationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OrganisationFilter>>;
};

/** Represents an update to a `Organisation`. Fields that are set will be updated. */
export type OrganisationPatch = {
  name?: InputMaybe<Scalars['String']['input']>;
  preferences?: InputMaybe<Scalars['JSON']['input']>;
};

export type OrganisationPayload = {
  __typename?: 'OrganisationPayload';
  organisation?: Maybe<Organisation>;
  query?: Maybe<Query>;
};

/** A `OrganisationPermissionsRecord` edge in the connection. */
export type OrganisationPermissionEdge = {
  __typename?: 'OrganisationPermissionEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `OrganisationPermissionsRecord` at the end of the edge. */
  node: OrganisationPermissionsRecord;
};

/** A connection to a list of `OrganisationPermissionsRecord` values. */
export type OrganisationPermissionsConnection = {
  __typename?: 'OrganisationPermissionsConnection';
  /** A list of edges which contains the `OrganisationPermissionsRecord` and cursor to aid in pagination. */
  edges: Array<OrganisationPermissionEdge>;
  /** A list of `OrganisationPermissionsRecord` objects. */
  nodes: Array<OrganisationPermissionsRecord>;
  /** The count of *all* `OrganisationPermissionsRecord` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** The return type of our `permissions` query. */
export type OrganisationPermissionsRecord = {
  __typename?: 'OrganisationPermissionsRecord';
  action?: Maybe<PermissionAction>;
  environmentId?: Maybe<Scalars['String']['output']>;
  resource?: Maybe<PermissionResource>;
};

/** A filter to be used against `OrganisationPermissionsRecord` object types. All fields are combined with a logical ‘and.’ */
export type OrganisationPermissionsRecordFilter = {
  /** Filter by the object’s `action` field. */
  action?: InputMaybe<PermissionActionFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OrganisationPermissionsRecordFilter>>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OrganisationPermissionsRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OrganisationPermissionsRecordFilter>>;
  /** Filter by the object’s `resource` field. */
  resource?: InputMaybe<PermissionResourceFilter>;
};

/** All input for the `organisationUpdatePreferences` mutation. */
export type OrganisationUpdatePreferencesInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organisationId: Scalars['String']['input'];
  updates: Scalars['JSON']['input'];
};

/** The output of our `organisationUpdatePreferences` mutation. */
export type OrganisationUpdatePreferencesPayload = {
  __typename?: 'OrganisationUpdatePreferencesPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  organisation?: Maybe<Organisation>;
  /** An edge for our `Organisation`. May be used by Relay 1. */
  organisationEdge?: Maybe<OrganisationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `organisationUpdatePreferences` mutation. */
export type OrganisationUpdatePreferencesPayloadOrganisationEdgeArgs = {
  orderBy?: InputMaybe<Array<OrganisationsOrderBy>>;
};

/** A connection to a list of `Organisation` values. */
export type OrganisationsConnection = {
  __typename?: 'OrganisationsConnection';
  /** A list of edges which contains the `Organisation` and cursor to aid in pagination. */
  edges: Array<OrganisationsEdge>;
  /** A list of `Organisation` objects. */
  nodes: Array<Organisation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Organisation` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Organisation` edge in the connection. */
export type OrganisationsEdge = {
  __typename?: 'OrganisationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Organisation` at the end of the edge. */
  node: Organisation;
};

/** Methods to use when ordering `Organisation`. */
export enum OrganisationsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']['output']>;
};

export enum PermissionAction {
  Admin = 'ADMIN',
  Edit = 'EDIT',
  View = 'VIEW'
}

/** A filter to be used against PermissionAction fields. All fields are combined with a logical ‘and.’ */
export type PermissionActionFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<PermissionAction>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<PermissionAction>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<PermissionAction>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<PermissionAction>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<PermissionAction>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<PermissionAction>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<PermissionAction>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<PermissionAction>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<PermissionAction>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<PermissionAction>>;
};

export enum PermissionResource {
  Account = 'ACCOUNT',
  ActionFlow = 'ACTION_FLOW',
  ActionFlowApproval = 'ACTION_FLOW_APPROVAL',
  ActivityLog = 'ACTIVITY_LOG',
  AnalyticsBatch = 'ANALYTICS_BATCH',
  AuditLog = 'AUDIT_LOG',
  AuthAccount = 'AUTH_ACCOUNT',
  BusinessUser = 'BUSINESS_USER',
  BusinessUserGroup = 'BUSINESS_USER_GROUP',
  BusinessUserInvite = 'BUSINESS_USER_INVITE',
  CardApproval = 'CARD_APPROVAL',
  CardInstance = 'CARD_INSTANCE',
  CardTemplate = 'CARD_TEMPLATE',
  ClientKey = 'CLIENT_KEY',
  CustomerToken = 'CUSTOMER_TOKEN',
  CustomRole = 'CUSTOM_ROLE',
  EndUser = 'END_USER',
  EndUserSegment = 'END_USER_SEGMENT',
  EndUserTag = 'END_USER_TAG',
  Environment = 'ENVIRONMENT',
  EventDefinition = 'EVENT_DEFINITION',
  EventInstance = 'EVENT_INSTANCE',
  Group = 'GROUP',
  IncomingWebhook = 'INCOMING_WEBHOOK',
  Journey = 'JOURNEY',
  Organisation = 'ORGANISATION',
  ResourceUser = 'RESOURCE_USER',
  SnsPlatform = 'SNS_PLATFORM',
  Stream = 'STREAM',
  StreamContainer = 'STREAM_CONTAINER',
  Tag = 'TAG',
  Theme = 'THEME',
  TriggerEvent = 'TRIGGER_EVENT',
  WebhooksEndpoint = 'WEBHOOKS_ENDPOINT',
  WebhookCredential = 'WEBHOOK_CREDENTIAL',
  WebhookLog = 'WEBHOOK_LOG'
}

/** A filter to be used against PermissionResource fields. All fields are combined with a logical ‘and.’ */
export type PermissionResourceFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<PermissionResource>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<PermissionResource>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<PermissionResource>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<PermissionResource>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<PermissionResource>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<PermissionResource>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<PermissionResource>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<PermissionResource>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<PermissionResource>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<PermissionResource>>;
};

export type Permissions = {
  action: PermissionAction;
  active: Scalars['Boolean']['input'];
  resource: PermissionResource;
};

export type Preferences = {
  notificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfileConditions = {
  conditions?: InputMaybe<Array<Condition>>;
  operator: Scalars['String']['input'];
};

/** An input for mutations affecting `ProfileFilter` */
export type ProfileFilterInput = {
  condition?: InputMaybe<ConditionOperator>;
  field?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ProfileFiltersInput = {
  conditions?: InputMaybe<Array<ProfileConditions>>;
  operator: Scalars['String']['input'];
};

export type PublishActionFlowInput = {
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  targetSegmentsOnPublish?: InputMaybe<Array<Scalars['String']['input']>>;
  versionsToCancelCards?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** The root query type which gives access points into the data universe. */
export type Query = Node & {
  __typename?: 'Query';
  account?: Maybe<Account>;
  accountByEmail?: Maybe<Account>;
  /** Reads a single `Account` using its globally unique `ID`. */
  accountByNodeId?: Maybe<Account>;
  /** Reads and enables pagination through a set of `Account`. */
  accounts?: Maybe<AccountsConnection>;
  actionFlowApproval?: Maybe<ActionFlowApproval>;
  /** Reads a single `ActionFlowApproval` using its globally unique `ID`. */
  actionFlowApprovalByNodeId?: Maybe<ActionFlowApproval>;
  actionFlowApprovalRequest?: Maybe<ActionFlowApprovalRequest>;
  /** Reads a single `ActionFlowApprovalRequest` using its globally unique `ID`. */
  actionFlowApprovalRequestByNodeId?: Maybe<ActionFlowApprovalRequest>;
  /** Reads and enables pagination through a set of `ActionFlowApprovalRequest`. */
  actionFlowApprovalRequests?: Maybe<ActionFlowApprovalRequestsConnection>;
  /** Reads and enables pagination through a set of `ActionFlowApproval`. */
  actionFlowApprovals?: Maybe<ActionFlowApprovalsConnection>;
  actionFlowConfig?: Maybe<ActionFlowConfig>;
  /** Reads a single `ActionFlowConfig` using its globally unique `ID`. */
  actionFlowConfigByNodeId?: Maybe<ActionFlowConfig>;
  /** Count of distinct action flow status, used by action flow list page for folder badges */
  actionFlowConfigStatusCounts?: Maybe<ActionFlowConfigStatusCountsConnection>;
  actionFlowConfigVersion?: Maybe<ActionFlowConfigVersion>;
  actionFlowConfigVersionAnalytic?: Maybe<ActionFlowConfigVersionAnalytic>;
  actionFlowConfigVersionAnalyticByEnvironmentIdAndFlowConfigIdAndFlowConfigVersionAndStepIdAndEventNameAndIsTest?: Maybe<ActionFlowConfigVersionAnalytic>;
  /** Reads a single `ActionFlowConfigVersionAnalytic` using its globally unique `ID`. */
  actionFlowConfigVersionAnalyticByNodeId?: Maybe<ActionFlowConfigVersionAnalytic>;
  /** Reads and enables pagination through a set of `ActionFlowConfigVersionAnalytic`. */
  actionFlowConfigVersionAnalytics?: Maybe<ActionFlowConfigVersionAnalyticsConnection>;
  /** Reads a single `ActionFlowConfigVersion` using its globally unique `ID`. */
  actionFlowConfigVersionByNodeId?: Maybe<ActionFlowConfigVersion>;
  /** Reads and enables pagination through a set of `ActionFlowConfigVersion`. */
  actionFlowConfigVersions?: Maybe<ActionFlowConfigVersionsConnection>;
  /** Reads and enables pagination through a set of `ActionFlowConfig`. */
  actionFlowConfigs?: Maybe<ActionFlowConfigsConnection>;
  analyticsBatch?: Maybe<AnalyticsBatch>;
  /** Reads a single `AnalyticsBatch` using its globally unique `ID`. */
  analyticsBatchByNodeId?: Maybe<AnalyticsBatch>;
  appClient?: Maybe<AppClient>;
  /** Reads a single `AppClient` using its globally unique `ID`. */
  appClientByNodeId?: Maybe<AppClient>;
  /** Reads and enables pagination through a set of `AppClient`. */
  appClients?: Maybe<AppClientsConnection>;
  approvalConfiguration?: Maybe<ApprovalConfigurationResponse>;
  auditLog?: Maybe<AuditLog>;
  /** Reads a single `AuditLog` using its globally unique `ID`. */
  auditLogByNodeId?: Maybe<AuditLog>;
  auditLogListQuery?: Maybe<AuditLogListResponse>;
  /** Reads and enables pagination through a set of `AuditLog`. */
  auditLogs?: Maybe<AuditLogsConnection>;
  authAccount?: Maybe<AuthAccount>;
  authAccountByAccountIdAndAppClientId?: Maybe<AuthAccount>;
  /** Reads a single `AuthAccount` using its globally unique `ID`. */
  authAccountByNodeId?: Maybe<AuthAccount>;
  authAccountBySubAndAppClientId?: Maybe<AuthAccount>;
  /** Reads and enables pagination through a set of `AuthAccount`. */
  authAccounts?: Maybe<AuthAccountsConnection>;
  businessUser?: Maybe<BusinessUser>;
  businessUserByInviteSecret?: Maybe<BusinessUser>;
  /** Reads a single `BusinessUser` using its globally unique `ID`. */
  businessUserByNodeId?: Maybe<BusinessUser>;
  businessUserByOrganisationIdAndId?: Maybe<BusinessUser>;
  businessUserGroup?: Maybe<BusinessUserGroup>;
  /** Reads a single `BusinessUserGroup` using its globally unique `ID`. */
  businessUserGroupByNodeId?: Maybe<BusinessUserGroup>;
  /** Reads and enables pagination through a set of `BusinessUserGroup`. */
  businessUserGroups?: Maybe<BusinessUserGroupsConnection>;
  /** Reads and enables pagination through a set of `BusinessUser`. */
  businessUsers?: Maybe<BusinessUsersConnection>;
  cardApproval?: Maybe<CardApproval>;
  /** Reads a single `CardApproval` using its globally unique `ID`. */
  cardApprovalByNodeId?: Maybe<CardApproval>;
  cardApprovalRequest?: Maybe<CardApprovalRequest>;
  /** Reads a single `CardApprovalRequest` using its globally unique `ID`. */
  cardApprovalRequestByNodeId?: Maybe<CardApprovalRequest>;
  /** Reads and enables pagination through a set of `CardApprovalRequest`. */
  cardApprovalRequests?: Maybe<CardApprovalRequestsConnection>;
  /** Reads and enables pagination through a set of `CardApproval`. */
  cardApprovals?: Maybe<CardApprovalsConnection>;
  cardCancelTask?: Maybe<CardCancelTask>;
  /** Reads a single `CardCancelTask` using its globally unique `ID`. */
  cardCancelTaskByNodeId?: Maybe<CardCancelTask>;
  /** Reads and enables pagination through a set of `CardCancelTask`. */
  cardCancelTasks?: Maybe<CardCancelTasksConnection>;
  cardCancelTasksProgress: CardCancelProgressResult;
  cardList: CardListResponse;
  cardTemplate?: Maybe<CardTemplate>;
  /** Reads a single `CardTemplate` using its globally unique `ID`. */
  cardTemplateByNodeId?: Maybe<CardTemplate>;
  /** Count of distinct card templates status, used by card template list page */
  cardTemplateStatusCounts?: Maybe<CardTemplateStatusCountsConnection>;
  cardTemplateVersion?: Maybe<CardTemplateVersion>;
  /** Reads a single `CardTemplateVersion` using its globally unique `ID`. */
  cardTemplateVersionByNodeId?: Maybe<CardTemplateVersion>;
  /** Reads and enables pagination through a set of `CardTemplateVersionHistory`. */
  cardTemplateVersionHistories?: Maybe<CardTemplateVersionHistoriesConnection>;
  /** Reads and enables pagination through a set of `CardTemplateVersionWithHistory`. */
  cardTemplateVersionWithHistories?: Maybe<CardTemplateVersionWithHistoriesConnection>;
  /** Reads and enables pagination through a set of `CardTemplateVersion`. */
  cardTemplateVersions?: Maybe<CardTemplateVersionsConnection>;
  /** Reads and enables pagination through a set of `CardTemplate`. */
  cardTemplates?: Maybe<CardTemplatesConnection>;
  clientKey?: Maybe<ClientKey>;
  clientKeyByApiKey?: Maybe<ClientKey>;
  /** Reads a single `ClientKey` using its globally unique `ID`. */
  clientKeyByNodeId?: Maybe<ClientKey>;
  /** Reads and enables pagination through a set of `ClientKey`. */
  clientKeys?: Maybe<ClientKeysConnection>;
  connectorRuntime?: Maybe<ConnectorRuntime>;
  connectorRuntimeByEnvironmentIdAndSecret?: Maybe<ConnectorRuntime>;
  /** Reads a single `ConnectorRuntime` using its globally unique `ID`. */
  connectorRuntimeByNodeId?: Maybe<ConnectorRuntime>;
  /** Reads and enables pagination through a set of `ConnectorRuntime`. */
  connectorRuntimes?: Maybe<ConnectorRuntimesConnection>;
  csvUploadTask?: Maybe<CsvUploadTask>;
  /** Reads a single `CsvUploadTask` using its globally unique `ID`. */
  csvUploadTaskByNodeId?: Maybe<CsvUploadTask>;
  /** Reads and enables pagination through a set of `CsvUploadTask`. */
  csvUploadTasks?: Maybe<CsvUploadTasksConnection>;
  currentBusinessUserGroupIds?: Maybe<CurrentBusinessUserGroupIdsConnection>;
  customEventConfig?: Maybe<CustomEventConfig>;
  /** Reads a single `CustomEventConfig` using its globally unique `ID`. */
  customEventConfigByNodeId?: Maybe<CustomEventConfig>;
  /** Reads and enables pagination through a set of `CustomEventConfig`. */
  customEventConfigList?: Maybe<CustomEventConfigsConnection>;
  /** Reads and enables pagination through a set of `CustomEventConfig`. */
  customEventConfigs?: Maybe<CustomEventConfigsConnection>;
  customRole?: Maybe<CustomRole>;
  /** Reads a single `CustomRole` using its globally unique `ID`. */
  customRoleByNodeId?: Maybe<CustomRole>;
  customRoleByOrganisationIdAndName?: Maybe<CustomRole>;
  /** Reads and enables pagination through a set of `CustomRole`. */
  customRoles?: Maybe<CustomRolesConnection>;
  customerToken?: Maybe<CustomerToken>;
  customerTokenByClientIdAndEnvironmentId?: Maybe<CustomerToken>;
  /** Reads a single `CustomerToken` using its globally unique `ID`. */
  customerTokenByNodeId?: Maybe<CustomerToken>;
  /** Reads and enables pagination through a set of `CustomerToken`. */
  customerTokens?: Maybe<CustomerTokensConnection>;
  endUserSegment?: Maybe<EndUserSegment>;
  endUserSegmentByEnvironmentIdAndName?: Maybe<EndUserSegment>;
  /** Reads a single `EndUserSegment` using its globally unique `ID`. */
  endUserSegmentByNodeId?: Maybe<EndUserSegment>;
  /** Reads and enables pagination through a set of `EndUserSegment`. */
  endUserSegments?: Maybe<EndUserSegmentsConnection>;
  environment?: Maybe<Environment>;
  /** Reads a single `Environment` using its globally unique `ID`. */
  environmentByNodeId?: Maybe<Environment>;
  environmentByOrganisationIdAndId?: Maybe<Environment>;
  /** Reads and enables pagination through a set of `Group`. */
  environmentGroups?: Maybe<GroupsConnection>;
  /** Reads and enables pagination through a set of `Environment`. */
  environments?: Maybe<EnvironmentsConnection>;
  eventDefinition?: Maybe<EventDefinition>;
  eventDefinitionByEnvironmentIdAndEventName?: Maybe<EventDefinition>;
  /** Reads a single `EventDefinition` using its globally unique `ID`. */
  eventDefinitionByNodeId?: Maybe<EventDefinition>;
  eventDefinitionVersion?: Maybe<EventDefinitionVersion>;
  /** Reads a single `EventDefinitionVersion` using its globally unique `ID`. */
  eventDefinitionVersionByNodeId?: Maybe<EventDefinitionVersion>;
  /** Reads and enables pagination through a set of `EventDefinitionVersion`. */
  eventDefinitionVersions?: Maybe<EventDefinitionVersionsConnection>;
  /** Reads and enables pagination through a set of `EventDefinition`. */
  eventDefinitions?: Maybe<EventDefinitionsConnection>;
  featureFlags?: Maybe<FeatureFlags>;
  getActionFlowInstances?: Maybe<GetActionFlowInstanceOutput>;
  /** Retrieves current authenticated account id */
  getCurrentAccount?: Maybe<Account>;
  getCurrentAccountId?: Maybe<Scalars['Int']['output']>;
  getOrganisationAccess?: Maybe<OrganisationAccess>;
  /** Reads and enables pagination through a set of `CardInstance`. */
  getSyncedCardInstances?: Maybe<CardInstancesConnection>;
  /** Reads and enables pagination through a set of `WebhookLog`. */
  getWebhookLogs?: Maybe<WebhookLogsConnection>;
  grant?: Maybe<Grant>;
  /** Reads a single `Grant` using its globally unique `ID`. */
  grantByNodeId?: Maybe<Grant>;
  /** Reads and enables pagination through a set of `Grant`. */
  grants?: Maybe<GrantsConnection>;
  group?: Maybe<Group>;
  /** Reads a single `Group` using its globally unique `ID`. */
  groupByNodeId?: Maybe<Group>;
  groupByOrganisationIdAndName?: Maybe<Group>;
  /** Reads and enables pagination through a set of `Group`. */
  groups?: Maybe<GroupsConnection>;
  insightsQuery?: Maybe<InsightsResponse>;
  insightsReport?: Maybe<InsightsReport>;
  /** Reads a single `InsightsReport` using its globally unique `ID`. */
  insightsReportByNodeId?: Maybe<InsightsReport>;
  /** Reads and enables pagination through a set of `InsightsReport`. */
  insightsReports?: Maybe<InsightsReportsConnection>;
  integrationConfiguration?: Maybe<IntegrationConfiguration>;
  /** Reads a single `IntegrationConfiguration` using its globally unique `ID`. */
  integrationConfigurationByNodeId?: Maybe<IntegrationConfiguration>;
  /** Reads and enables pagination through a set of `IntegrationConfiguration`. */
  integrationConfigurations?: Maybe<IntegrationConfigurationsConnection>;
  magicLink?: Maybe<MagicLink>;
  /** Reads a single `MagicLink` using its globally unique `ID`. */
  magicLinkByNodeId?: Maybe<MagicLink>;
  /** Fetches an object given its globally unique `ID`. */
  node?: Maybe<Node>;
  /** The root query type must be a `Node` to work well with Relay 1 mutations. This just resolves to `query`. */
  nodeId: Scalars['ID']['output'];
  organisation?: Maybe<Organisation>;
  /** Reads a single `Organisation` using its globally unique `ID`. */
  organisationByNodeId?: Maybe<Organisation>;
  /** Reads and enables pagination through a set of `Organisation`. */
  organisations?: Maybe<OrganisationsConnection>;
  /**
   * Exposes the root query type nested one level down. This is helpful for Relay 1
   * which can only query top level fields if they are in a particular form.
   */
  query: Query;
  resourceUser?: Maybe<ResourceUser>;
  /** Reads a single `ResourceUser` using its globally unique `ID`. */
  resourceUserByNodeId?: Maybe<ResourceUser>;
  /** Reads and enables pagination through a set of `ResourceUser`. */
  resourceUsers?: Maybe<ResourceUsersConnection>;
  retrieveEndUserQuery: CustomEndUserType;
  retrieveTestUsersQuery: RetrieveTestUsersResponse;
  rolePermission?: Maybe<RolePermission>;
  /** Reads a single `RolePermission` using its globally unique `ID`. */
  rolePermissionByNodeId?: Maybe<RolePermission>;
  /** Reads and enables pagination through a set of `RolePermission`. */
  rolePermissions?: Maybe<RolePermissionsConnection>;
  screenshotCardQuery?: Maybe<Response>;
  stream?: Maybe<Stream>;
  /** Reads a single `Stream` using its globally unique `ID`. */
  streamByNodeId?: Maybe<Stream>;
  streamContainer?: Maybe<StreamContainer>;
  /** Reads a single `StreamContainer` using its globally unique `ID`. */
  streamContainerByNodeId?: Maybe<StreamContainer>;
  /** Reads and enables pagination through a set of `StreamContainer`. */
  streamContainers?: Maybe<StreamContainersConnection>;
  /** Reads and enables pagination through a set of `Stream`. */
  streams?: Maybe<StreamsConnection>;
  syncedEndUser?: Maybe<SyncedEndUser>;
  /** Reads a single `SyncedEndUser` using its globally unique `ID`. */
  syncedEndUserByNodeId?: Maybe<SyncedEndUser>;
  /** Reads and enables pagination through a set of `SyncedEndUser`. */
  syncedEndUsers?: Maybe<SyncedEndUsersConnection>;
  tag?: Maybe<Tag>;
  tagByEnvironmentIdAndName?: Maybe<Tag>;
  /** Reads a single `Tag` using its globally unique `ID`. */
  tagByNodeId?: Maybe<Tag>;
  /** Reads and enables pagination through a set of `Tag`. */
  tags?: Maybe<TagsConnection>;
  theme?: Maybe<Theme>;
  /** Reads a single `Theme` using its globally unique `ID`. */
  themeByNodeId?: Maybe<Theme>;
  /** Reads and enables pagination through a set of `Theme`. */
  themes?: Maybe<ThemesConnection>;
  triggerEvent?: Maybe<TriggerEvent>;
  triggerEventByEnvironmentIdAndStreamIdAndEventDefinitionIdAndEventDefinitionVersionAndCardTemplateIdAndCardTemplateVersion?: Maybe<TriggerEvent>;
  /** Reads a single `TriggerEvent` using its globally unique `ID`. */
  triggerEventByNodeId?: Maybe<TriggerEvent>;
  /** Reads and enables pagination through a set of `TriggerEventHistory`. */
  triggerEventHistories?: Maybe<TriggerEventHistoriesConnection>;
  /** Reads and enables pagination through a set of `TriggerEventWithHistory`. */
  triggerEventWithHistories?: Maybe<TriggerEventWithHistoriesConnection>;
  /** Reads and enables pagination through a set of `TriggerEvent`. */
  triggerEvents?: Maybe<TriggerEventsConnection>;
  userCountQuery?: Maybe<UserCountResponse>;
  userProfileQuery?: Maybe<EndUserListResponse>;
  verifyClientJwt?: Maybe<TestClientJwtResult>;
  webhookCredential?: Maybe<WebhookCredential>;
  /** Reads a single `WebhookCredential` using its globally unique `ID`. */
  webhookCredentialByNodeId?: Maybe<WebhookCredential>;
  /** Reads and enables pagination through a set of `WebhookCredential`. */
  webhookCredentials?: Maybe<WebhookCredentialsConnection>;
  webhookEndpoint?: Maybe<WebhookEndpoint>;
  /** Reads a single `WebhookEndpoint` using its globally unique `ID`. */
  webhookEndpointByNodeId?: Maybe<WebhookEndpoint>;
  /** Reads and enables pagination through a set of `WebhookEndpoint`. */
  webhookEndpoints?: Maybe<WebhookEndpointsConnection>;
  /** Returns a recent slice of platform activity for viewing in the workbench */
  workbenchActivityLog?: Maybe<WorkbenchActivityLogConnection>;
  /** Returns a recent slice of platform activity for viewing in the workbench with pagination */
  workbenchActivityLogV2?: Maybe<WorkbenchActivityLogV2Connection>;
  /** Returns a recent slice of analytics for viewing in the workbench */
  workbenchAnalytics?: Maybe<WorkbenchAnalyticsConnection>;
  workbenchFolder?: Maybe<WorkbenchFolder>;
  workbenchFolderByEnvironmentIdAndName?: Maybe<WorkbenchFolder>;
  /** Reads a single `WorkbenchFolder` using its globally unique `ID`. */
  workbenchFolderByNodeId?: Maybe<WorkbenchFolder>;
  /** Reads and enables pagination through a set of `WorkbenchFolder`. */
  workbenchFolders?: Maybe<WorkbenchFoldersConnection>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAccountArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAccountByEmailArgs = {
  email: Scalars['Email']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAccountByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAccountsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountCondition>;
  filter?: InputMaybe<AccountFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryActionFlowApprovalArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryActionFlowApprovalByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryActionFlowApprovalRequestArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryActionFlowApprovalRequestByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryActionFlowApprovalRequestsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ActionFlowApprovalRequestCondition>;
  filter?: InputMaybe<ActionFlowApprovalRequestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActionFlowApprovalRequestsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryActionFlowApprovalsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ActionFlowApprovalCondition>;
  filter?: InputMaybe<ActionFlowApprovalFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActionFlowApprovalsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryActionFlowConfigArgs = {
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryActionFlowConfigByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryActionFlowConfigStatusCountsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  environmentId: Scalars['String']['input'];
  filter?: InputMaybe<ActionFlowConfigStatusCountsRecordFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  workbenchFolderIds?: InputMaybe<Scalars['String']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryActionFlowConfigVersionArgs = {
  environmentId: Scalars['String']['input'];
  flowConfigId: Scalars['String']['input'];
  version: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryActionFlowConfigVersionAnalyticArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryActionFlowConfigVersionAnalyticByEnvironmentIdAndFlowConfigIdAndFlowConfigVersionAndStepIdAndEventNameAndIsTestArgs = {
  environmentId: Scalars['String']['input'];
  eventName: Scalars['String']['input'];
  flowConfigId: Scalars['String']['input'];
  flowConfigVersion: Scalars['Int']['input'];
  isTest: Scalars['Boolean']['input'];
  stepId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryActionFlowConfigVersionAnalyticByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryActionFlowConfigVersionAnalyticsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ActionFlowConfigVersionAnalyticCondition>;
  filter?: InputMaybe<ActionFlowConfigVersionAnalyticFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActionFlowConfigVersionAnalyticsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryActionFlowConfigVersionByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryActionFlowConfigVersionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ActionFlowConfigVersionCondition>;
  filter?: InputMaybe<ActionFlowConfigVersionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActionFlowConfigVersionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryActionFlowConfigsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ActionFlowConfigCondition>;
  filter?: InputMaybe<ActionFlowConfigFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ActionFlowConfigsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAnalyticsBatchArgs = {
  environmentId: Scalars['String']['input'];
  processFrom: Scalars['Datetime']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAnalyticsBatchByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAppClientArgs = {
  appClientId: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAppClientByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAppClientsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AppClientCondition>;
  filter?: InputMaybe<AppClientFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AppClientsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryApprovalConfigurationArgs = {
  environmentId?: InputMaybe<Scalars['String']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAuditLogArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAuditLogByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAuditLogListQueryArgs = {
  filters: AuditLogFilters;
  organisationId: Scalars['String']['input'];
  pagination: AuditLogPaginationInput;
};


/** The root query type which gives access points into the data universe. */
export type QueryAuditLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AuditLogCondition>;
  filter?: InputMaybe<AuditLogFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AuditLogsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAuthAccountArgs = {
  appClientId: Scalars['String']['input'];
  email: Scalars['Email']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAuthAccountByAccountIdAndAppClientIdArgs = {
  accountId: Scalars['Int']['input'];
  appClientId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAuthAccountByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAuthAccountBySubAndAppClientIdArgs = {
  appClientId: Scalars['String']['input'];
  sub: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAuthAccountsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AuthAccountCondition>;
  filter?: InputMaybe<AuthAccountFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AuthAccountsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryBusinessUserArgs = {
  accountId: Scalars['Int']['input'];
  organisationId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBusinessUserByInviteSecretArgs = {
  inviteSecret: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBusinessUserByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBusinessUserByOrganisationIdAndIdArgs = {
  id: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBusinessUserGroupArgs = {
  businessUserId: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBusinessUserGroupByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBusinessUserGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BusinessUserGroupCondition>;
  filter?: InputMaybe<BusinessUserGroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessUserGroupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryBusinessUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BusinessUserCondition>;
  filter?: InputMaybe<BusinessUserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BusinessUsersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCardApprovalArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCardApprovalByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCardApprovalRequestArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCardApprovalRequestByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCardApprovalRequestsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CardApprovalRequestCondition>;
  filter?: InputMaybe<CardApprovalRequestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CardApprovalRequestsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCardApprovalsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CardApprovalCondition>;
  filter?: InputMaybe<CardApprovalFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CardApprovalsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCardCancelTaskArgs = {
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCardCancelTaskByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCardCancelTasksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CardCancelTaskCondition>;
  filter?: InputMaybe<CardCancelTaskFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CardCancelTasksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCardCancelTasksProgressArgs = {
  input?: InputMaybe<CardCancelProgressInput>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCardListArgs = {
  condition: CardListCondition;
  criteria?: InputMaybe<Scalars['JSON']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCardTemplateArgs = {
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCardTemplateByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCardTemplateStatusCountsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  environmentId: Scalars['String']['input'];
  filter?: InputMaybe<CardTemplateStatusCountsRecordFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCardTemplateVersionArgs = {
  cardTemplateId: Scalars['String']['input'];
  environmentId: Scalars['String']['input'];
  version: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCardTemplateVersionByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCardTemplateVersionHistoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CardTemplateVersionHistoryCondition>;
  filter?: InputMaybe<CardTemplateVersionHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CardTemplateVersionHistoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCardTemplateVersionWithHistoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CardTemplateVersionWithHistoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCardTemplateVersionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CardTemplateVersionCondition>;
  filter?: InputMaybe<CardTemplateVersionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CardTemplateVersionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCardTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CardTemplateCondition>;
  filter?: InputMaybe<CardTemplateFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CardTemplatesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryClientKeyArgs = {
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryClientKeyByApiKeyArgs = {
  apiKey: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryClientKeyByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryClientKeysArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ClientKeyCondition>;
  filter?: InputMaybe<ClientKeyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ClientKeysOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryConnectorRuntimeArgs = {
  environmentId: Scalars['String']['input'];
  flowConfigId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryConnectorRuntimeByEnvironmentIdAndSecretArgs = {
  environmentId: Scalars['String']['input'];
  secret: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryConnectorRuntimeByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryConnectorRuntimesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ConnectorRuntimeCondition>;
  filter?: InputMaybe<ConnectorRuntimeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ConnectorRuntimesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCsvUploadTaskArgs = {
  environmentId: Scalars['String']['input'];
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCsvUploadTaskByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCsvUploadTasksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CsvUploadTaskCondition>;
  filter?: InputMaybe<CsvUploadTaskFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CsvUploadTasksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCurrentBusinessUserGroupIdsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<CurrentBusinessUserGroupIdsRecordFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organisationId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomEventConfigArgs = {
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomEventConfigByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomEventConfigListArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  environmentId: Scalars['String']['input'];
  filter?: InputMaybe<CustomEventConfigFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organisationId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomEventConfigsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CustomEventConfigCondition>;
  filter?: InputMaybe<CustomEventConfigFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CustomEventConfigsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomRoleArgs = {
  id: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomRoleByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomRoleByOrganisationIdAndNameArgs = {
  name: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CustomRoleCondition>;
  filter?: InputMaybe<CustomRoleFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CustomRolesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomerTokenArgs = {
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomerTokenByClientIdAndEnvironmentIdArgs = {
  clientId: Scalars['String']['input'];
  environmentId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomerTokenByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCustomerTokensArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CustomerTokenCondition>;
  filter?: InputMaybe<CustomerTokenFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CustomerTokensOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEndUserSegmentArgs = {
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEndUserSegmentByEnvironmentIdAndNameArgs = {
  environmentId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEndUserSegmentByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEndUserSegmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EndUserSegmentCondition>;
  filter?: InputMaybe<EndUserSegmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EndUserSegmentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEnvironmentArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEnvironmentByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEnvironmentByOrganisationIdAndIdArgs = {
  id: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEnvironmentGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  environmentId: Scalars['String']['input'];
  filter?: InputMaybe<GroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEnvironmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EnvironmentCondition>;
  filter?: InputMaybe<EnvironmentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EnvironmentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEventDefinitionArgs = {
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEventDefinitionByEnvironmentIdAndEventNameArgs = {
  environmentId: Scalars['String']['input'];
  eventName: Scalars['EventName']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEventDefinitionByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEventDefinitionVersionArgs = {
  environmentId: Scalars['String']['input'];
  eventDefinitionId: Scalars['String']['input'];
  version: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEventDefinitionVersionByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEventDefinitionVersionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EventDefinitionVersionCondition>;
  filter?: InputMaybe<EventDefinitionVersionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EventDefinitionVersionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEventDefinitionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EventDefinitionCondition>;
  filter?: InputMaybe<EventDefinitionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EventDefinitionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFeatureFlagsArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  organisationId?: InputMaybe<Scalars['String']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetActionFlowInstancesArgs = {
  environmentId: Scalars['String']['input'];
  flowInstanceIds: Array<InputMaybe<Scalars['String']['input']>>;
  organisationId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetOrganisationAccessArgs = {
  organisationId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetSyncedCardInstancesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  cardTemplateId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetWebhookLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  environmentId: Scalars['String']['input'];
  filter?: InputMaybe<WebhookLogFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  webhookEndpointId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGrantArgs = {
  id: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGrantByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGrantsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GrantCondition>;
  filter?: InputMaybe<GrantFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GrantsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGroupArgs = {
  id: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGroupByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGroupByOrganisationIdAndNameArgs = {
  name: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<GroupCondition>;
  filter?: InputMaybe<GroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryInsightsQueryArgs = {
  cardTemplateId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  from: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
  platform?: InputMaybe<Scalars['String']['input']>;
  streamId?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInsightsReportArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInsightsReportByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryInsightsReportsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<InsightsReportCondition>;
  filter?: InputMaybe<InsightsReportFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InsightsReportsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryIntegrationConfigurationArgs = {
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIntegrationConfigurationByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIntegrationConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<IntegrationConfigurationCondition>;
  filter?: InputMaybe<IntegrationConfigurationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IntegrationConfigurationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMagicLinkArgs = {
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMagicLinkByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNodeArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrganisationArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrganisationByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOrganisationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OrganisationCondition>;
  filter?: InputMaybe<OrganisationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganisationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryResourceUserArgs = {
  environmentId: Scalars['String']['input'];
  resourceId: Scalars['String']['input'];
  resourceType: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
  sub: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryResourceUserByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryResourceUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ResourceUserCondition>;
  filter?: InputMaybe<ResourceUserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ResourceUsersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRetrieveEndUserQueryArgs = {
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRetrieveTestUsersQueryArgs = {
  environmentId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRolePermissionArgs = {
  organisationId: Scalars['String']['input'];
  resource: PermissionResource;
  roleId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRolePermissionByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRolePermissionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RolePermissionCondition>;
  filter?: InputMaybe<RolePermissionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RolePermissionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryScreenshotCardQueryArgs = {
  actionFlowConfigId: Scalars['String']['input'];
  actionFlowConfigVersion: Scalars['Int']['input'];
  cardDefinition: Scalars['JSON']['input'];
  cardTemplateId: Scalars['String']['input'];
  environmentId: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
  payload?: InputMaybe<Scalars['JSON']['input']>;
  sdkVersion: Scalars['String']['input'];
  subviewId?: InputMaybe<Scalars['String']['input']>;
  theme: Scalars['JSON']['input'];
  themeId: Scalars['String']['input'];
  type: Scalars['String']['input'];
  updated: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryStreamArgs = {
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryStreamByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryStreamContainerArgs = {
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryStreamContainerByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryStreamContainersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<StreamContainerCondition>;
  filter?: InputMaybe<StreamContainerFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<StreamContainersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryStreamsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<StreamCondition>;
  filter?: InputMaybe<StreamFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<StreamsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QuerySyncedEndUserArgs = {
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySyncedEndUserByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySyncedEndUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SyncedEndUserCondition>;
  filter?: InputMaybe<SyncedEndUserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SyncedEndUsersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTagArgs = {
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTagByEnvironmentIdAndNameArgs = {
  environmentId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTagByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TagCondition>;
  filter?: InputMaybe<TagFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryThemeArgs = {
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryThemeByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryThemesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ThemeCondition>;
  filter?: InputMaybe<ThemeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ThemesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTriggerEventArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTriggerEventByEnvironmentIdAndStreamIdAndEventDefinitionIdAndEventDefinitionVersionAndCardTemplateIdAndCardTemplateVersionArgs = {
  cardTemplateId: Scalars['String']['input'];
  cardTemplateVersion: Scalars['Int']['input'];
  environmentId: Scalars['String']['input'];
  eventDefinitionId: Scalars['String']['input'];
  eventDefinitionVersion: Scalars['Int']['input'];
  streamId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTriggerEventByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTriggerEventHistoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TriggerEventHistoryCondition>;
  filter?: InputMaybe<TriggerEventHistoryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TriggerEventHistoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTriggerEventWithHistoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TriggerEventWithHistoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTriggerEventsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TriggerEventCondition>;
  filter?: InputMaybe<TriggerEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TriggerEventsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserCountQueryArgs = {
  condition: SyncedEndUserQueryConditions;
  profileFilters?: InputMaybe<ProfileFiltersInput>;
  segmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserProfileQueryArgs = {
  condition: SyncedEndUserQueryConditions;
  customOrderBy?: InputMaybe<SyncedEndUsersCustomOrderBy>;
  pagination?: InputMaybe<SyncedEndUserPaginationInput>;
  profileFilters: ProfileFiltersInput;
};


/** The root query type which gives access points into the data universe. */
export type QueryVerifyClientJwtArgs = {
  input: TestClientJwtInput;
};


/** The root query type which gives access points into the data universe. */
export type QueryWebhookCredentialArgs = {
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryWebhookCredentialByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryWebhookCredentialsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<WebhookCredentialCondition>;
  filter?: InputMaybe<WebhookCredentialFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WebhookCredentialsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryWebhookEndpointArgs = {
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryWebhookEndpointByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryWebhookEndpointsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<WebhookEndpointCondition>;
  filter?: InputMaybe<WebhookEndpointFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WebhookEndpointsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryWorkbenchActivityLogArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<WorkbenchActivityLogRecordFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organisationId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryWorkbenchActivityLogV2Args = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<WorkbenchActivityLogV2RecordFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastId?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organisationId: Scalars['String']['input'];
  resultLimit?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryWorkbenchAnalyticsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  environmentId: Scalars['String']['input'];
  filter?: InputMaybe<WorkbenchAnalyticsRecordFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryWorkbenchFolderArgs = {
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryWorkbenchFolderByEnvironmentIdAndNameArgs = {
  environmentId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryWorkbenchFolderByNodeIdArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryWorkbenchFoldersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<WorkbenchFolderCondition>;
  filter?: InputMaybe<WorkbenchFolderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WorkbenchFoldersOrderBy>>;
};

/** All input for the `removeActionFlowApprovalRequest` mutation. */
export type RemoveActionFlowApprovalRequestInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  flowConfigId: Scalars['String']['input'];
  flowConfigVersion: Scalars['Int']['input'];
};

/** The output of our `removeActionFlowApprovalRequest` mutation. */
export type RemoveActionFlowApprovalRequestPayload = {
  __typename?: 'RemoveActionFlowApprovalRequestPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `removeCardApprovalRequest` mutation. */
export type RemoveCardApprovalRequestInput = {
  cardTemplateId: Scalars['String']['input'];
  cardTemplateVersion: Scalars['Int']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
};

/** The output of our `removeCardApprovalRequest` mutation. */
export type RemoveCardApprovalRequestPayload = {
  __typename?: 'RemoveCardApprovalRequestPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `removeTriggerEvent` mutation. */
export type RemoveTriggerEventInput = {
  _triggerEventId: Scalars['Int']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `removeTriggerEvent` mutation. */
export type RemoveTriggerEventPayload = {
  __typename?: 'RemoveTriggerEventPayload';
  /** Reads a single `ActionFlowConfigVersion` that is related to this `TriggerEvent`. */
  actionFlowConfigVersionByEnvironmentIdAndFlowConfigIdAndFlowConfigVersion?: Maybe<ActionFlowConfigVersion>;
  /** Reads a single `CardTemplateVersion` that is related to this `TriggerEvent`. */
  cardTemplateVersionByEnvironmentIdAndCardTemplateIdAndCardTemplateVersion?: Maybe<CardTemplateVersion>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Environment` that is related to this `TriggerEvent`. */
  environment?: Maybe<Environment>;
  /** Reads a single `Stream` that is related to this `TriggerEvent`. */
  environmentStream?: Maybe<Stream>;
  /** Reads a single `EventDefinitionVersion` that is related to this `TriggerEvent`. */
  eventDefinitionVersionByEnvironmentIdAndEventDefinitionIdAndEventDefinitionVersion?: Maybe<EventDefinitionVersion>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  triggerEvent?: Maybe<TriggerEvent>;
  /** An edge for our `TriggerEvent`. May be used by Relay 1. */
  triggerEventEdge?: Maybe<TriggerEventsEdge>;
};


/** The output of our `removeTriggerEvent` mutation. */
export type RemoveTriggerEventPayloadTriggerEventEdgeArgs = {
  orderBy?: InputMaybe<Array<TriggerEventsOrderBy>>;
};

/** All input for the `requestActionFlowApproval` mutation. */
export type RequestActionFlowApprovalInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  flowConfigId: Scalars['String']['input'];
  flowConfigVersion: Scalars['Int']['input'];
};

/** The output of our `requestActionFlowApproval` mutation. */
export type RequestActionFlowApprovalPayload = {
  __typename?: 'RequestActionFlowApprovalPayload';
  actionFlowApprovalRequest?: Maybe<ActionFlowApprovalRequest>;
  /** An edge for our `ActionFlowApprovalRequest`. May be used by Relay 1. */
  actionFlowApprovalRequestEdge?: Maybe<ActionFlowApprovalRequestsEdge>;
  /** Reads a single `ActionFlowConfigVersion` that is related to this `ActionFlowApprovalRequest`. */
  actionFlowConfigVersionByEnvironmentIdAndFlowConfigIdAndFlowConfigVersion?: Maybe<ActionFlowConfigVersion>;
  /** Reads a single `BusinessUser` that is related to this `ActionFlowApprovalRequest`. */
  businessUserByOrganisationIdAndRequestedBy?: Maybe<BusinessUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organisation` that is related to this `ActionFlowApprovalRequest`. */
  organisation?: Maybe<Organisation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `requestActionFlowApproval` mutation. */
export type RequestActionFlowApprovalPayloadActionFlowApprovalRequestEdgeArgs = {
  orderBy?: InputMaybe<Array<ActionFlowApprovalRequestsOrderBy>>;
};

/** All input for the `requestCardApproval` mutation. */
export type RequestCardApprovalInput = {
  cardTemplateId: Scalars['String']['input'];
  cardTemplateVersion: Scalars['Int']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
};

/** The output of our `requestCardApproval` mutation. */
export type RequestCardApprovalPayload = {
  __typename?: 'RequestCardApprovalPayload';
  /** Reads a single `BusinessUser` that is related to this `CardApprovalRequest`. */
  businessUserByOrganisationIdAndRequestedBy?: Maybe<BusinessUser>;
  cardApprovalRequest?: Maybe<CardApprovalRequest>;
  /** An edge for our `CardApprovalRequest`. May be used by Relay 1. */
  cardApprovalRequestEdge?: Maybe<CardApprovalRequestsEdge>;
  /** Reads a single `CardTemplateVersion` that is related to this `CardApprovalRequest`. */
  cardTemplateVersionByEnvironmentIdAndCardTemplateIdAndCardTemplateVersion?: Maybe<CardTemplateVersion>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organisation` that is related to this `CardApprovalRequest`. */
  organisation?: Maybe<Organisation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `requestCardApproval` mutation. */
export type RequestCardApprovalPayloadCardApprovalRequestEdgeArgs = {
  orderBy?: InputMaybe<Array<CardApprovalRequestsOrderBy>>;
};

/** All input for the `resendInviteEmailById` mutation. */
export type ResendInviteEmailByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
};

/** The output of our `resendInviteEmailById` mutation. */
export type ResendInviteEmailByIdPayload = {
  __typename?: 'ResendInviteEmailByIdPayload';
  boolean?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `resendInviteEmail` mutation. */
export type ResendInviteEmailInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
};

/** The output of our `resendInviteEmail` mutation. */
export type ResendInviteEmailPayload = {
  __typename?: 'ResendInviteEmailPayload';
  /** Reads a single `Account` that is related to this `BusinessUser`. */
  account?: Maybe<Account>;
  businessUser?: Maybe<BusinessUser>;
  /** An edge for our `BusinessUser`. May be used by Relay 1. */
  businessUserEdge?: Maybe<BusinessUsersEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organisation` that is related to this `BusinessUser`. */
  organisation?: Maybe<Organisation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `resendInviteEmail` mutation. */
export type ResendInviteEmailPayloadBusinessUserEdgeArgs = {
  orderBy?: InputMaybe<Array<BusinessUsersOrderBy>>;
};

export type ResourceUser = Node & {
  __typename?: 'ResourceUser';
  activeAt: Scalars['Datetime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  environmentId: Scalars['String']['output'];
  mode: ResourceUserMode;
  name?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  resourceId: Scalars['String']['output'];
  resourceType: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
  sub: Scalars['UUID']['output'];
  sysPeriod: DatetimeRange;
};

/**
 * A condition to be used against `ResourceUser` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ResourceUserCondition = {
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `ResourceUser` object types. All fields are combined with a logical ‘and.’ */
export type ResourceUserFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ResourceUserFilter>>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ResourceUserFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ResourceUserFilter>>;
};

/** An input for mutations affecting `ResourceUser` */
export type ResourceUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  mode?: InputMaybe<ResourceUserMode>;
  name?: InputMaybe<Scalars['String']['input']>;
  resourceId: Scalars['String']['input'];
  resourceType: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
  sub: Scalars['UUID']['input'];
};

export enum ResourceUserMode {
  Edit = 'EDIT',
  View = 'VIEW'
}

/** Represents an update to a `ResourceUser`. Fields that are set will be updated. */
export type ResourceUserPatch = {
  activeAt?: InputMaybe<Scalars['Datetime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<ResourceUserMode>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `ResourceUser` values. */
export type ResourceUsersConnection = {
  __typename?: 'ResourceUsersConnection';
  /** A list of edges which contains the `ResourceUser` and cursor to aid in pagination. */
  edges: Array<ResourceUsersEdge>;
  /** A list of `ResourceUser` objects. */
  nodes: Array<ResourceUser>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ResourceUser` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ResourceUser` edge in the connection. */
export type ResourceUsersEdge = {
  __typename?: 'ResourceUsersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ResourceUser` at the end of the edge. */
  node: ResourceUser;
};

/** Methods to use when ordering `ResourceUser`. */
export enum ResourceUsersOrderBy {
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type Response = {
  __typename?: 'Response';
  downloadUrl?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
};

/** All input for the `restoreCardTemplate` mutation. */
export type RestoreCardTemplateInput = {
  _cardTemplateId: Scalars['String']['input'];
  _environmentId: Scalars['String']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our `restoreCardTemplate` mutation. */
export type RestoreCardTemplatePayload = {
  __typename?: 'RestoreCardTemplatePayload';
  /** Reads a single `BusinessUser` that is related to this `CardTemplateVersion`. */
  businessUserByOrganisationIdAndPublishedBy?: Maybe<BusinessUser>;
  /** Reads a single `BusinessUser` that is related to this `CardTemplateVersion`. */
  businessUserByOrganisationIdAndUpdatedBy?: Maybe<BusinessUser>;
  cardTemplateVersion?: Maybe<CardTemplateVersion>;
  /** An edge for our `CardTemplateVersion`. May be used by Relay 1. */
  cardTemplateVersionEdge?: Maybe<CardTemplateVersionsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CardTemplate` that is related to this `CardTemplateVersion`. */
  environmentCardTemplate?: Maybe<CardTemplate>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `restoreCardTemplate` mutation. */
export type RestoreCardTemplatePayloadCardTemplateVersionEdgeArgs = {
  orderBy?: InputMaybe<Array<CardTemplateVersionsOrderBy>>;
};

export type RetrieveTestUsersResponse = {
  __typename?: 'RetrieveTestUsersResponse';
  nodes: Array<CustomEndUserType>;
  totalCount: Scalars['Int']['output'];
};

/** All input for the `revertActionFlowMigration` mutation. */
export type RevertActionFlowMigrationInput = {
  cardEnvironmentId: Scalars['String']['input'];
  cardTemplateId: Scalars['String']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  flowConfigId: Scalars['String']['input'];
};

/** The output of our `revertActionFlowMigration` mutation. */
export type RevertActionFlowMigrationPayload = {
  __typename?: 'RevertActionFlowMigrationPayload';
  /** Reads a single `BusinessUser` that is related to this `CardTemplateVersion`. */
  businessUserByOrganisationIdAndPublishedBy?: Maybe<BusinessUser>;
  /** Reads a single `BusinessUser` that is related to this `CardTemplateVersion`. */
  businessUserByOrganisationIdAndUpdatedBy?: Maybe<BusinessUser>;
  cardTemplateVersion?: Maybe<CardTemplateVersion>;
  /** An edge for our `CardTemplateVersion`. May be used by Relay 1. */
  cardTemplateVersionEdge?: Maybe<CardTemplateVersionsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CardTemplate` that is related to this `CardTemplateVersion`. */
  environmentCardTemplate?: Maybe<CardTemplate>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `revertActionFlowMigration` mutation. */
export type RevertActionFlowMigrationPayloadCardTemplateVersionEdgeArgs = {
  orderBy?: InputMaybe<Array<CardTemplateVersionsOrderBy>>;
};

export type RevokeActionFlowShareLinkResponse = {
  __typename?: 'RevokeActionFlowShareLinkResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RolePermission = Node & {
  __typename?: 'RolePermission';
  action: PermissionAction;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Organisation` that is related to this `RolePermission`. */
  organisation?: Maybe<Organisation>;
  organisationId: Scalars['String']['output'];
  /** Reads a single `CustomRole` that is related to this `RolePermission`. */
  organisationRole?: Maybe<CustomRole>;
  resource: PermissionResource;
  roleId: Scalars['String']['output'];
};

/**
 * A condition to be used against `RolePermission` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RolePermissionCondition = {
  /** Checks for equality with the object’s `organisationId` field. */
  organisationId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `RolePermission` object types. All fields are combined with a logical ‘and.’ */
export type RolePermissionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RolePermissionFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<RolePermissionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RolePermissionFilter>>;
  /** Filter by the object’s `organisationId` field. */
  organisationId?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `RolePermission` */
export type RolePermissionInput = {
  action: PermissionAction;
  organisationId: Scalars['String']['input'];
  resource: PermissionResource;
  roleId: Scalars['String']['input'];
};

/** Represents an update to a `RolePermission`. Fields that are set will be updated. */
export type RolePermissionPatch = {
  action?: InputMaybe<PermissionAction>;
  resource?: InputMaybe<PermissionResource>;
};

/** A connection to a list of `RolePermission` values. */
export type RolePermissionsConnection = {
  __typename?: 'RolePermissionsConnection';
  /** A list of edges which contains the `RolePermission` and cursor to aid in pagination. */
  edges: Array<RolePermissionsEdge>;
  /** A list of `RolePermission` objects. */
  nodes: Array<RolePermission>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RolePermission` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `RolePermission` edge in the connection. */
export type RolePermissionsEdge = {
  __typename?: 'RolePermissionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `RolePermission` at the end of the edge. */
  node: RolePermission;
};

export type RolePermissionsInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
  permissions?: InputMaybe<Array<Permissions>>;
};

/** Methods to use when ordering `RolePermission`. */
export enum RolePermissionsOrderBy {
  Natural = 'NATURAL',
  OrganisationIdAsc = 'ORGANISATION_ID_ASC',
  OrganisationIdDesc = 'ORGANISATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type SaveActionFlowConfigurationInput = {
  config: Scalars['JSON']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishVersion?: InputMaybe<Scalars['Boolean']['input']>;
  workbenchFolderIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SaveBusinessUserInput = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  businessUserId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  groupIds: Array<Scalars['String']['input']>;
  inviteEmail?: InputMaybe<Scalars['String']['input']>;
  inviteMessage?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organisationId: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type SaveBusinessUserPayload = {
  __typename?: 'SaveBusinessUserPayload';
  businessUser?: Maybe<BusinessUser>;
};

/** All input for the `saveCardTemplateVersion` mutation. */
export type SaveCardTemplateVersionInput = {
  archivePrevious?: InputMaybe<Scalars['Boolean']['input']>;
  cardEnvironmentId: Scalars['String']['input'];
  cardTemplateId: Scalars['String']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  targetSegmentsOnPublish?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  versionDefinition?: InputMaybe<Scalars['JSON']['input']>;
  versionEmbargo?: InputMaybe<Scalars['Datetime']['input']>;
  versionExpires?: InputMaybe<Scalars['Datetime']['input']>;
  versionExpiresInterval?: InputMaybe<IntervalInput>;
  versionMetadata?: InputMaybe<Scalars['JSON']['input']>;
  versionTestData?: InputMaybe<Scalars['JSON']['input']>;
};

/** The output of our `saveCardTemplateVersion` mutation. */
export type SaveCardTemplateVersionPayload = {
  __typename?: 'SaveCardTemplateVersionPayload';
  /** Reads a single `BusinessUser` that is related to this `CardTemplateVersion`. */
  businessUserByOrganisationIdAndPublishedBy?: Maybe<BusinessUser>;
  /** Reads a single `BusinessUser` that is related to this `CardTemplateVersion`. */
  businessUserByOrganisationIdAndUpdatedBy?: Maybe<BusinessUser>;
  cardTemplateVersion?: Maybe<CardTemplateVersion>;
  /** An edge for our `CardTemplateVersion`. May be used by Relay 1. */
  cardTemplateVersionEdge?: Maybe<CardTemplateVersionsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CardTemplate` that is related to this `CardTemplateVersion`. */
  environmentCardTemplate?: Maybe<CardTemplate>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `saveCardTemplateVersion` mutation. */
export type SaveCardTemplateVersionPayloadCardTemplateVersionEdgeArgs = {
  orderBy?: InputMaybe<Array<CardTemplateVersionsOrderBy>>;
};

/** All input for the `saveEventDefinitionVersion` mutation. */
export type SaveEventDefinitionVersionInput = {
  archivePrevious?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clientTriggerEnable?: InputMaybe<Scalars['Boolean']['input']>;
  envId: Scalars['String']['input'];
  eventDefinitionId: Scalars['String']['input'];
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  versionDetailSchema: Scalars['JSON']['input'];
};

/** The output of our `saveEventDefinitionVersion` mutation. */
export type SaveEventDefinitionVersionPayload = {
  __typename?: 'SaveEventDefinitionVersionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `EventDefinition` that is related to this `EventDefinitionVersion`. */
  environmentEventDefinition?: Maybe<EventDefinition>;
  eventDefinitionVersion?: Maybe<EventDefinitionVersion>;
  /** An edge for our `EventDefinitionVersion`. May be used by Relay 1. */
  eventDefinitionVersionEdge?: Maybe<EventDefinitionVersionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `saveEventDefinitionVersion` mutation. */
export type SaveEventDefinitionVersionPayloadEventDefinitionVersionEdgeArgs = {
  orderBy?: InputMaybe<Array<EventDefinitionVersionsOrderBy>>;
};

export type SaveSegmentTriggerPayload = {
  __typename?: 'SaveSegmentTriggerPayload';
  actionFlowConfig?: Maybe<ActionFlowConfig>;
  query?: Maybe<Query>;
};

export enum SegmentMode {
  Entered = 'ENTERED',
  Exited = 'EXITED'
}

/** All input for the `setDefaultStreamContainer` mutation. */
export type SetDefaultStreamContainerInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  streamContainerId: Scalars['String']['input'];
};

/** The output of our `setDefaultStreamContainer` mutation. */
export type SetDefaultStreamContainerPayload = {
  __typename?: 'SetDefaultStreamContainerPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  streamContainers?: Maybe<Array<StreamContainer>>;
};

/** All input for the `setDefaultTheme` mutation. */
export type SetDefaultThemeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  themeId: Scalars['String']['input'];
};

/** The output of our `setDefaultTheme` mutation. */
export type SetDefaultThemePayload = {
  __typename?: 'SetDefaultThemePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  themes?: Maybe<Array<Theme>>;
};

export type SetRolesPayload = {
  __typename?: 'SetRolesPayload';
  customRole?: Maybe<CustomRole>;
};

export type SetTagsInputNested = {
  environmentId: Scalars['String']['input'];
  profileFilters: ProfileFiltersInput;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SetUserTagsPayload = {
  __typename?: 'SetUserTagsPayload';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type StoreSegmentTriggerInput = {
  cardTemplateId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  flowConfigId: Scalars['String']['input'];
  mode: SegmentMode;
  segmentId: Scalars['String']['input'];
  triggerId?: InputMaybe<Scalars['String']['input']>;
};

/** A stream of cards */
export type Stream = Node & {
  __typename?: 'Stream';
  /** Returns triggers events excluding those attached to archived cards */
  activeTriggers: TriggerEventsConnection;
  created: Scalars['Datetime']['output'];
  deleted: Scalars['Boolean']['output'];
  /** Reads a single `Environment` that is related to this `Stream`. */
  environment?: Maybe<Environment>;
  environmentId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isMandatory: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `StreamContainer`. */
  streamContainersByEnvironmentIdAndStreamId: StreamContainersConnection;
  /** Reads and enables pagination through a set of `TriggerEvent`. */
  triggerEventsByEnvironmentIdAndStreamId: TriggerEventsConnection;
  updated: Scalars['Datetime']['output'];
};


/** A stream of cards */
export type StreamActiveTriggersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<TriggerEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** A stream of cards */
export type StreamStreamContainersByEnvironmentIdAndStreamIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<StreamContainerCondition>;
  filter?: InputMaybe<StreamContainerFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<StreamContainersOrderBy>>;
};


/** A stream of cards */
export type StreamTriggerEventsByEnvironmentIdAndStreamIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TriggerEventCondition>;
  filter?: InputMaybe<TriggerEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TriggerEventsOrderBy>>;
};

/** A condition to be used against `Stream` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type StreamCondition = {
  /** Checks for equality with the object’s `deleted` field. */
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updated` field. */
  updated?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A container for a stream of cards which will be embedded in a client app */
export type StreamContainer = Node & {
  __typename?: 'StreamContainer';
  cardLimit: Scalars['Int']['output'];
  created: Scalars['Datetime']['output'];
  darkThemeId?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** Reads a single `Theme` that is related to this `StreamContainer`. */
  environmentDarkTheme?: Maybe<Theme>;
  environmentId: Scalars['String']['output'];
  /** Reads a single `Stream` that is related to this `StreamContainer`. */
  environmentStream?: Maybe<Stream>;
  /** Reads a single `Theme` that is related to this `StreamContainer`. */
  environmentTheme?: Maybe<Theme>;
  filter: Array<Maybe<Scalars['JSON']['output']>>;
  id: Scalars['String']['output'];
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Legacy. Returns the connected stream. Use the native environmentStream connection instead */
  stream?: Maybe<Stream>;
  streamId: Scalars['String']['output'];
  themeId: Scalars['String']['output'];
  updated: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `StreamContainer` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type StreamContainerCondition = {
  /** Checks for equality with the object’s `cardLimit` field. */
  cardLimit?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `enabled` field. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `streamId` field. */
  streamId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updated` field. */
  updated?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `StreamContainer` object types. All fields are combined with a logical ‘and.’ */
export type StreamContainerFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<StreamContainerFilter>>;
  /** Filter by the object’s `cardLimit` field. */
  cardLimit?: InputMaybe<IntFilter>;
  /** Filter by the object’s `enabled` field. */
  enabled?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<StreamContainerFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<StreamContainerFilter>>;
  /** Filter by the object’s `streamId` field. */
  streamId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updated` field. */
  updated?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `StreamContainer` */
export type StreamContainerInput = {
  cardLimit?: InputMaybe<Scalars['Int']['input']>;
  darkThemeId?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  environmentId: Scalars['String']['input'];
  filter?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  streamId: Scalars['String']['input'];
  themeId: Scalars['String']['input'];
};

/** Represents an update to a `StreamContainer`. Fields that are set will be updated. */
export type StreamContainerPatch = {
  cardLimit?: InputMaybe<Scalars['Int']['input']>;
  darkThemeId?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  streamId?: InputMaybe<Scalars['String']['input']>;
  themeId?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `StreamContainer` values. */
export type StreamContainersConnection = {
  __typename?: 'StreamContainersConnection';
  /** A list of edges which contains the `StreamContainer` and cursor to aid in pagination. */
  edges: Array<StreamContainersEdge>;
  /** A list of `StreamContainer` objects. */
  nodes: Array<StreamContainer>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `StreamContainer` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `StreamContainer` edge in the connection. */
export type StreamContainersEdge = {
  __typename?: 'StreamContainersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `StreamContainer` at the end of the edge. */
  node: StreamContainer;
};

/** Methods to use when ordering `StreamContainer`. */
export enum StreamContainersOrderBy {
  CardLimitAsc = 'CARD_LIMIT_ASC',
  CardLimitDesc = 'CARD_LIMIT_DESC',
  EnabledAsc = 'ENABLED_ASC',
  EnabledDesc = 'ENABLED_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StreamIdAsc = 'STREAM_ID_ASC',
  StreamIdDesc = 'STREAM_ID_DESC',
  UpdatedAsc = 'UPDATED_ASC',
  UpdatedDesc = 'UPDATED_DESC'
}

/** A filter to be used against `Stream` object types. All fields are combined with a logical ‘and.’ */
export type StreamFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<StreamFilter>>;
  /** Filter by the object’s `deleted` field. */
  deleted?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<StreamFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<StreamFilter>>;
  /** Filter by the object’s `updated` field. */
  updated?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Stream` */
export type StreamInput = {
  environmentId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

/** Represents an update to a `Stream`. Fields that are set will be updated. */
export type StreamPatch = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `Stream` values. */
export type StreamsConnection = {
  __typename?: 'StreamsConnection';
  /** A list of edges which contains the `Stream` and cursor to aid in pagination. */
  edges: Array<StreamsEdge>;
  /** A list of `Stream` objects. */
  nodes: Array<Stream>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Stream` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Stream` edge in the connection. */
export type StreamsEdge = {
  __typename?: 'StreamsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Stream` at the end of the edge. */
  node: Stream;
};

/** Methods to use when ordering `Stream`. */
export enum StreamsOrderBy {
  DeletedAsc = 'DELETED_ASC',
  DeletedDesc = 'DELETED_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAsc = 'UPDATED_ASC',
  UpdatedDesc = 'UPDATED_DESC'
}

/** A filter to be used against String fields. All fields are combined with a logical ‘and.’ */
export type StringFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value (case-insensitive). */
  distinctFromInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Ends with the specified string (case-sensitive). */
  endsWith?: InputMaybe<Scalars['String']['input']>;
  /** Ends with the specified string (case-insensitive). */
  endsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value (case-insensitive). */
  equalToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  /** Greater than the specified value (case-insensitive). */
  greaterThanInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to the specified value (case-insensitive). */
  greaterThanOrEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Included in the specified list (case-insensitive). */
  inInsensitive?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains the specified string (case-sensitive). */
  includes?: InputMaybe<Scalars['String']['input']>;
  /** Contains the specified string (case-insensitive). */
  includesInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['String']['input']>;
  /** Less than the specified value (case-insensitive). */
  lessThanInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to the specified value (case-insensitive). */
  lessThanOrEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Matches the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  like?: InputMaybe<Scalars['String']['input']>;
  /** Matches the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  likeInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value, treating null like an ordinary value (case-insensitive). */
  notDistinctFromInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with the specified string (case-sensitive). */
  notEndsWith?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with the specified string (case-insensitive). */
  notEndsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value (case-insensitive). */
  notEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Not included in the specified list (case-insensitive). */
  notInInsensitive?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not contain the specified string (case-sensitive). */
  notIncludes?: InputMaybe<Scalars['String']['input']>;
  /** Does not contain the specified string (case-insensitive). */
  notIncludesInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not match the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLike?: InputMaybe<Scalars['String']['input']>;
  /** Does not match the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLikeInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with the specified string (case-sensitive). */
  notStartsWith?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with the specified string (case-insensitive). */
  notStartsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Starts with the specified string (case-sensitive). */
  startsWith?: InputMaybe<Scalars['String']['input']>;
  /** Starts with the specified string (case-insensitive). */
  startsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against String List fields. All fields are combined with a logical ‘and.’ */
export type StringListFilter = {
  /** Any array item is equal to the specified value. */
  anyEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is greater than the specified value. */
  anyGreaterThan?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is greater than or equal to the specified value. */
  anyGreaterThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is less than the specified value. */
  anyLessThan?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is less than or equal to the specified value. */
  anyLessThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Any array item is not equal to the specified value. */
  anyNotEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Contained by the specified list of values. */
  containedBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Contains the specified list of values. */
  contains?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Overlaps the specified list of values. */
  overlaps?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** An action cards end user synced from DynamoDB */
export type SyncedEndUser = Node & {
  __typename?: 'SyncedEndUser';
  allowTest: Scalars['Boolean']['output'];
  businessUserAccountId?: Maybe<Scalars['Int']['output']>;
  created: Scalars['Datetime']['output'];
  /** Reads a single `Environment` that is related to this `SyncedEndUser`. */
  environment?: Maybe<Environment>;
  environmentId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  nickname: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  organisationId: Scalars['String']['output'];
  preferences: Scalars['JSON']['output'];
  preferencesUpdated: Scalars['Datetime']['output'];
  profile: Scalars['JSON']['output'];
  profileFilter?: Maybe<Scalars['Boolean']['output']>;
  tagIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updated: Scalars['Datetime']['output'];
};


/** An action cards end user synced from DynamoDB */
export type SyncedEndUserProfileFilterArgs = {
  condition: ProfileFilterInput;
  currentTz?: InputMaybe<Scalars['Datetime']['input']>;
};

/**
 * A condition to be used against `SyncedEndUser` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SyncedEndUserCondition = {
  /** Checks for equality with the object’s `allowTest` field. */
  allowTest?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `created` field. */
  created?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `nickname` field. */
  nickname?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `profile` field. */
  profile?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `tagIds` field. */
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Checks for equality with the object’s `updated` field. */
  updated?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `SyncedEndUser` object types. All fields are combined with a logical ‘and.’ */
export type SyncedEndUserFilter = {
  /** Filter by the object’s `allowTest` field. */
  allowTest?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SyncedEndUserFilter>>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `nickname` field. */
  nickname?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SyncedEndUserFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SyncedEndUserFilter>>;
  /** Filter by the object’s `profile` field. */
  profile?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `tagIds` field. */
  tagIds?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `updated` field. */
  updated?: InputMaybe<DatetimeFilter>;
};

export type SyncedEndUserNode = {
  __typename?: 'SyncedEndUserNode';
  allowTest: Scalars['Boolean']['output'];
  businessUserAccountId?: Maybe<Scalars['Int']['output']>;
  created: Scalars['String']['output'];
  environmentId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  nickname?: Maybe<Scalars['String']['output']>;
  organisationId: Scalars['String']['output'];
  profile: Scalars['JSON']['output'];
};

export type SyncedEndUserNodes = {
  __typename?: 'SyncedEndUserNodes';
  node: SyncedEndUserNode;
};

export type SyncedEndUserPaginationInput = {
  last?: InputMaybe<LastSyncedEndUserInput>;
  limit: Scalars['Int']['input'];
};

export type SyncedEndUserPaginationResponse = {
  __typename?: 'SyncedEndUserPaginationResponse';
  hasNextPage: Scalars['Boolean']['output'];
  last: LastSyncedEndUser;
};

export type SyncedEndUserQueryConditions = {
  environmentId: Scalars['String']['input'];
};

/** A connection to a list of `SyncedEndUser` values. */
export type SyncedEndUsersConnection = {
  __typename?: 'SyncedEndUsersConnection';
  /** A list of edges which contains the `SyncedEndUser` and cursor to aid in pagination. */
  edges: Array<SyncedEndUsersEdge>;
  /** A list of `SyncedEndUser` objects. */
  nodes: Array<SyncedEndUser>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SyncedEndUser` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

export type SyncedEndUsersCustomOrderBy = {
  ascending: Scalars['Boolean']['input'];
  field: Scalars['String']['input'];
};

/** A `SyncedEndUser` edge in the connection. */
export type SyncedEndUsersEdge = {
  __typename?: 'SyncedEndUsersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `SyncedEndUser` at the end of the edge. */
  node: SyncedEndUser;
};

/** Methods to use when ordering `SyncedEndUser`. */
export enum SyncedEndUsersOrderBy {
  AllowTestAsc = 'ALLOW_TEST_ASC',
  AllowTestDesc = 'ALLOW_TEST_DESC',
  AtomicCreatedAsc = 'ATOMIC___CREATED_ASC',
  AtomicCreatedDesc = 'ATOMIC___CREATED_DESC',
  AtomicIdAsc = 'ATOMIC___ID_ASC',
  AtomicIdDesc = 'ATOMIC___ID_DESC',
  CityAsc = 'CITY_ASC',
  CityDesc = 'CITY_DESC',
  CountryAsc = 'COUNTRY_ASC',
  CountryDesc = 'COUNTRY_DESC',
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  ExternalIdAsc = 'EXTERNAL_ID_ASC',
  ExternalIdDesc = 'EXTERNAL_ID_DESC',
  FirstActionFlowCompletedAtAsc = 'FIRST_ACTION_FLOW_COMPLETED_AT_ASC',
  FirstActionFlowCompletedAtDesc = 'FIRST_ACTION_FLOW_COMPLETED_AT_DESC',
  FirstActionFlowFailedAtAsc = 'FIRST_ACTION_FLOW_FAILED_AT_ASC',
  FirstActionFlowFailedAtDesc = 'FIRST_ACTION_FLOW_FAILED_AT_DESC',
  FirstActionFlowStartedAtAsc = 'FIRST_ACTION_FLOW_STARTED_AT_ASC',
  FirstActionFlowStartedAtDesc = 'FIRST_ACTION_FLOW_STARTED_AT_DESC',
  FirstActionFlowStepCompletedAtAsc = 'FIRST_ACTION_FLOW_STEP_COMPLETED_AT_ASC',
  FirstActionFlowStepCompletedAtDesc = 'FIRST_ACTION_FLOW_STEP_COMPLETED_AT_DESC',
  FirstActionFlowStepFailedAtAsc = 'FIRST_ACTION_FLOW_STEP_FAILED_AT_ASC',
  FirstActionFlowStepFailedAtDesc = 'FIRST_ACTION_FLOW_STEP_FAILED_AT_DESC',
  FirstActionFlowWaitCompletedAtAsc = 'FIRST_ACTION_FLOW_WAIT_COMPLETED_AT_ASC',
  FirstActionFlowWaitCompletedAtDesc = 'FIRST_ACTION_FLOW_WAIT_COMPLETED_AT_DESC',
  FirstCancelledCardAtAsc = 'FIRST_CANCELLED_CARD_AT_ASC',
  FirstCancelledCardAtDesc = 'FIRST_CANCELLED_CARD_AT_DESC',
  FirstCardErrorAtAsc = 'FIRST_CARD_ERROR_AT_ASC',
  FirstCardErrorAtDesc = 'FIRST_CARD_ERROR_AT_DESC',
  FirstCardSubviewDisplayedAtAsc = 'FIRST_CARD_SUBVIEW_DISPLAYED_AT_ASC',
  FirstCardSubviewDisplayedAtDesc = 'FIRST_CARD_SUBVIEW_DISPLAYED_AT_DESC',
  FirstCardSubviewExitedAtAsc = 'FIRST_CARD_SUBVIEW_EXITED_AT_ASC',
  FirstCardSubviewExitedAtDesc = 'FIRST_CARD_SUBVIEW_EXITED_AT_DESC',
  FirstCompletedCardAtAsc = 'FIRST_COMPLETED_CARD_AT_ASC',
  FirstCompletedCardAtDesc = 'FIRST_COMPLETED_CARD_AT_DESC',
  FirstDismissedCardAtAsc = 'FIRST_DISMISSED_CARD_AT_ASC',
  FirstDismissedCardAtDesc = 'FIRST_DISMISSED_CARD_AT_DESC',
  FirstDisplayedCardAtAsc = 'FIRST_DISPLAYED_CARD_AT_ASC',
  FirstDisplayedCardAtDesc = 'FIRST_DISPLAYED_CARD_AT_DESC',
  FirstEmbargoedCardAtAsc = 'FIRST_EMBARGOED_CARD_AT_ASC',
  FirstEmbargoedCardAtDesc = 'FIRST_EMBARGOED_CARD_AT_DESC',
  FirstExpiredCardAtAsc = 'FIRST_EXPIRED_CARD_AT_ASC',
  FirstExpiredCardAtDesc = 'FIRST_EXPIRED_CARD_AT_DESC',
  FirstNotificationReceivedAtAsc = 'FIRST_NOTIFICATION_RECEIVED_AT_ASC',
  FirstNotificationReceivedAtDesc = 'FIRST_NOTIFICATION_RECEIVED_AT_DESC',
  FirstNotificationSentAtAsc = 'FIRST_NOTIFICATION_SENT_AT_ASC',
  FirstNotificationSentAtDesc = 'FIRST_NOTIFICATION_SENT_AT_DESC',
  FirstPublishedCardAtAsc = 'FIRST_PUBLISHED_CARD_AT_ASC',
  FirstPublishedCardAtDesc = 'FIRST_PUBLISHED_CARD_AT_DESC',
  FirstRequestFailedAtAsc = 'FIRST_REQUEST_FAILED_AT_ASC',
  FirstRequestFailedAtDesc = 'FIRST_REQUEST_FAILED_AT_DESC',
  FirstRuntimeVarsUpdatedAtAsc = 'FIRST_RUNTIME_VARS_UPDATED_AT_ASC',
  FirstRuntimeVarsUpdatedAtDesc = 'FIRST_RUNTIME_VARS_UPDATED_AT_DESC',
  FirstSdkInitializedAtAsc = 'FIRST_SDK_INITIALIZED_AT_ASC',
  FirstSdkInitializedAtDesc = 'FIRST_SDK_INITIALIZED_AT_DESC',
  FirstSeenAtAsc = 'FIRST_SEEN_AT_ASC',
  FirstSeenAtDesc = 'FIRST_SEEN_AT_DESC',
  FirstSegmentEnteredAtAsc = 'FIRST_SEGMENT_ENTERED_AT_ASC',
  FirstSegmentEnteredAtDesc = 'FIRST_SEGMENT_ENTERED_AT_DESC',
  FirstSegmentExitedAtAsc = 'FIRST_SEGMENT_EXITED_AT_ASC',
  FirstSegmentExitedAtDesc = 'FIRST_SEGMENT_EXITED_AT_DESC',
  FirstSnoozedCardAtAsc = 'FIRST_SNOOZED_CARD_AT_ASC',
  FirstSnoozedCardAtDesc = 'FIRST_SNOOZED_CARD_AT_DESC',
  FirstSnoozeOptionsCanceledAtAsc = 'FIRST_SNOOZE_OPTIONS_CANCELED_AT_ASC',
  FirstSnoozeOptionsCanceledAtDesc = 'FIRST_SNOOZE_OPTIONS_CANCELED_AT_DESC',
  FirstSnoozeOptionsDisplayedAtAsc = 'FIRST_SNOOZE_OPTIONS_DISPLAYED_AT_ASC',
  FirstSnoozeOptionsDisplayedAtDesc = 'FIRST_SNOOZE_OPTIONS_DISPLAYED_AT_DESC',
  FirstStreamDisplayedAtAsc = 'FIRST_STREAM_DISPLAYED_AT_ASC',
  FirstStreamDisplayedAtDesc = 'FIRST_STREAM_DISPLAYED_AT_DESC',
  FirstUnsnoozedCardAtAsc = 'FIRST_UNSNOOZED_CARD_AT_ASC',
  FirstUnsnoozedCardAtDesc = 'FIRST_UNSNOOZED_CARD_AT_DESC',
  FirstUserRedirectedAtAsc = 'FIRST_USER_REDIRECTED_AT_ASC',
  FirstUserRedirectedAtDesc = 'FIRST_USER_REDIRECTED_AT_DESC',
  FirstVideoCompletedAtAsc = 'FIRST_VIDEO_COMPLETED_AT_ASC',
  FirstVideoCompletedAtDesc = 'FIRST_VIDEO_COMPLETED_AT_DESC',
  FirstVideoPlayedAtAsc = 'FIRST_VIDEO_PLAYED_AT_ASC',
  FirstVideoPlayedAtDesc = 'FIRST_VIDEO_PLAYED_AT_DESC',
  FirstVotedDownCardAtAsc = 'FIRST_VOTED_DOWN_CARD_AT_ASC',
  FirstVotedDownCardAtDesc = 'FIRST_VOTED_DOWN_CARD_AT_DESC',
  FirstVotedUpCardAtAsc = 'FIRST_VOTED_UP_CARD_AT_ASC',
  FirstVotedUpCardAtDesc = 'FIRST_VOTED_UP_CARD_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LastActionFlowCompletedAtAsc = 'LAST_ACTION_FLOW_COMPLETED_AT_ASC',
  LastActionFlowCompletedAtDesc = 'LAST_ACTION_FLOW_COMPLETED_AT_DESC',
  LastActionFlowFailedAtAsc = 'LAST_ACTION_FLOW_FAILED_AT_ASC',
  LastActionFlowFailedAtDesc = 'LAST_ACTION_FLOW_FAILED_AT_DESC',
  LastActionFlowStartedAtAsc = 'LAST_ACTION_FLOW_STARTED_AT_ASC',
  LastActionFlowStartedAtDesc = 'LAST_ACTION_FLOW_STARTED_AT_DESC',
  LastActionFlowStepCompletedAtAsc = 'LAST_ACTION_FLOW_STEP_COMPLETED_AT_ASC',
  LastActionFlowStepCompletedAtDesc = 'LAST_ACTION_FLOW_STEP_COMPLETED_AT_DESC',
  LastActionFlowStepFailedAtAsc = 'LAST_ACTION_FLOW_STEP_FAILED_AT_ASC',
  LastActionFlowStepFailedAtDesc = 'LAST_ACTION_FLOW_STEP_FAILED_AT_DESC',
  LastActionFlowWaitCompletedAtAsc = 'LAST_ACTION_FLOW_WAIT_COMPLETED_AT_ASC',
  LastActionFlowWaitCompletedAtDesc = 'LAST_ACTION_FLOW_WAIT_COMPLETED_AT_DESC',
  LastAndroidDeviceAsc = 'LAST_ANDROID_DEVICE_ASC',
  LastAndroidDeviceDesc = 'LAST_ANDROID_DEVICE_DESC',
  LastAndroidDeviceNameAsc = 'LAST_ANDROID_DEVICE_NAME_ASC',
  LastAndroidDeviceNameDesc = 'LAST_ANDROID_DEVICE_NAME_DESC',
  LastAndroidOsVersionAsc = 'LAST_ANDROID_OS_VERSION_ASC',
  LastAndroidOsVersionDesc = 'LAST_ANDROID_OS_VERSION_DESC',
  LastAndroidSdkClientAppVersionAsc = 'LAST_ANDROID_SDK_CLIENT_APP_VERSION_ASC',
  LastAndroidSdkClientAppVersionDesc = 'LAST_ANDROID_SDK_CLIENT_APP_VERSION_DESC',
  LastAndroidSdkVersionAsc = 'LAST_ANDROID_SDK_VERSION_ASC',
  LastAndroidSdkVersionDesc = 'LAST_ANDROID_SDK_VERSION_DESC',
  LastAndroidSeenAtAsc = 'LAST_ANDROID_SEEN_AT_ASC',
  LastAndroidSeenAtDesc = 'LAST_ANDROID_SEEN_AT_DESC',
  LastBrowserAsc = 'LAST_BROWSER_ASC',
  LastBrowserDesc = 'LAST_BROWSER_DESC',
  LastBrowserNameAsc = 'LAST_BROWSER_NAME_ASC',
  LastBrowserNameDesc = 'LAST_BROWSER_NAME_DESC',
  LastBrowserOsAsc = 'LAST_BROWSER_OS_ASC',
  LastBrowserOsDesc = 'LAST_BROWSER_OS_DESC',
  LastBrowserOsVersionAsc = 'LAST_BROWSER_OS_VERSION_ASC',
  LastBrowserOsVersionDesc = 'LAST_BROWSER_OS_VERSION_DESC',
  LastBrowserSdkVersionAsc = 'LAST_BROWSER_SDK_VERSION_ASC',
  LastBrowserSdkVersionDesc = 'LAST_BROWSER_SDK_VERSION_DESC',
  LastBrowserSeenAtAsc = 'LAST_BROWSER_SEEN_AT_ASC',
  LastBrowserSeenAtDesc = 'LAST_BROWSER_SEEN_AT_DESC',
  LastBrowserVersionAsc = 'LAST_BROWSER_VERSION_ASC',
  LastBrowserVersionDesc = 'LAST_BROWSER_VERSION_DESC',
  LastCancelledCardAtAsc = 'LAST_CANCELLED_CARD_AT_ASC',
  LastCancelledCardAtDesc = 'LAST_CANCELLED_CARD_AT_DESC',
  LastCardErrorAtAsc = 'LAST_CARD_ERROR_AT_ASC',
  LastCardErrorAtDesc = 'LAST_CARD_ERROR_AT_DESC',
  LastCardSubviewDisplayedAtAsc = 'LAST_CARD_SUBVIEW_DISPLAYED_AT_ASC',
  LastCardSubviewDisplayedAtDesc = 'LAST_CARD_SUBVIEW_DISPLAYED_AT_DESC',
  LastCardSubviewExitedAtAsc = 'LAST_CARD_SUBVIEW_EXITED_AT_ASC',
  LastCardSubviewExitedAtDesc = 'LAST_CARD_SUBVIEW_EXITED_AT_DESC',
  LastCompletedCardAtAsc = 'LAST_COMPLETED_CARD_AT_ASC',
  LastCompletedCardAtDesc = 'LAST_COMPLETED_CARD_AT_DESC',
  LastDismissedCardAtAsc = 'LAST_DISMISSED_CARD_AT_ASC',
  LastDismissedCardAtDesc = 'LAST_DISMISSED_CARD_AT_DESC',
  LastDisplayedCardAtAsc = 'LAST_DISPLAYED_CARD_AT_ASC',
  LastDisplayedCardAtDesc = 'LAST_DISPLAYED_CARD_AT_DESC',
  LastEmbargoedCardAtAsc = 'LAST_EMBARGOED_CARD_AT_ASC',
  LastEmbargoedCardAtDesc = 'LAST_EMBARGOED_CARD_AT_DESC',
  LastExpiredCardAtAsc = 'LAST_EXPIRED_CARD_AT_ASC',
  LastExpiredCardAtDesc = 'LAST_EXPIRED_CARD_AT_DESC',
  LastIosDeviceAsc = 'LAST_IOS_DEVICE_ASC',
  LastIosDeviceDesc = 'LAST_IOS_DEVICE_DESC',
  LastIosDeviceNameAsc = 'LAST_IOS_DEVICE_NAME_ASC',
  LastIosDeviceNameDesc = 'LAST_IOS_DEVICE_NAME_DESC',
  LastIosOsVersionAsc = 'LAST_IOS_OS_VERSION_ASC',
  LastIosOsVersionDesc = 'LAST_IOS_OS_VERSION_DESC',
  LastIosSdkClientAppVersionAsc = 'LAST_IOS_SDK_CLIENT_APP_VERSION_ASC',
  LastIosSdkClientAppVersionDesc = 'LAST_IOS_SDK_CLIENT_APP_VERSION_DESC',
  LastIosSdkVersionAsc = 'LAST_IOS_SDK_VERSION_ASC',
  LastIosSdkVersionDesc = 'LAST_IOS_SDK_VERSION_DESC',
  LastIosSeenAtAsc = 'LAST_IOS_SEEN_AT_ASC',
  LastIosSeenAtDesc = 'LAST_IOS_SEEN_AT_DESC',
  LastNotificationReceivedAtAsc = 'LAST_NOTIFICATION_RECEIVED_AT_ASC',
  LastNotificationReceivedAtDesc = 'LAST_NOTIFICATION_RECEIVED_AT_DESC',
  LastNotificationSentAtAsc = 'LAST_NOTIFICATION_SENT_AT_ASC',
  LastNotificationSentAtDesc = 'LAST_NOTIFICATION_SENT_AT_DESC',
  LastPublishedCardAtAsc = 'LAST_PUBLISHED_CARD_AT_ASC',
  LastPublishedCardAtDesc = 'LAST_PUBLISHED_CARD_AT_DESC',
  LastRequestFailedAtAsc = 'LAST_REQUEST_FAILED_AT_ASC',
  LastRequestFailedAtDesc = 'LAST_REQUEST_FAILED_AT_DESC',
  LastRuntimeVarsUpdatedAtAsc = 'LAST_RUNTIME_VARS_UPDATED_AT_ASC',
  LastRuntimeVarsUpdatedAtDesc = 'LAST_RUNTIME_VARS_UPDATED_AT_DESC',
  LastSdkInitializedAtAsc = 'LAST_SDK_INITIALIZED_AT_ASC',
  LastSdkInitializedAtDesc = 'LAST_SDK_INITIALIZED_AT_DESC',
  LastSeenAtAsc = 'LAST_SEEN_AT_ASC',
  LastSeenAtDesc = 'LAST_SEEN_AT_DESC',
  LastSegmentEnteredAtAsc = 'LAST_SEGMENT_ENTERED_AT_ASC',
  LastSegmentEnteredAtDesc = 'LAST_SEGMENT_ENTERED_AT_DESC',
  LastSegmentExitedAtAsc = 'LAST_SEGMENT_EXITED_AT_ASC',
  LastSegmentExitedAtDesc = 'LAST_SEGMENT_EXITED_AT_DESC',
  LastSnoozedCardAtAsc = 'LAST_SNOOZED_CARD_AT_ASC',
  LastSnoozedCardAtDesc = 'LAST_SNOOZED_CARD_AT_DESC',
  LastSnoozeOptionsCanceledAtAsc = 'LAST_SNOOZE_OPTIONS_CANCELED_AT_ASC',
  LastSnoozeOptionsCanceledAtDesc = 'LAST_SNOOZE_OPTIONS_CANCELED_AT_DESC',
  LastSnoozeOptionsDisplayedAtAsc = 'LAST_SNOOZE_OPTIONS_DISPLAYED_AT_ASC',
  LastSnoozeOptionsDisplayedAtDesc = 'LAST_SNOOZE_OPTIONS_DISPLAYED_AT_DESC',
  LastStreamDisplayedAtAsc = 'LAST_STREAM_DISPLAYED_AT_ASC',
  LastStreamDisplayedAtDesc = 'LAST_STREAM_DISPLAYED_AT_DESC',
  LastUnsnoozedCardAtAsc = 'LAST_UNSNOOZED_CARD_AT_ASC',
  LastUnsnoozedCardAtDesc = 'LAST_UNSNOOZED_CARD_AT_DESC',
  LastUserRedirectedAtAsc = 'LAST_USER_REDIRECTED_AT_ASC',
  LastUserRedirectedAtDesc = 'LAST_USER_REDIRECTED_AT_DESC',
  LastVideoCompletedAtAsc = 'LAST_VIDEO_COMPLETED_AT_ASC',
  LastVideoCompletedAtDesc = 'LAST_VIDEO_COMPLETED_AT_DESC',
  LastVideoPlayedAtAsc = 'LAST_VIDEO_PLAYED_AT_ASC',
  LastVideoPlayedAtDesc = 'LAST_VIDEO_PLAYED_AT_DESC',
  LastVotedDownCardAtAsc = 'LAST_VOTED_DOWN_CARD_AT_ASC',
  LastVotedDownCardAtDesc = 'LAST_VOTED_DOWN_CARD_AT_DESC',
  LastVotedUpCardAtAsc = 'LAST_VOTED_UP_CARD_AT_ASC',
  LastVotedUpCardAtDesc = 'LAST_VOTED_UP_CARD_AT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  NicknameAsc = 'NICKNAME_ASC',
  NicknameDesc = 'NICKNAME_DESC',
  PhoneAsc = 'PHONE_ASC',
  PhoneDesc = 'PHONE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProfileAsc = 'PROFILE_ASC',
  ProfileDesc = 'PROFILE_DESC',
  RegionAsc = 'REGION_ASC',
  RegionDesc = 'REGION_DESC',
  TagIdsAsc = 'TAG_IDS_ASC',
  TagIdsDesc = 'TAG_IDS_DESC',
  TimezoneAsc = 'TIMEZONE_ASC',
  TimezoneDesc = 'TIMEZONE_DESC',
  UpdatedAsc = 'UPDATED_ASC',
  UpdatedDesc = 'UPDATED_DESC',
  UserTypeAsc = 'USER_TYPE_ASC',
  UserTypeDesc = 'USER_TYPE_DESC'
}

export type Tag = Node & {
  __typename?: 'Tag';
  created: Scalars['Datetime']['output'];
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** Reads a single `Environment` that is related to this `Tag`. */
  environment?: Maybe<Environment>;
  environmentId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  updated?: Maybe<Scalars['Datetime']['output']>;
};

/** A condition to be used against `Tag` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type TagCondition = {
  /** Checks for equality with the object’s `created` field. */
  created?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `Tag` object types. All fields are combined with a logical ‘and.’ */
export type TagFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TagFilter>>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TagFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TagFilter>>;
};

/** An input for mutations affecting `Tag` */
export type TagInput = {
  environmentId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

/** Represents an update to a `Tag`. Fields that are set will be updated. */
export type TagPatch = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `Tag` values. */
export type TagsConnection = {
  __typename?: 'TagsConnection';
  /** A list of edges which contains the `Tag` and cursor to aid in pagination. */
  edges: Array<TagsEdge>;
  /** A list of `Tag` objects. */
  nodes: Array<Tag>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Tag` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Tag` edge in the connection. */
export type TagsEdge = {
  __typename?: 'TagsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Tag` at the end of the edge. */
  node: Tag;
};

/** Methods to use when ordering `Tag`. */
export enum TagsOrderBy {
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type TestClientJwtInput = {
  apiKey: Scalars['String']['input'];
  environmentId: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type TestClientJwtResult = {
  __typename?: 'TestClientJwtResult';
  claims?: Maybe<Scalars['JSON']['output']>;
  expiry?: Maybe<Scalars['Int']['output']>;
  sub?: Maybe<Scalars['String']['output']>;
};

export type Theme = Node & {
  __typename?: 'Theme';
  created: Scalars['Datetime']['output'];
  /** Reads a single `Environment` that is related to this `Theme`. */
  environment?: Maybe<Environment>;
  environmentId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  payload: Scalars['JSON']['output'];
  /** Reads and enables pagination through a set of `StreamContainer`. */
  streamContainersByEnvironmentIdAndDarkThemeId: StreamContainersConnection;
  /** Reads and enables pagination through a set of `StreamContainer`. */
  streamContainersByEnvironmentIdAndThemeId: StreamContainersConnection;
  updated: Scalars['Datetime']['output'];
};


export type ThemeStreamContainersByEnvironmentIdAndDarkThemeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<StreamContainerCondition>;
  filter?: InputMaybe<StreamContainerFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<StreamContainersOrderBy>>;
};


export type ThemeStreamContainersByEnvironmentIdAndThemeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<StreamContainerCondition>;
  filter?: InputMaybe<StreamContainerFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<StreamContainersOrderBy>>;
};

/** A condition to be used against `Theme` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ThemeCondition = {
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updated` field. */
  updated?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `Theme` object types. All fields are combined with a logical ‘and.’ */
export type ThemeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ThemeFilter>>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ThemeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ThemeFilter>>;
  /** Filter by the object’s `updated` field. */
  updated?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Theme` */
export type ThemeInput = {
  environmentId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  payload?: InputMaybe<Scalars['JSON']['input']>;
};

/** Represents an update to a `Theme`. Fields that are set will be updated. */
export type ThemePatch = {
  name?: InputMaybe<Scalars['String']['input']>;
  payload?: InputMaybe<Scalars['JSON']['input']>;
};

/** A connection to a list of `Theme` values. */
export type ThemesConnection = {
  __typename?: 'ThemesConnection';
  /** A list of edges which contains the `Theme` and cursor to aid in pagination. */
  edges: Array<ThemesEdge>;
  /** A list of `Theme` objects. */
  nodes: Array<Theme>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Theme` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Theme` edge in the connection. */
export type ThemesEdge = {
  __typename?: 'ThemesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Theme` at the end of the edge. */
  node: Theme;
};

/** Methods to use when ordering `Theme`. */
export enum ThemesOrderBy {
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAsc = 'UPDATED_ASC',
  UpdatedDesc = 'UPDATED_DESC'
}

/** Links event and card definitions */
export type TriggerEvent = Node & {
  __typename?: 'TriggerEvent';
  /** Reads a single `ActionFlowConfigVersion` that is related to this `TriggerEvent`. */
  actionFlowConfigVersionByEnvironmentIdAndFlowConfigIdAndFlowConfigVersion?: Maybe<ActionFlowConfigVersion>;
  cardTemplateId: Scalars['String']['output'];
  cardTemplateVersion: Scalars['Int']['output'];
  /** Reads a single `CardTemplateVersion` that is related to this `TriggerEvent`. */
  cardTemplateVersionByEnvironmentIdAndCardTemplateIdAndCardTemplateVersion?: Maybe<CardTemplateVersion>;
  created: Scalars['Datetime']['output'];
  /** Reads a single `Environment` that is related to this `TriggerEvent`. */
  environment?: Maybe<Environment>;
  environmentId: Scalars['String']['output'];
  /** Reads a single `Stream` that is related to this `TriggerEvent`. */
  environmentStream?: Maybe<Stream>;
  eventDefinitionId: Scalars['String']['output'];
  eventDefinitionVersion: Scalars['Int']['output'];
  /** Reads a single `EventDefinitionVersion` that is related to this `TriggerEvent`. */
  eventDefinitionVersionByEnvironmentIdAndEventDefinitionIdAndEventDefinitionVersion?: Maybe<EventDefinitionVersion>;
  flowConfigId: Scalars['String']['output'];
  flowConfigVersion: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isDraft?: Maybe<Scalars['Boolean']['output']>;
  mapping: Scalars['JSON']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  streamId?: Maybe<Scalars['String']['output']>;
  sysPeriod: DatetimeRange;
};

/**
 * A condition to be used against `TriggerEvent` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type TriggerEventCondition = {
  /** Checks for equality with the object’s `cardTemplateId` field. */
  cardTemplateId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `cardTemplateVersion` field. */
  cardTemplateVersion?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `created` field. */
  created?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `eventDefinitionId` field. */
  eventDefinitionId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `eventDefinitionVersion` field. */
  eventDefinitionVersion?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
};

/** A filter to be used against `TriggerEvent` object types. All fields are combined with a logical ‘and.’ */
export type TriggerEventFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TriggerEventFilter>>;
  /** Filter by the object’s `cardTemplateId` field. */
  cardTemplateId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `cardTemplateVersion` field. */
  cardTemplateVersion?: InputMaybe<IntFilter>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `eventDefinitionId` field. */
  eventDefinitionId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `eventDefinitionVersion` field. */
  eventDefinitionVersion?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isDraft` field. */
  isDraft?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TriggerEventFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TriggerEventFilter>>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
};

/** A connection to a list of `TriggerEventHistory` values. */
export type TriggerEventHistoriesConnection = {
  __typename?: 'TriggerEventHistoriesConnection';
  /** A list of edges which contains the `TriggerEventHistory` and cursor to aid in pagination. */
  edges: Array<TriggerEventHistoriesEdge>;
  /** A list of `TriggerEventHistory` objects. */
  nodes: Array<TriggerEventHistory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TriggerEventHistory` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `TriggerEventHistory` edge in the connection. */
export type TriggerEventHistoriesEdge = {
  __typename?: 'TriggerEventHistoriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `TriggerEventHistory` at the end of the edge. */
  node: TriggerEventHistory;
};

/** Methods to use when ordering `TriggerEventHistory`. */
export enum TriggerEventHistoriesOrderBy {
  CardTemplateIdAsc = 'CARD_TEMPLATE_ID_ASC',
  CardTemplateIdDesc = 'CARD_TEMPLATE_ID_DESC',
  CardTemplateVersionAsc = 'CARD_TEMPLATE_VERSION_ASC',
  CardTemplateVersionDesc = 'CARD_TEMPLATE_VERSION_DESC',
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  EventDefinitionIdAsc = 'EVENT_DEFINITION_ID_ASC',
  EventDefinitionIdDesc = 'EVENT_DEFINITION_ID_DESC',
  EventDefinitionVersionAsc = 'EVENT_DEFINITION_VERSION_ASC',
  EventDefinitionVersionDesc = 'EVENT_DEFINITION_VERSION_DESC',
  Natural = 'NATURAL',
  StreamIdAsc = 'STREAM_ID_ASC',
  StreamIdDesc = 'STREAM_ID_DESC',
  SysPeriodAsc = 'SYS_PERIOD_ASC',
  SysPeriodDesc = 'SYS_PERIOD_DESC'
}

export type TriggerEventHistory = {
  __typename?: 'TriggerEventHistory';
  cardTemplateId: Scalars['String']['output'];
  cardTemplateVersion: Scalars['Int']['output'];
  created: Scalars['Datetime']['output'];
  environmentId: Scalars['String']['output'];
  eventDefinitionId: Scalars['String']['output'];
  eventDefinitionVersion: Scalars['Int']['output'];
  flowConfigId?: Maybe<Scalars['String']['output']>;
  flowConfigVersion?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  mapping: Scalars['JSON']['output'];
  streamId?: Maybe<Scalars['String']['output']>;
  sysPeriod: DatetimeRange;
};

/**
 * A condition to be used against `TriggerEventHistory` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type TriggerEventHistoryCondition = {
  /** Checks for equality with the object’s `cardTemplateId` field. */
  cardTemplateId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `cardTemplateVersion` field. */
  cardTemplateVersion?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `created` field. */
  created?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `eventDefinitionId` field. */
  eventDefinitionId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `eventDefinitionVersion` field. */
  eventDefinitionVersion?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `streamId` field. */
  streamId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeInput>;
};

/** A filter to be used against `TriggerEventHistory` object types. All fields are combined with a logical ‘and.’ */
export type TriggerEventHistoryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TriggerEventHistoryFilter>>;
  /** Filter by the object’s `cardTemplateId` field. */
  cardTemplateId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `cardTemplateVersion` field. */
  cardTemplateVersion?: InputMaybe<IntFilter>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `eventDefinitionId` field. */
  eventDefinitionId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `eventDefinitionVersion` field. */
  eventDefinitionVersion?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TriggerEventHistoryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TriggerEventHistoryFilter>>;
  /** Filter by the object’s `streamId` field. */
  streamId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `sysPeriod` field. */
  sysPeriod?: InputMaybe<DatetimeRangeFilter>;
};

/** An input for mutations affecting `TriggerEvent` */
export type TriggerEventInput = {
  cardTemplateId: Scalars['String']['input'];
  cardTemplateVersion: Scalars['Int']['input'];
  environmentId: Scalars['String']['input'];
  eventDefinitionId: Scalars['String']['input'];
  eventDefinitionVersion: Scalars['Int']['input'];
  mapping?: InputMaybe<Scalars['JSON']['input']>;
  streamId?: InputMaybe<Scalars['String']['input']>;
};

/** Represents an update to a `TriggerEvent`. Fields that are set will be updated. */
export type TriggerEventPatch = {
  mapping?: InputMaybe<Scalars['JSON']['input']>;
};

/** A connection to a list of `TriggerEventWithHistory` values. */
export type TriggerEventWithHistoriesConnection = {
  __typename?: 'TriggerEventWithHistoriesConnection';
  /** A list of edges which contains the `TriggerEventWithHistory` and cursor to aid in pagination. */
  edges: Array<TriggerEventWithHistoriesEdge>;
  /** A list of `TriggerEventWithHistory` objects. */
  nodes: Array<TriggerEventWithHistory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TriggerEventWithHistory` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `TriggerEventWithHistory` edge in the connection. */
export type TriggerEventWithHistoriesEdge = {
  __typename?: 'TriggerEventWithHistoriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `TriggerEventWithHistory` at the end of the edge. */
  node: TriggerEventWithHistory;
};

/** Methods to use when ordering `TriggerEventWithHistory`. */
export enum TriggerEventWithHistoriesOrderBy {
  Natural = 'NATURAL'
}

export type TriggerEventWithHistory = {
  __typename?: 'TriggerEventWithHistory';
  cardTemplateId?: Maybe<Scalars['String']['output']>;
  cardTemplateVersion?: Maybe<Scalars['Int']['output']>;
  created?: Maybe<Scalars['Datetime']['output']>;
  environmentId?: Maybe<Scalars['String']['output']>;
  eventDefinitionId?: Maybe<Scalars['String']['output']>;
  eventDefinitionVersion?: Maybe<Scalars['Int']['output']>;
  flowConfigId?: Maybe<Scalars['String']['output']>;
  flowConfigVersion?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  mapping?: Maybe<Scalars['JSON']['output']>;
  streamId?: Maybe<Scalars['String']['output']>;
  sysPeriod?: Maybe<DatetimeRange>;
};

/** A connection to a list of `TriggerEvent` values. */
export type TriggerEventsConnection = {
  __typename?: 'TriggerEventsConnection';
  /** A list of edges which contains the `TriggerEvent` and cursor to aid in pagination. */
  edges: Array<TriggerEventsEdge>;
  /** A list of `TriggerEvent` objects. */
  nodes: Array<TriggerEvent>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TriggerEvent` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `TriggerEvent` edge in the connection. */
export type TriggerEventsEdge = {
  __typename?: 'TriggerEventsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `TriggerEvent` at the end of the edge. */
  node: TriggerEvent;
};

/** Methods to use when ordering `TriggerEvent`. */
export enum TriggerEventsOrderBy {
  CardTemplateIdAsc = 'CARD_TEMPLATE_ID_ASC',
  CardTemplateIdDesc = 'CARD_TEMPLATE_ID_DESC',
  CardTemplateVersionAsc = 'CARD_TEMPLATE_VERSION_ASC',
  CardTemplateVersionDesc = 'CARD_TEMPLATE_VERSION_DESC',
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  EventDefinitionIdAsc = 'EVENT_DEFINITION_ID_ASC',
  EventDefinitionIdDesc = 'EVENT_DEFINITION_ID_DESC',
  EventDefinitionVersionAsc = 'EVENT_DEFINITION_VERSION_ASC',
  EventDefinitionVersionDesc = 'EVENT_DEFINITION_VERSION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SysPeriodAsc = 'SYS_PERIOD_ASC',
  SysPeriodDesc = 'SYS_PERIOD_DESC'
}

export type TriggerInceptionEventInput = {
  payload: Scalars['JSON']['input'];
};

export type TriggerInceptionEventResponse = {
  __typename?: 'TriggerInceptionEventResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** A filter to be used against UUID fields. All fields are combined with a logical ‘and.’ */
export type UuidFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['UUID']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['UUID']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['UUID']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['UUID']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** All input for the `unarchiveActionFlowConfigVersion` mutation. */
export type UnarchiveActionFlowConfigVersionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  flowConfigId: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
};

/** The output of our `unarchiveActionFlowConfigVersion` mutation. */
export type UnarchiveActionFlowConfigVersionPayload = {
  __typename?: 'UnarchiveActionFlowConfigVersionPayload';
  actionFlowConfigVersion?: Maybe<ActionFlowConfigVersion>;
  /** An edge for our `ActionFlowConfigVersion`. May be used by Relay 1. */
  actionFlowConfigVersionEdge?: Maybe<ActionFlowConfigVersionsEdge>;
  /** Reads a single `BusinessUser` that is related to this `ActionFlowConfigVersion`. */
  businessUserByOrganisationIdAndPublishedBy?: Maybe<BusinessUser>;
  /** Reads a single `BusinessUser` that is related to this `ActionFlowConfigVersion`. */
  businessUserByOrganisationIdAndUpdatedBy?: Maybe<BusinessUser>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `ActionFlowConfig` that is related to this `ActionFlowConfigVersion`. */
  environmentFlowConfig?: Maybe<ActionFlowConfig>;
  /** Reads a single `Organisation` that is related to this `ActionFlowConfigVersion`. */
  organisation?: Maybe<Organisation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `unarchiveActionFlowConfigVersion` mutation. */
export type UnarchiveActionFlowConfigVersionPayloadActionFlowConfigVersionEdgeArgs = {
  orderBy?: InputMaybe<Array<ActionFlowConfigVersionsOrderBy>>;
};

export type UpdateActionFlowFolderInput = {
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  workbenchFolderIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** All input for the `updateAppClientByNodeId` mutation. */
export type UpdateAppClientByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `AppClient` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `AppClient` being updated. */
  patch: AppClientPatch;
};

/** All input for the `updateAppClient` mutation. */
export type UpdateAppClientInput = {
  appClientId: Scalars['String']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organisationId: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `AppClient` being updated. */
  patch: AppClientPatch;
};

/** The output of our update `AppClient` mutation. */
export type UpdateAppClientPayload = {
  __typename?: 'UpdateAppClientPayload';
  /** The `AppClient` that was updated by this mutation. */
  appClient?: Maybe<AppClient>;
  /** An edge for our `AppClient`. May be used by Relay 1. */
  appClientEdge?: Maybe<AppClientsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organisation` that is related to this `AppClient`. */
  organisation?: Maybe<Organisation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `AppClient` mutation. */
export type UpdateAppClientPayloadAppClientEdgeArgs = {
  orderBy?: InputMaybe<Array<AppClientsOrderBy>>;
};

/** All input for the `updateAuthAccountByAccountIdAndAppClientId` mutation. */
export type UpdateAuthAccountByAccountIdAndAppClientIdInput = {
  accountId: Scalars['Int']['input'];
  appClientId: Scalars['String']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `AuthAccount` being updated. */
  patch: AuthAccountPatch;
};

/** All input for the `updateAuthAccountByNodeId` mutation. */
export type UpdateAuthAccountByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `AuthAccount` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `AuthAccount` being updated. */
  patch: AuthAccountPatch;
};

/** All input for the `updateAuthAccountBySubAndAppClientId` mutation. */
export type UpdateAuthAccountBySubAndAppClientIdInput = {
  appClientId: Scalars['String']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `AuthAccount` being updated. */
  patch: AuthAccountPatch;
  sub: Scalars['UUID']['input'];
};

/** All input for the `updateAuthAccount` mutation. */
export type UpdateAuthAccountInput = {
  appClientId: Scalars['String']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['Email']['input'];
  /** An object where the defined keys will be set on the `AuthAccount` being updated. */
  patch: AuthAccountPatch;
};

/** The output of our update `AuthAccount` mutation. */
export type UpdateAuthAccountPayload = {
  __typename?: 'UpdateAuthAccountPayload';
  /** Reads a single `Account` that is related to this `AuthAccount`. */
  account?: Maybe<Account>;
  /** The `AuthAccount` that was updated by this mutation. */
  authAccount?: Maybe<AuthAccount>;
  /** An edge for our `AuthAccount`. May be used by Relay 1. */
  authAccountEdge?: Maybe<AuthAccountsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `AuthAccount` mutation. */
export type UpdateAuthAccountPayloadAuthAccountEdgeArgs = {
  orderBy?: InputMaybe<Array<AuthAccountsOrderBy>>;
};

/** All input for the `updateBusinessUserByInviteSecret` mutation. */
export type UpdateBusinessUserByInviteSecretInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  inviteSecret: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `BusinessUser` being updated. */
  patch: BusinessUserPatch;
};

/** All input for the `updateBusinessUserByNodeId` mutation. */
export type UpdateBusinessUserByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `BusinessUser` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `BusinessUser` being updated. */
  patch: BusinessUserPatch;
};

/** All input for the `updateBusinessUserByOrganisationIdAndId` mutation. */
export type UpdateBusinessUserByOrganisationIdAndIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `BusinessUser` being updated. */
  patch: BusinessUserPatch;
};

/** All input for the `updateBusinessUser` mutation. */
export type UpdateBusinessUserInput = {
  accountId: Scalars['Int']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organisationId: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `BusinessUser` being updated. */
  patch: BusinessUserPatch;
};

/** The output of our update `BusinessUser` mutation. */
export type UpdateBusinessUserPayload = {
  __typename?: 'UpdateBusinessUserPayload';
  /** Reads a single `Account` that is related to this `BusinessUser`. */
  account?: Maybe<Account>;
  /** The `BusinessUser` that was updated by this mutation. */
  businessUser?: Maybe<BusinessUser>;
  /** An edge for our `BusinessUser`. May be used by Relay 1. */
  businessUserEdge?: Maybe<BusinessUsersEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organisation` that is related to this `BusinessUser`. */
  organisation?: Maybe<Organisation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `BusinessUser` mutation. */
export type UpdateBusinessUserPayloadBusinessUserEdgeArgs = {
  orderBy?: InputMaybe<Array<BusinessUsersOrderBy>>;
};

/** All input for the `updateCardTemplateByNodeId` mutation. */
export type UpdateCardTemplateByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CardTemplate` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `CardTemplate` being updated. */
  patch: CardTemplatePatch;
};

/** All input for the `updateCardTemplate` mutation. */
export type UpdateCardTemplateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `CardTemplate` being updated. */
  patch: CardTemplatePatch;
};

/** The output of our update `CardTemplate` mutation. */
export type UpdateCardTemplatePayload = {
  __typename?: 'UpdateCardTemplatePayload';
  /** The `CardTemplate` that was updated by this mutation. */
  cardTemplate?: Maybe<CardTemplate>;
  /** An edge for our `CardTemplate`. May be used by Relay 1. */
  cardTemplateEdge?: Maybe<CardTemplatesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Environment` that is related to this `CardTemplate`. */
  environment?: Maybe<Environment>;
  /** Reads a single `ActionFlowConfig` that is related to this `CardTemplate`. */
  environmentFlowConfig?: Maybe<ActionFlowConfig>;
  /** Reads a single `Organisation` that is related to this `CardTemplate`. */
  organisation?: Maybe<Organisation>;
  /** Reads a single `Environment` that is related to this `CardTemplate`. */
  organisationEnvironment?: Maybe<Environment>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CardTemplate` mutation. */
export type UpdateCardTemplatePayloadCardTemplateEdgeArgs = {
  orderBy?: InputMaybe<Array<CardTemplatesOrderBy>>;
};

/** All input for the `updateCardTemplateVersionByNodeId` mutation. */
export type UpdateCardTemplateVersionByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CardTemplateVersion` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `CardTemplateVersion` being updated. */
  patch: CardTemplateVersionPatch;
};

/** All input for the `updateCardTemplateVersion` mutation. */
export type UpdateCardTemplateVersionInput = {
  cardTemplateId: Scalars['String']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `CardTemplateVersion` being updated. */
  patch: CardTemplateVersionPatch;
  version: Scalars['Int']['input'];
};

/** The output of our update `CardTemplateVersion` mutation. */
export type UpdateCardTemplateVersionPayload = {
  __typename?: 'UpdateCardTemplateVersionPayload';
  /** Reads a single `BusinessUser` that is related to this `CardTemplateVersion`. */
  businessUserByOrganisationIdAndPublishedBy?: Maybe<BusinessUser>;
  /** Reads a single `BusinessUser` that is related to this `CardTemplateVersion`. */
  businessUserByOrganisationIdAndUpdatedBy?: Maybe<BusinessUser>;
  /** The `CardTemplateVersion` that was updated by this mutation. */
  cardTemplateVersion?: Maybe<CardTemplateVersion>;
  /** An edge for our `CardTemplateVersion`. May be used by Relay 1. */
  cardTemplateVersionEdge?: Maybe<CardTemplateVersionsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `CardTemplate` that is related to this `CardTemplateVersion`. */
  environmentCardTemplate?: Maybe<CardTemplate>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CardTemplateVersion` mutation. */
export type UpdateCardTemplateVersionPayloadCardTemplateVersionEdgeArgs = {
  orderBy?: InputMaybe<Array<CardTemplateVersionsOrderBy>>;
};

/** All input for the `updateClientKeyByApiKey` mutation. */
export type UpdateClientKeyByApiKeyInput = {
  apiKey: Scalars['String']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An object where the defined keys will be set on the `ClientKey` being updated. */
  patch: ClientKeyPatch;
};

/** All input for the `updateClientKeyByNodeId` mutation. */
export type UpdateClientKeyByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ClientKey` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `ClientKey` being updated. */
  patch: ClientKeyPatch;
};

/** All input for the `updateClientKey` mutation. */
export type UpdateClientKeyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `ClientKey` being updated. */
  patch: ClientKeyPatch;
};

/** The output of our update `ClientKey` mutation. */
export type UpdateClientKeyPayload = {
  __typename?: 'UpdateClientKeyPayload';
  /** The `ClientKey` that was updated by this mutation. */
  clientKey?: Maybe<ClientKey>;
  /** An edge for our `ClientKey`. May be used by Relay 1. */
  clientKeyEdge?: Maybe<ClientKeysEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Environment` that is related to this `ClientKey`. */
  environment?: Maybe<Environment>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `ClientKey` mutation. */
export type UpdateClientKeyPayloadClientKeyEdgeArgs = {
  orderBy?: InputMaybe<Array<ClientKeysOrderBy>>;
};

/** All input for the `updateConnectorRuntimeByEnvironmentIdAndSecret` mutation. */
export type UpdateConnectorRuntimeByEnvironmentIdAndSecretInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `ConnectorRuntime` being updated. */
  patch: ConnectorRuntimePatch;
  secret: Scalars['String']['input'];
};

/** All input for the `updateConnectorRuntimeByNodeId` mutation. */
export type UpdateConnectorRuntimeByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ConnectorRuntime` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `ConnectorRuntime` being updated. */
  patch: ConnectorRuntimePatch;
};

/** All input for the `updateConnectorRuntime` mutation. */
export type UpdateConnectorRuntimeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  flowConfigId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `ConnectorRuntime` being updated. */
  patch: ConnectorRuntimePatch;
};

/** The output of our update `ConnectorRuntime` mutation. */
export type UpdateConnectorRuntimePayload = {
  __typename?: 'UpdateConnectorRuntimePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `ConnectorRuntime` that was updated by this mutation. */
  connectorRuntime?: Maybe<ConnectorRuntime>;
  /** An edge for our `ConnectorRuntime`. May be used by Relay 1. */
  connectorRuntimeEdge?: Maybe<ConnectorRuntimesEdge>;
  /** Reads a single `Environment` that is related to this `ConnectorRuntime`. */
  environment?: Maybe<Environment>;
  /** Reads a single `ActionFlowConfig` that is related to this `ConnectorRuntime`. */
  environmentFlowConfig?: Maybe<ActionFlowConfig>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `ConnectorRuntime` mutation. */
export type UpdateConnectorRuntimePayloadConnectorRuntimeEdgeArgs = {
  orderBy?: InputMaybe<Array<ConnectorRuntimesOrderBy>>;
};

/** All input for the `updateCurrentAccounts` mutation. */
export type UpdateCurrentAccountsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organisationId: Scalars['String']['input'];
};

/** The output of our `updateCurrentAccounts` mutation. */
export type UpdateCurrentAccountsPayload = {
  __typename?: 'UpdateCurrentAccountsPayload';
  account?: Maybe<Account>;
  /** An edge for our `Account`. May be used by Relay 1. */
  accountEdge?: Maybe<AccountsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `updateCurrentAccounts` mutation. */
export type UpdateCurrentAccountsPayloadAccountEdgeArgs = {
  orderBy?: InputMaybe<Array<AccountsOrderBy>>;
};

/** All input for the `updateCustomRoleByNodeId` mutation. */
export type UpdateCustomRoleByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CustomRole` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `CustomRole` being updated. */
  patch: CustomRolePatch;
};

/** All input for the `updateCustomRoleByOrganisationIdAndName` mutation. */
export type UpdateCustomRoleByOrganisationIdAndNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `CustomRole` being updated. */
  patch: CustomRolePatch;
};

/** All input for the `updateCustomRole` mutation. */
export type UpdateCustomRoleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `CustomRole` being updated. */
  patch: CustomRolePatch;
};

/** The output of our update `CustomRole` mutation. */
export type UpdateCustomRolePayload = {
  __typename?: 'UpdateCustomRolePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `CustomRole` that was updated by this mutation. */
  customRole?: Maybe<CustomRole>;
  /** An edge for our `CustomRole`. May be used by Relay 1. */
  customRoleEdge?: Maybe<CustomRolesEdge>;
  /** Reads a single `Organisation` that is related to this `CustomRole`. */
  organisation?: Maybe<Organisation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CustomRole` mutation. */
export type UpdateCustomRolePayloadCustomRoleEdgeArgs = {
  orderBy?: InputMaybe<Array<CustomRolesOrderBy>>;
};

/** All input for the `updateCustomerTokenByClientIdAndEnvironmentId` mutation. */
export type UpdateCustomerTokenByClientIdAndEnvironmentIdInput = {
  clientId: Scalars['String']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `CustomerToken` being updated. */
  patch: CustomerTokenPatch;
};

/** All input for the `updateCustomerTokenByNodeId` mutation. */
export type UpdateCustomerTokenByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `CustomerToken` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `CustomerToken` being updated. */
  patch: CustomerTokenPatch;
};

/** All input for the `updateCustomerToken` mutation. */
export type UpdateCustomerTokenInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `CustomerToken` being updated. */
  patch: CustomerTokenPatch;
};

/** The output of our update `CustomerToken` mutation. */
export type UpdateCustomerTokenPayload = {
  __typename?: 'UpdateCustomerTokenPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `CustomerToken` that was updated by this mutation. */
  customerToken?: Maybe<CustomerToken>;
  /** An edge for our `CustomerToken`. May be used by Relay 1. */
  customerTokenEdge?: Maybe<CustomerTokensEdge>;
  /** Reads a single `Environment` that is related to this `CustomerToken`. */
  environment?: Maybe<Environment>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `CustomerToken` mutation. */
export type UpdateCustomerTokenPayloadCustomerTokenEdgeArgs = {
  orderBy?: InputMaybe<Array<CustomerTokensOrderBy>>;
};

export type UpdateEndUserResponse = {
  __typename?: 'UpdateEndUserResponse';
  endUser: CustomEndUserType;
};

/** All input for the `updateEndUserSegmentByEnvironmentIdAndName` mutation. */
export type UpdateEndUserSegmentByEnvironmentIdAndNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `EndUserSegment` being updated. */
  patch: EndUserSegmentPatch;
};

/** All input for the `updateEndUserSegmentByNodeId` mutation. */
export type UpdateEndUserSegmentByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `EndUserSegment` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `EndUserSegment` being updated. */
  patch: EndUserSegmentPatch;
};

/** All input for the `updateEndUserSegment` mutation. */
export type UpdateEndUserSegmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `EndUserSegment` being updated. */
  patch: EndUserSegmentPatch;
};

/** The output of our update `EndUserSegment` mutation. */
export type UpdateEndUserSegmentPayload = {
  __typename?: 'UpdateEndUserSegmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `EndUserSegment` that was updated by this mutation. */
  endUserSegment?: Maybe<EndUserSegment>;
  /** An edge for our `EndUserSegment`. May be used by Relay 1. */
  endUserSegmentEdge?: Maybe<EndUserSegmentsEdge>;
  /** Reads a single `Environment` that is related to this `EndUserSegment`. */
  environment?: Maybe<Environment>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `EndUserSegment` mutation. */
export type UpdateEndUserSegmentPayloadEndUserSegmentEdgeArgs = {
  orderBy?: InputMaybe<Array<EndUserSegmentsOrderBy>>;
};

/** All input for the `updateEnvironmentByNodeId` mutation. */
export type UpdateEnvironmentByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Environment` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `Environment` being updated. */
  patch: EnvironmentPatch;
};

/** All input for the `updateEnvironmentByOrganisationIdAndId` mutation. */
export type UpdateEnvironmentByOrganisationIdAndIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `Environment` being updated. */
  patch: EnvironmentPatch;
};

/** All input for the `updateEnvironment` mutation. */
export type UpdateEnvironmentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `Environment` being updated. */
  patch: EnvironmentPatch;
};

/** All input for the `updateEnvironmentName` mutation. */
export type UpdateEnvironmentNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

/** The output of our `updateEnvironmentName` mutation. */
export type UpdateEnvironmentNamePayload = {
  __typename?: 'UpdateEnvironmentNamePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  environment?: Maybe<Environment>;
  /** An edge for our `Environment`. May be used by Relay 1. */
  environmentEdge?: Maybe<EnvironmentsEdge>;
  /** Reads a single `Organisation` that is related to this `Environment`. */
  organisation?: Maybe<Organisation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `updateEnvironmentName` mutation. */
export type UpdateEnvironmentNamePayloadEnvironmentEdgeArgs = {
  orderBy?: InputMaybe<Array<EnvironmentsOrderBy>>;
};

/** The output of our update `Environment` mutation. */
export type UpdateEnvironmentPayload = {
  __typename?: 'UpdateEnvironmentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Environment` that was updated by this mutation. */
  environment?: Maybe<Environment>;
  /** An edge for our `Environment`. May be used by Relay 1. */
  environmentEdge?: Maybe<EnvironmentsEdge>;
  /** Reads a single `Organisation` that is related to this `Environment`. */
  organisation?: Maybe<Organisation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Environment` mutation. */
export type UpdateEnvironmentPayloadEnvironmentEdgeArgs = {
  orderBy?: InputMaybe<Array<EnvironmentsOrderBy>>;
};

/** All input for the `updateEventDefinitionVersionByNodeId` mutation. */
export type UpdateEventDefinitionVersionByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `EventDefinitionVersion` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `EventDefinitionVersion` being updated. */
  patch: EventDefinitionVersionPatch;
};

/** All input for the `updateEventDefinitionVersion` mutation. */
export type UpdateEventDefinitionVersionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  eventDefinitionId: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `EventDefinitionVersion` being updated. */
  patch: EventDefinitionVersionPatch;
  version: Scalars['Int']['input'];
};

/** The output of our update `EventDefinitionVersion` mutation. */
export type UpdateEventDefinitionVersionPayload = {
  __typename?: 'UpdateEventDefinitionVersionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `EventDefinition` that is related to this `EventDefinitionVersion`. */
  environmentEventDefinition?: Maybe<EventDefinition>;
  /** The `EventDefinitionVersion` that was updated by this mutation. */
  eventDefinitionVersion?: Maybe<EventDefinitionVersion>;
  /** An edge for our `EventDefinitionVersion`. May be used by Relay 1. */
  eventDefinitionVersionEdge?: Maybe<EventDefinitionVersionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `EventDefinitionVersion` mutation. */
export type UpdateEventDefinitionVersionPayloadEventDefinitionVersionEdgeArgs = {
  orderBy?: InputMaybe<Array<EventDefinitionVersionsOrderBy>>;
};

/** All input for the `updateGrantByNodeId` mutation. */
export type UpdateGrantByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Grant` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `Grant` being updated. */
  patch: GrantPatch;
};

/** All input for the `updateGrant` mutation. */
export type UpdateGrantInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `Grant` being updated. */
  patch: GrantPatch;
};

/** The output of our update `Grant` mutation. */
export type UpdateGrantPayload = {
  __typename?: 'UpdateGrantPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Environment` that is related to this `Grant`. */
  environment?: Maybe<Environment>;
  /** The `Grant` that was updated by this mutation. */
  grant?: Maybe<Grant>;
  /** An edge for our `Grant`. May be used by Relay 1. */
  grantEdge?: Maybe<GrantsEdge>;
  /** Reads a single `Organisation` that is related to this `Grant`. */
  organisation?: Maybe<Organisation>;
  /** Reads a single `Group` that is related to this `Grant`. */
  organisationGroup?: Maybe<Group>;
  /** Reads a single `CustomRole` that is related to this `Grant`. */
  organisationRole?: Maybe<CustomRole>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Grant` mutation. */
export type UpdateGrantPayloadGrantEdgeArgs = {
  orderBy?: InputMaybe<Array<GrantsOrderBy>>;
};

/** All input for the `updateGroupByNodeId` mutation. */
export type UpdateGroupByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Group` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `Group` being updated. */
  patch: GroupPatch;
};

/** All input for the `updateGroupByOrganisationIdAndName` mutation. */
export type UpdateGroupByOrganisationIdAndNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `Group` being updated. */
  patch: GroupPatch;
};

/** All input for the `updateGroup` mutation. */
export type UpdateGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `Group` being updated. */
  patch: GroupPatch;
};

/** The output of our update `Group` mutation. */
export type UpdateGroupPayload = {
  __typename?: 'UpdateGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Group` that was updated by this mutation. */
  group?: Maybe<Group>;
  /** An edge for our `Group`. May be used by Relay 1. */
  groupEdge?: Maybe<GroupsEdge>;
  /** Reads a single `Organisation` that is related to this `Group`. */
  organisation?: Maybe<Organisation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Group` mutation. */
export type UpdateGroupPayloadGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};

/** All input for the `updateInsightsReportByNodeId` mutation. */
export type UpdateInsightsReportByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `InsightsReport` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `InsightsReport` being updated. */
  patch: InsightsReportPatch;
};

/** All input for the `updateInsightsReport` mutation. */
export type UpdateInsightsReportInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `InsightsReport` being updated. */
  patch: InsightsReportPatch;
};

/** The output of our update `InsightsReport` mutation. */
export type UpdateInsightsReportPayload = {
  __typename?: 'UpdateInsightsReportPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Environment` that is related to this `InsightsReport`. */
  environment?: Maybe<Environment>;
  /** The `InsightsReport` that was updated by this mutation. */
  insightsReport?: Maybe<InsightsReport>;
  /** An edge for our `InsightsReport`. May be used by Relay 1. */
  insightsReportEdge?: Maybe<InsightsReportsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `InsightsReport` mutation. */
export type UpdateInsightsReportPayloadInsightsReportEdgeArgs = {
  orderBy?: InputMaybe<Array<InsightsReportsOrderBy>>;
};

/** All input for the `updateIntegrationConfigurationByNodeId` mutation. */
export type UpdateIntegrationConfigurationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `IntegrationConfiguration` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `IntegrationConfiguration` being updated. */
  patch: IntegrationConfigurationPatch;
};

/** All input for the `updateIntegrationConfiguration` mutation. */
export type UpdateIntegrationConfigurationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `IntegrationConfiguration` being updated. */
  patch: IntegrationConfigurationPatch;
};

/** The output of our update `IntegrationConfiguration` mutation. */
export type UpdateIntegrationConfigurationPayload = {
  __typename?: 'UpdateIntegrationConfigurationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `IntegrationConfiguration` that was updated by this mutation. */
  integrationConfiguration?: Maybe<IntegrationConfiguration>;
  /** An edge for our `IntegrationConfiguration`. May be used by Relay 1. */
  integrationConfigurationEdge?: Maybe<IntegrationConfigurationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `IntegrationConfiguration` mutation. */
export type UpdateIntegrationConfigurationPayloadIntegrationConfigurationEdgeArgs = {
  orderBy?: InputMaybe<Array<IntegrationConfigurationsOrderBy>>;
};

/** All input for the `updateOrganisationByNodeId` mutation. */
export type UpdateOrganisationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Organisation` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `Organisation` being updated. */
  patch: OrganisationPatch;
};

/** All input for the `updateOrganisation` mutation. */
export type UpdateOrganisationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `Organisation` being updated. */
  patch: OrganisationPatch;
};

/** The output of our update `Organisation` mutation. */
export type UpdateOrganisationPayload = {
  __typename?: 'UpdateOrganisationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `Organisation` that was updated by this mutation. */
  organisation?: Maybe<Organisation>;
  /** An edge for our `Organisation`. May be used by Relay 1. */
  organisationEdge?: Maybe<OrganisationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Organisation` mutation. */
export type UpdateOrganisationPayloadOrganisationEdgeArgs = {
  orderBy?: InputMaybe<Array<OrganisationsOrderBy>>;
};

/** All input for the `updateOwnBusinessUserPreferences` mutation. */
export type UpdateOwnBusinessUserPreferencesInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organisationId: Scalars['String']['input'];
  preferences: Scalars['JSON']['input'];
};

/** The output of our `updateOwnBusinessUserPreferences` mutation. */
export type UpdateOwnBusinessUserPreferencesPayload = {
  __typename?: 'UpdateOwnBusinessUserPreferencesPayload';
  /** Reads a single `Account` that is related to this `BusinessUser`. */
  account?: Maybe<Account>;
  businessUser?: Maybe<BusinessUser>;
  /** An edge for our `BusinessUser`. May be used by Relay 1. */
  businessUserEdge?: Maybe<BusinessUsersEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organisation` that is related to this `BusinessUser`. */
  organisation?: Maybe<Organisation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `updateOwnBusinessUserPreferences` mutation. */
export type UpdateOwnBusinessUserPreferencesPayloadBusinessUserEdgeArgs = {
  orderBy?: InputMaybe<Array<BusinessUsersOrderBy>>;
};

/** All input for the `updateOwnBusinessUserProfile` mutation. */
export type UpdateOwnBusinessUserProfileInput = {
  accountId: Scalars['Int']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

/** The output of our `updateOwnBusinessUserProfile` mutation. */
export type UpdateOwnBusinessUserProfilePayload = {
  __typename?: 'UpdateOwnBusinessUserProfilePayload';
  /** Reads a single `Account` that is related to this `BusinessUser`. */
  account?: Maybe<Account>;
  businessUser?: Maybe<BusinessUser>;
  /** An edge for our `BusinessUser`. May be used by Relay 1. */
  businessUserEdge?: Maybe<BusinessUsersEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organisation` that is related to this `BusinessUser`. */
  organisation?: Maybe<Organisation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our `updateOwnBusinessUserProfile` mutation. */
export type UpdateOwnBusinessUserProfilePayloadBusinessUserEdgeArgs = {
  orderBy?: InputMaybe<Array<BusinessUsersOrderBy>>;
};

/** All input for the `updateResourceUserByNodeId` mutation. */
export type UpdateResourceUserByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `ResourceUser` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `ResourceUser` being updated. */
  patch: ResourceUserPatch;
};

/** All input for the `updateResourceUser` mutation. */
export type UpdateResourceUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `ResourceUser` being updated. */
  patch: ResourceUserPatch;
  resourceId: Scalars['String']['input'];
  resourceType: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
  sub: Scalars['UUID']['input'];
};

/** The output of our update `ResourceUser` mutation. */
export type UpdateResourceUserPayload = {
  __typename?: 'UpdateResourceUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `ResourceUser` that was updated by this mutation. */
  resourceUser?: Maybe<ResourceUser>;
  /** An edge for our `ResourceUser`. May be used by Relay 1. */
  resourceUserEdge?: Maybe<ResourceUsersEdge>;
};


/** The output of our update `ResourceUser` mutation. */
export type UpdateResourceUserPayloadResourceUserEdgeArgs = {
  orderBy?: InputMaybe<Array<ResourceUsersOrderBy>>;
};

/** All input for the `updateRolePermissionByNodeId` mutation. */
export type UpdateRolePermissionByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `RolePermission` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `RolePermission` being updated. */
  patch: RolePermissionPatch;
};

/** All input for the `updateRolePermission` mutation. */
export type UpdateRolePermissionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organisationId: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `RolePermission` being updated. */
  patch: RolePermissionPatch;
  resource: PermissionResource;
  roleId: Scalars['String']['input'];
};

/** The output of our update `RolePermission` mutation. */
export type UpdateRolePermissionPayload = {
  __typename?: 'UpdateRolePermissionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Organisation` that is related to this `RolePermission`. */
  organisation?: Maybe<Organisation>;
  /** Reads a single `CustomRole` that is related to this `RolePermission`. */
  organisationRole?: Maybe<CustomRole>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RolePermission` that was updated by this mutation. */
  rolePermission?: Maybe<RolePermission>;
  /** An edge for our `RolePermission`. May be used by Relay 1. */
  rolePermissionEdge?: Maybe<RolePermissionsEdge>;
};


/** The output of our update `RolePermission` mutation. */
export type UpdateRolePermissionPayloadRolePermissionEdgeArgs = {
  orderBy?: InputMaybe<Array<RolePermissionsOrderBy>>;
};

/** All input for the `updateStreamByNodeId` mutation. */
export type UpdateStreamByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Stream` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `Stream` being updated. */
  patch: StreamPatch;
};

/** All input for the `updateStreamContainerByNodeId` mutation. */
export type UpdateStreamContainerByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `StreamContainer` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `StreamContainer` being updated. */
  patch: StreamContainerPatch;
};

/** All input for the `updateStreamContainer` mutation. */
export type UpdateStreamContainerInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `StreamContainer` being updated. */
  patch: StreamContainerPatch;
};

/** The output of our update `StreamContainer` mutation. */
export type UpdateStreamContainerPayload = {
  __typename?: 'UpdateStreamContainerPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Theme` that is related to this `StreamContainer`. */
  environmentDarkTheme?: Maybe<Theme>;
  /** Reads a single `Stream` that is related to this `StreamContainer`. */
  environmentStream?: Maybe<Stream>;
  /** Reads a single `Theme` that is related to this `StreamContainer`. */
  environmentTheme?: Maybe<Theme>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `StreamContainer` that was updated by this mutation. */
  streamContainer?: Maybe<StreamContainer>;
  /** An edge for our `StreamContainer`. May be used by Relay 1. */
  streamContainerEdge?: Maybe<StreamContainersEdge>;
};


/** The output of our update `StreamContainer` mutation. */
export type UpdateStreamContainerPayloadStreamContainerEdgeArgs = {
  orderBy?: InputMaybe<Array<StreamContainersOrderBy>>;
};

/** All input for the `updateStream` mutation. */
export type UpdateStreamInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `Stream` being updated. */
  patch: StreamPatch;
};

/** The output of our update `Stream` mutation. */
export type UpdateStreamPayload = {
  __typename?: 'UpdateStreamPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Environment` that is related to this `Stream`. */
  environment?: Maybe<Environment>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Stream` that was updated by this mutation. */
  stream?: Maybe<Stream>;
  /** An edge for our `Stream`. May be used by Relay 1. */
  streamEdge?: Maybe<StreamsEdge>;
};


/** The output of our update `Stream` mutation. */
export type UpdateStreamPayloadStreamEdgeArgs = {
  orderBy?: InputMaybe<Array<StreamsOrderBy>>;
};

/** All input for the `updateTagByEnvironmentIdAndName` mutation. */
export type UpdateTagByEnvironmentIdAndNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `Tag` being updated. */
  patch: TagPatch;
};

/** All input for the `updateTagByNodeId` mutation. */
export type UpdateTagByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Tag` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `Tag` being updated. */
  patch: TagPatch;
};

/** All input for the `updateTag` mutation. */
export type UpdateTagInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `Tag` being updated. */
  patch: TagPatch;
};

/** The output of our update `Tag` mutation. */
export type UpdateTagPayload = {
  __typename?: 'UpdateTagPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Environment` that is related to this `Tag`. */
  environment?: Maybe<Environment>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Tag` that was updated by this mutation. */
  tag?: Maybe<Tag>;
  /** An edge for our `Tag`. May be used by Relay 1. */
  tagEdge?: Maybe<TagsEdge>;
};


/** The output of our update `Tag` mutation. */
export type UpdateTagPayloadTagEdgeArgs = {
  orderBy?: InputMaybe<Array<TagsOrderBy>>;
};

/** All input for the `updateThemeByNodeId` mutation. */
export type UpdateThemeByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `Theme` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `Theme` being updated. */
  patch: ThemePatch;
};

/** All input for the `updateTheme` mutation. */
export type UpdateThemeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `Theme` being updated. */
  patch: ThemePatch;
};

/** The output of our update `Theme` mutation. */
export type UpdateThemePayload = {
  __typename?: 'UpdateThemePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Environment` that is related to this `Theme`. */
  environment?: Maybe<Environment>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Theme` that was updated by this mutation. */
  theme?: Maybe<Theme>;
  /** An edge for our `Theme`. May be used by Relay 1. */
  themeEdge?: Maybe<ThemesEdge>;
};


/** The output of our update `Theme` mutation. */
export type UpdateThemePayloadThemeEdgeArgs = {
  orderBy?: InputMaybe<Array<ThemesOrderBy>>;
};

/** All input for the `updateTriggerEventByEnvironmentIdAndStreamIdAndEventDefinitionIdAndEventDefinitionVersionAndCardTemplateIdAndCardTemplateVersion` mutation. */
export type UpdateTriggerEventByEnvironmentIdAndStreamIdAndEventDefinitionIdAndEventDefinitionVersionAndCardTemplateIdAndCardTemplateVersionInput = {
  cardTemplateId: Scalars['String']['input'];
  cardTemplateVersion: Scalars['Int']['input'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  eventDefinitionId: Scalars['String']['input'];
  eventDefinitionVersion: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `TriggerEvent` being updated. */
  patch: TriggerEventPatch;
  streamId: Scalars['String']['input'];
};

/** All input for the `updateTriggerEventByNodeId` mutation. */
export type UpdateTriggerEventByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `TriggerEvent` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `TriggerEvent` being updated. */
  patch: TriggerEventPatch;
};

/** All input for the `updateTriggerEvent` mutation. */
export type UpdateTriggerEventInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  /** An object where the defined keys will be set on the `TriggerEvent` being updated. */
  patch: TriggerEventPatch;
};

/** The output of our update `TriggerEvent` mutation. */
export type UpdateTriggerEventPayload = {
  __typename?: 'UpdateTriggerEventPayload';
  /** Reads a single `ActionFlowConfigVersion` that is related to this `TriggerEvent`. */
  actionFlowConfigVersionByEnvironmentIdAndFlowConfigIdAndFlowConfigVersion?: Maybe<ActionFlowConfigVersion>;
  /** Reads a single `CardTemplateVersion` that is related to this `TriggerEvent`. */
  cardTemplateVersionByEnvironmentIdAndCardTemplateIdAndCardTemplateVersion?: Maybe<CardTemplateVersion>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Environment` that is related to this `TriggerEvent`. */
  environment?: Maybe<Environment>;
  /** Reads a single `Stream` that is related to this `TriggerEvent`. */
  environmentStream?: Maybe<Stream>;
  /** Reads a single `EventDefinitionVersion` that is related to this `TriggerEvent`. */
  eventDefinitionVersionByEnvironmentIdAndEventDefinitionIdAndEventDefinitionVersion?: Maybe<EventDefinitionVersion>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `TriggerEvent` that was updated by this mutation. */
  triggerEvent?: Maybe<TriggerEvent>;
  /** An edge for our `TriggerEvent`. May be used by Relay 1. */
  triggerEventEdge?: Maybe<TriggerEventsEdge>;
};


/** The output of our update `TriggerEvent` mutation. */
export type UpdateTriggerEventPayloadTriggerEventEdgeArgs = {
  orderBy?: InputMaybe<Array<TriggerEventsOrderBy>>;
};

/** All input for the `updateWebhookCredentialByNodeId` mutation. */
export type UpdateWebhookCredentialByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `WebhookCredential` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `WebhookCredential` being updated. */
  patch: WebhookCredentialPatch;
};

/** All input for the `updateWebhookCredential` mutation. */
export type UpdateWebhookCredentialInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `WebhookCredential` being updated. */
  patch: WebhookCredentialPatch;
};

/** The output of our update `WebhookCredential` mutation. */
export type UpdateWebhookCredentialPayload = {
  __typename?: 'UpdateWebhookCredentialPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Environment` that is related to this `WebhookCredential`. */
  environment?: Maybe<Environment>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `WebhookCredential` that was updated by this mutation. */
  webhookCredential?: Maybe<WebhookCredential>;
  /** An edge for our `WebhookCredential`. May be used by Relay 1. */
  webhookCredentialEdge?: Maybe<WebhookCredentialsEdge>;
};


/** The output of our update `WebhookCredential` mutation. */
export type UpdateWebhookCredentialPayloadWebhookCredentialEdgeArgs = {
  orderBy?: InputMaybe<Array<WebhookCredentialsOrderBy>>;
};

/** All input for the `updateWebhookEndpointByNodeId` mutation. */
export type UpdateWebhookEndpointByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `WebhookEndpoint` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `WebhookEndpoint` being updated. */
  patch: WebhookEndpointPatch;
};

/** All input for the `updateWebhookEndpoint` mutation. */
export type UpdateWebhookEndpointInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `WebhookEndpoint` being updated. */
  patch: WebhookEndpointPatch;
};

/** The output of our update `WebhookEndpoint` mutation. */
export type UpdateWebhookEndpointPayload = {
  __typename?: 'UpdateWebhookEndpointPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Environment` that is related to this `WebhookEndpoint`. */
  environment?: Maybe<Environment>;
  /** Reads a single `WebhookCredential` that is related to this `WebhookEndpoint`. */
  environmentWebhookCredential?: Maybe<WebhookCredential>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `WebhookEndpoint` that was updated by this mutation. */
  webhookEndpoint?: Maybe<WebhookEndpoint>;
  /** An edge for our `WebhookEndpoint`. May be used by Relay 1. */
  webhookEndpointEdge?: Maybe<WebhookEndpointsEdge>;
};


/** The output of our update `WebhookEndpoint` mutation. */
export type UpdateWebhookEndpointPayloadWebhookEndpointEdgeArgs = {
  orderBy?: InputMaybe<Array<WebhookEndpointsOrderBy>>;
};

/** All input for the `updateWorkbenchFolderByEnvironmentIdAndName` mutation. */
export type UpdateWorkbenchFolderByEnvironmentIdAndNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `WorkbenchFolder` being updated. */
  patch: WorkbenchFolderPatch;
};

/** All input for the `updateWorkbenchFolderByNodeId` mutation. */
export type UpdateWorkbenchFolderByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The globally unique `ID` which will identify a single `WorkbenchFolder` to be updated. */
  nodeId: Scalars['ID']['input'];
  /** An object where the defined keys will be set on the `WorkbenchFolder` being updated. */
  patch: WorkbenchFolderPatch;
};

/** All input for the `updateWorkbenchFolder` mutation. */
export type UpdateWorkbenchFolderInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  /** An object where the defined keys will be set on the `WorkbenchFolder` being updated. */
  patch: WorkbenchFolderPatch;
};

/** The output of our update `WorkbenchFolder` mutation. */
export type UpdateWorkbenchFolderPayload = {
  __typename?: 'UpdateWorkbenchFolderPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Environment` that is related to this `WorkbenchFolder`. */
  environment?: Maybe<Environment>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `WorkbenchFolder` that was updated by this mutation. */
  workbenchFolder?: Maybe<WorkbenchFolder>;
  /** An edge for our `WorkbenchFolder`. May be used by Relay 1. */
  workbenchFolderEdge?: Maybe<WorkbenchFoldersEdge>;
};


/** The output of our update `WorkbenchFolder` mutation. */
export type UpdateWorkbenchFolderPayloadWorkbenchFolderEdgeArgs = {
  orderBy?: InputMaybe<Array<WorkbenchFoldersOrderBy>>;
};

export type UpsertMagicLinkInput = {
  endUserId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  streamContainerId: Scalars['String']['input'];
};

export type UserCountResponse = {
  __typename?: 'UserCountResponse';
  totalCount: Scalars['Int']['output'];
};

export type WebhookCredential = Node & {
  __typename?: 'WebhookCredential';
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
  configuration?: Maybe<Scalars['JSON']['output']>;
  created: Scalars['Datetime']['output'];
  /** Reads a single `Environment` that is related to this `WebhookCredential`. */
  environment?: Maybe<Environment>;
  environmentId: Scalars['String']['output'];
  expirySeconds: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  identityUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  updated: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `WebhookEndpoint`. */
  webhookEndpointsByEnvironmentIdAndWebhookCredentialId: WebhookEndpointsConnection;
};


export type WebhookCredentialWebhookEndpointsByEnvironmentIdAndWebhookCredentialIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<WebhookEndpointCondition>;
  filter?: InputMaybe<WebhookEndpointFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<WebhookEndpointsOrderBy>>;
};

/**
 * A condition to be used against `WebhookCredential` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type WebhookCredentialCondition = {
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `WebhookCredential` object types. All fields are combined with a logical ‘and.’ */
export type WebhookCredentialFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<WebhookCredentialFilter>>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<WebhookCredentialFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<WebhookCredentialFilter>>;
};

/** An input for mutations affecting `WebhookCredential` */
export type WebhookCredentialInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  configuration?: InputMaybe<Scalars['JSON']['input']>;
  environmentId: Scalars['String']['input'];
  expirySeconds?: InputMaybe<Scalars['Int']['input']>;
  identityUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/** Represents an update to a `WebhookCredential`. Fields that are set will be updated. */
export type WebhookCredentialPatch = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  configuration?: InputMaybe<Scalars['JSON']['input']>;
  expirySeconds?: InputMaybe<Scalars['Int']['input']>;
  identityUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `WebhookCredential` values. */
export type WebhookCredentialsConnection = {
  __typename?: 'WebhookCredentialsConnection';
  /** A list of edges which contains the `WebhookCredential` and cursor to aid in pagination. */
  edges: Array<WebhookCredentialsEdge>;
  /** A list of `WebhookCredential` objects. */
  nodes: Array<WebhookCredential>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `WebhookCredential` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `WebhookCredential` edge in the connection. */
export type WebhookCredentialsEdge = {
  __typename?: 'WebhookCredentialsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `WebhookCredential` at the end of the edge. */
  node: WebhookCredential;
};

/** Methods to use when ordering `WebhookCredential`. */
export enum WebhookCredentialsOrderBy {
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type WebhookEndpoint = Node & {
  __typename?: 'WebhookEndpoint';
  actionFlowConfigId?: Maybe<Scalars['String']['output']>;
  batchInterval?: Maybe<Scalars['Int']['output']>;
  batchLastRunTime: Scalars['Datetime']['output'];
  /** computed column card template definition for webhook endpoint */
  cardTemplateDefinition?: Maybe<Scalars['JSON']['output']>;
  cardTemplateId?: Maybe<Scalars['String']['output']>;
  created: Scalars['Datetime']['output'];
  /** Reads a single `Environment` that is related to this `WebhookEndpoint`. */
  environment?: Maybe<Environment>;
  environmentId: Scalars['String']['output'];
  /** Reads a single `WebhookCredential` that is related to this `WebhookEndpoint`. */
  environmentWebhookCredential?: Maybe<WebhookCredential>;
  failures: Scalars['Int']['output'];
  headers: Scalars['JSON']['output'];
  id: Scalars['String']['output'];
  lastError?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  organisationId: Scalars['String']['output'];
  payloadMapping?: Maybe<Scalars['JSON']['output']>;
  requestMethod: WebhookRequestMethod;
  secret: Scalars['String']['output'];
  status: WebhookStatus;
  types?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updated: Scalars['Datetime']['output'];
  url: Scalars['String']['output'];
  webhookCredentialId?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `WebhookEndpoint` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type WebhookEndpointCondition = {
  /** Checks for equality with the object’s `actionFlowConfigId` field. */
  actionFlowConfigId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `cardTemplateId` field. */
  cardTemplateId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<WebhookStatus>;
};

/** A filter to be used against `WebhookEndpoint` object types. All fields are combined with a logical ‘and.’ */
export type WebhookEndpointFilter = {
  /** Filter by the object’s `actionFlowConfigId` field. */
  actionFlowConfigId?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<WebhookEndpointFilter>>;
  /** Filter by the object’s `cardTemplateDefinition` field. */
  cardTemplateDefinition?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `cardTemplateId` field. */
  cardTemplateId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<WebhookEndpointFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<WebhookEndpointFilter>>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<WebhookStatusFilter>;
};

/** An input for mutations affecting `WebhookEndpoint` */
export type WebhookEndpointInput = {
  actionFlowConfigId?: InputMaybe<Scalars['String']['input']>;
  batchInterval?: InputMaybe<Scalars['Int']['input']>;
  cardTemplateId?: InputMaybe<Scalars['String']['input']>;
  environmentId: Scalars['String']['input'];
  headers?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  payloadMapping?: InputMaybe<Scalars['JSON']['input']>;
  requestMethod?: InputMaybe<WebhookRequestMethod>;
  status?: InputMaybe<WebhookStatus>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url: Scalars['String']['input'];
  webhookCredentialId?: InputMaybe<Scalars['String']['input']>;
};

/** Represents an update to a `WebhookEndpoint`. Fields that are set will be updated. */
export type WebhookEndpointPatch = {
  batchInterval?: InputMaybe<Scalars['Int']['input']>;
  headers?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  payloadMapping?: InputMaybe<Scalars['JSON']['input']>;
  requestMethod?: InputMaybe<WebhookRequestMethod>;
  status?: InputMaybe<WebhookStatus>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url?: InputMaybe<Scalars['String']['input']>;
  webhookCredentialId?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `WebhookEndpoint` values. */
export type WebhookEndpointsConnection = {
  __typename?: 'WebhookEndpointsConnection';
  /** A list of edges which contains the `WebhookEndpoint` and cursor to aid in pagination. */
  edges: Array<WebhookEndpointsEdge>;
  /** A list of `WebhookEndpoint` objects. */
  nodes: Array<WebhookEndpoint>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `WebhookEndpoint` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `WebhookEndpoint` edge in the connection. */
export type WebhookEndpointsEdge = {
  __typename?: 'WebhookEndpointsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `WebhookEndpoint` at the end of the edge. */
  node: WebhookEndpoint;
};

/** Methods to use when ordering `WebhookEndpoint`. */
export enum WebhookEndpointsOrderBy {
  ActionFlowConfigIdAsc = 'ACTION_FLOW_CONFIG_ID_ASC',
  ActionFlowConfigIdDesc = 'ACTION_FLOW_CONFIG_ID_DESC',
  CardTemplateIdAsc = 'CARD_TEMPLATE_ID_ASC',
  CardTemplateIdDesc = 'CARD_TEMPLATE_ID_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC'
}

export type WebhookLog = Node & {
  __typename?: 'WebhookLog';
  context?: Maybe<Scalars['JSON']['output']>;
  environmentId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  payload?: Maybe<Scalars['JSON']['output']>;
  responseAt?: Maybe<Scalars['Datetime']['output']>;
  responseBody?: Maybe<Scalars['String']['output']>;
  responseCode?: Maybe<Scalars['Int']['output']>;
  sentAt: Scalars['Datetime']['output'];
  webhookEndpointId: Scalars['String']['output'];
};

/** A filter to be used against `WebhookLog` object types. All fields are combined with a logical ‘and.’ */
export type WebhookLogFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<WebhookLogFilter>>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<WebhookLogFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<WebhookLogFilter>>;
};

/** A connection to a list of `WebhookLog` values. */
export type WebhookLogsConnection = {
  __typename?: 'WebhookLogsConnection';
  /** A list of edges which contains the `WebhookLog` and cursor to aid in pagination. */
  edges: Array<WebhookLogsEdge>;
  /** A list of `WebhookLog` objects. */
  nodes: Array<WebhookLog>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `WebhookLog` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `WebhookLog` edge in the connection. */
export type WebhookLogsEdge = {
  __typename?: 'WebhookLogsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `WebhookLog` at the end of the edge. */
  node: WebhookLog;
};

export enum WebhookRequestMethod {
  Post = 'POST',
  Put = 'PUT'
}

export enum WebhookStatus {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
  Failed = 'FAILED'
}

/** A filter to be used against WebhookStatus fields. All fields are combined with a logical ‘and.’ */
export type WebhookStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<WebhookStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<WebhookStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<WebhookStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<WebhookStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<WebhookStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<WebhookStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<WebhookStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<WebhookStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<WebhookStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<WebhookStatus>>;
};

/** A connection to a list of `WorkbenchActivityLogRecord` values. */
export type WorkbenchActivityLogConnection = {
  __typename?: 'WorkbenchActivityLogConnection';
  /** A list of edges which contains the `WorkbenchActivityLogRecord` and cursor to aid in pagination. */
  edges: Array<WorkbenchActivityLogEdge>;
  /** A list of `WorkbenchActivityLogRecord` objects. */
  nodes: Array<WorkbenchActivityLogRecord>;
  /** The count of *all* `WorkbenchActivityLogRecord` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `WorkbenchActivityLogRecord` edge in the connection. */
export type WorkbenchActivityLogEdge = {
  __typename?: 'WorkbenchActivityLogEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `WorkbenchActivityLogRecord` at the end of the edge. */
  node: WorkbenchActivityLogRecord;
};

/** The return type of our `workbenchActivityLog` query. */
export type WorkbenchActivityLogRecord = {
  __typename?: 'WorkbenchActivityLogRecord';
  created?: Maybe<Scalars['Datetime']['output']>;
  eventType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  organisationId?: Maybe<Scalars['String']['output']>;
  payload?: Maybe<Scalars['JSON']['output']>;
};

/** A filter to be used against `WorkbenchActivityLogRecord` object types. All fields are combined with a logical ‘and.’ */
export type WorkbenchActivityLogRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<WorkbenchActivityLogRecordFilter>>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `eventType` field. */
  eventType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<WorkbenchActivityLogRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<WorkbenchActivityLogRecordFilter>>;
  /** Filter by the object’s `organisationId` field. */
  organisationId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `payload` field. */
  payload?: InputMaybe<JsonFilter>;
};

/** A connection to a list of `WorkbenchActivityLogV2Record` values. */
export type WorkbenchActivityLogV2Connection = {
  __typename?: 'WorkbenchActivityLogV2Connection';
  /** A list of edges which contains the `WorkbenchActivityLogV2Record` and cursor to aid in pagination. */
  edges: Array<WorkbenchActivityLogV2Edge>;
  /** A list of `WorkbenchActivityLogV2Record` objects. */
  nodes: Array<WorkbenchActivityLogV2Record>;
  /** The count of *all* `WorkbenchActivityLogV2Record` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `WorkbenchActivityLogV2Record` edge in the connection. */
export type WorkbenchActivityLogV2Edge = {
  __typename?: 'WorkbenchActivityLogV2Edge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `WorkbenchActivityLogV2Record` at the end of the edge. */
  node: WorkbenchActivityLogV2Record;
};

/** The return type of our `workbenchActivityLogV2` query. */
export type WorkbenchActivityLogV2Record = {
  __typename?: 'WorkbenchActivityLogV2Record';
  created?: Maybe<Scalars['Datetime']['output']>;
  eventType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  organisationId?: Maybe<Scalars['String']['output']>;
  payload?: Maybe<Scalars['JSON']['output']>;
};

/** A filter to be used against `WorkbenchActivityLogV2Record` object types. All fields are combined with a logical ‘and.’ */
export type WorkbenchActivityLogV2RecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<WorkbenchActivityLogV2RecordFilter>>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `eventType` field. */
  eventType?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<WorkbenchActivityLogV2RecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<WorkbenchActivityLogV2RecordFilter>>;
  /** Filter by the object’s `organisationId` field. */
  organisationId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `payload` field. */
  payload?: InputMaybe<JsonFilter>;
};

/** A `WorkbenchAnalyticsRecord` edge in the connection. */
export type WorkbenchAnalyticEdge = {
  __typename?: 'WorkbenchAnalyticEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `WorkbenchAnalyticsRecord` at the end of the edge. */
  node: WorkbenchAnalyticsRecord;
};

/** A connection to a list of `WorkbenchAnalyticsRecord` values. */
export type WorkbenchAnalyticsConnection = {
  __typename?: 'WorkbenchAnalyticsConnection';
  /** A list of edges which contains the `WorkbenchAnalyticsRecord` and cursor to aid in pagination. */
  edges: Array<WorkbenchAnalyticEdge>;
  /** A list of `WorkbenchAnalyticsRecord` objects. */
  nodes: Array<WorkbenchAnalyticsRecord>;
  /** The count of *all* `WorkbenchAnalyticsRecord` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** The return type of our `workbenchAnalytics` query. */
export type WorkbenchAnalyticsRecord = {
  __typename?: 'WorkbenchAnalyticsRecord';
  created?: Maybe<Scalars['Datetime']['output']>;
  environmentId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  payload?: Maybe<Scalars['JSON']['output']>;
};

/** A filter to be used against `WorkbenchAnalyticsRecord` object types. All fields are combined with a logical ‘and.’ */
export type WorkbenchAnalyticsRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<WorkbenchAnalyticsRecordFilter>>;
  /** Filter by the object’s `created` field. */
  created?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<WorkbenchAnalyticsRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<WorkbenchAnalyticsRecordFilter>>;
  /** Filter by the object’s `payload` field. */
  payload?: InputMaybe<JsonFilter>;
};

export type WorkbenchFolder = Node & {
  __typename?: 'WorkbenchFolder';
  /** Computed column, for action_flow_status */
  actionFlowStatusCounts?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  created: Scalars['Datetime']['output'];
  /** Reads a single `Environment` that is related to this `WorkbenchFolder`. */
  environment?: Maybe<Environment>;
  environmentId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  organisationId: Scalars['String']['output'];
  type: WorkbenchFolderType;
  updated: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `WorkbenchFolder` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type WorkbenchFolderCondition = {
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<WorkbenchFolderType>;
  /** Checks for equality with the object’s `updated` field. */
  updated?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `WorkbenchFolder` object types. All fields are combined with a logical ‘and.’ */
export type WorkbenchFolderFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<WorkbenchFolderFilter>>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<WorkbenchFolderFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<WorkbenchFolderFilter>>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<WorkbenchFolderTypeFilter>;
  /** Filter by the object’s `updated` field. */
  updated?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `WorkbenchFolder` */
export type WorkbenchFolderInput = {
  created?: InputMaybe<Scalars['Datetime']['input']>;
  environmentId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organisationId: Scalars['String']['input'];
  type: WorkbenchFolderType;
  updated?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Represents an update to a `WorkbenchFolder`. Fields that are set will be updated. */
export type WorkbenchFolderPatch = {
  created?: InputMaybe<Scalars['Datetime']['input']>;
  environmentId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<WorkbenchFolderType>;
  updated?: InputMaybe<Scalars['Datetime']['input']>;
};

export enum WorkbenchFolderType {
  ActionFlow = 'ACTION_FLOW'
}

/** A filter to be used against WorkbenchFolderType fields. All fields are combined with a logical ‘and.’ */
export type WorkbenchFolderTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<WorkbenchFolderType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<WorkbenchFolderType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<WorkbenchFolderType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<WorkbenchFolderType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<WorkbenchFolderType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<WorkbenchFolderType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<WorkbenchFolderType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<WorkbenchFolderType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<WorkbenchFolderType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<WorkbenchFolderType>>;
};

/** A connection to a list of `WorkbenchFolder` values. */
export type WorkbenchFoldersConnection = {
  __typename?: 'WorkbenchFoldersConnection';
  /** A list of edges which contains the `WorkbenchFolder` and cursor to aid in pagination. */
  edges: Array<WorkbenchFoldersEdge>;
  /** A list of `WorkbenchFolder` objects. */
  nodes: Array<WorkbenchFolder>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `WorkbenchFolder` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `WorkbenchFolder` edge in the connection. */
export type WorkbenchFoldersEdge = {
  __typename?: 'WorkbenchFoldersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `WorkbenchFolder` at the end of the edge. */
  node: WorkbenchFolder;
};

/** Methods to use when ordering `WorkbenchFolder`. */
export enum WorkbenchFoldersOrderBy {
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  UpdatedAsc = 'UPDATED_ASC',
  UpdatedDesc = 'UPDATED_DESC'
}

export type TagUsersMutationResponse = {
  __typename?: 'tagUsersMutationResponse';
  tags: Array<Maybe<Scalars['String']['output']>>;
};

export type UntagUsersMutationResponse = {
  __typename?: 'untagUsersMutationResponse';
  endUserId?: Maybe<Scalars['String']['output']>;
  tagId?: Maybe<Scalars['String']['output']>;
};

export type UpdateOrganisationPurgeDaysInput = {
  id: Scalars['String']['input'];
  purgeDays?: InputMaybe<Scalars['Int']['input']>;
};
